const b = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, z = globalThis, ct = "10.6.0";
function mt() {
  return lr(z), z;
}
function lr(e) {
  const t = e.__SENTRY__ = e.__SENTRY__ || {};
  return t.version = t.version || ct, t[ct] = t[ct] || {};
}
function rn(e, t, n = z) {
  const r = n.__SENTRY__ = n.__SENTRY__ || {}, s = r[ct] = r[ct] || {};
  return s[e] || (s[e] = t());
}
const wu = [
  "debug",
  "info",
  "warn",
  "error",
  "log",
  "assert",
  "trace"
], ku = "Sentry Logger ", jn = {};
function We(e) {
  if (!("console" in z))
    return e();
  const t = z.console, n = {}, r = Object.keys(jn);
  r.forEach((s) => {
    const i = jn[s];
    n[s] = t[s], t[s] = i;
  });
  try {
    return e();
  } finally {
    r.forEach((s) => {
      t[s] = n[s];
    });
  }
}
function Ru() {
  xs().enabled = !0;
}
function Cu() {
  xs().enabled = !1;
}
function Qo() {
  return xs().enabled;
}
function xu(...e) {
  Cs("log", ...e);
}
function Mu(...e) {
  Cs("warn", ...e);
}
function Au(...e) {
  Cs("error", ...e);
}
function Cs(e, ...t) {
  b && Qo() && We(() => {
    z.console[e](`${ku}[${e}]:`, ...t);
  });
}
function xs() {
  return b ? rn("loggerSettings", () => ({ enabled: !1 })) : { enabled: !1 };
}
const g = {
  /** Enable logging. */
  enable: Ru,
  /** Disable logging. */
  disable: Cu,
  /** Check if logging is enabled. */
  isEnabled: Qo,
  /** Log a message. */
  log: xu,
  /** Log a warning. */
  warn: Mu,
  /** Log an error. */
  error: Au
}, Zo = 50, ft = "?", Ei = /\(error: (.*)\)/, bi = /captureMessage|captureException/;
function ea(...e) {
  const t = e.sort((n, r) => n[0] - r[0]).map((n) => n[1]);
  return (n, r = 0, s = 0) => {
    const i = [], o = n.split(`
`);
    for (let c = r; c < o.length; c++) {
      let a = o[c];
      a.length > 1024 && (a = a.slice(0, 1024));
      const u = Ei.test(a) ? a.replace(Ei, "$1") : a;
      if (!u.match(/\S*Error: /)) {
        for (const l of t) {
          const d = l(u);
          if (d) {
            i.push(d);
            break;
          }
        }
        if (i.length >= Zo + s)
          break;
      }
    }
    return Nu(i.slice(s));
  };
}
function Ou(e) {
  return Array.isArray(e) ? ea(...e) : e;
}
function Nu(e) {
  if (!e.length)
    return [];
  const t = Array.from(e);
  return /sentryWrapped/.test(bn(t).function || "") && t.pop(), t.reverse(), bi.test(bn(t).function || "") && (t.pop(), bi.test(bn(t).function || "") && t.pop()), t.slice(0, Zo).map((n) => ({
    ...n,
    filename: n.filename || bn(t).filename,
    function: n.function || ft
  }));
}
function bn(e) {
  return e[e.length - 1] || {};
}
const Mr = "<anonymous>";
function Pe(e) {
  try {
    return !e || typeof e != "function" ? Mr : e.name || Mr;
  } catch {
    return Mr;
  }
}
function vi(e) {
  const t = e.exception;
  if (t) {
    const n = [];
    try {
      return t.values.forEach((r) => {
        r.stacktrace.frames && n.push(...r.stacktrace.frames);
      }), n;
    } catch {
      return;
    }
  }
}
const Ln = {}, Ti = {};
function et(e, t) {
  Ln[e] = Ln[e] || [], Ln[e].push(t);
}
function tt(e, t) {
  if (!Ti[e]) {
    Ti[e] = !0;
    try {
      t();
    } catch (n) {
      b && g.error(`Error while instrumenting ${e}`, n);
    }
  }
}
function ye(e, t) {
  const n = e && Ln[e];
  if (n)
    for (const r of n)
      try {
        r(t);
      } catch (s) {
        b && g.error(
          `Error while triggering instrumentation handler.
Type: ${e}
Name: ${Pe(r)}
Error:`,
          s
        );
      }
}
let Ar = null;
function ta(e) {
  const t = "error";
  et(t, e), tt(t, Du);
}
function Du() {
  Ar = z.onerror, z.onerror = function(e, t, n, r, s) {
    return ye("error", {
      column: r,
      error: s,
      line: n,
      msg: e,
      url: t
    }), Ar ? Ar.apply(this, arguments) : !1;
  }, z.onerror.__SENTRY_INSTRUMENTED__ = !0;
}
let Or = null;
function na(e) {
  const t = "unhandledrejection";
  et(t, e), tt(t, Lu);
}
function Lu() {
  Or = z.onunhandledrejection, z.onunhandledrejection = function(e) {
    return ye("unhandledrejection", e), Or ? Or.apply(this, arguments) : !0;
  }, z.onunhandledrejection.__SENTRY_INSTRUMENTED__ = !0;
}
const ra = Object.prototype.toString;
function Ms(e) {
  switch (ra.call(e)) {
    case "[object Error]":
    case "[object Exception]":
    case "[object DOMException]":
    case "[object WebAssembly.Exception]":
      return !0;
    default:
      return Fe(e, Error);
  }
}
function Lt(e, t) {
  return ra.call(e) === `[object ${t}]`;
}
function sa(e) {
  return Lt(e, "ErrorEvent");
}
function Ii(e) {
  return Lt(e, "DOMError");
}
function Pu(e) {
  return Lt(e, "DOMException");
}
function Ne(e) {
  return Lt(e, "String");
}
function As(e) {
  return typeof e == "object" && e !== null && "__sentry_template_string__" in e && "__sentry_template_values__" in e;
}
function Kt(e) {
  return e === null || As(e) || typeof e != "object" && typeof e != "function";
}
function Xt(e) {
  return Lt(e, "Object");
}
function dr(e) {
  return typeof Event < "u" && Fe(e, Event);
}
function Fu(e) {
  return typeof Element < "u" && Fe(e, Element);
}
function $u(e) {
  return Lt(e, "RegExp");
}
function sn(e) {
  return !!(e?.then && typeof e.then == "function");
}
function Bu(e) {
  return Xt(e) && "nativeEvent" in e && "preventDefault" in e && "stopPropagation" in e;
}
function Fe(e, t) {
  try {
    return e instanceof t;
  } catch {
    return !1;
  }
}
function ia(e) {
  return !!(typeof e == "object" && e !== null && (e.__isVue || e._isVue));
}
function oa(e) {
  return typeof Request < "u" && Fe(e, Request);
}
const Os = z, Uu = 80;
function Ee(e, t = {}) {
  if (!e)
    return "<unknown>";
  try {
    let n = e;
    const r = 5, s = [];
    let i = 0, o = 0;
    const c = " > ", a = c.length;
    let u;
    const l = Array.isArray(t) ? t : t.keyAttrs, d = !Array.isArray(t) && t.maxStringLength || Uu;
    for (; n && i++ < r && (u = Hu(n, l), !(u === "html" || i > 1 && o + s.length * a + u.length >= d)); )
      s.push(u), o += u.length, n = n.parentNode;
    return s.reverse().join(c);
  } catch {
    return "<unknown>";
  }
}
function Hu(e, t) {
  const n = e, r = [];
  if (!n?.tagName)
    return "";
  if (Os.HTMLElement && n instanceof HTMLElement && n.dataset) {
    if (n.dataset.sentryComponent)
      return n.dataset.sentryComponent;
    if (n.dataset.sentryElement)
      return n.dataset.sentryElement;
  }
  r.push(n.tagName.toLowerCase());
  const s = t?.length ? t.filter((o) => n.getAttribute(o)).map((o) => [o, n.getAttribute(o)]) : null;
  if (s?.length)
    s.forEach((o) => {
      r.push(`[${o[0]}="${o[1]}"]`);
    });
  else {
    n.id && r.push(`#${n.id}`);
    const o = n.className;
    if (o && Ne(o)) {
      const c = o.split(/\s+/);
      for (const a of c)
        r.push(`.${a}`);
    }
  }
  const i = ["aria-label", "type", "name", "title", "alt"];
  for (const o of i) {
    const c = n.getAttribute(o);
    c && r.push(`[${o}="${c}"]`);
  }
  return r.join("");
}
function Pt() {
  try {
    return Os.document.location.href;
  } catch {
    return "";
  }
}
function aa(e) {
  if (!Os.HTMLElement)
    return null;
  let t = e;
  const n = 5;
  for (let r = 0; r < n; r++) {
    if (!t)
      return null;
    if (t instanceof HTMLElement) {
      if (t.dataset.sentryComponent)
        return t.dataset.sentryComponent;
      if (t.dataset.sentryElement)
        return t.dataset.sentryElement;
    }
    t = t.parentNode;
  }
  return null;
}
function qn(e, t = 0) {
  return typeof e != "string" || t === 0 || e.length <= t ? e : `${e.slice(0, t)}...`;
}
function wi(e, t) {
  if (!Array.isArray(e))
    return "";
  const n = [];
  for (let r = 0; r < e.length; r++) {
    const s = e[r];
    try {
      ia(s) ? n.push("[VueViewModel]") : n.push(String(s));
    } catch {
      n.push("[value cannot be serialized]");
    }
  }
  return n.join(t);
}
function Pn(e, t, n = !1) {
  return Ne(e) ? $u(t) ? t.test(e) : Ne(t) ? n ? e === t : e.includes(t) : !1 : !1;
}
function De(e, t = [], n = !1) {
  return t.some((r) => Pn(e, r, n));
}
function pe(e, t, n) {
  if (!(t in e))
    return;
  const r = e[t];
  if (typeof r != "function")
    return;
  const s = n(r);
  typeof s == "function" && ca(s, r);
  try {
    e[t] = s;
  } catch {
    b && g.log(`Failed to replace method "${t}" in object`, e);
  }
}
function Se(e, t, n) {
  try {
    Object.defineProperty(e, t, {
      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
      value: n,
      writable: !0,
      configurable: !0
    });
  } catch {
    b && g.log(`Failed to add non-enumerable property "${t}" to object`, e);
  }
}
function ca(e, t) {
  try {
    const n = t.prototype || {};
    e.prototype = t.prototype = n, Se(e, "__sentry_original__", t);
  } catch {
  }
}
function Ns(e) {
  return e.__sentry_original__;
}
function ua(e) {
  if (Ms(e))
    return {
      message: e.message,
      name: e.name,
      stack: e.stack,
      ...Ri(e)
    };
  if (dr(e)) {
    const t = {
      type: e.type,
      target: ki(e.target),
      currentTarget: ki(e.currentTarget),
      ...Ri(e)
    };
    return typeof CustomEvent < "u" && Fe(e, CustomEvent) && (t.detail = e.detail), t;
  } else
    return e;
}
function ki(e) {
  try {
    return Fu(e) ? Ee(e) : Object.prototype.toString.call(e);
  } catch {
    return "<unknown>";
  }
}
function Ri(e) {
  if (typeof e == "object" && e !== null) {
    const t = {};
    for (const n in e)
      Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
    return t;
  } else
    return {};
}
function Wu(e, t = 40) {
  const n = Object.keys(ua(e));
  n.sort();
  const r = n[0];
  if (!r)
    return "[object has no keys]";
  if (r.length >= t)
    return qn(r, t);
  for (let s = n.length; s > 0; s--) {
    const i = n.slice(0, s).join(", ");
    if (!(i.length > t))
      return s === n.length ? i : qn(i, t);
  }
  return "";
}
function zu() {
  const e = z;
  return e.crypto || e.msCrypto;
}
function _e(e = zu()) {
  let t = () => Math.random() * 16;
  try {
    if (e?.randomUUID)
      return e.randomUUID().replace(/-/g, "");
    e?.getRandomValues && (t = () => {
      const n = new Uint8Array(1);
      return e.getRandomValues(n), n[0];
    });
  } catch {
  }
  return ("10000000100040008000" + 1e11).replace(
    /[018]/g,
    (n) => (
      // eslint-disable-next-line no-bitwise
      (n ^ (t() & 15) >> n / 4).toString(16)
    )
  );
}
function la(e) {
  return e.exception?.values?.[0];
}
function it(e) {
  const { message: t, event_id: n } = e;
  if (t)
    return t;
  const r = la(e);
  return r ? r.type && r.value ? `${r.type}: ${r.value}` : r.type || r.value || n || "<unknown>" : n || "<unknown>";
}
function Qr(e, t, n) {
  const r = e.exception = e.exception || {}, s = r.values = r.values || [], i = s[0] = s[0] || {};
  i.value || (i.value = t || ""), i.type || (i.type = "Error");
}
function kt(e, t) {
  const n = la(e);
  if (!n)
    return;
  const r = { type: "generic", handled: !0 }, s = n.mechanism;
  if (n.mechanism = { ...r, ...s, ...t }, t && "data" in t) {
    const i = { ...s?.data, ...t.data };
    n.mechanism.data = i;
  }
}
function Ci(e) {
  if (ju(e))
    return !0;
  try {
    Se(e, "__sentry_captured__", !0);
  } catch {
  }
  return !1;
}
function ju(e) {
  try {
    return e.__sentry_captured__;
  } catch {
  }
}
const da = 1e3;
function gt() {
  return Date.now() / da;
}
function qu() {
  const { performance: e } = z;
  if (!e?.now || !e.timeOrigin)
    return gt;
  const t = e.timeOrigin;
  return () => (t + e.now()) / da;
}
let xi;
function re() {
  return (xi ?? (xi = qu()))();
}
let Nr;
function Vu() {
  const { performance: e } = z;
  if (!e?.now)
    return [void 0, "none"];
  const t = 3600 * 1e3, n = e.now(), r = Date.now(), s = e.timeOrigin ? Math.abs(e.timeOrigin + n - r) : t, i = s < t, o = e.timing?.navigationStart, a = typeof o == "number" ? Math.abs(o + n - r) : t, u = a < t;
  return i || u ? s <= a ? [e.timeOrigin, "timeOrigin"] : [o, "navigationStart"] : [r, "dateNow"];
}
function me() {
  return Nr || (Nr = Vu()), Nr[0];
}
function Gu(e) {
  const t = re(), n = {
    sid: _e(),
    init: !0,
    timestamp: t,
    started: t,
    duration: 0,
    status: "ok",
    errors: 0,
    ignoreDuration: !1,
    toJSON: () => Ku(n)
  };
  return e && Rt(n, e), n;
}
function Rt(e, t = {}) {
  if (t.user && (!e.ipAddress && t.user.ip_address && (e.ipAddress = t.user.ip_address), !e.did && !t.did && (e.did = t.user.id || t.user.email || t.user.username)), e.timestamp = t.timestamp || re(), t.abnormal_mechanism && (e.abnormal_mechanism = t.abnormal_mechanism), t.ignoreDuration && (e.ignoreDuration = t.ignoreDuration), t.sid && (e.sid = t.sid.length === 32 ? t.sid : _e()), t.init !== void 0 && (e.init = t.init), !e.did && t.did && (e.did = `${t.did}`), typeof t.started == "number" && (e.started = t.started), e.ignoreDuration)
    e.duration = void 0;
  else if (typeof t.duration == "number")
    e.duration = t.duration;
  else {
    const n = e.timestamp - e.started;
    e.duration = n >= 0 ? n : 0;
  }
  t.release && (e.release = t.release), t.environment && (e.environment = t.environment), !e.ipAddress && t.ipAddress && (e.ipAddress = t.ipAddress), !e.userAgent && t.userAgent && (e.userAgent = t.userAgent), typeof t.errors == "number" && (e.errors = t.errors), t.status && (e.status = t.status);
}
function Yu(e, t) {
  let n = {};
  e.status === "ok" && (n = { status: "exited" }), Rt(e, n);
}
function Ku(e) {
  return {
    sid: `${e.sid}`,
    init: e.init,
    // Make sure that sec is converted to ms for date constructor
    started: new Date(e.started * 1e3).toISOString(),
    timestamp: new Date(e.timestamp * 1e3).toISOString(),
    status: e.status,
    errors: e.errors,
    did: typeof e.did == "number" || typeof e.did == "string" ? `${e.did}` : void 0,
    duration: e.duration,
    abnormal_mechanism: e.abnormal_mechanism,
    attrs: {
      release: e.release,
      environment: e.environment,
      ip_address: e.ipAddress,
      user_agent: e.userAgent
    }
  };
}
function on(e, t, n = 2) {
  if (!t || typeof t != "object" || n <= 0)
    return t;
  if (e && Object.keys(t).length === 0)
    return e;
  const r = { ...e };
  for (const s in t)
    Object.prototype.hasOwnProperty.call(t, s) && (r[s] = on(r[s], t[s], n - 1));
  return r;
}
function Ye() {
  return _e();
}
function an() {
  return _e().substring(16);
}
const Zr = "_sentrySpan";
function Ct(e, t) {
  t ? Se(e, Zr, t) : delete e[Zr];
}
function Vn(e) {
  return e[Zr];
}
const Xu = 100;
class Me {
  /** Flag if notifying is happening. */
  /** Callback for client to receive scope changes. */
  /** Callback list that will be called during event processing. */
  /** Array of breadcrumbs. */
  /** User */
  /** Tags */
  /** Extra */
  /** Contexts */
  /** Attachments */
  /** Propagation Context for distributed tracing */
  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */
  /** Fingerprint */
  /** Severity */
  /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */
  /** Session */
  /** The client on this scope */
  /** Contains the last event id of a captured event.  */
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  constructor() {
    this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = {
      traceId: Ye(),
      sampleRand: Math.random()
    };
  }
  /**
   * Clone all data from this scope into a new scope.
   */
  clone() {
    const t = new Me();
    return t._breadcrumbs = [...this._breadcrumbs], t._tags = { ...this._tags }, t._extra = { ...this._extra }, t._contexts = { ...this._contexts }, this._contexts.flags && (t._contexts.flags = {
      values: [...this._contexts.flags.values]
    }), t._user = this._user, t._level = this._level, t._session = this._session, t._transactionName = this._transactionName, t._fingerprint = this._fingerprint, t._eventProcessors = [...this._eventProcessors], t._attachments = [...this._attachments], t._sdkProcessingMetadata = { ...this._sdkProcessingMetadata }, t._propagationContext = { ...this._propagationContext }, t._client = this._client, t._lastEventId = this._lastEventId, Ct(t, Vn(this)), t;
  }
  /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */
  setClient(t) {
    this._client = t;
  }
  /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */
  setLastEventId(t) {
    this._lastEventId = t;
  }
  /**
   * Get the client assigned to this scope.
   */
  getClient() {
    return this._client;
  }
  /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */
  lastEventId() {
    return this._lastEventId;
  }
  /**
   * @inheritDoc
   */
  addScopeListener(t) {
    this._scopeListeners.push(t);
  }
  /**
   * Add an event processor that will be called before an event is sent.
   */
  addEventProcessor(t) {
    return this._eventProcessors.push(t), this;
  }
  /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */
  setUser(t) {
    return this._user = t || {
      email: void 0,
      id: void 0,
      ip_address: void 0,
      username: void 0
    }, this._session && Rt(this._session, { user: t }), this._notifyScopeListeners(), this;
  }
  /**
   * Get the user from this scope.
   */
  getUser() {
    return this._user;
  }
  /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */
  setTags(t) {
    return this._tags = {
      ...this._tags,
      ...t
    }, this._notifyScopeListeners(), this;
  }
  /**
   * Set a single tag that will be sent as tags data with the event.
   */
  setTag(t, n) {
    return this._tags = { ...this._tags, [t]: n }, this._notifyScopeListeners(), this;
  }
  /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */
  setExtras(t) {
    return this._extra = {
      ...this._extra,
      ...t
    }, this._notifyScopeListeners(), this;
  }
  /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */
  setExtra(t, n) {
    return this._extra = { ...this._extra, [t]: n }, this._notifyScopeListeners(), this;
  }
  /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */
  setFingerprint(t) {
    return this._fingerprint = t, this._notifyScopeListeners(), this;
  }
  /**
   * Sets the level on the scope for future events.
   */
  setLevel(t) {
    return this._level = t, this._notifyScopeListeners(), this;
  }
  /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */
  setTransactionName(t) {
    return this._transactionName = t, this._notifyScopeListeners(), this;
  }
  /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */
  setContext(t, n) {
    return n === null ? delete this._contexts[t] : this._contexts[t] = n, this._notifyScopeListeners(), this;
  }
  /**
   * Set the session for the scope.
   */
  setSession(t) {
    return t ? this._session = t : delete this._session, this._notifyScopeListeners(), this;
  }
  /**
   * Get the session from the scope.
   */
  getSession() {
    return this._session;
  }
  /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */
  update(t) {
    if (!t)
      return this;
    const n = typeof t == "function" ? t(this) : t, r = n instanceof Me ? n.getScopeData() : Xt(n) ? t : void 0, { tags: s, extra: i, user: o, contexts: c, level: a, fingerprint: u = [], propagationContext: l } = r || {};
    return this._tags = { ...this._tags, ...s }, this._extra = { ...this._extra, ...i }, this._contexts = { ...this._contexts, ...c }, o && Object.keys(o).length && (this._user = o), a && (this._level = a), u.length && (this._fingerprint = u), l && (this._propagationContext = l), this;
  }
  /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   */
  clear() {
    return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._session = void 0, Ct(this, void 0), this._attachments = [], this.setPropagationContext({ traceId: Ye(), sampleRand: Math.random() }), this._notifyScopeListeners(), this;
  }
  /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */
  addBreadcrumb(t, n) {
    const r = typeof n == "number" ? n : Xu;
    if (r <= 0)
      return this;
    const s = {
      timestamp: gt(),
      ...t,
      // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
      message: t.message ? qn(t.message, 2048) : t.message
    };
    return this._breadcrumbs.push(s), this._breadcrumbs.length > r && (this._breadcrumbs = this._breadcrumbs.slice(-r), this._client?.recordDroppedEvent("buffer_overflow", "log_item")), this._notifyScopeListeners(), this;
  }
  /**
   * Get the last breadcrumb of the scope.
   */
  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }
  /**
   * Clear all breadcrumbs from the scope.
   */
  clearBreadcrumbs() {
    return this._breadcrumbs = [], this._notifyScopeListeners(), this;
  }
  /**
   * Add an attachment to the scope.
   */
  addAttachment(t) {
    return this._attachments.push(t), this;
  }
  /**
   * Clear all attachments from the scope.
   */
  clearAttachments() {
    return this._attachments = [], this;
  }
  /**
   * Get the data of this scope, which should be applied to an event during processing.
   */
  getScopeData() {
    return {
      breadcrumbs: this._breadcrumbs,
      attachments: this._attachments,
      contexts: this._contexts,
      tags: this._tags,
      extra: this._extra,
      user: this._user,
      level: this._level,
      fingerprint: this._fingerprint || [],
      eventProcessors: this._eventProcessors,
      propagationContext: this._propagationContext,
      sdkProcessingMetadata: this._sdkProcessingMetadata,
      transactionName: this._transactionName,
      span: Vn(this)
    };
  }
  /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */
  setSDKProcessingMetadata(t) {
    return this._sdkProcessingMetadata = on(this._sdkProcessingMetadata, t, 2), this;
  }
  /**
   * Add propagation context to the scope, used for distributed tracing
   */
  setPropagationContext(t) {
    return this._propagationContext = t, this;
  }
  /**
   * Get propagation context from the scope, used for distributed tracing
   */
  getPropagationContext() {
    return this._propagationContext;
  }
  /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */
  captureException(t, n) {
    const r = n?.event_id || _e();
    if (!this._client)
      return b && g.warn("No client configured on scope - will not capture exception!"), r;
    const s = new Error("Sentry syntheticException");
    return this._client.captureException(
      t,
      {
        originalException: t,
        syntheticException: s,
        ...n,
        event_id: r
      },
      this
    ), r;
  }
  /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */
  captureMessage(t, n, r) {
    const s = r?.event_id || _e();
    if (!this._client)
      return b && g.warn("No client configured on scope - will not capture message!"), s;
    const i = new Error(t);
    return this._client.captureMessage(
      t,
      n,
      {
        originalException: t,
        syntheticException: i,
        ...r,
        event_id: s
      },
      this
    ), s;
  }
  /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */
  captureEvent(t, n) {
    const r = n?.event_id || _e();
    return this._client ? (this._client.captureEvent(t, { ...n, event_id: r }, this), r) : (b && g.warn("No client configured on scope - will not capture event!"), r);
  }
  /**
   * This will be called on every set call.
   */
  _notifyScopeListeners() {
    this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach((t) => {
      t(this);
    }), this._notifyingListeners = !1);
  }
}
function Ju() {
  return rn("defaultCurrentScope", () => new Me());
}
function Qu() {
  return rn("defaultIsolationScope", () => new Me());
}
class Zu {
  constructor(t, n) {
    let r;
    t ? r = t : r = new Me();
    let s;
    n ? s = n : s = new Me(), this._stack = [{ scope: r }], this._isolationScope = s;
  }
  /**
   * Fork a scope for the stack.
   */
  withScope(t) {
    const n = this._pushScope();
    let r;
    try {
      r = t(n);
    } catch (s) {
      throw this._popScope(), s;
    }
    return sn(r) ? r.then(
      (s) => (this._popScope(), s),
      (s) => {
        throw this._popScope(), s;
      }
    ) : (this._popScope(), r);
  }
  /**
   * Get the client of the stack.
   */
  getClient() {
    return this.getStackTop().client;
  }
  /**
   * Returns the scope of the top stack.
   */
  getScope() {
    return this.getStackTop().scope;
  }
  /**
   * Get the isolation scope for the stack.
   */
  getIsolationScope() {
    return this._isolationScope;
  }
  /**
   * Returns the topmost scope layer in the order domain > local > process.
   */
  getStackTop() {
    return this._stack[this._stack.length - 1];
  }
  /**
   * Push a scope to the stack.
   */
  _pushScope() {
    const t = this.getScope().clone();
    return this._stack.push({
      client: this.getClient(),
      scope: t
    }), t;
  }
  /**
   * Pop a scope from the stack.
   */
  _popScope() {
    return this._stack.length <= 1 ? !1 : !!this._stack.pop();
  }
}
function xt() {
  const e = mt(), t = lr(e);
  return t.stack = t.stack || new Zu(Ju(), Qu());
}
function el(e) {
  return xt().withScope(e);
}
function tl(e, t) {
  const n = xt();
  return n.withScope(() => (n.getStackTop().scope = e, t(e)));
}
function Mi(e) {
  return xt().withScope(() => e(xt().getIsolationScope()));
}
function nl() {
  return {
    withIsolationScope: Mi,
    withScope: el,
    withSetScope: tl,
    withSetIsolationScope: (e, t) => Mi(t),
    getCurrentScope: () => xt().getScope(),
    getIsolationScope: () => xt().getIsolationScope()
  };
}
function Ft(e) {
  const t = lr(e);
  return t.acs ? t.acs : nl();
}
function V() {
  const e = mt();
  return Ft(e).getCurrentScope();
}
function Ae() {
  const e = mt();
  return Ft(e).getIsolationScope();
}
function rl() {
  return rn("globalScope", () => new Me());
}
function fr(...e) {
  const t = mt(), n = Ft(t);
  if (e.length === 2) {
    const [r, s] = e;
    return r ? n.withSetScope(r, s) : n.withScope(s);
  }
  return n.withScope(e[0]);
}
function U() {
  return V().getClient();
}
function sl(e) {
  const t = e.getPropagationContext(), { traceId: n, parentSpanId: r, propagationSpanId: s } = t, i = {
    trace_id: n,
    span_id: s || an()
  };
  return r && (i.parent_span_id = r), i;
}
const he = "sentry.source", Ds = "sentry.sample_rate", fa = "sentry.previous_trace_sample_rate", $e = "sentry.op", ee = "sentry.origin", Gn = "sentry.idle_span_finish_reason", cn = "sentry.measurement_unit", un = "sentry.measurement_value", Ai = "sentry.custom_span_name", Ls = "sentry.profile_id", $t = "sentry.exclusive_time", il = "sentry.link.type", ol = 0, pa = 1, se = 2;
function al(e) {
  if (e < 400 && e >= 100)
    return { code: pa };
  if (e >= 400 && e < 500)
    switch (e) {
      case 401:
        return { code: se, message: "unauthenticated" };
      case 403:
        return { code: se, message: "permission_denied" };
      case 404:
        return { code: se, message: "not_found" };
      case 409:
        return { code: se, message: "already_exists" };
      case 413:
        return { code: se, message: "failed_precondition" };
      case 429:
        return { code: se, message: "resource_exhausted" };
      case 499:
        return { code: se, message: "cancelled" };
      default:
        return { code: se, message: "invalid_argument" };
    }
  if (e >= 500 && e < 600)
    switch (e) {
      case 501:
        return { code: se, message: "unimplemented" };
      case 503:
        return { code: se, message: "unavailable" };
      case 504:
        return { code: se, message: "deadline_exceeded" };
      default:
        return { code: se, message: "internal_error" };
    }
  return { code: se, message: "unknown_error" };
}
function ha(e, t) {
  e.setAttribute("http.response.status_code", t);
  const n = al(t);
  n.message !== "unknown_error" && e.setStatus(n);
}
const ma = "_sentryScope", ga = "_sentryIsolationScope";
function cl(e, t, n) {
  e && (Se(e, ga, n), Se(e, ma, t));
}
function Yn(e) {
  return {
    scope: e[ma],
    isolationScope: e[ga]
  };
}
const Ps = "sentry-", ul = /^sentry-/, ll = 8192;
function _a(e) {
  const t = fl(e);
  if (!t)
    return;
  const n = Object.entries(t).reduce((r, [s, i]) => {
    if (s.match(ul)) {
      const o = s.slice(Ps.length);
      r[o] = i;
    }
    return r;
  }, {});
  if (Object.keys(n).length > 0)
    return n;
}
function dl(e) {
  if (!e)
    return;
  const t = Object.entries(e).reduce(
    (n, [r, s]) => (s && (n[`${Ps}${r}`] = s), n),
    {}
  );
  return pl(t);
}
function fl(e) {
  if (!(!e || !Ne(e) && !Array.isArray(e)))
    return Array.isArray(e) ? e.reduce((t, n) => {
      const r = Oi(n);
      return Object.entries(r).forEach(([s, i]) => {
        t[s] = i;
      }), t;
    }, {}) : Oi(e);
}
function Oi(e) {
  return e.split(",").map(
    (t) => t.split("=").map((n) => {
      try {
        return decodeURIComponent(n.trim());
      } catch {
        return;
      }
    })
  ).reduce((t, [n, r]) => (n && r && (t[n] = r), t), {});
}
function pl(e) {
  if (Object.keys(e).length !== 0)
    return Object.entries(e).reduce((t, [n, r], s) => {
      const i = `${encodeURIComponent(n)}=${encodeURIComponent(r)}`, o = s === 0 ? i : `${t},${i}`;
      return o.length > ll ? (b && g.warn(
        `Not adding key: ${n} with val: ${r} to baggage header due to exceeding baggage size limits.`
      ), t) : o;
    }, "");
}
const hl = /^o(\d+)\./, ml = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function gl(e) {
  return e === "http" || e === "https";
}
function ln(e, t = !1) {
  const { host: n, path: r, pass: s, port: i, projectId: o, protocol: c, publicKey: a } = e;
  return `${c}://${a}${t && s ? `:${s}` : ""}@${n}${i ? `:${i}` : ""}/${r && `${r}/`}${o}`;
}
function _l(e) {
  const t = ml.exec(e);
  if (!t) {
    We(() => {
      console.error(`Invalid Sentry Dsn: ${e}`);
    });
    return;
  }
  const [n, r, s = "", i = "", o = "", c = ""] = t.slice(1);
  let a = "", u = c;
  const l = u.split("/");
  if (l.length > 1 && (a = l.slice(0, -1).join("/"), u = l.pop()), u) {
    const d = u.match(/^\d+/);
    d && (u = d[0]);
  }
  return Sa({ host: i, pass: s, path: a, projectId: u, port: o, protocol: n, publicKey: r });
}
function Sa(e) {
  return {
    protocol: e.protocol,
    publicKey: e.publicKey || "",
    pass: e.pass || "",
    host: e.host,
    port: e.port || "",
    path: e.path || "",
    projectId: e.projectId
  };
}
function Sl(e) {
  if (!b)
    return !0;
  const { port: t, projectId: n, protocol: r } = e;
  return ["protocol", "publicKey", "host", "projectId"].find((o) => e[o] ? !1 : (g.error(`Invalid Sentry Dsn: ${o} missing`), !0)) ? !1 : n.match(/^\d+$/) ? gl(r) ? t && isNaN(parseInt(t, 10)) ? (g.error(`Invalid Sentry Dsn: Invalid port ${t}`), !1) : !0 : (g.error(`Invalid Sentry Dsn: Invalid protocol ${r}`), !1) : (g.error(`Invalid Sentry Dsn: Invalid projectId ${n}`), !1);
}
function yl(e) {
  return e.match(hl)?.[1];
}
function El(e) {
  const t = e.getOptions(), { host: n } = e.getDsn() || {};
  let r;
  return t.orgId ? r = String(t.orgId) : n && (r = yl(n)), r;
}
function bl(e) {
  const t = typeof e == "string" ? _l(e) : Sa(e);
  if (!(!t || !Sl(t)))
    return t;
}
function pt(e) {
  if (typeof e == "boolean")
    return Number(e);
  const t = typeof e == "string" ? parseFloat(e) : e;
  if (!(typeof t != "number" || isNaN(t) || t < 0 || t > 1))
    return t;
}
const ya = new RegExp(
  "^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$"
  // whitespace
);
function vl(e) {
  if (!e)
    return;
  const t = e.match(ya);
  if (!t)
    return;
  let n;
  return t[3] === "1" ? n = !0 : t[3] === "0" && (n = !1), {
    traceId: t[1],
    parentSampled: n,
    parentSpanId: t[2]
  };
}
function Tl(e, t) {
  const n = vl(e), r = _a(t);
  if (!n?.traceId)
    return {
      traceId: Ye(),
      sampleRand: Math.random()
    };
  const s = Il(n, r);
  r && (r.sample_rand = s.toString());
  const { traceId: i, parentSpanId: o, parentSampled: c } = n;
  return {
    traceId: i,
    parentSpanId: o,
    sampled: c,
    dsc: r || {},
    // If we have traceparent data but no DSC it means we are not head of trace and we must freeze it
    sampleRand: s
  };
}
function Ea(e = Ye(), t = an(), n) {
  let r = "";
  return n !== void 0 && (r = n ? "-1" : "-0"), `${e}-${t}${r}`;
}
function Il(e, t) {
  const n = pt(t?.sample_rand);
  if (n !== void 0)
    return n;
  const r = pt(t?.sample_rate);
  return r && e?.parentSampled !== void 0 ? e.parentSampled ? (
    // Returns a sample rand with positive sampling decision [0, sampleRate)
    Math.random() * r
  ) : (
    // Returns a sample rand with negative sampling decision [sampleRate, 1)
    r + Math.random() * (1 - r)
  ) : Math.random();
}
const ba = 0, Fs = 1;
let Ni = !1;
function wl(e) {
  const { spanId: t, traceId: n } = e.spanContext(), { data: r, op: s, parent_span_id: i, status: o, origin: c, links: a } = B(e);
  return {
    parent_span_id: i,
    span_id: t,
    trace_id: n,
    data: r,
    op: s,
    status: o,
    origin: c,
    links: a
  };
}
function kl(e) {
  const { spanId: t, traceId: n, isRemote: r } = e.spanContext(), s = r ? t : B(e).parent_span_id, i = Yn(e).scope, o = r ? i?.getPropagationContext().propagationSpanId || an() : t;
  return {
    parent_span_id: s,
    span_id: o,
    trace_id: n
  };
}
function Rl(e) {
  const { traceId: t, spanId: n } = e.spanContext(), r = _t(e);
  return Ea(t, n, r);
}
function va(e) {
  if (e && e.length > 0)
    return e.map(({ context: { spanId: t, traceId: n, traceFlags: r, ...s }, attributes: i }) => ({
      span_id: t,
      trace_id: n,
      sampled: r === Fs,
      attributes: i,
      ...s
    }));
}
function ut(e) {
  return typeof e == "number" ? Di(e) : Array.isArray(e) ? e[0] + e[1] / 1e9 : e instanceof Date ? Di(e.getTime()) : re();
}
function Di(e) {
  return e > 9999999999 ? e / 1e3 : e;
}
function B(e) {
  if (xl(e))
    return e.getSpanJSON();
  const { spanId: t, traceId: n } = e.spanContext();
  if (Cl(e)) {
    const { attributes: r, startTime: s, name: i, endTime: o, status: c, links: a } = e, u = "parentSpanId" in e ? e.parentSpanId : "parentSpanContext" in e ? e.parentSpanContext?.spanId : void 0;
    return {
      span_id: t,
      trace_id: n,
      data: r,
      description: i,
      parent_span_id: u,
      start_timestamp: ut(s),
      // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
      timestamp: ut(o) || void 0,
      status: Ta(c),
      op: r[$e],
      origin: r[ee],
      links: va(a)
    };
  }
  return {
    span_id: t,
    trace_id: n,
    start_timestamp: 0,
    data: {}
  };
}
function Cl(e) {
  const t = e;
  return !!t.attributes && !!t.startTime && !!t.name && !!t.endTime && !!t.status;
}
function xl(e) {
  return typeof e.getSpanJSON == "function";
}
function _t(e) {
  const { traceFlags: t } = e.spanContext();
  return t === Fs;
}
function Ta(e) {
  if (!(!e || e.code === ol))
    return e.code === pa ? "ok" : e.message || "unknown_error";
}
const lt = "_sentryChildSpans", es = "_sentryRootSpan";
function Ia(e, t) {
  const n = e[es] || e;
  Se(t, es, n), e[lt] ? e[lt].add(t) : Se(e, lt, /* @__PURE__ */ new Set([t]));
}
function Ml(e, t) {
  e[lt] && e[lt].delete(t);
}
function Fn(e) {
  const t = /* @__PURE__ */ new Set();
  function n(r) {
    if (!t.has(r) && _t(r)) {
      t.add(r);
      const s = r[lt] ? Array.from(r[lt]) : [];
      for (const i of s)
        n(i);
    }
  }
  return n(e), Array.from(t);
}
function ae(e) {
  return e[es] || e;
}
function ce() {
  const e = mt(), t = Ft(e);
  return t.getActiveSpan ? t.getActiveSpan() : Vn(V());
}
function ts() {
  Ni || (We(() => {
    console.warn(
      "[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly."
    );
  }), Ni = !0);
}
let Li = !1;
function Al() {
  if (Li)
    return;
  function e() {
    const t = ce(), n = t && ae(t);
    if (n) {
      const r = "internal_error";
      b && g.log(`[Tracing] Root span: ${r} -> Global error occurred`), n.setStatus({ code: se, message: r });
    }
  }
  e.tag = "sentry_tracingErrorCallback", Li = !0, ta(e), na(e);
}
function Be(e) {
  if (typeof __SENTRY_TRACING__ == "boolean" && !__SENTRY_TRACING__)
    return !1;
  const t = e || U()?.getOptions();
  return !!t && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
  (t.tracesSampleRate != null || !!t.tracesSampler);
}
const $s = "production", wa = "_frozenDsc";
function $n(e, t) {
  Se(e, wa, t);
}
function ka(e, t) {
  const n = t.getOptions(), { publicKey: r } = t.getDsn() || {}, s = {
    environment: n.environment || $s,
    release: n.release,
    public_key: r,
    trace_id: e,
    org_id: El(t)
  };
  return t.emit("createDsc", s), s;
}
function Ra(e, t) {
  const n = t.getPropagationContext();
  return n.dsc || ka(n.traceId, e);
}
function Ue(e) {
  const t = U();
  if (!t)
    return {};
  const n = ae(e), r = B(n), s = r.data, i = n.spanContext().traceState, o = i?.get("sentry.sample_rate") ?? s[Ds] ?? s[fa];
  function c(h) {
    return (typeof o == "number" || typeof o == "string") && (h.sample_rate = `${o}`), h;
  }
  const a = n[wa];
  if (a)
    return c(a);
  const u = i?.get("sentry.dsc"), l = u && _a(u);
  if (l)
    return c(l);
  const d = ka(e.spanContext().traceId, t), f = s[he], p = r.description;
  return f !== "url" && p && (d.transaction = p), Be() && (d.sampled = String(_t(n)), d.sample_rand = // In OTEL we store the sample rand on the trace state because we cannot access scopes for NonRecordingSpans
  // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
  i?.get("sentry.sample_rand") ?? // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
  Yn(n).scope?.getPropagationContext().sampleRand.toString()), c(d), t.emit("createDsc", d, n), d;
}
class Ke {
  constructor(t = {}) {
    this._traceId = t.traceId || Ye(), this._spanId = t.spanId || an();
  }
  /** @inheritdoc */
  spanContext() {
    return {
      spanId: this._spanId,
      traceId: this._traceId,
      traceFlags: ba
    };
  }
  /** @inheritdoc */
  end(t) {
  }
  /** @inheritdoc */
  setAttribute(t, n) {
    return this;
  }
  /** @inheritdoc */
  setAttributes(t) {
    return this;
  }
  /** @inheritdoc */
  setStatus(t) {
    return this;
  }
  /** @inheritdoc */
  updateName(t) {
    return this;
  }
  /** @inheritdoc */
  isRecording() {
    return !1;
  }
  /** @inheritdoc */
  addEvent(t, n, r) {
    return this;
  }
  /** @inheritDoc */
  addLink(t) {
    return this;
  }
  /** @inheritDoc */
  addLinks(t) {
    return this;
  }
  /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */
  recordException(t, n) {
  }
}
function we(e, t = 100, n = 1 / 0) {
  try {
    return ns("", e, t, n);
  } catch (r) {
    return { ERROR: `**non-serializable** (${r})` };
  }
}
function Ca(e, t = 3, n = 100 * 1024) {
  const r = we(e, t);
  return Ll(r) > n ? Ca(e, t - 1, n) : r;
}
function ns(e, t, n = 1 / 0, r = 1 / 0, s = Pl()) {
  const [i, o] = s;
  if (t == null || // this matches null and undefined -> eqeq not eqeqeq
  ["boolean", "string"].includes(typeof t) || typeof t == "number" && Number.isFinite(t))
    return t;
  const c = Ol(e, t);
  if (!c.startsWith("[object "))
    return c;
  if (t.__sentry_skip_normalization__)
    return t;
  const a = typeof t.__sentry_override_normalization_depth__ == "number" ? t.__sentry_override_normalization_depth__ : n;
  if (a === 0)
    return c.replace("object ", "");
  if (i(t))
    return "[Circular ~]";
  const u = t;
  if (u && typeof u.toJSON == "function")
    try {
      const p = u.toJSON();
      return ns("", p, a - 1, r, s);
    } catch {
    }
  const l = Array.isArray(t) ? [] : {};
  let d = 0;
  const f = ua(t);
  for (const p in f) {
    if (!Object.prototype.hasOwnProperty.call(f, p))
      continue;
    if (d >= r) {
      l[p] = "[MaxProperties ~]";
      break;
    }
    const h = f[p];
    l[p] = ns(p, h, a - 1, r, s), d++;
  }
  return o(t), l;
}
function Ol(e, t) {
  try {
    if (e === "domain" && t && typeof t == "object" && t._events)
      return "[Domain]";
    if (e === "domainEmitter")
      return "[DomainEmitter]";
    if (typeof global < "u" && t === global)
      return "[Global]";
    if (typeof window < "u" && t === window)
      return "[Window]";
    if (typeof document < "u" && t === document)
      return "[Document]";
    if (ia(t))
      return "[VueViewModel]";
    if (Bu(t))
      return "[SyntheticEvent]";
    if (typeof t == "number" && !Number.isFinite(t))
      return `[${t}]`;
    if (typeof t == "function")
      return `[Function: ${Pe(t)}]`;
    if (typeof t == "symbol")
      return `[${String(t)}]`;
    if (typeof t == "bigint")
      return `[BigInt: ${String(t)}]`;
    const n = Nl(t);
    return /^HTML(\w*)Element$/.test(n) ? `[HTMLElement: ${n}]` : `[object ${n}]`;
  } catch (n) {
    return `**non-serializable** (${n})`;
  }
}
function Nl(e) {
  const t = Object.getPrototypeOf(e);
  return t?.constructor ? t.constructor.name : "null prototype";
}
function Dl(e) {
  return ~-encodeURI(e).split(/%..|./).length;
}
function Ll(e) {
  return Dl(JSON.stringify(e));
}
function Pl() {
  const e = /* @__PURE__ */ new WeakSet();
  function t(r) {
    return e.has(r) ? !0 : (e.add(r), !1);
  }
  function n(r) {
    e.delete(r);
  }
  return [t, n];
}
function St(e, t = []) {
  return [e, t];
}
function Fl(e, t) {
  const [n, r] = e;
  return [n, [...r, t]];
}
function Pi(e, t) {
  const n = e[1];
  for (const r of n) {
    const s = r[0].type;
    if (t(r, s))
      return !0;
  }
  return !1;
}
function rs(e) {
  const t = lr(z);
  return t.encodePolyfill ? t.encodePolyfill(e) : new TextEncoder().encode(e);
}
function $l(e) {
  const [t, n] = e;
  let r = JSON.stringify(t);
  function s(i) {
    typeof r == "string" ? r = typeof i == "string" ? r + i : [rs(r), i] : r.push(typeof i == "string" ? rs(i) : i);
  }
  for (const i of n) {
    const [o, c] = i;
    if (s(`
${JSON.stringify(o)}
`), typeof c == "string" || c instanceof Uint8Array)
      s(c);
    else {
      let a;
      try {
        a = JSON.stringify(c);
      } catch {
        a = JSON.stringify(we(c));
      }
      s(a);
    }
  }
  return typeof r == "string" ? r : Bl(r);
}
function Bl(e) {
  const t = e.reduce((s, i) => s + i.length, 0), n = new Uint8Array(t);
  let r = 0;
  for (const s of e)
    n.set(s, r), r += s.length;
  return n;
}
function Ul(e) {
  return [{
    type: "span"
  }, e];
}
function Hl(e) {
  const t = typeof e.data == "string" ? rs(e.data) : e.data;
  return [
    {
      type: "attachment",
      length: t.length,
      filename: e.filename,
      content_type: e.contentType,
      attachment_type: e.attachmentType
    },
    t
  ];
}
const Wl = {
  session: "session",
  sessions: "session",
  attachment: "attachment",
  transaction: "transaction",
  event: "error",
  client_report: "internal",
  user_report: "default",
  profile: "profile",
  profile_chunk: "profile",
  replay_event: "replay",
  replay_recording: "replay",
  check_in: "monitor",
  feedback: "feedback",
  span: "span",
  raw_security: "security",
  log: "log_item"
};
function Fi(e) {
  return Wl[e];
}
function Bs(e) {
  if (!e?.sdk)
    return;
  const { name: t, version: n } = e.sdk;
  return { name: t, version: n };
}
function xa(e, t, n, r) {
  const s = e.sdkProcessingMetadata?.dynamicSamplingContext;
  return {
    event_id: e.event_id,
    sent_at: (/* @__PURE__ */ new Date()).toISOString(),
    ...t && { sdk: t },
    ...!!n && r && { dsn: ln(r) },
    ...s && {
      trace: s
    }
  };
}
function ss(e, t) {
  if (!t?.length || !e.description)
    return !1;
  for (const n of t) {
    if (jl(n)) {
      if (Pn(e.description, n))
        return !0;
      continue;
    }
    if (!n.name && !n.op)
      continue;
    const r = n.name ? Pn(e.description, n.name) : !0, s = n.op ? e.op && Pn(e.op, n.op) : !0;
    if (r && s)
      return !0;
  }
  return !1;
}
function zl(e, t) {
  const n = t.parent_span_id, r = t.span_id;
  if (n)
    for (const s of e)
      s.parent_span_id === r && (s.parent_span_id = n);
}
function jl(e) {
  return typeof e == "string" || e instanceof RegExp;
}
function ql(e, t) {
  if (!t)
    return e;
  const n = e.sdk || {};
  return e.sdk = {
    ...n,
    name: n.name || t.name,
    version: n.version || t.version,
    integrations: [...e.sdk?.integrations || [], ...t.integrations || []],
    packages: [...e.sdk?.packages || [], ...t.packages || []],
    settings: e.sdk?.settings || t.settings ? {
      ...e.sdk?.settings,
      ...t.settings
    } : void 0
  }, e;
}
function Vl(e, t, n, r) {
  const s = Bs(n), i = {
    sent_at: (/* @__PURE__ */ new Date()).toISOString(),
    ...s && { sdk: s },
    ...!!r && t && { dsn: ln(t) }
  }, o = "aggregates" in e ? [{ type: "sessions" }, e] : [{ type: "session" }, e.toJSON()];
  return St(i, [o]);
}
function Gl(e, t, n, r) {
  const s = Bs(n), i = e.type && e.type !== "replay_event" ? e.type : "event";
  ql(e, n?.sdk);
  const o = xa(e, s, r, t);
  return delete e.sdkProcessingMetadata, St(o, [[{ type: i }, e]]);
}
function Yl(e, t) {
  function n(p) {
    return !!p.trace_id && !!p.public_key;
  }
  const r = Ue(e[0]), s = t?.getDsn(), i = t?.getOptions().tunnel, o = {
    sent_at: (/* @__PURE__ */ new Date()).toISOString(),
    ...n(r) && { trace: r },
    ...!!i && s && { dsn: ln(s) }
  }, { beforeSendSpan: c, ignoreSpans: a } = t?.getOptions() || {}, u = a?.length ? e.filter((p) => !ss(B(p), a)) : e, l = e.length - u.length;
  l && t?.recordDroppedEvent("before_send", "span", l);
  const d = c ? (p) => {
    const h = B(p), m = c(h);
    return m || (ts(), h);
  } : B, f = [];
  for (const p of u) {
    const h = d(p);
    h && f.push(Ul(h));
  }
  return St(o, f);
}
function Kl(e) {
  if (!b) return;
  const { description: t = "< unknown name >", op: n = "< unknown op >", parent_span_id: r } = B(e), { spanId: s } = e.spanContext(), i = _t(e), o = ae(e), c = o === e, a = `[Tracing] Starting ${i ? "sampled" : "unsampled"} ${c ? "root " : ""}span`, u = [`op: ${n}`, `name: ${t}`, `ID: ${s}`];
  if (r && u.push(`parent ID: ${r}`), !c) {
    const { op: l, description: d } = B(o);
    u.push(`root ID: ${o.spanContext().spanId}`), l && u.push(`root op: ${l}`), d && u.push(`root description: ${d}`);
  }
  g.log(`${a}
  ${u.join(`
  `)}`);
}
function Xl(e) {
  if (!b) return;
  const { description: t = "< unknown name >", op: n = "< unknown op >" } = B(e), { spanId: r } = e.spanContext(), i = ae(e) === e, o = `[Tracing] Finishing "${n}" ${i ? "root " : ""}span "${t}" with ID ${r}`;
  g.log(o);
}
function Jl(e, t, n, r = ce()) {
  const s = r && ae(r);
  s && (b && g.log(`[Measurement] Setting measurement on root span: ${e} = ${t} ${n}`), s.addEvent(e, {
    [un]: t,
    [cn]: n
  }));
}
function $i(e) {
  if (!e || e.length === 0)
    return;
  const t = {};
  return e.forEach((n) => {
    const r = n.attributes || {}, s = r[cn], i = r[un];
    typeof s == "string" && typeof i == "number" && (t[n.name] = { value: i, unit: s });
  }), t;
}
const Bi = 1e3;
class pr {
  /** Epoch timestamp in seconds when the span started. */
  /** Epoch timestamp in seconds when the span ended. */
  /** Internal keeper of the status */
  /** The timed events added to this span. */
  /** if true, treat span as a standalone span (not part of a transaction) */
  /**
   * You should never call the constructor manually, always use `Sentry.startSpan()`
   * or other span methods.
   * @internal
   * @hideconstructor
   * @hidden
   */
  constructor(t = {}) {
    this._traceId = t.traceId || Ye(), this._spanId = t.spanId || an(), this._startTime = t.startTimestamp || re(), this._links = t.links, this._attributes = {}, this.setAttributes({
      [ee]: "manual",
      [$e]: t.op,
      ...t.attributes
    }), this._name = t.name, t.parentSpanId && (this._parentSpanId = t.parentSpanId), "sampled" in t && (this._sampled = t.sampled), t.endTimestamp && (this._endTime = t.endTimestamp), this._events = [], this._isStandaloneSpan = t.isStandalone, this._endTime && this._onSpanEnded();
  }
  /** @inheritDoc */
  addLink(t) {
    return this._links ? this._links.push(t) : this._links = [t], this;
  }
  /** @inheritDoc */
  addLinks(t) {
    return this._links ? this._links.push(...t) : this._links = t, this;
  }
  /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */
  recordException(t, n) {
  }
  /** @inheritdoc */
  spanContext() {
    const { _spanId: t, _traceId: n, _sampled: r } = this;
    return {
      spanId: t,
      traceId: n,
      traceFlags: r ? Fs : ba
    };
  }
  /** @inheritdoc */
  setAttribute(t, n) {
    return n === void 0 ? delete this._attributes[t] : this._attributes[t] = n, this;
  }
  /** @inheritdoc */
  setAttributes(t) {
    return Object.keys(t).forEach((n) => this.setAttribute(n, t[n])), this;
  }
  /**
   * This should generally not be used,
   * but we need it for browser tracing where we want to adjust the start time afterwards.
   * USE THIS WITH CAUTION!
   *
   * @hidden
   * @internal
   */
  updateStartTime(t) {
    this._startTime = ut(t);
  }
  /**
   * @inheritDoc
   */
  setStatus(t) {
    return this._status = t, this;
  }
  /**
   * @inheritDoc
   */
  updateName(t) {
    return this._name = t, this.setAttribute(he, "custom"), this;
  }
  /** @inheritdoc */
  end(t) {
    this._endTime || (this._endTime = ut(t), Xl(this), this._onSpanEnded());
  }
  /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */
  getSpanJSON() {
    return {
      data: this._attributes,
      description: this._name,
      op: this._attributes[$e],
      parent_span_id: this._parentSpanId,
      span_id: this._spanId,
      start_timestamp: this._startTime,
      status: Ta(this._status),
      timestamp: this._endTime,
      trace_id: this._traceId,
      origin: this._attributes[ee],
      profile_id: this._attributes[Ls],
      exclusive_time: this._attributes[$t],
      measurements: $i(this._events),
      is_segment: this._isStandaloneSpan && ae(this) === this || void 0,
      segment_id: this._isStandaloneSpan ? ae(this).spanContext().spanId : void 0,
      links: va(this._links)
    };
  }
  /** @inheritdoc */
  isRecording() {
    return !this._endTime && !!this._sampled;
  }
  /**
   * @inheritdoc
   */
  addEvent(t, n, r) {
    b && g.log("[Tracing] Adding an event to span:", t);
    const s = Ui(n) ? n : r || re(), i = Ui(n) ? {} : n || {}, o = {
      name: t,
      time: ut(s),
      attributes: i
    };
    return this._events.push(o), this;
  }
  /**
   * This method should generally not be used,
   * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
   * USE THIS WITH CAUTION!
   * @internal
   * @hidden
   * @experimental
   */
  isStandaloneSpan() {
    return !!this._isStandaloneSpan;
  }
  /** Emit `spanEnd` when the span is ended. */
  _onSpanEnded() {
    const t = U();
    if (t && t.emit("spanEnd", this), !(this._isStandaloneSpan || this === ae(this)))
      return;
    if (this._isStandaloneSpan) {
      this._sampled ? Zl(Yl([this], t)) : (b && g.log("[Tracing] Discarding standalone span because its trace was not chosen to be sampled."), t && t.recordDroppedEvent("sample_rate", "span"));
      return;
    }
    const r = this._convertSpanToTransaction();
    r && (Yn(this).scope || V()).captureEvent(r);
  }
  /**
   * Finish the transaction & prepare the event to send to Sentry.
   */
  _convertSpanToTransaction() {
    if (!Hi(B(this)))
      return;
    this._name || (b && g.warn("Transaction has no name, falling back to `<unlabeled transaction>`."), this._name = "<unlabeled transaction>");
    const { scope: t, isolationScope: n } = Yn(this), r = t?.getScopeData().sdkProcessingMetadata?.normalizedRequest;
    if (this._sampled !== !0)
      return;
    const i = Fn(this).filter((l) => l !== this && !Ql(l)).map((l) => B(l)).filter(Hi), o = this._attributes[he];
    delete this._attributes[Ai], i.forEach((l) => {
      delete l.data[Ai];
    });
    const c = {
      contexts: {
        trace: wl(this)
      },
      spans: (
        // spans.sort() mutates the array, but `spans` is already a copy so we can safely do this here
        // we do not use spans anymore after this point
        i.length > Bi ? i.sort((l, d) => l.start_timestamp - d.start_timestamp).slice(0, Bi) : i
      ),
      start_timestamp: this._startTime,
      timestamp: this._endTime,
      transaction: this._name,
      type: "transaction",
      sdkProcessingMetadata: {
        capturedSpanScope: t,
        capturedSpanIsolationScope: n,
        dynamicSamplingContext: Ue(this)
      },
      request: r,
      ...o && {
        transaction_info: {
          source: o
        }
      }
    }, a = $i(this._events);
    return a && Object.keys(a).length && (b && g.log(
      "[Measurements] Adding measurements to transaction event",
      JSON.stringify(a, void 0, 2)
    ), c.measurements = a), c;
  }
}
function Ui(e) {
  return e && typeof e == "number" || e instanceof Date || Array.isArray(e);
}
function Hi(e) {
  return !!e.start_timestamp && !!e.timestamp && !!e.span_id && !!e.trace_id;
}
function Ql(e) {
  return e instanceof pr && e.isStandaloneSpan();
}
function Zl(e) {
  const t = U();
  if (!t)
    return;
  const n = e[1];
  if (!n || n.length === 0) {
    t.recordDroppedEvent("before_send", "span");
    return;
  }
  t.sendEnvelope(e);
}
function ed(e, t, n = () => {
}) {
  let r;
  try {
    r = e();
  } catch (s) {
    throw t(s), n(), s;
  }
  return td(r, t, n);
}
function td(e, t, n) {
  return sn(e) ? e.then(
    (r) => (n(), r),
    (r) => {
      throw t(r), n(), r;
    }
  ) : (n(), e);
}
function nd(e, t, n) {
  if (!Be(e))
    return [!1];
  let r, s;
  typeof e.tracesSampler == "function" ? (s = e.tracesSampler({
    ...t,
    inheritOrSampleWith: (c) => typeof t.parentSampleRate == "number" ? t.parentSampleRate : typeof t.parentSampled == "boolean" ? Number(t.parentSampled) : c
  }), r = !0) : t.parentSampled !== void 0 ? s = t.parentSampled : typeof e.tracesSampleRate < "u" && (s = e.tracesSampleRate, r = !0);
  const i = pt(s);
  if (i === void 0)
    return b && g.warn(
      `[Tracing] Discarding root span because of invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(
        s
      )} of type ${JSON.stringify(typeof s)}.`
    ), [!1];
  if (!i)
    return b && g.log(
      `[Tracing] Discarding transaction because ${typeof e.tracesSampler == "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`
    ), [!1, i, r];
  const o = n < i;
  return o || b && g.log(
    `[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(
      s
    )})`
  ), [o, i, r];
}
const Ma = "__SENTRY_SUPPRESS_TRACING__";
function rd(e, t) {
  const n = Hs();
  if (n.startSpan)
    return n.startSpan(e, t);
  const r = Oa(e), { forceTransaction: s, parentSpan: i, scope: o } = e, c = o?.clone();
  return fr(c, () => id(i)(() => {
    const u = V(), l = Na(u, i), f = e.onlyIfParent && !l ? new Ke() : Aa({
      parentSpan: l,
      spanArguments: r,
      forceTransaction: s,
      scope: u
    });
    return Ct(u, f), ed(
      () => t(f),
      () => {
        const { status: p } = B(f);
        f.isRecording() && (!p || p === "ok") && f.setStatus({ code: se, message: "internal_error" });
      },
      () => {
        f.end();
      }
    );
  }));
}
function Xe(e) {
  const t = Hs();
  if (t.startInactiveSpan)
    return t.startInactiveSpan(e);
  const n = Oa(e), { forceTransaction: r, parentSpan: s } = e;
  return (e.scope ? (o) => fr(e.scope, o) : s !== void 0 ? (o) => Us(s, o) : (o) => o())(() => {
    const o = V(), c = Na(o, s);
    return e.onlyIfParent && !c ? new Ke() : Aa({
      parentSpan: c,
      spanArguments: n,
      forceTransaction: r,
      scope: o
    });
  });
}
function Us(e, t) {
  const n = Hs();
  return n.withActiveSpan ? n.withActiveSpan(e, t) : fr((r) => (Ct(r, e || void 0), t(r)));
}
function Aa({
  parentSpan: e,
  spanArguments: t,
  forceTransaction: n,
  scope: r
}) {
  if (!Be()) {
    const o = new Ke();
    if (n || !e) {
      const c = {
        sampled: "false",
        sample_rate: "0",
        transaction: t.name,
        ...Ue(o)
      };
      $n(o, c);
    }
    return o;
  }
  const s = Ae();
  let i;
  if (e && !n)
    i = sd(e, r, t), Ia(e, i);
  else if (e) {
    const o = Ue(e), { traceId: c, spanId: a } = e.spanContext(), u = _t(e);
    i = Wi(
      {
        traceId: c,
        parentSpanId: a,
        ...t
      },
      r,
      u
    ), $n(i, o);
  } else {
    const {
      traceId: o,
      dsc: c,
      parentSpanId: a,
      sampled: u
    } = {
      ...s.getPropagationContext(),
      ...r.getPropagationContext()
    };
    i = Wi(
      {
        traceId: o,
        parentSpanId: a,
        ...t
      },
      r,
      u
    ), c && $n(i, c);
  }
  return Kl(i), cl(i, r, s), i;
}
function Oa(e) {
  const n = {
    isStandalone: (e.experimental || {}).standalone,
    ...e
  };
  if (e.startTime) {
    const r = { ...n };
    return r.startTimestamp = ut(e.startTime), delete r.startTime, r;
  }
  return n;
}
function Hs() {
  const e = mt();
  return Ft(e);
}
function Wi(e, t, n) {
  const r = U(), s = r?.getOptions() || {}, { name: i = "" } = e, o = { spanAttributes: { ...e.attributes }, spanName: i, parentSampled: n };
  r?.emit("beforeSampling", o, { decision: !1 });
  const c = o.parentSampled ?? n, a = o.spanAttributes, u = t.getPropagationContext(), [l, d, f] = t.getScopeData().sdkProcessingMetadata[Ma] ? [!1] : nd(
    s,
    {
      name: i,
      parentSampled: c,
      attributes: a,
      parentSampleRate: pt(u.dsc?.sample_rate)
    },
    u.sampleRand
  ), p = new pr({
    ...e,
    attributes: {
      [he]: "custom",
      [Ds]: d !== void 0 && f ? d : void 0,
      ...a
    },
    sampled: l
  });
  return !l && r && (b && g.log("[Tracing] Discarding root span because its trace was not chosen to be sampled."), r.recordDroppedEvent("sample_rate", "transaction")), r && r.emit("spanStart", p), p;
}
function sd(e, t, n) {
  const { spanId: r, traceId: s } = e.spanContext(), i = t.getScopeData().sdkProcessingMetadata[Ma] ? !1 : _t(e), o = i ? new pr({
    ...n,
    parentSpanId: r,
    traceId: s,
    sampled: i
  }) : new Ke({ traceId: s });
  Ia(e, o);
  const c = U();
  return c && (c.emit("spanStart", o), n.endTimestamp && c.emit("spanEnd", o)), o;
}
function Na(e, t) {
  if (t)
    return t;
  if (t === null)
    return;
  const n = Vn(e);
  if (!n)
    return;
  const r = U();
  return (r ? r.getOptions() : {}).parentSpanIsAlwaysRootSpan ? ae(n) : n;
}
function id(e) {
  return e !== void 0 ? (t) => Us(e, t) : (t) => t();
}
const Bn = {
  idleTimeout: 1e3,
  finalTimeout: 3e4,
  childSpanTimeout: 15e3
}, od = "heartbeatFailed", ad = "idleTimeout", cd = "finalTimeout", ud = "externalFinish";
function Da(e, t = {}) {
  const n = /* @__PURE__ */ new Map();
  let r = !1, s, i = ud, o = !t.disableAutoFinish;
  const c = [], {
    idleTimeout: a = Bn.idleTimeout,
    finalTimeout: u = Bn.finalTimeout,
    childSpanTimeout: l = Bn.childSpanTimeout,
    beforeSpanEnd: d
  } = t, f = U();
  if (!f || !Be()) {
    const _ = new Ke(), v = {
      sample_rate: "0",
      sampled: "false",
      ...Ue(_)
    };
    return $n(_, v), _;
  }
  const p = V(), h = ce(), m = ld(e);
  m.end = new Proxy(m.end, {
    apply(_, v, M) {
      if (d && d(m), v instanceof Ke)
        return;
      const [y, ...I] = M, $ = y || re(), A = ut($), K = Fn(m).filter((O) => O !== m);
      if (!K.length)
        return C(A), Reflect.apply(_, v, [A, ...I]);
      const J = K.map((O) => B(O).timestamp).filter((O) => !!O), L = J.length ? Math.max(...J) : void 0, T = B(m).start_timestamp, D = Math.min(
        T ? T + u / 1e3 : 1 / 0,
        Math.max(T || -1 / 0, Math.min(A, L || 1 / 0))
      );
      return C(D), Reflect.apply(_, v, [D, ...I]);
    }
  });
  function S() {
    s && (clearTimeout(s), s = void 0);
  }
  function E(_) {
    S(), s = setTimeout(() => {
      !r && n.size === 0 && o && (i = ad, m.end(_));
    }, a);
  }
  function w(_) {
    s = setTimeout(() => {
      !r && o && (i = od, m.end(_));
    }, l);
  }
  function q(_) {
    S(), n.set(_, !0);
    const v = re();
    w(v + l / 1e3);
  }
  function F(_) {
    if (n.has(_) && n.delete(_), n.size === 0) {
      const v = re();
      E(v + a / 1e3);
    }
  }
  function C(_) {
    r = !0, n.clear(), c.forEach((A) => A()), Ct(p, h);
    const v = B(m), { start_timestamp: M } = v;
    if (!M)
      return;
    v.data[Gn] || m.setAttribute(Gn, i), g.log(`[Tracing] Idle span "${v.op}" finished`);
    const I = Fn(m).filter((A) => A !== m);
    let $ = 0;
    I.forEach((A) => {
      A.isRecording() && (A.setStatus({ code: se, message: "cancelled" }), A.end(_), b && g.log("[Tracing] Cancelling span since span ended early", JSON.stringify(A, void 0, 2)));
      const K = B(A), { timestamp: J = 0, start_timestamp: L = 0 } = K, T = L <= _, D = (u + a) / 1e3, O = J - L <= D;
      if (b) {
        const X = JSON.stringify(A, void 0, 2);
        T ? O || g.log("[Tracing] Discarding span since it finished after idle span final timeout", X) : g.log("[Tracing] Discarding span since it happened after idle span was finished", X);
      }
      (!O || !T) && (Ml(m, A), $++);
    }), $ > 0 && m.setAttribute("sentry.idle_span_discarded_spans", $);
  }
  return c.push(
    f.on("spanStart", (_) => {
      if (r || _ === m || B(_).timestamp || _ instanceof pr && _.isStandaloneSpan())
        return;
      Fn(m).includes(_) && q(_.spanContext().spanId);
    })
  ), c.push(
    f.on("spanEnd", (_) => {
      r || F(_.spanContext().spanId);
    })
  ), c.push(
    f.on("idleSpanEnableAutoFinish", (_) => {
      _ === m && (o = !0, E(), n.size && w());
    })
  ), t.disableAutoFinish || E(), setTimeout(() => {
    r || (m.setStatus({ code: se, message: "deadline_exceeded" }), i = cd, m.end());
  }, u), m;
}
function ld(e) {
  const t = Xe(e);
  return Ct(V(), t), b && g.log("[Tracing] Started span is an idle span"), t;
}
const Dr = 0, zi = 1, ji = 2;
function He(e) {
  return new Je((t) => {
    t(e);
  });
}
function Kn(e) {
  return new Je((t, n) => {
    n(e);
  });
}
class Je {
  constructor(t) {
    this._state = Dr, this._handlers = [], this._runExecutor(t);
  }
  /** @inheritdoc */
  then(t, n) {
    return new Je((r, s) => {
      this._handlers.push([
        !1,
        (i) => {
          if (!t)
            r(i);
          else
            try {
              r(t(i));
            } catch (o) {
              s(o);
            }
        },
        (i) => {
          if (!n)
            s(i);
          else
            try {
              r(n(i));
            } catch (o) {
              s(o);
            }
        }
      ]), this._executeHandlers();
    });
  }
  /** @inheritdoc */
  catch(t) {
    return this.then((n) => n, t);
  }
  /** @inheritdoc */
  finally(t) {
    return new Je((n, r) => {
      let s, i;
      return this.then(
        (o) => {
          i = !1, s = o, t && t();
        },
        (o) => {
          i = !0, s = o, t && t();
        }
      ).then(() => {
        if (i) {
          r(s);
          return;
        }
        n(s);
      });
    });
  }
  /** Excute the resolve/reject handlers. */
  _executeHandlers() {
    if (this._state === Dr)
      return;
    const t = this._handlers.slice();
    this._handlers = [], t.forEach((n) => {
      n[0] || (this._state === zi && n[1](this._value), this._state === ji && n[2](this._value), n[0] = !0);
    });
  }
  /** Run the executor for the SyncPromise. */
  _runExecutor(t) {
    const n = (i, o) => {
      if (this._state === Dr) {
        if (sn(o)) {
          o.then(r, s);
          return;
        }
        this._state = i, this._value = o, this._executeHandlers();
      }
    }, r = (i) => {
      n(zi, i);
    }, s = (i) => {
      n(ji, i);
    };
    try {
      t(r, s);
    } catch (i) {
      s(i);
    }
  }
}
function is(e, t, n, r = 0) {
  return new Je((s, i) => {
    const o = e[r];
    if (t === null || typeof o != "function")
      s(t);
    else {
      const c = o({ ...t }, n);
      b && o.id && c === null && g.log(`Event processor "${o.id}" dropped event`), sn(c) ? c.then((a) => is(e, a, n, r + 1).then(s)).then(null, i) : is(e, c, n, r + 1).then(s).then(null, i);
    }
  });
}
function dd(e, t) {
  const { fingerprint: n, span: r, breadcrumbs: s, sdkProcessingMetadata: i } = t;
  fd(e, t), r && md(e, r), gd(e, n), pd(e, s), hd(e, i);
}
function qi(e, t) {
  const {
    extra: n,
    tags: r,
    user: s,
    contexts: i,
    level: o,
    sdkProcessingMetadata: c,
    breadcrumbs: a,
    fingerprint: u,
    eventProcessors: l,
    attachments: d,
    propagationContext: f,
    transactionName: p,
    span: h
  } = t;
  vn(e, "extra", n), vn(e, "tags", r), vn(e, "user", s), vn(e, "contexts", i), e.sdkProcessingMetadata = on(e.sdkProcessingMetadata, c, 2), o && (e.level = o), p && (e.transactionName = p), h && (e.span = h), a.length && (e.breadcrumbs = [...e.breadcrumbs, ...a]), u.length && (e.fingerprint = [...e.fingerprint, ...u]), l.length && (e.eventProcessors = [...e.eventProcessors, ...l]), d.length && (e.attachments = [...e.attachments, ...d]), e.propagationContext = { ...e.propagationContext, ...f };
}
function vn(e, t, n) {
  e[t] = on(e[t], n, 1);
}
function fd(e, t) {
  const { extra: n, tags: r, user: s, contexts: i, level: o, transactionName: c } = t;
  Object.keys(n).length && (e.extra = { ...n, ...e.extra }), Object.keys(r).length && (e.tags = { ...r, ...e.tags }), Object.keys(s).length && (e.user = { ...s, ...e.user }), Object.keys(i).length && (e.contexts = { ...i, ...e.contexts }), o && (e.level = o), c && e.type !== "transaction" && (e.transaction = c);
}
function pd(e, t) {
  const n = [...e.breadcrumbs || [], ...t];
  e.breadcrumbs = n.length ? n : void 0;
}
function hd(e, t) {
  e.sdkProcessingMetadata = {
    ...e.sdkProcessingMetadata,
    ...t
  };
}
function md(e, t) {
  e.contexts = {
    trace: kl(t),
    ...e.contexts
  }, e.sdkProcessingMetadata = {
    dynamicSamplingContext: Ue(t),
    ...e.sdkProcessingMetadata
  };
  const n = ae(t), r = B(n).description;
  r && !e.transaction && e.type === "transaction" && (e.transaction = r);
}
function gd(e, t) {
  e.fingerprint = e.fingerprint ? Array.isArray(e.fingerprint) ? e.fingerprint : [e.fingerprint] : [], t && (e.fingerprint = e.fingerprint.concat(t)), e.fingerprint.length || delete e.fingerprint;
}
let Tn, Vi, In;
function _d(e) {
  const t = z._sentryDebugIds;
  if (!t)
    return {};
  const n = Object.keys(t);
  return In && n.length === Vi || (Vi = n.length, In = n.reduce((r, s) => {
    Tn || (Tn = {});
    const i = Tn[s];
    if (i)
      r[i[0]] = i[1];
    else {
      const o = e(s);
      for (let c = o.length - 1; c >= 0; c--) {
        const u = o[c]?.filename, l = t[s];
        if (u && l) {
          r[u] = l, Tn[s] = [u, l];
          break;
        }
      }
    }
    return r;
  }, {})), In;
}
function La(e, t, n, r, s, i) {
  const { normalizeDepth: o = 3, normalizeMaxBreadth: c = 1e3 } = e, a = {
    ...t,
    event_id: t.event_id || n.event_id || _e(),
    timestamp: t.timestamp || gt()
  }, u = n.integrations || e.integrations.map((S) => S.name);
  Sd(a, e), bd(a, u), s && s.emit("applyFrameMetadata", t), t.type === void 0 && yd(a, e.stackParser);
  const l = Td(r, n.captureContext);
  n.mechanism && kt(a, n.mechanism);
  const d = s ? s.getEventProcessors() : [], f = rl().getScopeData();
  if (i) {
    const S = i.getScopeData();
    qi(f, S);
  }
  if (l) {
    const S = l.getScopeData();
    qi(f, S);
  }
  const p = [...n.attachments || [], ...f.attachments];
  p.length && (n.attachments = p), dd(a, f);
  const h = [
    ...d,
    // Run scope event processors _after_ all other processors
    ...f.eventProcessors
  ];
  return is(h, a, n).then((S) => (S && Ed(S), typeof o == "number" && o > 0 ? vd(S, o, c) : S));
}
function Sd(e, t) {
  const { environment: n, release: r, dist: s, maxValueLength: i = 250 } = t;
  e.environment = e.environment || n || $s, !e.release && r && (e.release = r), !e.dist && s && (e.dist = s);
  const o = e.request;
  o?.url && (o.url = qn(o.url, i));
}
function yd(e, t) {
  const n = _d(t);
  e.exception?.values?.forEach((r) => {
    r.stacktrace?.frames?.forEach((s) => {
      s.filename && (s.debug_id = n[s.filename]);
    });
  });
}
function Ed(e) {
  const t = {};
  if (e.exception?.values?.forEach((r) => {
    r.stacktrace?.frames?.forEach((s) => {
      s.debug_id && (s.abs_path ? t[s.abs_path] = s.debug_id : s.filename && (t[s.filename] = s.debug_id), delete s.debug_id);
    });
  }), Object.keys(t).length === 0)
    return;
  e.debug_meta = e.debug_meta || {}, e.debug_meta.images = e.debug_meta.images || [];
  const n = e.debug_meta.images;
  Object.entries(t).forEach(([r, s]) => {
    n.push({
      type: "sourcemap",
      code_file: r,
      debug_id: s
    });
  });
}
function bd(e, t) {
  t.length > 0 && (e.sdk = e.sdk || {}, e.sdk.integrations = [...e.sdk.integrations || [], ...t]);
}
function vd(e, t, n) {
  if (!e)
    return null;
  const r = {
    ...e,
    ...e.breadcrumbs && {
      breadcrumbs: e.breadcrumbs.map((s) => ({
        ...s,
        ...s.data && {
          data: we(s.data, t, n)
        }
      }))
    },
    ...e.user && {
      user: we(e.user, t, n)
    },
    ...e.contexts && {
      contexts: we(e.contexts, t, n)
    },
    ...e.extra && {
      extra: we(e.extra, t, n)
    }
  };
  return e.contexts?.trace && r.contexts && (r.contexts.trace = e.contexts.trace, e.contexts.trace.data && (r.contexts.trace.data = we(e.contexts.trace.data, t, n))), e.spans && (r.spans = e.spans.map((s) => ({
    ...s,
    ...s.data && {
      data: we(s.data, t, n)
    }
  }))), e.contexts?.flags && r.contexts && (r.contexts.flags = we(e.contexts.flags, 3, n)), r;
}
function Td(e, t) {
  if (!t)
    return e;
  const n = e ? e.clone() : new Me();
  return n.update(t), n;
}
function Id(e) {
  if (e)
    return wd(e) ? { captureContext: e } : Rd(e) ? {
      captureContext: e
    } : e;
}
function wd(e) {
  return e instanceof Me || typeof e == "function";
}
const kd = [
  "user",
  "level",
  "extra",
  "contexts",
  "tags",
  "fingerprint",
  "propagationContext"
];
function Rd(e) {
  return Object.keys(e).some((t) => kd.includes(t));
}
function dn(e, t) {
  return V().captureException(e, Id(t));
}
function Pa(e, t) {
  return V().captureEvent(e, t);
}
function Cd(e, t) {
  Ae().setContext(e, t);
}
function xd() {
  const e = U();
  return e?.getOptions().enabled !== !1 && !!e?.getTransport();
}
function Md(e) {
  Ae().addEventProcessor(e);
}
function Gi(e) {
  const t = Ae(), n = V(), { userAgent: r } = z.navigator || {}, s = Gu({
    user: n.getUser() || t.getUser(),
    ...r && { userAgent: r },
    ...e
  }), i = t.getSession();
  return i?.status === "ok" && Rt(i, { status: "exited" }), Fa(), t.setSession(s), s;
}
function Fa() {
  const e = Ae(), n = V().getSession() || e.getSession();
  n && Yu(n), $a(), e.setSession();
}
function $a() {
  const e = Ae(), t = U(), n = e.getSession();
  n && t && t.captureSession(n);
}
function Yi(e = !1) {
  if (e) {
    Fa();
    return;
  }
  $a();
}
const Ad = "7";
function Od(e) {
  const t = e.protocol ? `${e.protocol}:` : "", n = e.port ? `:${e.port}` : "";
  return `${t}//${e.host}${n}${e.path ? `/${e.path}` : ""}/api/`;
}
function Nd(e) {
  return `${Od(e)}${e.projectId}/envelope/`;
}
function Dd(e, t) {
  const n = {
    sentry_version: Ad
  };
  return e.publicKey && (n.sentry_key = e.publicKey), t && (n.sentry_client = `${t.name}/${t.version}`), new URLSearchParams(n).toString();
}
function Ld(e, t, n) {
  return t || `${Nd(e)}?${Dd(e, n)}`;
}
const Ki = [];
function Pd(e) {
  const t = {};
  return e.forEach((n) => {
    const { name: r } = n, s = t[r];
    s && !s.isDefaultInstance && n.isDefaultInstance || (t[r] = n);
  }), Object.values(t);
}
function Fd(e) {
  const t = e.defaultIntegrations || [], n = e.integrations;
  t.forEach((s) => {
    s.isDefaultInstance = !0;
  });
  let r;
  if (Array.isArray(n))
    r = [...t, ...n];
  else if (typeof n == "function") {
    const s = n(t);
    r = Array.isArray(s) ? s : [s];
  } else
    r = t;
  return Pd(r);
}
function $d(e, t) {
  const n = {};
  return t.forEach((r) => {
    r && Ba(e, r, n);
  }), n;
}
function Xi(e, t) {
  for (const n of t)
    n?.afterAllSetup && n.afterAllSetup(e);
}
function Ba(e, t, n) {
  if (n[t.name]) {
    b && g.log(`Integration skipped because it was already installed: ${t.name}`);
    return;
  }
  if (n[t.name] = t, Ki.indexOf(t.name) === -1 && typeof t.setupOnce == "function" && (t.setupOnce(), Ki.push(t.name)), t.setup && typeof t.setup == "function" && t.setup(e), typeof t.preprocessEvent == "function") {
    const r = t.preprocessEvent.bind(t);
    e.on("preprocessEvent", (s, i) => r(s, i, e));
  }
  if (typeof t.processEvent == "function") {
    const r = t.processEvent.bind(t), s = Object.assign((i, o) => r(i, o, e), {
      id: t.name
    });
    e.addEventProcessor(s);
  }
  b && g.log(`Integration installed: ${t.name}`);
}
function Bd(e, t, n) {
  const r = [
    { type: "client_report" },
    {
      timestamp: gt(),
      discarded_events: e
    }
  ];
  return St(t ? { dsn: t } : {}, [r]);
}
function Ua(e) {
  const t = [];
  e.message && t.push(e.message);
  try {
    const n = e.exception.values[e.exception.values.length - 1];
    n?.value && (t.push(n.value), n.type && t.push(`${n.type}: ${n.value}`));
  } catch {
  }
  return t;
}
function Ud(e) {
  const { trace_id: t, parent_span_id: n, span_id: r, status: s, origin: i, data: o, op: c } = e.contexts?.trace ?? {};
  return {
    data: o ?? {},
    description: e.transaction,
    op: c,
    parent_span_id: n,
    span_id: r ?? "",
    start_timestamp: e.start_timestamp ?? 0,
    status: s,
    timestamp: e.timestamp,
    trace_id: t ?? "",
    origin: i,
    profile_id: o?.[Ls],
    exclusive_time: o?.[$t],
    measurements: e.measurements,
    is_segment: !0
  };
}
function Hd(e) {
  return {
    type: "transaction",
    timestamp: e.timestamp,
    start_timestamp: e.start_timestamp,
    transaction: e.description,
    contexts: {
      trace: {
        trace_id: e.trace_id,
        span_id: e.span_id,
        parent_span_id: e.parent_span_id,
        op: e.op,
        status: e.status,
        origin: e.origin,
        data: {
          ...e.data,
          ...e.profile_id && { [Ls]: e.profile_id },
          ...e.exclusive_time && { [$t]: e.exclusive_time }
        }
      }
    },
    measurements: e.measurements
  };
}
const Ji = "Not capturing exception because it's already been captured.", Qi = "Discarded session because of missing or non-string release", Ha = Symbol.for("SentryInternalError"), Wa = Symbol.for("SentryDoNotSendEventError");
function Un(e) {
  return {
    message: e,
    [Ha]: !0
  };
}
function Lr(e) {
  return {
    message: e,
    [Wa]: !0
  };
}
function Zi(e) {
  return !!e && typeof e == "object" && Ha in e;
}
function eo(e) {
  return !!e && typeof e == "object" && Wa in e;
}
class Wd {
  /** Options passed to the SDK. */
  /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */
  /** Array of set up integrations. */
  /** Number of calls being processed */
  /** Holds flushable  */
  // eslint-disable-next-line @typescript-eslint/ban-types
  /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */
  constructor(t) {
    if (this._options = t, this._integrations = {}, this._numProcessing = 0, this._outcomes = {}, this._hooks = {}, this._eventProcessors = [], t.dsn ? this._dsn = bl(t.dsn) : b && g.warn("No DSN provided, client will not send events."), this._dsn) {
      const n = Ld(
        this._dsn,
        t.tunnel,
        t._metadata ? t._metadata.sdk : void 0
      );
      this._transport = t.transport({
        tunnel: this._options.tunnel,
        recordDroppedEvent: this.recordDroppedEvent.bind(this),
        ...t.transportOptions,
        url: n
      });
    }
  }
  /**
   * Captures an exception event and sends it to Sentry.
   *
   * Unlike `captureException` exported from every SDK, this method requires that you pass it the current scope.
   */
  captureException(t, n, r) {
    const s = _e();
    if (Ci(t))
      return b && g.log(Ji), s;
    const i = {
      event_id: s,
      ...n
    };
    return this._process(
      this.eventFromException(t, i).then(
        (o) => this._captureEvent(o, i, r)
      )
    ), i.event_id;
  }
  /**
   * Captures a message event and sends it to Sentry.
   *
   * Unlike `captureMessage` exported from every SDK, this method requires that you pass it the current scope.
   */
  captureMessage(t, n, r, s) {
    const i = {
      event_id: _e(),
      ...r
    }, o = As(t) ? t : String(t), c = Kt(t) ? this.eventFromMessage(o, n, i) : this.eventFromException(t, i);
    return this._process(c.then((a) => this._captureEvent(a, i, s))), i.event_id;
  }
  /**
   * Captures a manually created event and sends it to Sentry.
   *
   * Unlike `captureEvent` exported from every SDK, this method requires that you pass it the current scope.
   */
  captureEvent(t, n, r) {
    const s = _e();
    if (n?.originalException && Ci(n.originalException))
      return b && g.log(Ji), s;
    const i = {
      event_id: s,
      ...n
    }, o = t.sdkProcessingMetadata || {}, c = o.capturedSpanScope, a = o.capturedSpanIsolationScope;
    return this._process(
      this._captureEvent(t, i, c || r, a)
    ), i.event_id;
  }
  /**
   * Captures a session.
   */
  captureSession(t) {
    this.sendSession(t), Rt(t, { init: !1 });
  }
  /**
   * Create a cron monitor check in and send it to Sentry. This method is not available on all clients.
   *
   * @param checkIn An object that describes a check in.
   * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
   * to create a monitor automatically when sending a check in.
   * @param scope An optional scope containing event metadata.
   * @returns A string representing the id of the check in.
   */
  /**
   * Get the current Dsn.
   */
  getDsn() {
    return this._dsn;
  }
  /**
   * Get the current options.
   */
  getOptions() {
    return this._options;
  }
  /**
   * Get the SDK metadata.
   * @see SdkMetadata
   */
  getSdkMetadata() {
    return this._options._metadata;
  }
  /**
   * Returns the transport that is used by the client.
   * Please note that the transport gets lazy initialized so it will only be there once the first event has been sent.
   */
  getTransport() {
    return this._transport;
  }
  /**
   * Wait for all events to be sent or the timeout to expire, whichever comes first.
   *
   * @param timeout Maximum time in ms the client should wait for events to be flushed. Omitting this parameter will
   *   cause the client to wait until all events are sent before resolving the promise.
   * @returns A promise that will resolve with `true` if all events are sent before the timeout, or `false` if there are
   * still events in the queue when the timeout is reached.
   */
  flush(t) {
    const n = this._transport;
    return n ? (this.emit("flush"), this._isClientDoneProcessing(t).then((r) => n.flush(t).then((s) => r && s))) : He(!0);
  }
  /**
   * Flush the event queue and set the client to `enabled = false`. See {@link Client.flush}.
   *
   * @param {number} timeout Maximum time in ms the client should wait before shutting down. Omitting this parameter will cause
   *   the client to wait until all events are sent before disabling itself.
   * @returns {Promise<boolean>} A promise which resolves to `true` if the flush completes successfully before the timeout, or `false` if
   * it doesn't.
   */
  close(t) {
    return this.flush(t).then((n) => (this.getOptions().enabled = !1, this.emit("close"), n));
  }
  /**
   * Get all installed event processors.
   */
  getEventProcessors() {
    return this._eventProcessors;
  }
  /**
   * Adds an event processor that applies to any event processed by this client.
   */
  addEventProcessor(t) {
    this._eventProcessors.push(t);
  }
  /**
   * Initialize this client.
   * Call this after the client was set on a scope.
   */
  init() {
    (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
    // Spotlight enabled. This is particularly important for browser as we
    // don't support the `spotlight` option there and rely on the users
    // adding the `spotlightBrowserIntegration()` to their integrations which
    // wouldn't get initialized with the check below when there's no DSN set.
    this._options.integrations.some(({ name: t }) => t.startsWith("Spotlight"))) && this._setupIntegrations();
  }
  /**
   * Gets an installed integration by its name.
   *
   * @returns {Integration|undefined} The installed integration or `undefined` if no integration with that `name` was installed.
   */
  getIntegrationByName(t) {
    return this._integrations[t];
  }
  /**
   * Add an integration to the client.
   * This can be used to e.g. lazy load integrations.
   * In most cases, this should not be necessary,
   * and you're better off just passing the integrations via `integrations: []` at initialization time.
   * However, if you find the need to conditionally load & add an integration, you can use `addIntegration` to do so.
   */
  addIntegration(t) {
    const n = this._integrations[t.name];
    Ba(this, t, this._integrations), n || Xi(this, [t]);
  }
  /**
   * Send a fully prepared event to Sentry.
   */
  sendEvent(t, n = {}) {
    this.emit("beforeSendEvent", t, n);
    let r = Gl(t, this._dsn, this._options._metadata, this._options.tunnel);
    for (const i of n.attachments || [])
      r = Fl(r, Hl(i));
    const s = this.sendEnvelope(r);
    s && s.then((i) => this.emit("afterSendEvent", t, i), null);
  }
  /**
   * Send a session or session aggregrates to Sentry.
   */
  sendSession(t) {
    const { release: n, environment: r = $s } = this._options;
    if ("aggregates" in t) {
      const i = t.attrs || {};
      if (!i.release && !n) {
        b && g.warn(Qi);
        return;
      }
      i.release = i.release || n, i.environment = i.environment || r, t.attrs = i;
    } else {
      if (!t.release && !n) {
        b && g.warn(Qi);
        return;
      }
      t.release = t.release || n, t.environment = t.environment || r;
    }
    this.emit("beforeSendSession", t);
    const s = Vl(t, this._dsn, this._options._metadata, this._options.tunnel);
    this.sendEnvelope(s);
  }
  /**
   * Record on the client that an event got dropped (ie, an event that will not be sent to Sentry).
   */
  recordDroppedEvent(t, n, r = 1) {
    if (this._options.sendClientReports) {
      const s = `${t}:${n}`;
      b && g.log(`Recording outcome: "${s}"${r > 1 ? ` (${r} times)` : ""}`), this._outcomes[s] = (this._outcomes[s] || 0) + r;
    }
  }
  /* eslint-disable @typescript-eslint/unified-signatures */
  /**
   * Register a callback for whenever a span is started.
   * Receives the span as argument.
   * @returns {() => void} A function that, when executed, removes the registered callback.
   */
  /**
   * Register a hook on this client.
   */
  on(t, n) {
    const r = this._hooks[t] = this._hooks[t] || [];
    return r.push(n), () => {
      const s = r.indexOf(n);
      s > -1 && r.splice(s, 1);
    };
  }
  /** Fire a hook whenever a span starts. */
  /**
   * Emit a hook that was previously registered via `on()`.
   */
  emit(t, ...n) {
    const r = this._hooks[t];
    r && r.forEach((s) => s(...n));
  }
  /**
   * Send an envelope to Sentry.
   */
  sendEnvelope(t) {
    return this.emit("beforeEnvelope", t), this._isEnabled() && this._transport ? this._transport.send(t).then(null, (n) => (b && g.error("Error while sending envelope:", n), n)) : (b && g.error("Transport disabled"), He({}));
  }
  /* eslint-enable @typescript-eslint/unified-signatures */
  /** Setup integrations for this client. */
  _setupIntegrations() {
    const { integrations: t } = this._options;
    this._integrations = $d(this, t), Xi(this, t);
  }
  /** Updates existing session based on the provided event */
  _updateSessionFromEvent(t, n) {
    let r = n.level === "fatal", s = !1;
    const i = n.exception?.values;
    if (i) {
      s = !0;
      for (const a of i)
        if (a.mechanism?.handled === !1) {
          r = !0;
          break;
        }
    }
    const o = t.status === "ok";
    (o && t.errors === 0 || o && r) && (Rt(t, {
      ...r && { status: "crashed" },
      errors: t.errors || Number(s || r)
    }), this.captureSession(t));
  }
  /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */
  _isClientDoneProcessing(t) {
    return new Je((n) => {
      let r = 0;
      const s = 1, i = setInterval(() => {
        this._numProcessing == 0 ? (clearInterval(i), n(!0)) : (r += s, t && r >= t && (clearInterval(i), n(!1)));
      }, s);
    });
  }
  /** Determines whether this SDK is enabled and a transport is present. */
  _isEnabled() {
    return this.getOptions().enabled !== !1 && this._transport !== void 0;
  }
  /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */
  _prepareEvent(t, n, r, s) {
    const i = this.getOptions(), o = Object.keys(this._integrations);
    return !n.integrations && o?.length && (n.integrations = o), this.emit("preprocessEvent", t, n), t.type || s.setLastEventId(t.event_id || n.event_id), La(i, t, n, r, this, s).then((c) => {
      if (c === null)
        return c;
      this.emit("postprocessEvent", c, n), c.contexts = {
        trace: sl(r),
        ...c.contexts
      };
      const a = Ra(this, r);
      return c.sdkProcessingMetadata = {
        dynamicSamplingContext: a,
        ...c.sdkProcessingMetadata
      }, c;
    });
  }
  /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */
  _captureEvent(t, n = {}, r = V(), s = Ae()) {
    return b && os(t) && g.log(`Captured error event \`${Ua(t)[0] || "<unknown>"}\``), this._processEvent(t, n, r, s).then(
      (i) => i.event_id,
      (i) => {
        b && (eo(i) ? g.log(i.message) : Zi(i) ? g.warn(i.message) : g.warn(i));
      }
    );
  }
  /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */
  _processEvent(t, n, r, s) {
    const i = this.getOptions(), { sampleRate: o } = i, c = za(t), a = os(t), u = t.type || "error", l = `before send for type \`${u}\``, d = typeof o > "u" ? void 0 : pt(o);
    if (a && typeof d == "number" && Math.random() > d)
      return this.recordDroppedEvent("sample_rate", "error"), Kn(
        Lr(
          `Discarding event because it's not included in the random sample (sampling rate = ${o})`
        )
      );
    const f = u === "replay_event" ? "replay" : u;
    return this._prepareEvent(t, n, r, s).then((p) => {
      if (p === null)
        throw this.recordDroppedEvent("event_processor", f), Lr("An event processor returned `null`, will not send event.");
      if (n.data && n.data.__sentry__ === !0)
        return p;
      const m = jd(this, i, p, n);
      return zd(m, l);
    }).then((p) => {
      if (p === null) {
        if (this.recordDroppedEvent("before_send", f), c) {
          const E = 1 + (t.spans || []).length;
          this.recordDroppedEvent("before_send", "span", E);
        }
        throw Lr(`${l} returned \`null\`, will not send event.`);
      }
      const h = r.getSession() || s.getSession();
      if (a && h && this._updateSessionFromEvent(h, p), c) {
        const S = p.sdkProcessingMetadata?.spanCountBeforeProcessing || 0, E = p.spans ? p.spans.length : 0, w = S - E;
        w > 0 && this.recordDroppedEvent("before_send", "span", w);
      }
      const m = p.transaction_info;
      if (c && m && p.transaction !== t.transaction) {
        const S = "custom";
        p.transaction_info = {
          ...m,
          source: S
        };
      }
      return this.sendEvent(p, n), p;
    }).then(null, (p) => {
      throw eo(p) || Zi(p) ? p : (this.captureException(p, {
        mechanism: {
          handled: !1,
          type: "internal"
        },
        data: {
          __sentry__: !0
        },
        originalException: p
      }), Un(
        `Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.
Reason: ${p}`
      ));
    });
  }
  /**
   * Occupies the client with processing and event
   */
  _process(t) {
    this._numProcessing++, t.then(
      (n) => (this._numProcessing--, n),
      (n) => (this._numProcessing--, n)
    );
  }
  /**
   * Clears outcomes on this client and returns them.
   */
  _clearOutcomes() {
    const t = this._outcomes;
    return this._outcomes = {}, Object.entries(t).map(([n, r]) => {
      const [s, i] = n.split(":");
      return {
        reason: s,
        category: i,
        quantity: r
      };
    });
  }
  /**
   * Sends client reports as an envelope.
   */
  _flushOutcomes() {
    b && g.log("Flushing outcomes...");
    const t = this._clearOutcomes();
    if (t.length === 0) {
      b && g.log("No outcomes to send");
      return;
    }
    if (!this._dsn) {
      b && g.log("No dsn provided, will not send outcomes");
      return;
    }
    b && g.log("Sending outcomes:", t);
    const n = Bd(t, this._options.tunnel && ln(this._dsn));
    this.sendEnvelope(n);
  }
  /**
   * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
   */
}
function zd(e, t) {
  const n = `${t} must return \`null\` or a valid event.`;
  if (sn(e))
    return e.then(
      (r) => {
        if (!Xt(r) && r !== null)
          throw Un(n);
        return r;
      },
      (r) => {
        throw Un(`${t} rejected with ${r}`);
      }
    );
  if (!Xt(e) && e !== null)
    throw Un(n);
  return e;
}
function jd(e, t, n, r) {
  const { beforeSend: s, beforeSendTransaction: i, beforeSendSpan: o, ignoreSpans: c } = t;
  let a = n;
  if (os(a) && s)
    return s(a, r);
  if (za(a)) {
    if (o || c) {
      const u = Ud(a);
      if (c?.length && ss(u, c))
        return null;
      if (o) {
        const l = o(u);
        l ? a = on(n, Hd(l)) : ts();
      }
      if (a.spans) {
        const l = [], d = a.spans;
        for (const p of d) {
          if (c?.length && ss(p, c)) {
            zl(d, p);
            continue;
          }
          if (o) {
            const h = o(p);
            h ? l.push(h) : (ts(), l.push(p));
          } else
            l.push(p);
        }
        const f = a.spans.length - l.length;
        f && e.recordDroppedEvent("before_send", "span", f), a.spans = l;
      }
    }
    if (i) {
      if (a.spans) {
        const u = a.spans.length;
        a.sdkProcessingMetadata = {
          ...n.sdkProcessingMetadata,
          spanCountBeforeProcessing: u
        };
      }
      return i(a, r);
    }
  }
  return a;
}
function os(e) {
  return e.type === void 0;
}
function za(e) {
  return e.type === "transaction";
}
function qd(e) {
  return [
    {
      type: "log",
      item_count: e.length,
      content_type: "application/vnd.sentry.items.log+json"
    },
    {
      items: e
    }
  ];
}
function Vd(e, t, n, r) {
  const s = {};
  return t?.sdk && (s.sdk = {
    name: t.sdk.name,
    version: t.sdk.version
  }), n && r && (s.dsn = ln(r)), St(s, [qd(e)]);
}
function Pr(e, t) {
  const n = Gd(e) ?? [];
  if (n.length === 0)
    return;
  const r = e.getOptions(), s = Vd(n, r._metadata, r.tunnel, e.getDsn());
  ja().set(e, []), e.emit("flushLogs"), e.sendEnvelope(s);
}
function Gd(e) {
  return ja().get(e);
}
function ja() {
  return rn("clientToLogBufferMap", () => /* @__PURE__ */ new WeakMap());
}
function Yd(e, t) {
  t.debug === !0 && (b ? g.enable() : We(() => {
    console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
  })), V().update(t.initialScope);
  const r = new e(t);
  return Kd(r), r.init(), r;
}
function Kd(e) {
  V().setClient(e);
}
const qa = Symbol.for("SentryBufferFullError");
function Xd(e) {
  const t = [];
  function n() {
    return e === void 0 || t.length < e;
  }
  function r(o) {
    return t.splice(t.indexOf(o), 1)[0] || Promise.resolve(void 0);
  }
  function s(o) {
    if (!n())
      return Kn(qa);
    const c = o();
    return t.indexOf(c) === -1 && t.push(c), c.then(() => r(c)).then(
      null,
      () => r(c).then(null, () => {
      })
    ), c;
  }
  function i(o) {
    return new Je((c, a) => {
      let u = t.length;
      if (!u)
        return c(!0);
      const l = setTimeout(() => {
        o && o > 0 && c(!1);
      }, o);
      t.forEach((d) => {
        He(d).then(() => {
          --u || (clearTimeout(l), c(!0));
        }, a);
      });
    });
  }
  return {
    $: t,
    add: s,
    drain: i
  };
}
const Jd = 60 * 1e3;
function Qd(e, t = Date.now()) {
  const n = parseInt(`${e}`, 10);
  if (!isNaN(n))
    return n * 1e3;
  const r = Date.parse(`${e}`);
  return isNaN(r) ? Jd : r - t;
}
function Zd(e, t) {
  return e[t] || e.all || 0;
}
function Va(e, t, n = Date.now()) {
  return Zd(e, t) > n;
}
function Ga(e, { statusCode: t, headers: n }, r = Date.now()) {
  const s = {
    ...e
  }, i = n?.["x-sentry-rate-limits"], o = n?.["retry-after"];
  if (i)
    for (const c of i.trim().split(",")) {
      const [a, u, , , l] = c.split(":", 5), d = parseInt(a, 10), f = (isNaN(d) ? 60 : d) * 1e3;
      if (!u)
        s.all = r + f;
      else
        for (const p of u.split(";"))
          p === "metric_bucket" ? (!l || l.split(";").includes("custom")) && (s[p] = r + f) : s[p] = r + f;
    }
  else o ? s.all = r + Qd(o, r) : t === 429 && (s.all = r + 60 * 1e3);
  return s;
}
const ef = 64;
function tf(e, t, n = Xd(
  e.bufferSize || ef
)) {
  let r = {};
  const s = (o) => n.drain(o);
  function i(o) {
    const c = [];
    if (Pi(o, (d, f) => {
      const p = Fi(f);
      Va(r, p) ? e.recordDroppedEvent("ratelimit_backoff", p) : c.push(d);
    }), c.length === 0)
      return He({});
    const a = St(o[0], c), u = (d) => {
      Pi(a, (f, p) => {
        e.recordDroppedEvent(d, Fi(p));
      });
    }, l = () => t({ body: $l(a) }).then(
      (d) => (d.statusCode !== void 0 && (d.statusCode < 200 || d.statusCode >= 300) && b && g.warn(`Sentry responded with status code ${d.statusCode} to sent event.`), r = Ga(r, d), d),
      (d) => {
        throw u("network_error"), b && g.error("Encountered error running transport request:", d), d;
      }
    );
    return n.add(l).then(
      (d) => d,
      (d) => {
        if (d === qa)
          return b && g.error("Skipped sending event because buffer is full."), u("queue_overflow"), He({});
        throw d;
      }
    );
  }
  return {
    send: i,
    flush: s
  };
}
const nf = "thismessage:/";
function Ws(e) {
  return "isRelative" in e;
}
function zs(e, t) {
  const n = e.indexOf("://") <= 0 && e.indexOf("//") !== 0, r = n ? nf : void 0;
  try {
    if ("canParse" in URL && !URL.canParse(e, r))
      return;
    const s = new URL(e, r);
    return n ? {
      isRelative: n,
      pathname: s.pathname,
      search: s.search,
      hash: s.hash
    } : s;
  } catch {
  }
}
function rf(e) {
  if (Ws(e))
    return e.pathname;
  const t = new URL(e);
  return t.search = "", t.hash = "", ["80", "443"].includes(t.port) && (t.port = ""), t.password && (t.password = "%filtered%"), t.username && (t.username = "%filtered%"), t.toString();
}
function dt(e) {
  if (!e)
    return {};
  const t = e.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
  if (!t)
    return {};
  const n = t[6] || "", r = t[8] || "";
  return {
    host: t[4],
    path: t[5],
    protocol: t[2],
    search: n,
    hash: r,
    relative: t[5] + n + r
    // everything minus origin
  };
}
function sf(e) {
  return e.split(/[?#]/, 1)[0];
}
function of(e, t) {
  const n = t?.getDsn(), r = t?.getOptions().tunnel;
  return cf(e, n) || af(e, r);
}
function af(e, t) {
  return t ? to(e) === to(t) : !1;
}
function cf(e, t) {
  const n = zs(e);
  return !n || Ws(n) ? !1 : t ? n.host.includes(t.host) && /(^|&|\?)sentry_key=/.test(n.search) : !1;
}
function to(e) {
  return e[e.length - 1] === "/" ? e.slice(0, -1) : e;
}
function uf(e) {
  "aggregates" in e ? e.attrs?.ip_address === void 0 && (e.attrs = {
    ...e.attrs,
    ip_address: "{{auto}}"
  }) : e.ipAddress === void 0 && (e.ipAddress = "{{auto}}");
}
function Ya(e, t, n = [t], r = "npm") {
  const s = e._metadata || {};
  s.sdk || (s.sdk = {
    name: `sentry.javascript.${t}`,
    packages: n.map((i) => ({
      name: `${r}:@sentry/${i}`,
      version: ct
    })),
    version: ct
  }), e._metadata = s;
}
function Ka(e = {}) {
  const t = e.client || U();
  if (!xd() || !t)
    return {};
  const n = mt(), r = Ft(n);
  if (r.getTraceData)
    return r.getTraceData(e);
  const s = e.scope || V(), i = e.span || ce(), o = i ? Rl(i) : lf(s), c = i ? Ue(i) : Ra(t, s), a = dl(c);
  return ya.test(o) ? {
    "sentry-trace": o,
    baggage: a
  } : (g.warn("Invalid sentry-trace data. Cannot generate trace data"), {});
}
function lf(e) {
  const { traceId: t, sampled: n, propagationSpanId: r } = e.getPropagationContext();
  return Ea(t, r, n);
}
function df(e, t, n) {
  let r, s, i;
  const o = n?.maxWait ? Math.max(n.maxWait, t) : 0, c = n?.setTimeoutImpl || setTimeout;
  function a() {
    return u(), r = e(), r;
  }
  function u() {
    s !== void 0 && clearTimeout(s), i !== void 0 && clearTimeout(i), s = i = void 0;
  }
  function l() {
    return s !== void 0 || i !== void 0 ? a() : r;
  }
  function d() {
    return s && clearTimeout(s), s = c(a, t), o && i === void 0 && (i = c(a, o)), r;
  }
  return d.cancel = u, d.flush = l, d;
}
const ff = 100;
function Qe(e, t) {
  const n = U(), r = Ae();
  if (!n) return;
  const { beforeBreadcrumb: s = null, maxBreadcrumbs: i = ff } = n.getOptions();
  if (i <= 0) return;
  const c = { timestamp: gt(), ...e }, a = s ? We(() => s(c, t)) : c;
  a !== null && (n.emit && n.emit("beforeAddBreadcrumb", a, t), r.addBreadcrumb(a, i));
}
let no;
const pf = "FunctionToString", ro = /* @__PURE__ */ new WeakMap(), hf = () => ({
  name: pf,
  setupOnce() {
    no = Function.prototype.toString;
    try {
      Function.prototype.toString = function(...e) {
        const t = Ns(this), n = ro.has(U()) && t !== void 0 ? t : this;
        return no.apply(n, e);
      };
    } catch {
    }
  },
  setup(e) {
    ro.set(e, !0);
  }
}), mf = hf, gf = [
  /^Script error\.?$/,
  /^Javascript error: Script error\.? on line 0$/,
  /^ResizeObserver loop completed with undelivered notifications.$/,
  // The browser logs this when a ResizeObserver handler takes a bit longer. Usually this is not an actual issue though. It indicates slowness.
  /^Cannot redefine property: googletag$/,
  // This is thrown when google tag manager is used in combination with an ad blocker
  /^Can't find variable: gmo$/,
  // Error from Google Search App https://issuetracker.google.com/issues/396043331
  /^undefined is not an object \(evaluating 'a\.[A-Z]'\)$/,
  // Random error that happens but not actionable or noticeable to end-users.
  `can't redefine non-configurable property "solana"`,
  // Probably a browser extension or custom browser (Brave) throwing this error
  "vv().getRestrictions is not a function. (In 'vv().getRestrictions(1,a)', 'vv().getRestrictions' is undefined)",
  // Error thrown by GTM, seemingly not affecting end-users
  "Can't find variable: _AutofillCallbackHandler",
  // Unactionable error in instagram webview https://developers.facebook.com/community/threads/320013549791141/
  /^Non-Error promise rejection captured with value: Object Not Found Matching Id:\d+, MethodName:simulateEvent, ParamCount:\d+$/,
  // unactionable error from CEFSharp, a .NET library that embeds chromium in .NET apps
  /^Java exception was raised during method invocation$/
  // error from Facebook Mobile browser (https://github.com/getsentry/sentry-javascript/issues/15065)
], _f = "EventFilters", Sf = (e = {}) => {
  let t;
  return {
    name: _f,
    setup(n) {
      const r = n.getOptions();
      t = so(e, r);
    },
    processEvent(n, r, s) {
      if (!t) {
        const i = s.getOptions();
        t = so(e, i);
      }
      return Ef(n, t) ? null : n;
    }
  };
}, yf = (e = {}) => ({
  ...Sf(e),
  name: "InboundFilters"
});
function so(e = {}, t = {}) {
  return {
    allowUrls: [...e.allowUrls || [], ...t.allowUrls || []],
    denyUrls: [...e.denyUrls || [], ...t.denyUrls || []],
    ignoreErrors: [
      ...e.ignoreErrors || [],
      ...t.ignoreErrors || [],
      ...e.disableErrorDefaults ? [] : gf
    ],
    ignoreTransactions: [...e.ignoreTransactions || [], ...t.ignoreTransactions || []]
  };
}
function Ef(e, t) {
  if (e.type) {
    if (e.type === "transaction" && vf(e, t.ignoreTransactions))
      return b && g.warn(
        `Event dropped due to being matched by \`ignoreTransactions\` option.
Event: ${it(e)}`
      ), !0;
  } else {
    if (bf(e, t.ignoreErrors))
      return b && g.warn(
        `Event dropped due to being matched by \`ignoreErrors\` option.
Event: ${it(e)}`
      ), !0;
    if (kf(e))
      return b && g.warn(
        `Event dropped due to not having an error message, error type or stacktrace.
Event: ${it(
          e
        )}`
      ), !0;
    if (Tf(e, t.denyUrls))
      return b && g.warn(
        `Event dropped due to being matched by \`denyUrls\` option.
Event: ${it(
          e
        )}.
Url: ${Xn(e)}`
      ), !0;
    if (!If(e, t.allowUrls))
      return b && g.warn(
        `Event dropped due to not being matched by \`allowUrls\` option.
Event: ${it(
          e
        )}.
Url: ${Xn(e)}`
      ), !0;
  }
  return !1;
}
function bf(e, t) {
  return t?.length ? Ua(e).some((n) => De(n, t)) : !1;
}
function vf(e, t) {
  if (!t?.length)
    return !1;
  const n = e.transaction;
  return n ? De(n, t) : !1;
}
function Tf(e, t) {
  if (!t?.length)
    return !1;
  const n = Xn(e);
  return n ? De(n, t) : !1;
}
function If(e, t) {
  if (!t?.length)
    return !0;
  const n = Xn(e);
  return n ? De(n, t) : !0;
}
function wf(e = []) {
  for (let t = e.length - 1; t >= 0; t--) {
    const n = e[t];
    if (n && n.filename !== "<anonymous>" && n.filename !== "[native code]")
      return n.filename || null;
  }
  return null;
}
function Xn(e) {
  try {
    const n = [...e.exception?.values ?? []].reverse().find((r) => r.mechanism?.parent_id === void 0 && r.stacktrace?.frames?.length)?.stacktrace?.frames;
    return n ? wf(n) : null;
  } catch {
    return b && g.error(`Cannot extract url for event ${it(e)}`), null;
  }
}
function kf(e) {
  return e.exception?.values?.length ? (
    // No top-level message
    !e.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !e.exception.values.some((t) => t.stacktrace || t.type && t.type !== "Error" || t.value)
  ) : !1;
}
function Rf(e, t, n, r, s, i) {
  if (!s.exception?.values || !i || !Fe(i.originalException, Error))
    return;
  const o = s.exception.values.length > 0 ? s.exception.values[s.exception.values.length - 1] : void 0;
  o && (s.exception.values = as(
    e,
    t,
    r,
    i.originalException,
    n,
    s.exception.values,
    o,
    0
  ));
}
function as(e, t, n, r, s, i, o, c) {
  if (i.length >= n + 1)
    return i;
  let a = [...i];
  if (Fe(r[s], Error)) {
    io(o, c);
    const u = e(t, r[s]), l = a.length;
    oo(u, s, l, c), a = as(
      e,
      t,
      n,
      r[s],
      s,
      [u, ...a],
      u,
      l
    );
  }
  return Array.isArray(r.errors) && r.errors.forEach((u, l) => {
    if (Fe(u, Error)) {
      io(o, c);
      const d = e(t, u), f = a.length;
      oo(d, `errors[${l}]`, f, c), a = as(
        e,
        t,
        n,
        u,
        s,
        [d, ...a],
        d,
        f
      );
    }
  }), a;
}
function io(e, t) {
  e.mechanism = e.mechanism || { type: "generic", handled: !0 }, e.mechanism = {
    ...e.mechanism,
    ...e.type === "AggregateError" && { is_exception_group: !0 },
    exception_id: t
  };
}
function oo(e, t, n, r) {
  e.mechanism = e.mechanism || { type: "generic", handled: !0 }, e.mechanism = {
    ...e.mechanism,
    type: "chained",
    source: t,
    exception_id: n,
    parent_id: r
  };
}
function Cf(e) {
  const t = "console";
  et(t, e), tt(t, xf);
}
function xf() {
  "console" in z && wu.forEach(function(e) {
    e in z.console && pe(z.console, e, function(t) {
      return jn[e] = t, function(...n) {
        ye("console", { args: n, level: e }), jn[e]?.apply(z.console, n);
      };
    });
  });
}
function Xa(e) {
  return e === "warn" ? "warning" : ["fatal", "error", "warning", "log", "info", "debug"].includes(e) ? e : "log";
}
const Mf = "Dedupe", Af = () => {
  let e;
  return {
    name: Mf,
    processEvent(t) {
      if (t.type)
        return t;
      try {
        if (Nf(t, e))
          return b && g.warn("Event dropped due to being a duplicate of previously captured event."), null;
      } catch {
      }
      return e = t;
    }
  };
}, Of = Af;
function Nf(e, t) {
  return t ? !!(Df(e, t) || Lf(e, t)) : !1;
}
function Df(e, t) {
  const n = e.message, r = t.message;
  return !(!n && !r || n && !r || !n && r || n !== r || !Qa(e, t) || !Ja(e, t));
}
function Lf(e, t) {
  const n = ao(t), r = ao(e);
  return !(!n || !r || n.type !== r.type || n.value !== r.value || !Qa(e, t) || !Ja(e, t));
}
function Ja(e, t) {
  let n = vi(e), r = vi(t);
  if (!n && !r)
    return !0;
  if (n && !r || !n && r || (n = n, r = r, r.length !== n.length))
    return !1;
  for (let s = 0; s < r.length; s++) {
    const i = r[s], o = n[s];
    if (i.filename !== o.filename || i.lineno !== o.lineno || i.colno !== o.colno || i.function !== o.function)
      return !1;
  }
  return !0;
}
function Qa(e, t) {
  let n = e.fingerprint, r = t.fingerprint;
  if (!n && !r)
    return !0;
  if (n && !r || !n && r)
    return !1;
  n = n, r = r;
  try {
    return n.join("") === r.join("");
  } catch {
    return !1;
  }
}
function ao(e) {
  return e.exception?.values?.[0];
}
function Pf(e, t, n, r, s = "auto.http.browser") {
  if (!e.fetchData)
    return;
  const { method: i, url: o } = e.fetchData, c = Be() && t(o);
  if (e.endTimestamp && c) {
    const d = e.fetchData.__span;
    if (!d) return;
    const f = r[d];
    f && ($f(f, e), delete r[d]);
    return;
  }
  const a = !!ce(), u = c && a ? Xe(Uf(o, i, s)) : new Ke();
  if (e.fetchData.__span = u.spanContext().spanId, r[u.spanContext().spanId] = u, n(e.fetchData.url)) {
    const d = e.args[0], f = e.args[1] || {}, p = Ff(
      d,
      f,
      // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
      // we do not want to use the span as base for the trace headers,
      // which means that the headers will be generated from the scope and the sampling decision is deferred
      Be() && a ? u : void 0
    );
    p && (e.args[1] = f, f.headers = p);
  }
  const l = U();
  if (l) {
    const d = {
      input: e.args,
      response: e.response,
      startTimestamp: e.startTimestamp,
      endTimestamp: e.endTimestamp
    };
    l.emit("beforeOutgoingRequestSpan", u, d);
  }
  return u;
}
function Ff(e, t, n) {
  const r = Ka({ span: n }), s = r["sentry-trace"], i = r.baggage;
  if (!s)
    return;
  const o = t.headers || (oa(e) ? e.headers : void 0);
  if (o)
    if (Bf(o)) {
      const c = new Headers(o);
      if (c.get("sentry-trace") || c.set("sentry-trace", s), i) {
        const a = c.get("baggage");
        a ? wn(a) || c.set("baggage", `${a},${i}`) : c.set("baggage", i);
      }
      return c;
    } else if (Array.isArray(o)) {
      const c = [...o];
      o.find((u) => u[0] === "sentry-trace") || c.push(["sentry-trace", s]);
      const a = o.find(
        (u) => u[0] === "baggage" && wn(u[1])
      );
      return i && !a && c.push(["baggage", i]), c;
    } else {
      const c = "sentry-trace" in o ? o["sentry-trace"] : void 0, a = "baggage" in o ? o.baggage : void 0, u = a ? Array.isArray(a) ? [...a] : [a] : [], l = a && (Array.isArray(a) ? a.find((d) => wn(d)) : wn(a));
      return i && !l && u.push(i), {
        ...o,
        "sentry-trace": c ?? s,
        baggage: u.length > 0 ? u.join(",") : void 0
      };
    }
  else return { ...r };
}
function $f(e, t) {
  if (t.response) {
    ha(e, t.response.status);
    const n = t.response?.headers?.get("content-length");
    if (n) {
      const r = parseInt(n);
      r > 0 && e.setAttribute("http.response_content_length", r);
    }
  } else t.error && e.setStatus({ code: se, message: "internal_error" });
  e.end();
}
function wn(e) {
  return e.split(",").some((t) => t.trim().startsWith(Ps));
}
function Bf(e) {
  return typeof Headers < "u" && Fe(e, Headers);
}
function Uf(e, t, n) {
  const r = zs(e);
  return {
    name: r ? `${t} ${rf(r)}` : t,
    attributes: Hf(e, r, t, n)
  };
}
function Hf(e, t, n, r) {
  const s = {
    url: e,
    type: "fetch",
    "http.method": n,
    [ee]: r,
    [$e]: "http.client"
  };
  return t && (Ws(t) || (s["http.url"] = t.href, s["server.address"] = t.host), t.search && (s["http.query"] = t.search), t.hash && (s["http.fragment"] = t.hash)), s;
}
function Za(e) {
  if (e !== void 0)
    return e >= 400 && e < 500 ? "warning" : e >= 500 ? "error" : void 0;
}
const Jt = z;
function Wf() {
  return "history" in Jt && !!Jt.history;
}
function zf() {
  if (!("fetch" in Jt))
    return !1;
  try {
    return new Headers(), new Request("http://www.example.com"), new Response(), !0;
  } catch {
    return !1;
  }
}
function cs(e) {
  return e && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(e.toString());
}
function jf() {
  if (typeof EdgeRuntime == "string")
    return !0;
  if (!zf())
    return !1;
  if (cs(Jt.fetch))
    return !0;
  let e = !1;
  const t = Jt.document;
  if (t && typeof t.createElement == "function")
    try {
      const n = t.createElement("iframe");
      n.hidden = !0, t.head.appendChild(n), n.contentWindow?.fetch && (e = cs(n.contentWindow.fetch)), t.head.removeChild(n);
    } catch (n) {
      b && g.warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", n);
    }
  return e;
}
function ec(e, t) {
  const n = "fetch";
  et(n, e), tt(n, () => tc(void 0, t));
}
function qf(e) {
  const t = "fetch-body-resolved";
  et(t, e), tt(t, () => tc(Gf));
}
function tc(e, t = !1) {
  t && !jf() || pe(z, "fetch", function(n) {
    return function(...r) {
      const s = new Error(), { method: i, url: o } = Yf(r), c = {
        args: r,
        fetchData: {
          method: i,
          url: o
        },
        startTimestamp: re() * 1e3,
        // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
        virtualError: s,
        headers: Kf(r)
      };
      return e || ye("fetch", {
        ...c
      }), n.apply(z, r).then(
        async (a) => (e ? e(a) : ye("fetch", {
          ...c,
          endTimestamp: re() * 1e3,
          response: a
        }), a),
        (a) => {
          if (ye("fetch", {
            ...c,
            endTimestamp: re() * 1e3,
            error: a
          }), Ms(a) && a.stack === void 0 && (a.stack = s.stack, Se(a, "framesToPop", 1)), a instanceof TypeError && (a.message === "Failed to fetch" || a.message === "Load failed" || a.message === "NetworkError when attempting to fetch resource."))
            try {
              const u = new URL(c.fetchData.url);
              a.message = `${a.message} (${u.host})`;
            } catch {
            }
          throw a;
        }
      );
    };
  });
}
async function Vf(e, t) {
  if (e?.body) {
    const n = e.body, r = n.getReader(), s = setTimeout(
      () => {
        n.cancel().then(null, () => {
        });
      },
      90 * 1e3
      // 90s
    );
    let i = !0;
    for (; i; ) {
      let o;
      try {
        o = setTimeout(() => {
          n.cancel().then(null, () => {
          });
        }, 5e3);
        const { done: c } = await r.read();
        clearTimeout(o), c && (t(), i = !1);
      } catch {
        i = !1;
      } finally {
        clearTimeout(o);
      }
    }
    clearTimeout(s), r.releaseLock(), n.cancel().then(null, () => {
    });
  }
}
function Gf(e) {
  let t;
  try {
    t = e.clone();
  } catch {
    return;
  }
  Vf(t, () => {
    ye("fetch-body-resolved", {
      endTimestamp: re() * 1e3,
      response: e
    });
  });
}
function us(e, t) {
  return !!e && typeof e == "object" && !!e[t];
}
function co(e) {
  return typeof e == "string" ? e : e ? us(e, "url") ? e.url : e.toString ? e.toString() : "" : "";
}
function Yf(e) {
  if (e.length === 0)
    return { method: "GET", url: "" };
  if (e.length === 2) {
    const [n, r] = e;
    return {
      url: co(n),
      method: us(r, "method") ? String(r.method).toUpperCase() : "GET"
    };
  }
  const t = e[0];
  return {
    url: co(t),
    method: us(t, "method") ? String(t.method).toUpperCase() : "GET"
  };
}
function Kf(e) {
  const [t, n] = e;
  try {
    if (typeof n == "object" && n !== null && "headers" in n && n.headers)
      return new Headers(n.headers);
    if (oa(t))
      return new Headers(t.headers);
  } catch {
  }
}
function Xf() {
  return typeof __SENTRY_BROWSER_BUNDLE__ < "u" && !!__SENTRY_BROWSER_BUNDLE__;
}
function Jf() {
  return "npm";
}
function Qf() {
  return !Xf() && Object.prototype.toString.call(typeof process < "u" ? process : 0) === "[object process]";
}
function uo() {
  return typeof window < "u" && (!Qf() || Zf());
}
function Zf() {
  return z.process?.type === "renderer";
}
const j = z;
let ls = 0;
function nc() {
  return ls > 0;
}
function ep() {
  ls++, setTimeout(() => {
    ls--;
  });
}
function Mt(e, t = {}) {
  function n(s) {
    return typeof s == "function";
  }
  if (!n(e))
    return e;
  try {
    const s = e.__sentry_wrapped__;
    if (s)
      return typeof s == "function" ? s : e;
    if (Ns(e))
      return e;
  } catch {
    return e;
  }
  const r = function(...s) {
    try {
      const i = s.map((o) => Mt(o, t));
      return e.apply(this, i);
    } catch (i) {
      throw ep(), fr((o) => {
        o.addEventProcessor((c) => (t.mechanism && (Qr(c, void 0), kt(c, t.mechanism)), c.extra = {
          ...c.extra,
          arguments: s
        }, c)), dn(i);
      }), i;
    }
  };
  try {
    for (const s in e)
      Object.prototype.hasOwnProperty.call(e, s) && (r[s] = e[s]);
  } catch {
  }
  ca(r, e), Se(e, "__sentry_wrapped__", r);
  try {
    Object.getOwnPropertyDescriptor(r, "name").configurable && Object.defineProperty(r, "name", {
      get() {
        return e.name;
      }
    });
  } catch {
  }
  return r;
}
function js() {
  const e = Pt(), { referrer: t } = j.document || {}, { userAgent: n } = j.navigator || {}, r = {
    ...t && { Referer: t },
    ...n && { "User-Agent": n }
  };
  return {
    url: e,
    headers: r
  };
}
function qs(e, t) {
  const n = Vs(e, t), r = {
    type: ip(t),
    value: op(t)
  };
  return n.length && (r.stacktrace = { frames: n }), r.type === void 0 && r.value === "" && (r.value = "Unrecoverable error caught"), r;
}
function tp(e, t, n, r) {
  const i = U()?.getOptions().normalizeDepth, o = dp(t), c = {
    __serialized__: Ca(t, i)
  };
  if (o)
    return {
      exception: {
        values: [qs(e, o)]
      },
      extra: c
    };
  const a = {
    exception: {
      values: [
        {
          type: dr(t) ? t.constructor.name : r ? "UnhandledRejection" : "Error",
          value: up(t, { isUnhandledRejection: r })
        }
      ]
    },
    extra: c
  };
  if (n) {
    const u = Vs(e, n);
    u.length && (a.exception.values[0].stacktrace = { frames: u });
  }
  return a;
}
function Fr(e, t) {
  return {
    exception: {
      values: [qs(e, t)]
    }
  };
}
function Vs(e, t) {
  const n = t.stacktrace || t.stack || "", r = rp(t), s = sp(t);
  try {
    return e(n, r, s);
  } catch {
  }
  return [];
}
const np = /Minified React error #\d+;/i;
function rp(e) {
  return e && np.test(e.message) ? 1 : 0;
}
function sp(e) {
  return typeof e.framesToPop == "number" ? e.framesToPop : 0;
}
function rc(e) {
  return typeof WebAssembly < "u" && typeof WebAssembly.Exception < "u" ? e instanceof WebAssembly.Exception : !1;
}
function ip(e) {
  const t = e?.name;
  return !t && rc(e) ? e.message && Array.isArray(e.message) && e.message.length == 2 ? e.message[0] : "WebAssembly.Exception" : t;
}
function op(e) {
  const t = e?.message;
  return rc(e) ? Array.isArray(e.message) && e.message.length == 2 ? e.message[1] : "wasm exception" : t ? t.error && typeof t.error.message == "string" ? t.error.message : t : "No error message";
}
function ap(e, t, n, r) {
  const s = n?.syntheticException || void 0, i = Gs(e, t, s, r);
  return kt(i), i.level = "error", n?.event_id && (i.event_id = n.event_id), He(i);
}
function cp(e, t, n = "info", r, s) {
  const i = r?.syntheticException || void 0, o = ds(e, t, i, s);
  return o.level = n, r?.event_id && (o.event_id = r.event_id), He(o);
}
function Gs(e, t, n, r, s) {
  let i;
  if (sa(t) && t.error)
    return Fr(e, t.error);
  if (Ii(t) || Pu(t)) {
    const o = t;
    if ("stack" in t)
      i = Fr(e, t);
    else {
      const c = o.name || (Ii(o) ? "DOMError" : "DOMException"), a = o.message ? `${c}: ${o.message}` : c;
      i = ds(e, a, n, r), Qr(i, a);
    }
    return "code" in o && (i.tags = { ...i.tags, "DOMException.code": `${o.code}` }), i;
  }
  return Ms(t) ? Fr(e, t) : Xt(t) || dr(t) ? (i = tp(e, t, n, s), kt(i, {
    synthetic: !0
  }), i) : (i = ds(e, t, n, r), Qr(i, `${t}`), kt(i, {
    synthetic: !0
  }), i);
}
function ds(e, t, n, r) {
  const s = {};
  if (r && n) {
    const i = Vs(e, n);
    i.length && (s.exception = {
      values: [{ value: t, stacktrace: { frames: i } }]
    }), kt(s, { synthetic: !0 });
  }
  if (As(t)) {
    const { __sentry_template_string__: i, __sentry_template_values__: o } = t;
    return s.logentry = {
      message: i,
      params: o
    }, s;
  }
  return s.message = t, s;
}
function up(e, { isUnhandledRejection: t }) {
  const n = Wu(e), r = t ? "promise rejection" : "exception";
  return sa(e) ? `Event \`ErrorEvent\` captured as ${r} with message \`${e.message}\`` : dr(e) ? `Event \`${lp(e)}\` (type=${e.type}) captured as ${r}` : `Object captured as ${r} with keys: ${n}`;
}
function lp(e) {
  try {
    const t = Object.getPrototypeOf(e);
    return t ? t.constructor.name : void 0;
  } catch {
  }
}
function dp(e) {
  for (const t in e)
    if (Object.prototype.hasOwnProperty.call(e, t)) {
      const n = e[t];
      if (n instanceof Error)
        return n;
    }
}
const fp = 5e3;
class pp extends Wd {
  /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */
  constructor(t) {
    const n = hp(t), r = j.SENTRY_SDK_SOURCE || Jf();
    Ya(n, "browser", ["browser"], r), n._metadata?.sdk && (n._metadata.sdk.settings = {
      infer_ip: n.sendDefaultPii ? "auto" : "never",
      // purposefully allowing already passed settings to override the default
      ...n._metadata.sdk.settings
    }), super(n);
    const { sendDefaultPii: s, sendClientReports: i, enableLogs: o } = this._options;
    j.document && (i || o) && j.document.addEventListener("visibilitychange", () => {
      j.document.visibilityState === "hidden" && (i && this._flushOutcomes(), o && Pr(this));
    }), o && (this.on("flush", () => {
      Pr(this);
    }), this.on("afterCaptureLog", () => {
      this._logFlushIdleTimeout && clearTimeout(this._logFlushIdleTimeout), this._logFlushIdleTimeout = setTimeout(() => {
        Pr(this);
      }, fp);
    })), s && this.on("beforeSendSession", uf);
  }
  /**
   * @inheritDoc
   */
  eventFromException(t, n) {
    return ap(this._options.stackParser, t, n, this._options.attachStacktrace);
  }
  /**
   * @inheritDoc
   */
  eventFromMessage(t, n = "info", r) {
    return cp(this._options.stackParser, t, n, r, this._options.attachStacktrace);
  }
  /**
   * @inheritDoc
   */
  _prepareEvent(t, n, r, s) {
    return t.platform = t.platform || "javascript", super._prepareEvent(t, n, r, s);
  }
}
function hp(e) {
  return {
    release: typeof __SENTRY_RELEASE__ == "string" ? __SENTRY_RELEASE__ : j.SENTRY_RELEASE?.id,
    // This supports the variable that sentry-webpack-plugin injects
    sendClientReports: !0,
    // We default this to true, as it is the safer scenario
    parentSpanIsAlwaysRootSpan: !0,
    ...e
  };
}
const At = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, N = z, mp = (e, t) => e > t[1] ? "poor" : e > t[0] ? "needs-improvement" : "good", fn = (e, t, n, r) => {
  let s, i;
  return (o) => {
    t.value >= 0 && (o || r) && (i = t.value - (s ?? 0), (i || s === void 0) && (s = t.value, t.delta = i, t.rating = mp(t.value, n), e(t)));
  };
}, gp = () => `v5-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`, pn = (e = !0) => {
  const t = N.performance?.getEntriesByType?.("navigation")[0];
  if (
    // sentry-specific change:
    // We don't want to check for responseStart for our own use of `getNavigationEntry`
    !e || t && t.responseStart > 0 && t.responseStart < performance.now()
  )
    return t;
}, Bt = () => pn()?.activationStart ?? 0, hn = (e, t = -1) => {
  const n = pn();
  let r = "navigate";
  return n && (N.document?.prerendering || Bt() > 0 ? r = "prerender" : N.document?.wasDiscarded ? r = "restore" : n.type && (r = n.type.replace(/_/g, "-"))), {
    name: e,
    value: t,
    rating: "good",
    // If needed, will be updated when reported. `const` to keep the type from widening to `string`.
    delta: 0,
    entries: [],
    id: gp(),
    navigationType: r
  };
}, $r = /* @__PURE__ */ new WeakMap();
function Ys(e, t) {
  return $r.get(e) || $r.set(e, new t()), $r.get(e);
}
class Jn {
  constructor() {
    Jn.prototype.__init.call(this), Jn.prototype.__init2.call(this);
  }
  // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
  // eslint-disable-next-line @sentry-internal/sdk/no-class-field-initializers, @typescript-eslint/explicit-member-accessibility
  __init() {
    this._sessionValue = 0;
  }
  // eslint-disable-next-line @sentry-internal/sdk/no-class-field-initializers, @typescript-eslint/explicit-member-accessibility
  __init2() {
    this._sessionEntries = [];
  }
  // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
  _processEntry(t) {
    if (t.hadRecentInput) return;
    const n = this._sessionEntries[0], r = this._sessionEntries[this._sessionEntries.length - 1];
    this._sessionValue && n && r && t.startTime - r.startTime < 1e3 && t.startTime - n.startTime < 5e3 ? (this._sessionValue += t.value, this._sessionEntries.push(t)) : (this._sessionValue = t.value, this._sessionEntries = [t]), this._onAfterProcessingUnexpectedShift?.(t);
  }
}
const Ut = (e, t, n = {}) => {
  try {
    if (PerformanceObserver.supportedEntryTypes.includes(e)) {
      const r = new PerformanceObserver((s) => {
        Promise.resolve().then(() => {
          t(s.getEntries());
        });
      });
      return r.observe({ type: e, buffered: !0, ...n }), r;
    }
  } catch {
  }
}, Ks = (e) => {
  let t = !1;
  return () => {
    t || (e(), t = !0);
  };
};
let zt = -1;
const _p = () => N.document?.visibilityState === "hidden" && !N.document?.prerendering ? 0 : 1 / 0, Qn = (e) => {
  N.document.visibilityState === "hidden" && zt > -1 && (zt = e.type === "visibilitychange" ? e.timeStamp : 0, yp());
}, Sp = () => {
  addEventListener("visibilitychange", Qn, !0), addEventListener("prerenderingchange", Qn, !0);
}, yp = () => {
  removeEventListener("visibilitychange", Qn, !0), removeEventListener("prerenderingchange", Qn, !0);
}, Xs = () => {
  if (N.document && zt < 0) {
    const e = Bt();
    zt = (N.document.prerendering ? void 0 : globalThis.performance.getEntriesByType("visibility-state").filter((n) => n.name === "hidden" && n.startTime > e)[0]?.startTime) ?? _p(), Sp();
  }
  return {
    get firstHiddenTime() {
      return zt;
    }
  };
}, hr = (e) => {
  N.document?.prerendering ? addEventListener("prerenderingchange", () => e(), !0) : e();
}, Ep = [1800, 3e3], bp = (e, t = {}) => {
  hr(() => {
    const n = Xs(), r = hn("FCP");
    let s;
    const o = Ut("paint", (c) => {
      for (const a of c)
        a.name === "first-contentful-paint" && (o.disconnect(), a.startTime < n.firstHiddenTime && (r.value = Math.max(a.startTime - Bt(), 0), r.entries.push(a), s(!0)));
    });
    o && (s = fn(e, r, Ep, t.reportAllChanges));
  });
}, vp = [0.1, 0.25], Tp = (e, t = {}) => {
  bp(
    Ks(() => {
      const n = hn("CLS", 0);
      let r;
      const s = Ys(t, Jn), i = (c) => {
        for (const a of c)
          s._processEntry(a);
        s._sessionValue > n.value && (n.value = s._sessionValue, n.entries = s._sessionEntries, r());
      }, o = Ut("layout-shift", i);
      o && (r = fn(e, n, vp, t.reportAllChanges), N.document?.addEventListener("visibilitychange", () => {
        N.document?.visibilityState === "hidden" && (i(o.takeRecords()), r(!0));
      }), N?.setTimeout?.(r));
    })
  );
};
let sc = 0, Br = 1 / 0, kn = 0;
const Ip = (e) => {
  e.forEach((t) => {
    t.interactionId && (Br = Math.min(Br, t.interactionId), kn = Math.max(kn, t.interactionId), sc = kn ? (kn - Br) / 7 + 1 : 0);
  });
};
let fs;
const ic = () => fs ? sc : performance.interactionCount || 0, wp = () => {
  "interactionCount" in performance || fs || (fs = Ut("event", Ip, {
    type: "event",
    buffered: !0,
    durationThreshold: 0
  }));
}, Ur = 10;
let oc = 0;
const kp = () => ic() - oc;
class Zn {
  constructor() {
    Zn.prototype.__init.call(this), Zn.prototype.__init2.call(this);
  }
  /**
   * A list of longest interactions on the page (by latency) sorted so the
   * longest one is first. The list is at most MAX_INTERACTIONS_TO_CONSIDER
   * long.
   */
  // eslint-disable-next-line @sentry-internal/sdk/no-class-field-initializers, @typescript-eslint/explicit-member-accessibility
  __init() {
    this._longestInteractionList = [];
  }
  /**
   * A mapping of longest interactions by their interaction ID.
   * This is used for faster lookup.
   */
  // eslint-disable-next-line @sentry-internal/sdk/no-class-field-initializers, @typescript-eslint/explicit-member-accessibility
  __init2() {
    this._longestInteractionMap = /* @__PURE__ */ new Map();
  }
  // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
  // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
  // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility, jsdoc/require-jsdoc
  _resetInteractions() {
    oc = ic(), this._longestInteractionList.length = 0, this._longestInteractionMap.clear();
  }
  /**
   * Returns the estimated p98 longest interaction based on the stored
   * interaction candidates and the interaction count for the current page.
   */
  // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
  _estimateP98LongestInteraction() {
    const t = Math.min(
      this._longestInteractionList.length - 1,
      Math.floor(kp() / 50)
    );
    return this._longestInteractionList[t];
  }
  /**
   * Takes a performance entry and adds it to the list of worst interactions
   * if its duration is long enough to make it among the worst. If the
   * entry is part of an existing interaction, it is merged and the latency
   * and entries list is updated as needed.
   */
  // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
  _processEntry(t) {
    if (this._onBeforeProcessingEntry?.(t), !(t.interactionId || t.entryType === "first-input")) return;
    const n = this._longestInteractionList.at(-1);
    let r = this._longestInteractionMap.get(t.interactionId);
    if (r || this._longestInteractionList.length < Ur || // If the above conditions are false, `minLongestInteraction` will be set.
    t.duration > n._latency) {
      if (r ? t.duration > r._latency ? (r.entries = [t], r._latency = t.duration) : t.duration === r._latency && t.startTime === r.entries[0].startTime && r.entries.push(t) : (r = {
        id: t.interactionId,
        entries: [t],
        _latency: t.duration
      }, this._longestInteractionMap.set(r.id, r), this._longestInteractionList.push(r)), this._longestInteractionList.sort((s, i) => i._latency - s._latency), this._longestInteractionList.length > Ur) {
        const s = this._longestInteractionList.splice(Ur);
        for (const i of s)
          this._longestInteractionMap.delete(i.id);
      }
      this._onAfterProcessingINPCandidate?.(r);
    }
  }
}
const Js = (e) => {
  const t = (n) => {
    (n.type === "pagehide" || N.document?.visibilityState === "hidden") && e(n);
  };
  N.document && (addEventListener("visibilitychange", t, !0), addEventListener("pagehide", t, !0));
}, ac = (e) => {
  const t = N.requestIdleCallback || N.setTimeout;
  N.document?.visibilityState === "hidden" ? e() : (e = Ks(e), t(e), Js(e));
}, Rp = [200, 500], Cp = 40, xp = (e, t = {}) => {
  globalThis.PerformanceEventTiming && "interactionId" in PerformanceEventTiming.prototype && hr(() => {
    wp();
    const n = hn("INP");
    let r;
    const s = Ys(t, Zn), i = (c) => {
      ac(() => {
        for (const u of c)
          s._processEntry(u);
        const a = s._estimateP98LongestInteraction();
        a && a._latency !== n.value && (n.value = a._latency, n.entries = a.entries, r());
      });
    }, o = Ut("event", i, {
      // Event Timing entries have their durations rounded to the nearest 8ms,
      // so a duration of 40ms would be any event that spans 2.5 or more frames
      // at 60Hz. This threshold is chosen to strike a balance between usefulness
      // and performance. Running this callback for any interaction that spans
      // just one or two frames is likely not worth the insight that could be
      // gained.
      durationThreshold: t.durationThreshold ?? Cp
    });
    r = fn(e, n, Rp, t.reportAllChanges), o && (o.observe({ type: "first-input", buffered: !0 }), Js(() => {
      i(o.takeRecords()), r(!0);
    }));
  });
};
class Mp {
  // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
  // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility, jsdoc/require-jsdoc
  _processEntry(t) {
    this._onBeforeProcessingEntry?.(t);
  }
}
const Ap = [2500, 4e3], Op = (e, t = {}) => {
  hr(() => {
    const n = Xs(), r = hn("LCP");
    let s;
    const i = Ys(t, Mp), o = (a) => {
      t.reportAllChanges || (a = a.slice(-1));
      for (const u of a)
        i._processEntry(u), u.startTime < n.firstHiddenTime && (r.value = Math.max(u.startTime - Bt(), 0), r.entries = [u], s());
    }, c = Ut("largest-contentful-paint", o);
    if (c) {
      s = fn(e, r, Ap, t.reportAllChanges);
      const a = Ks(() => {
        o(c.takeRecords()), c.disconnect(), s(!0);
      });
      for (const u of ["keydown", "click", "visibilitychange"])
        N.document && addEventListener(u, () => ac(a), {
          capture: !0,
          once: !0
        });
    }
  });
}, Np = [800, 1800], ps = (e) => {
  N.document?.prerendering ? hr(() => ps(e)) : N.document?.readyState !== "complete" ? addEventListener("load", () => ps(e), !0) : setTimeout(e);
}, Dp = (e, t = {}) => {
  const n = hn("TTFB"), r = fn(e, n, Np, t.reportAllChanges);
  ps(() => {
    const s = pn();
    s && (n.value = Math.max(s.responseStart - Bt(), 0), n.entries = [s], r(!0));
  });
}, jt = {}, er = {};
let cc, uc, lc, dc;
function Qs(e, t = !1) {
  return mr("cls", e, Pp, cc, t);
}
function Zs(e, t = !1) {
  return mr("lcp", e, Fp, uc, t);
}
function Lp(e) {
  return mr("ttfb", e, $p, lc);
}
function fc(e) {
  return mr("inp", e, Bp, dc);
}
function ht(e, t) {
  return pc(e, t), er[e] || (Up(e), er[e] = !0), hc(e, t);
}
function mn(e, t) {
  const n = jt[e];
  if (n?.length)
    for (const r of n)
      try {
        r(t);
      } catch (s) {
        At && g.error(
          `Error while triggering instrumentation handler.
Type: ${e}
Name: ${Pe(r)}
Error:`,
          s
        );
      }
}
function Pp() {
  return Tp(
    (e) => {
      mn("cls", {
        metric: e
      }), cc = e;
    },
    // We want the callback to be called whenever the CLS value updates.
    // By default, the callback is only called when the tab goes to the background.
    { reportAllChanges: !0 }
  );
}
function Fp() {
  return Op(
    (e) => {
      mn("lcp", {
        metric: e
      }), uc = e;
    },
    // We want the callback to be called whenever the LCP value updates.
    // By default, the callback is only called when the tab goes to the background.
    { reportAllChanges: !0 }
  );
}
function $p() {
  return Dp((e) => {
    mn("ttfb", {
      metric: e
    }), lc = e;
  });
}
function Bp() {
  return xp((e) => {
    mn("inp", {
      metric: e
    }), dc = e;
  });
}
function mr(e, t, n, r, s = !1) {
  pc(e, t);
  let i;
  return er[e] || (i = n(), er[e] = !0), r && t({ metric: r }), hc(e, t, s ? i : void 0);
}
function Up(e) {
  const t = {};
  e === "event" && (t.durationThreshold = 0), Ut(
    e,
    (n) => {
      mn(e, { entries: n });
    },
    t
  );
}
function pc(e, t) {
  jt[e] = jt[e] || [], jt[e].push(t);
}
function hc(e, t, n) {
  return () => {
    n && n();
    const r = jt[e];
    if (!r)
      return;
    const s = r.indexOf(t);
    s !== -1 && r.splice(s, 1);
  };
}
function Hp(e) {
  return "duration" in e;
}
function Hr(e) {
  return typeof e == "number" && isFinite(e);
}
function Ze(e, t, n, { ...r }) {
  const s = B(e).start_timestamp;
  return s && s > t && typeof e.updateStartTime == "function" && e.updateStartTime(t), Us(e, () => {
    const i = Xe({
      startTime: t,
      ...r
    });
    return i && i.end(n), i;
  });
}
function ei(e) {
  const t = U();
  if (!t)
    return;
  const { name: n, transaction: r, attributes: s, startTime: i } = e, { release: o, environment: c, sendDefaultPii: a } = t.getOptions(), l = t.getIntegrationByName("Replay")?.getReplayId(), d = V(), f = d.getUser(), p = f !== void 0 ? f.email || f.id || f.ip_address : void 0;
  let h;
  try {
    h = d.getScopeData().contexts.profile.profile_id;
  } catch {
  }
  const m = {
    release: o,
    environment: c,
    user: p || void 0,
    profile_id: h || void 0,
    replay_id: l || void 0,
    transaction: r,
    // Web vital score calculation relies on the user agent to account for different
    // browsers setting different thresholds for what is considered a good/meh/bad value.
    // For example: Chrome vs. Chrome Mobile
    "user_agent.original": N.navigator?.userAgent,
    // This tells Sentry to infer the IP address from the request
    "client.address": a ? "{{auto}}" : void 0,
    ...s
  };
  return Xe({
    name: n,
    attributes: m,
    startTime: i,
    experimental: {
      standalone: !0
    }
  });
}
function gr() {
  return N.addEventListener && N.performance;
}
function ne(e) {
  return e / 1e3;
}
function mc(e) {
  let t = "unknown", n = "unknown", r = "";
  for (const s of e) {
    if (s === "/") {
      [t, n] = e.split("/");
      break;
    }
    if (!isNaN(Number(s))) {
      t = r === "h" ? "http" : r, n = e.split(r)[1];
      break;
    }
    r += s;
  }
  return r === e && (t = r), { name: t, version: n };
}
function gc(e) {
  try {
    return PerformanceObserver.supportedEntryTypes.includes(e);
  } catch {
    return !1;
  }
}
function _c(e, t) {
  let n, r = !1;
  function s(c) {
    !r && n && t(c, n), r = !0;
  }
  Js(() => {
    s("pagehide");
  });
  const i = e.on("beforeStartNavigationSpan", (c, a) => {
    a?.isRedirect || (s("navigation"), lo(i, o));
  }), o = e.on("afterStartPageLoadSpan", (c) => {
    n = c.spanContext().spanId, lo(o);
  });
}
function lo(...e) {
  e.forEach((t) => t && setTimeout(t, 0));
}
function Wp(e) {
  let t = 0, n;
  if (!gc("layout-shift"))
    return;
  const r = Qs(({ metric: s }) => {
    const i = s.entries[s.entries.length - 1];
    i && (t = s.value, n = i);
  }, !0);
  _c(e, (s, i) => {
    zp(t, n, i, s), r();
  });
}
function zp(e, t, n, r) {
  At && g.log(`Sending CLS span (${e})`);
  const s = ne((me() || 0) + (t?.startTime || 0)), i = V().getScopeData().transactionName, o = t ? Ee(t.sources[0]?.node) : "Layout shift", c = {
    [ee]: "auto.http.browser.cls",
    [$e]: "ui.webvital.cls",
    [$t]: t?.duration || 0,
    // attach the pageload span id to the CLS span so that we can link them in the UI
    "sentry.pageload.span_id": n,
    // describes what triggered the web vital to be reported
    "sentry.report_event": r
  };
  t?.sources && t.sources.forEach((u, l) => {
    c[`cls.source.${l + 1}`] = Ee(u.node);
  });
  const a = ei({
    name: o,
    transaction: i,
    attributes: c,
    startTime: s
  });
  a && (a.addEvent("cls", {
    [cn]: "",
    [un]: e
  }), a.end(s));
}
function jp(e) {
  let t = 0, n;
  if (!gc("largest-contentful-paint"))
    return;
  const r = Zs(({ metric: s }) => {
    const i = s.entries[s.entries.length - 1];
    i && (t = s.value, n = i);
  }, !0);
  _c(e, (s, i) => {
    qp(t, n, i, s), r();
  });
}
function qp(e, t, n, r) {
  At && g.log(`Sending LCP span (${e})`);
  const s = ne((me() || 0) + (t?.startTime || 0)), i = V().getScopeData().transactionName, o = t ? Ee(t.element) : "Largest contentful paint", c = {
    [ee]: "auto.http.browser.lcp",
    [$e]: "ui.webvital.lcp",
    [$t]: 0,
    // LCP is a point-in-time metric
    // attach the pageload span id to the LCP span so that we can link them in the UI
    "sentry.pageload.span_id": n,
    // describes what triggered the web vital to be reported
    "sentry.report_event": r
  };
  t && (t.element && (c["lcp.element"] = Ee(t.element)), t.id && (c["lcp.id"] = t.id), t.url && (c["lcp.url"] = t.url.trim().slice(0, 200)), t.loadTime != null && (c["lcp.loadTime"] = t.loadTime), t.renderTime != null && (c["lcp.renderTime"] = t.renderTime), t.size != null && (c["lcp.size"] = t.size));
  const a = ei({
    name: o,
    transaction: i,
    attributes: c,
    startTime: s
  });
  a && (a.addEvent("lcp", {
    [cn]: "millisecond",
    [un]: e
  }), a.end(s));
}
const Vp = 2147483647;
let fo = 0, ke = {}, fe, tr;
function Gp({
  recordClsStandaloneSpans: e,
  recordLcpStandaloneSpans: t,
  client: n
}) {
  const r = gr();
  if (r && me()) {
    r.mark && N.performance.mark("sentry-tracing-init");
    const s = t ? jp(n) : Qp(), i = Zp(), o = e ? Wp(n) : Jp();
    return () => {
      s?.(), i(), o?.();
    };
  }
  return () => {
  };
}
function Yp() {
  ht("longtask", ({ entries: e }) => {
    const t = ce();
    if (!t)
      return;
    const { op: n, start_timestamp: r } = B(t);
    for (const s of e) {
      const i = ne(me() + s.startTime), o = ne(s.duration);
      n === "navigation" && r && i < r || Ze(t, i, i + o, {
        name: "Main UI thread blocked",
        op: "ui.long-task",
        attributes: {
          [ee]: "auto.ui.browser.metrics"
        }
      });
    }
  });
}
function Kp() {
  new PerformanceObserver((t) => {
    const n = ce();
    if (n)
      for (const r of t.getEntries()) {
        if (!r.scripts[0])
          continue;
        const s = ne(me() + r.startTime), { start_timestamp: i, op: o } = B(n);
        if (o === "navigation" && i && s < i)
          continue;
        const c = ne(r.duration), a = {
          [ee]: "auto.ui.browser.metrics"
        }, u = r.scripts[0], { invoker: l, invokerType: d, sourceURL: f, sourceFunctionName: p, sourceCharPosition: h } = u;
        a["browser.script.invoker"] = l, a["browser.script.invoker_type"] = d, f && (a["code.filepath"] = f), p && (a["code.function"] = p), h !== -1 && (a["browser.script.source_char_position"] = h), Ze(n, s, s + c, {
          name: "Main UI thread blocked",
          op: "ui.long-animation-frame",
          attributes: a
        });
      }
  }).observe({ type: "long-animation-frame", buffered: !0 });
}
function Xp() {
  ht("event", ({ entries: e }) => {
    const t = ce();
    if (t) {
      for (const n of e)
        if (n.name === "click") {
          const r = ne(me() + n.startTime), s = ne(n.duration), i = {
            name: Ee(n.target),
            op: `ui.interaction.${n.name}`,
            startTime: r,
            attributes: {
              [ee]: "auto.ui.browser.metrics"
            }
          }, o = aa(n.target);
          o && (i.attributes["ui.component_name"] = o), Ze(t, r, r + s, i);
        }
    }
  });
}
function Jp() {
  return Qs(({ metric: e }) => {
    const t = e.entries[e.entries.length - 1];
    t && (ke.cls = { value: e.value, unit: "" }, tr = t);
  }, !0);
}
function Qp() {
  return Zs(({ metric: e }) => {
    const t = e.entries[e.entries.length - 1];
    t && (ke.lcp = { value: e.value, unit: "millisecond" }, fe = t);
  }, !0);
}
function Zp() {
  return Lp(({ metric: e }) => {
    e.entries[e.entries.length - 1] && (ke.ttfb = { value: e.value, unit: "millisecond" });
  });
}
function eh(e, t) {
  const n = gr(), r = me();
  if (!n?.getEntries || !r)
    return;
  const s = ne(r), i = n.getEntries(), { op: o, start_timestamp: c } = B(e);
  i.slice(fo).forEach((a) => {
    const u = ne(a.startTime), l = ne(
      // Inexplicably, Chrome sometimes emits a negative duration. We need to work around this.
      // There is a SO post attempting to explain this, but it leaves one with open questions: https://stackoverflow.com/questions/23191918/peformance-getentries-and-negative-duration-display
      // The way we clamp the value is probably not accurate, since we have observed this happen for things that may take a while to load, like for example the replay worker.
      // TODO: Investigate why this happens and how to properly mitigate. For now, this is a workaround to prevent transactions being dropped due to negative duration spans.
      Math.max(0, a.duration)
    );
    if (!(o === "navigation" && c && s + u < c))
      switch (a.entryType) {
        case "navigation": {
          rh(e, a, s);
          break;
        }
        case "mark":
        case "paint":
        case "measure": {
          th(e, a, u, l, s, t.ignorePerformanceApiSpans);
          const d = Xs(), f = a.startTime < d.firstHiddenTime;
          a.name === "first-paint" && f && (ke.fp = { value: a.startTime, unit: "millisecond" }), a.name === "first-contentful-paint" && f && (ke.fcp = { value: a.startTime, unit: "millisecond" });
          break;
        }
        case "resource": {
          oh(
            e,
            a,
            a.name,
            u,
            l,
            s,
            t.ignoreResourceSpans
          );
          break;
        }
      }
  }), fo = Math.max(i.length - 1, 0), ah(e), o === "pageload" && (uh(ke), t.recordClsOnPageloadSpan || delete ke.cls, t.recordLcpOnPageloadSpan || delete ke.lcp, Object.entries(ke).forEach(([a, u]) => {
    Jl(a, u.value, u.unit);
  }), e.setAttribute("performance.timeOrigin", s), e.setAttribute("performance.activationStart", Bt()), ch(e, t)), fe = void 0, tr = void 0, ke = {};
}
function th(e, t, n, r, s, i) {
  if (["mark", "measure"].includes(t.entryType) && De(t.name, i))
    return;
  const o = pn(!1), c = ne(o ? o.requestStart : 0), a = s + Math.max(n, c), u = s + n, l = u + r, d = {
    [ee]: "auto.resource.browser.metrics"
  };
  a !== u && (d["sentry.browser.measure_happened_before_request"] = !0, d["sentry.browser.measure_start_time"] = a), nh(d, t), a <= l && Ze(e, a, l, {
    name: t.name,
    op: t.entryType,
    attributes: d
  });
}
function nh(e, t) {
  try {
    const n = t.detail;
    if (!n)
      return;
    if (typeof n == "object") {
      for (const [r, s] of Object.entries(n))
        if (s && Kt(s))
          e[`sentry.browser.measure.detail.${r}`] = s;
        else if (s !== void 0)
          try {
            e[`sentry.browser.measure.detail.${r}`] = JSON.stringify(s);
          } catch {
          }
      return;
    }
    if (Kt(n)) {
      e["sentry.browser.measure.detail"] = n;
      return;
    }
    try {
      e["sentry.browser.measure.detail"] = JSON.stringify(n);
    } catch {
    }
  } catch {
  }
}
function rh(e, t, n) {
  ["unloadEvent", "redirect", "domContentLoadedEvent", "loadEvent", "connect"].forEach((r) => {
    Rn(e, t, r, n);
  }), Rn(e, t, "secureConnection", n, "TLS/SSL"), Rn(e, t, "fetch", n, "cache"), Rn(e, t, "domainLookup", n, "DNS"), ih(e, t, n);
}
function Rn(e, t, n, r, s = n) {
  const i = sh(n), o = t[i], c = t[`${n}Start`];
  !c || !o || Ze(e, r + ne(c), r + ne(o), {
    op: `browser.${s}`,
    name: t.name,
    attributes: {
      [ee]: "auto.ui.browser.metrics",
      ...n === "redirect" && t.redirectCount != null ? { "http.redirect_count": t.redirectCount } : {}
    }
  });
}
function sh(e) {
  return e === "secureConnection" ? "connectEnd" : e === "fetch" ? "domainLookupStart" : `${e}End`;
}
function ih(e, t, n) {
  const r = n + ne(t.requestStart), s = n + ne(t.responseEnd), i = n + ne(t.responseStart);
  t.responseEnd && (Ze(e, r, s, {
    op: "browser.request",
    name: t.name,
    attributes: {
      [ee]: "auto.ui.browser.metrics"
    }
  }), Ze(e, i, s, {
    op: "browser.response",
    name: t.name,
    attributes: {
      [ee]: "auto.ui.browser.metrics"
    }
  }));
}
function oh(e, t, n, r, s, i, o) {
  if (t.initiatorType === "xmlhttprequest" || t.initiatorType === "fetch")
    return;
  const c = t.initiatorType ? `resource.${t.initiatorType}` : "resource.other";
  if (o?.includes(c))
    return;
  const a = dt(n), u = {
    [ee]: "auto.resource.browser.metrics"
  };
  Wr(u, t, "transferSize", "http.response_transfer_size"), Wr(u, t, "encodedBodySize", "http.response_content_length"), Wr(u, t, "decodedBodySize", "http.decoded_response_content_length");
  const l = t.deliveryType;
  l != null && (u["http.response_delivery_type"] = l);
  const d = t.renderBlockingStatus;
  if (d && (u["resource.render_blocking_status"] = d), a.protocol && (u["url.scheme"] = a.protocol.split(":").pop()), a.host && (u["server.address"] = a.host), u["url.same_origin"] = n.includes(N.location.origin), t.nextHopProtocol != null) {
    const { name: h, version: m } = mc(t.nextHopProtocol);
    u["network.protocol.name"] = h, u["network.protocol.version"] = m;
  }
  const f = i + r, p = f + s;
  Ze(e, f, p, {
    name: n.replace(N.location.origin, ""),
    op: c,
    attributes: u
  });
}
function ah(e) {
  const t = N.navigator;
  if (!t)
    return;
  const n = t.connection;
  n && (n.effectiveType && e.setAttribute("effectiveConnectionType", n.effectiveType), n.type && e.setAttribute("connectionType", n.type), Hr(n.rtt) && (ke["connection.rtt"] = { value: n.rtt, unit: "millisecond" })), Hr(t.deviceMemory) && e.setAttribute("deviceMemory", `${t.deviceMemory} GB`), Hr(t.hardwareConcurrency) && e.setAttribute("hardwareConcurrency", String(t.hardwareConcurrency));
}
function ch(e, t) {
  fe && t.recordLcpOnPageloadSpan && (fe.element && e.setAttribute("lcp.element", Ee(fe.element)), fe.id && e.setAttribute("lcp.id", fe.id), fe.url && e.setAttribute("lcp.url", fe.url.trim().slice(0, 200)), fe.loadTime != null && e.setAttribute("lcp.loadTime", fe.loadTime), fe.renderTime != null && e.setAttribute("lcp.renderTime", fe.renderTime), e.setAttribute("lcp.size", fe.size)), tr?.sources && t.recordClsOnPageloadSpan && tr.sources.forEach(
    (n, r) => e.setAttribute(`cls.source.${r + 1}`, Ee(n.node))
  );
}
function Wr(e, t, n, r) {
  const s = t[n];
  s != null && s < Vp && (e[r] = s);
}
function uh(e) {
  const t = pn(!1);
  if (!t)
    return;
  const { responseStart: n, requestStart: r } = t;
  r <= n && (e["ttfb.requestTime"] = {
    value: n - r,
    unit: "millisecond"
  });
}
function lh() {
  return gr() && me() ? ht("element", dh) : () => {
  };
}
const dh = ({ entries: e }) => {
  const t = ce(), n = t ? ae(t) : void 0, r = n ? B(n).description : V().getScopeData().transactionName;
  e.forEach((s) => {
    const i = s;
    if (!i.identifier)
      return;
    const o = i.name, c = i.renderTime, a = i.loadTime, [u, l] = a ? [ne(a), "load-time"] : c ? [ne(c), "render-time"] : [re(), "entry-emission"], d = o === "image-paint" ? (
      // for image paints, we can acually get a duration because image-paint entries also have a `loadTime`
      // and `renderTime`. `loadTime` is the time when the image finished loading and `renderTime` is the
      // time when the image finished rendering.
      ne(Math.max(0, (c ?? 0) - (a ?? 0)))
    ) : (
      // for `'text-paint'` entries, we can't get a duration because the `loadTime` is always zero.
      0
    ), f = {
      [ee]: "auto.ui.browser.elementtiming",
      [$e]: "ui.elementtiming",
      // name must be user-entered, so we can assume low cardinality
      [he]: "component",
      // recording the source of the span start time, as it varies depending on available data
      "sentry.span_start_time_source": l,
      "sentry.transaction_name": r,
      "element.id": i.id,
      "element.type": i.element?.tagName?.toLowerCase() || "unknown",
      "element.size": i.naturalWidth && i.naturalHeight ? `${i.naturalWidth}x${i.naturalHeight}` : void 0,
      "element.render_time": c,
      "element.load_time": a,
      // `url` is `0`(number) for text paints (hence we fall back to undefined)
      "element.url": i.url || void 0,
      "element.identifier": i.identifier,
      "element.paint_type": o
    };
    rd(
      {
        name: `element[${i.identifier}]`,
        attributes: f,
        startTime: u,
        onlyIfParent: !0
      },
      (p) => {
        p.end(u + d);
      }
    );
  });
}, fh = 1e3;
let po, hs, ms;
function Sc(e) {
  et("dom", e), tt("dom", ph);
}
function ph() {
  if (!N.document)
    return;
  const e = ye.bind(null, "dom"), t = ho(e, !0);
  N.document.addEventListener("click", t, !1), N.document.addEventListener("keypress", t, !1), ["EventTarget", "Node"].forEach((n) => {
    const s = N[n]?.prototype;
    s?.hasOwnProperty?.("addEventListener") && (pe(s, "addEventListener", function(i) {
      return function(o, c, a) {
        if (o === "click" || o == "keypress")
          try {
            const u = this.__sentry_instrumentation_handlers__ = this.__sentry_instrumentation_handlers__ || {}, l = u[o] = u[o] || { refCount: 0 };
            if (!l.handler) {
              const d = ho(e);
              l.handler = d, i.call(this, o, d, a);
            }
            l.refCount++;
          } catch {
          }
        return i.call(this, o, c, a);
      };
    }), pe(
      s,
      "removeEventListener",
      function(i) {
        return function(o, c, a) {
          if (o === "click" || o == "keypress")
            try {
              const u = this.__sentry_instrumentation_handlers__ || {}, l = u[o];
              l && (l.refCount--, l.refCount <= 0 && (i.call(this, o, l.handler, a), l.handler = void 0, delete u[o]), Object.keys(u).length === 0 && delete this.__sentry_instrumentation_handlers__);
            } catch {
            }
          return i.call(this, o, c, a);
        };
      }
    ));
  });
}
function hh(e) {
  if (e.type !== hs)
    return !1;
  try {
    if (!e.target || e.target._sentryId !== ms)
      return !1;
  } catch {
  }
  return !0;
}
function mh(e, t) {
  return e !== "keypress" ? !1 : t?.tagName ? !(t.tagName === "INPUT" || t.tagName === "TEXTAREA" || t.isContentEditable) : !0;
}
function ho(e, t = !1) {
  return (n) => {
    if (!n || n._sentryCaptured)
      return;
    const r = gh(n);
    if (mh(n.type, r))
      return;
    Se(n, "_sentryCaptured", !0), r && !r._sentryId && Se(r, "_sentryId", _e());
    const s = n.type === "keypress" ? "input" : n.type;
    hh(n) || (e({ event: n, name: s, global: t }), hs = n.type, ms = r ? r._sentryId : void 0), clearTimeout(po), po = N.setTimeout(() => {
      ms = void 0, hs = void 0;
    }, fh);
  };
}
function gh(e) {
  try {
    return e.target;
  } catch {
    return null;
  }
}
let Cn;
function _r(e) {
  const t = "history";
  et(t, e), tt(t, _h);
}
function _h() {
  if (N.addEventListener("popstate", () => {
    const t = N.location.href, n = Cn;
    if (Cn = t, n === t)
      return;
    ye("history", { from: n, to: t });
  }), !Wf())
    return;
  function e(t) {
    return function(...n) {
      const r = n.length > 2 ? n[2] : void 0;
      if (r) {
        const s = Cn, i = Sh(String(r));
        if (Cn = i, s === i)
          return t.apply(this, n);
        ye("history", { from: s, to: i });
      }
      return t.apply(this, n);
    };
  }
  pe(N.history, "pushState", e), pe(N.history, "replaceState", e);
}
function Sh(e) {
  try {
    return new URL(e, N.location.origin).toString();
  } catch {
    return e;
  }
}
const Hn = {};
function yc(e) {
  const t = Hn[e];
  if (t)
    return t;
  let n = N[e];
  if (cs(n))
    return Hn[e] = n.bind(N);
  const r = N.document;
  if (r && typeof r.createElement == "function")
    try {
      const s = r.createElement("iframe");
      s.hidden = !0, r.head.appendChild(s);
      const i = s.contentWindow;
      i?.[e] && (n = i[e]), r.head.removeChild(s);
    } catch (s) {
      At && g.warn(`Could not create sandbox iframe for ${e} check, bailing to window.${e}: `, s);
    }
  return n && (Hn[e] = n.bind(N));
}
function mo(e) {
  Hn[e] = void 0;
}
function gn(...e) {
  return yc("setTimeout")(...e);
}
const ot = "__sentry_xhr_v3__";
function Ec(e) {
  et("xhr", e), tt("xhr", yh);
}
function yh() {
  if (!N.XMLHttpRequest)
    return;
  const e = XMLHttpRequest.prototype;
  e.open = new Proxy(e.open, {
    apply(t, n, r) {
      const s = new Error(), i = re() * 1e3, o = Ne(r[0]) ? r[0].toUpperCase() : void 0, c = Eh(r[1]);
      if (!o || !c)
        return t.apply(n, r);
      n[ot] = {
        method: o,
        url: c,
        request_headers: {}
      }, o === "POST" && c.match(/sentry_key/) && (n.__sentry_own_request__ = !0);
      const a = () => {
        const u = n[ot];
        if (u && n.readyState === 4) {
          try {
            u.status_code = n.status;
          } catch {
          }
          const l = {
            endTimestamp: re() * 1e3,
            startTimestamp: i,
            xhr: n,
            virtualError: s
          };
          ye("xhr", l);
        }
      };
      return "onreadystatechange" in n && typeof n.onreadystatechange == "function" ? n.onreadystatechange = new Proxy(n.onreadystatechange, {
        apply(u, l, d) {
          return a(), u.apply(l, d);
        }
      }) : n.addEventListener("readystatechange", a), n.setRequestHeader = new Proxy(n.setRequestHeader, {
        apply(u, l, d) {
          const [f, p] = d, h = l[ot];
          return h && Ne(f) && Ne(p) && (h.request_headers[f.toLowerCase()] = p), u.apply(l, d);
        }
      }), t.apply(n, r);
    }
  }), e.send = new Proxy(e.send, {
    apply(t, n, r) {
      const s = n[ot];
      if (!s)
        return t.apply(n, r);
      r[0] !== void 0 && (s.body = r[0]);
      const i = {
        startTimestamp: re() * 1e3,
        xhr: n
      };
      return ye("xhr", i), t.apply(n, r);
    }
  });
}
function Eh(e) {
  if (Ne(e))
    return e;
  try {
    return e.toString();
  } catch {
  }
}
function bc(e) {
  return new URLSearchParams(e).toString();
}
function vc(e, t = g) {
  try {
    if (typeof e == "string")
      return [e];
    if (e instanceof URLSearchParams)
      return [e.toString()];
    if (e instanceof FormData)
      return [bc(e)];
    if (!e)
      return [void 0];
  } catch (n) {
    return At && t.error(n, "Failed to serialize body", e), [void 0, "BODY_PARSE_ERROR"];
  }
  return At && t.log("Skipping network body because of body type", e), [void 0, "UNPARSEABLE_BODY_TYPE"];
}
function Tc(e = []) {
  if (!(e.length !== 2 || typeof e[1] != "object"))
    return e[1].body;
}
const zr = [], Wn = /* @__PURE__ */ new Map(), bh = 60;
function vh() {
  if (gr() && me()) {
    const t = Th();
    return () => {
      t();
    };
  }
  return () => {
  };
}
const go = {
  click: "click",
  pointerdown: "click",
  pointerup: "click",
  mousedown: "click",
  mouseup: "click",
  touchstart: "click",
  touchend: "click",
  mouseover: "hover",
  mouseout: "hover",
  mouseenter: "hover",
  mouseleave: "hover",
  pointerover: "hover",
  pointerout: "hover",
  pointerenter: "hover",
  pointerleave: "hover",
  dragstart: "drag",
  dragend: "drag",
  drag: "drag",
  dragenter: "drag",
  dragleave: "drag",
  dragover: "drag",
  drop: "drag",
  keydown: "press",
  keyup: "press",
  keypress: "press",
  input: "press"
};
function Th() {
  return fc(Ih);
}
const Ih = ({ metric: e }) => {
  if (e.value == null)
    return;
  const t = ne(e.value);
  if (t > bh)
    return;
  const n = e.entries.find((h) => h.duration === e.value && go[h.name]);
  if (!n)
    return;
  const { interactionId: r } = n, s = go[n.name], i = ne(me() + n.startTime), o = ce(), c = o ? ae(o) : void 0, u = (r != null ? Wn.get(r) : void 0) || c, l = u ? B(u).description : V().getScopeData().transactionName, d = Ee(n.target), f = {
    [ee]: "auto.http.browser.inp",
    [$e]: `ui.interaction.${s}`,
    [$t]: n.duration
  }, p = ei({
    name: d,
    transaction: l,
    attributes: f,
    startTime: i
  });
  p && (p.addEvent("inp", {
    [cn]: "millisecond",
    [un]: e.value
  }), p.end(i + t));
};
function wh() {
  const e = ({ entries: t }) => {
    const n = ce(), r = n && ae(n);
    t.forEach((s) => {
      if (!Hp(s) || !r)
        return;
      const i = s.interactionId;
      if (i != null && !Wn.has(i)) {
        if (zr.length > 10) {
          const o = zr.shift();
          Wn.delete(o);
        }
        zr.push(i), Wn.set(i, r);
      }
    });
  };
  ht("event", e), ht("first-input", e);
}
function kh(e, t = yc("fetch")) {
  let n = 0, r = 0;
  function s(i) {
    const o = i.body.length;
    n += o, r++;
    const c = {
      body: i.body,
      method: "POST",
      referrerPolicy: "strict-origin",
      headers: e.headers,
      // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
      // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
      // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
      // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
      // Gotchas:
      // - `keepalive` isn't supported by Firefox
      // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
      //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
      //   We will therefore only activate the flag when we're below that limit.
      // There is also a limit of requests that can be open at the same time, so we also limit this to 15
      // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
      keepalive: n <= 6e4 && r < 15,
      ...e.fetchOptions
    };
    if (!t)
      return mo("fetch"), Kn("No fetch implementation available");
    try {
      return t(e.url, c).then((a) => (n -= o, r--, {
        statusCode: a.status,
        headers: {
          "x-sentry-rate-limits": a.headers.get("X-Sentry-Rate-Limits"),
          "retry-after": a.headers.get("Retry-After")
        }
      }));
    } catch (a) {
      return mo("fetch"), n -= o, r--, Kn(a);
    }
  }
  return tf(e, s);
}
const Rh = 30, Ch = 50;
function gs(e, t, n, r) {
  const s = {
    filename: e,
    function: t === "<anonymous>" ? ft : t,
    in_app: !0
    // All browser frames are considered in_app
  };
  return n !== void 0 && (s.lineno = n), r !== void 0 && (s.colno = r), s;
}
const xh = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i, Mh = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i, Ah = /\((\S*)(?::(\d+))(?::(\d+))\)/, Oh = /at (.+?) ?\(data:(.+?),/, Nh = (e) => {
  const t = e.match(Oh);
  if (t)
    return {
      filename: `<data:${t[2]}>`,
      function: t[1]
    };
  const n = xh.exec(e);
  if (n) {
    const [, s, i, o] = n;
    return gs(s, ft, +i, +o);
  }
  const r = Mh.exec(e);
  if (r) {
    if (r[2] && r[2].indexOf("eval") === 0) {
      const c = Ah.exec(r[2]);
      c && (r[2] = c[1], r[3] = c[2], r[4] = c[3]);
    }
    const [i, o] = Ic(r[1] || ft, r[2]);
    return gs(o, i, r[3] ? +r[3] : void 0, r[4] ? +r[4] : void 0);
  }
}, Dh = [Rh, Nh], Lh = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i, Ph = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i, Fh = (e) => {
  const t = Lh.exec(e);
  if (t) {
    if (t[3] && t[3].indexOf(" > eval") > -1) {
      const i = Ph.exec(t[3]);
      i && (t[1] = t[1] || "eval", t[3] = i[1], t[4] = i[2], t[5] = "");
    }
    let r = t[3], s = t[1] || ft;
    return [s, r] = Ic(s, r), gs(r, s, t[4] ? +t[4] : void 0, t[5] ? +t[5] : void 0);
  }
}, $h = [Ch, Fh], Bh = [Dh, $h], Uh = ea(...Bh), Ic = (e, t) => {
  const n = e.indexOf("safari-extension") !== -1, r = e.indexOf("safari-web-extension") !== -1;
  return n || r ? [
    e.indexOf("@") !== -1 ? e.split("@")[0] : ft,
    n ? `safari-extension:${t}` : `safari-web-extension:${t}`
  ] : [e, t];
}, be = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, xn = 1024, Hh = "Breadcrumbs", Wh = (e = {}) => {
  const t = {
    console: !0,
    dom: !0,
    fetch: !0,
    history: !0,
    sentry: !0,
    xhr: !0,
    ...e
  };
  return {
    name: Hh,
    setup(n) {
      t.console && Cf(Vh(n)), t.dom && Sc(qh(n, t.dom)), t.xhr && Ec(Gh(n)), t.fetch && ec(Yh(n)), t.history && _r(Kh(n)), t.sentry && n.on("beforeSendEvent", jh(n));
    }
  };
}, zh = Wh;
function jh(e) {
  return function(n) {
    U() === e && Qe(
      {
        category: `sentry.${n.type === "transaction" ? "transaction" : "event"}`,
        event_id: n.event_id,
        level: n.level,
        message: it(n)
      },
      {
        event: n
      }
    );
  };
}
function qh(e, t) {
  return function(r) {
    if (U() !== e)
      return;
    let s, i, o = typeof t == "object" ? t.serializeAttribute : void 0, c = typeof t == "object" && typeof t.maxStringLength == "number" ? t.maxStringLength : void 0;
    c && c > xn && (be && g.warn(
      `\`dom.maxStringLength\` cannot exceed ${xn}, but a value of ${c} was configured. Sentry will use ${xn} instead.`
    ), c = xn), typeof o == "string" && (o = [o]);
    try {
      const u = r.event, l = Xh(u) ? u.target : u;
      s = Ee(l, { keyAttrs: o, maxStringLength: c }), i = aa(l);
    } catch {
      s = "<unknown>";
    }
    if (s.length === 0)
      return;
    const a = {
      category: `ui.${r.name}`,
      message: s
    };
    i && (a.data = { "ui.component_name": i }), Qe(a, {
      event: r.event,
      name: r.name,
      global: r.global
    });
  };
}
function Vh(e) {
  return function(n) {
    if (U() !== e)
      return;
    const r = {
      category: "console",
      data: {
        arguments: n.args,
        logger: "console"
      },
      level: Xa(n.level),
      message: wi(n.args, " ")
    };
    if (n.level === "assert")
      if (n.args[0] === !1)
        r.message = `Assertion failed: ${wi(n.args.slice(1), " ") || "console.assert"}`, r.data.arguments = n.args.slice(1);
      else
        return;
    Qe(r, {
      input: n.args,
      level: n.level
    });
  };
}
function Gh(e) {
  return function(n) {
    if (U() !== e)
      return;
    const { startTimestamp: r, endTimestamp: s } = n, i = n.xhr[ot];
    if (!r || !s || !i)
      return;
    const { method: o, url: c, status_code: a, body: u } = i, l = {
      method: o,
      url: c,
      status_code: a
    }, d = {
      xhr: n.xhr,
      input: u,
      startTimestamp: r,
      endTimestamp: s
    }, f = {
      category: "xhr",
      data: l,
      type: "http",
      level: Za(a)
    };
    e.emit("beforeOutgoingRequestBreadcrumb", f, d), Qe(f, d);
  };
}
function Yh(e) {
  return function(n) {
    if (U() !== e)
      return;
    const { startTimestamp: r, endTimestamp: s } = n;
    if (s && !(n.fetchData.url.match(/sentry_key/) && n.fetchData.method === "POST"))
      if (n.fetchData.method, n.fetchData.url, n.error) {
        const i = n.fetchData, o = {
          data: n.error,
          input: n.args,
          startTimestamp: r,
          endTimestamp: s
        }, c = {
          category: "fetch",
          data: i,
          level: "error",
          type: "http"
        };
        e.emit("beforeOutgoingRequestBreadcrumb", c, o), Qe(c, o);
      } else {
        const i = n.response, o = {
          ...n.fetchData,
          status_code: i?.status
        };
        n.fetchData.request_body_size, n.fetchData.response_body_size, i?.status;
        const c = {
          input: n.args,
          response: i,
          startTimestamp: r,
          endTimestamp: s
        }, a = {
          category: "fetch",
          data: o,
          type: "http",
          level: Za(o.status_code)
        };
        e.emit("beforeOutgoingRequestBreadcrumb", a, c), Qe(a, c);
      }
  };
}
function Kh(e) {
  return function(n) {
    if (U() !== e)
      return;
    let r = n.from, s = n.to;
    const i = dt(j.location.href);
    let o = r ? dt(r) : void 0;
    const c = dt(s);
    o?.path || (o = i), i.protocol === c.protocol && i.host === c.host && (s = c.relative), i.protocol === o.protocol && i.host === o.host && (r = o.relative), Qe({
      category: "navigation",
      data: {
        from: r,
        to: s
      }
    });
  };
}
function Xh(e) {
  return !!e && !!e.target;
}
const Jh = [
  "EventTarget",
  "Window",
  "Node",
  "ApplicationCache",
  "AudioTrackList",
  "BroadcastChannel",
  "ChannelMergerNode",
  "CryptoOperation",
  "EventSource",
  "FileReader",
  "HTMLUnknownElement",
  "IDBDatabase",
  "IDBRequest",
  "IDBTransaction",
  "KeyOperation",
  "MediaController",
  "MessagePort",
  "ModalWindow",
  "Notification",
  "SVGElementInstance",
  "Screen",
  "SharedWorker",
  "TextTrack",
  "TextTrackCue",
  "TextTrackList",
  "WebSocket",
  "WebSocketWorker",
  "Worker",
  "XMLHttpRequest",
  "XMLHttpRequestEventTarget",
  "XMLHttpRequestUpload"
], Qh = "BrowserApiErrors", Zh = (e = {}) => {
  const t = {
    XMLHttpRequest: !0,
    eventTarget: !0,
    requestAnimationFrame: !0,
    setInterval: !0,
    setTimeout: !0,
    unregisterOriginalCallbacks: !1,
    ...e
  };
  return {
    name: Qh,
    // TODO: This currently only works for the first client this is setup
    // We may want to adjust this to check for client etc.
    setupOnce() {
      t.setTimeout && pe(j, "setTimeout", _o), t.setInterval && pe(j, "setInterval", _o), t.requestAnimationFrame && pe(j, "requestAnimationFrame", tm), t.XMLHttpRequest && "XMLHttpRequest" in j && pe(XMLHttpRequest.prototype, "send", nm);
      const n = t.eventTarget;
      n && (Array.isArray(n) ? n : Jh).forEach((s) => rm(s, t));
    }
  };
}, em = Zh;
function _o(e) {
  return function(...t) {
    const n = t[0];
    return t[0] = Mt(n, {
      mechanism: {
        data: { function: Pe(e) },
        handled: !1,
        type: "instrument"
      }
    }), e.apply(this, t);
  };
}
function tm(e) {
  return function(t) {
    return e.apply(this, [
      Mt(t, {
        mechanism: {
          data: {
            function: "requestAnimationFrame",
            handler: Pe(e)
          },
          handled: !1,
          type: "instrument"
        }
      })
    ]);
  };
}
function nm(e) {
  return function(...t) {
    const n = this;
    return ["onload", "onerror", "onprogress", "onreadystatechange"].forEach((s) => {
      s in n && typeof n[s] == "function" && pe(n, s, function(i) {
        const o = {
          mechanism: {
            data: {
              function: s,
              handler: Pe(i)
            },
            handled: !1,
            type: "instrument"
          }
        }, c = Ns(i);
        return c && (o.mechanism.data.handler = Pe(c)), Mt(i, o);
      });
    }), e.apply(this, t);
  };
}
function rm(e, t) {
  const r = j[e]?.prototype;
  r?.hasOwnProperty?.("addEventListener") && (pe(r, "addEventListener", function(s) {
    return function(i, o, c) {
      try {
        sm(o) && (o.handleEvent = Mt(o.handleEvent, {
          mechanism: {
            data: {
              function: "handleEvent",
              handler: Pe(o),
              target: e
            },
            handled: !1,
            type: "instrument"
          }
        }));
      } catch {
      }
      return t.unregisterOriginalCallbacks && im(this, i, o), s.apply(this, [
        i,
        Mt(o, {
          mechanism: {
            data: {
              function: "addEventListener",
              handler: Pe(o),
              target: e
            },
            handled: !1,
            type: "instrument"
          }
        }),
        c
      ]);
    };
  }), pe(r, "removeEventListener", function(s) {
    return function(i, o, c) {
      try {
        const a = o.__sentry_wrapped__;
        a && s.call(this, i, a, c);
      } catch {
      }
      return s.call(this, i, o, c);
    };
  }));
}
function sm(e) {
  return typeof e.handleEvent == "function";
}
function im(e, t, n) {
  e && typeof e == "object" && "removeEventListener" in e && typeof e.removeEventListener == "function" && e.removeEventListener(t, n);
}
const om = () => ({
  name: "BrowserSession",
  setupOnce() {
    if (typeof j.document > "u") {
      be && g.warn("Using the `browserSessionIntegration` in non-browser environments is not supported.");
      return;
    }
    Gi({ ignoreDuration: !0 }), Yi(), _r(({ from: e, to: t }) => {
      e !== void 0 && e !== t && (Gi({ ignoreDuration: !0 }), Yi());
    });
  }
}), am = "GlobalHandlers", cm = (e = {}) => {
  const t = {
    onerror: !0,
    onunhandledrejection: !0,
    ...e
  };
  return {
    name: am,
    setupOnce() {
      Error.stackTraceLimit = 50;
    },
    setup(n) {
      t.onerror && (lm(n), So("onerror")), t.onunhandledrejection && (dm(n), So("onunhandledrejection"));
    }
  };
}, um = cm;
function lm(e) {
  ta((t) => {
    const { stackParser: n, attachStacktrace: r } = wc();
    if (U() !== e || nc())
      return;
    const { msg: s, url: i, line: o, column: c, error: a } = t, u = hm(
      Gs(n, a || s, void 0, r, !1),
      i,
      o,
      c
    );
    u.level = "error", Pa(u, {
      originalException: a,
      mechanism: {
        handled: !1,
        type: "auto.browser.global_handlers.onerror"
      }
    });
  });
}
function dm(e) {
  na((t) => {
    const { stackParser: n, attachStacktrace: r } = wc();
    if (U() !== e || nc())
      return;
    const s = fm(t), i = Kt(s) ? pm(s) : Gs(n, s, void 0, r, !0);
    i.level = "error", Pa(i, {
      originalException: s,
      mechanism: {
        handled: !1,
        type: "auto.browser.global_handlers.onunhandledrejection"
      }
    });
  });
}
function fm(e) {
  if (Kt(e))
    return e;
  try {
    if ("reason" in e)
      return e.reason;
    if ("detail" in e && "reason" in e.detail)
      return e.detail.reason;
  } catch {
  }
  return e;
}
function pm(e) {
  return {
    exception: {
      values: [
        {
          type: "UnhandledRejection",
          // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
          value: `Non-Error promise rejection captured with value: ${String(e)}`
        }
      ]
    }
  };
}
function hm(e, t, n, r) {
  const s = e.exception = e.exception || {}, i = s.values = s.values || [], o = i[0] = i[0] || {}, c = o.stacktrace = o.stacktrace || {}, a = c.frames = c.frames || [], u = r, l = n, d = mm(t) ?? Pt();
  return a.length === 0 && a.push({
    colno: u,
    filename: d,
    function: ft,
    in_app: !0,
    lineno: l
  }), e;
}
function So(e) {
  be && g.log(`Global Handler attached: ${e}`);
}
function wc() {
  return U()?.getOptions() || {
    stackParser: () => [],
    attachStacktrace: !1
  };
}
function mm(e) {
  if (!(!Ne(e) || e.length === 0)) {
    if (e.startsWith("data:")) {
      const t = e.match(/^data:([^;]+)/), n = t ? t[1] : "text/javascript", r = e.includes("base64,");
      return `<data:${n}${r ? ",base64" : ""}>`;
    }
    return e.slice(0, 1024);
  }
}
const gm = () => ({
  name: "HttpContext",
  preprocessEvent(e) {
    if (!j.navigator && !j.location && !j.document)
      return;
    const t = js(), n = {
      ...t.headers,
      ...e.request?.headers
    };
    e.request = {
      ...t,
      ...e.request,
      headers: n
    };
  }
}), _m = "cause", Sm = 5, ym = "LinkedErrors", Em = (e = {}) => {
  const t = e.limit || Sm, n = e.key || _m;
  return {
    name: ym,
    preprocessEvent(r, s, i) {
      const o = i.getOptions();
      Rf(
        // This differs from the LinkedErrors integration in core by using a different exceptionFromError function
        qs,
        o.stackParser,
        n,
        t,
        r,
        s
      );
    }
  };
}, bm = Em;
function vm() {
  return Tm() ? (be && We(() => {
    console.error(
      "[Sentry] You cannot use Sentry.init() in a browser extension, see: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/"
    );
  }), !0) : !1;
}
function Tm() {
  if (typeof j.window > "u")
    return !1;
  const e = j;
  if (e.nw || !(e.chrome || e.browser)?.runtime?.id)
    return !1;
  const n = Pt(), r = ["chrome-extension", "moz-extension", "ms-browser-extension", "safari-web-extension"];
  return !(j === j.top && r.some((i) => n.startsWith(`${i}://`)));
}
function kc(e) {
  return [
    // TODO(v11): Replace with `eventFiltersIntegration` once we remove the deprecated `inboundFiltersIntegration`
    // eslint-disable-next-line deprecation/deprecation
    yf(),
    mf(),
    em(),
    zh(),
    um(),
    bm(),
    Of(),
    gm(),
    om()
  ];
}
function Im(e = {}) {
  const t = !e.skipBrowserExtensionCheck && vm(), n = {
    ...e,
    enabled: t ? !1 : e.enabled,
    stackParser: Ou(e.stackParser || Uh),
    integrations: Fd({
      integrations: e.integrations,
      defaultIntegrations: e.defaultIntegrations == null ? kc() : e.defaultIntegrations
    }),
    transport: e.transport || kh
  };
  return Yd(pp, n);
}
const Z = z, ti = "sentryReplaySession", wm = "replay_event", ni = "Unable to send Replay", km = 3e5, Rm = 9e5, Cm = 5e3, xm = 5500, Mm = 6e4, Am = 5e3, Om = 3, yo = 15e4, Mn = 5e3, Nm = 3e3, Dm = 300, ri = 2e7, Lm = 4999, Pm = 15e3, Eo = 36e5;
var Fm = Object.defineProperty, $m = (e, t, n) => t in e ? Fm(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, bo = (e, t, n) => $m(e, typeof t != "symbol" ? t + "" : t, n), oe = /* @__PURE__ */ ((e) => (e[e.Document = 0] = "Document", e[e.DocumentType = 1] = "DocumentType", e[e.Element = 2] = "Element", e[e.Text = 3] = "Text", e[e.CDATA = 4] = "CDATA", e[e.Comment = 5] = "Comment", e))(oe || {});
function Bm(e) {
  return e.nodeType === e.ELEMENT_NODE;
}
function qt(e) {
  return e?.host?.shadowRoot === e;
}
function Vt(e) {
  return Object.prototype.toString.call(e) === "[object ShadowRoot]";
}
function Um(e) {
  return e.includes(" background-clip: text;") && !e.includes(" -webkit-background-clip: text;") && (e = e.replace(
    /\sbackground-clip:\s*text;/g,
    " -webkit-background-clip: text; background-clip: text;"
  )), e;
}
function Hm(e) {
  const { cssText: t } = e;
  if (t.split('"').length < 3) return t;
  const n = ["@import", `url(${JSON.stringify(e.href)})`];
  return e.layerName === "" ? n.push("layer") : e.layerName && n.push(`layer(${e.layerName})`), e.supportsText && n.push(`supports(${e.supportsText})`), e.media.length && n.push(e.media.mediaText), n.join(" ") + ";";
}
function nr(e) {
  try {
    const t = e.rules || e.cssRules;
    return t ? Um(
      Array.from(t, Rc).join("")
    ) : null;
  } catch {
    return null;
  }
}
function Wm(e) {
  let t = "";
  for (let n = 0; n < e.style.length; n++) {
    const r = e.style, s = r[n], i = r.getPropertyPriority(s);
    t += `${s}:${r.getPropertyValue(s)}${i ? " !important" : ""};`;
  }
  return `${e.selectorText} { ${t} }`;
}
function Rc(e) {
  let t;
  if (jm(e))
    try {
      t = // for same-origin stylesheets,
      // we can access the imported stylesheet rules directly
      nr(e.styleSheet) || // work around browser issues with the raw string `@import url(...)` statement
      Hm(e);
    } catch {
    }
  else if (qm(e)) {
    let n = e.cssText;
    const r = e.selectorText.includes(":"), s = typeof e.style.all == "string" && e.style.all;
    if (s && (n = Wm(e)), r && (n = zm(n)), r || s)
      return n;
  }
  return t || e.cssText;
}
function zm(e) {
  const t = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
  return e.replace(t, "$1\\$2");
}
function jm(e) {
  return "styleSheet" in e;
}
function qm(e) {
  return "selectorText" in e;
}
class Cc {
  constructor() {
    bo(this, "idNodeMap", /* @__PURE__ */ new Map()), bo(this, "nodeMetaMap", /* @__PURE__ */ new WeakMap());
  }
  getId(t) {
    return t ? this.getMeta(t)?.id ?? -1 : -1;
  }
  getNode(t) {
    return this.idNodeMap.get(t) || null;
  }
  getIds() {
    return Array.from(this.idNodeMap.keys());
  }
  getMeta(t) {
    return this.nodeMetaMap.get(t) || null;
  }
  // removes the node from idNodeMap
  // doesn't remove the node from nodeMetaMap
  removeNodeFromMap(t) {
    const n = this.getId(t);
    this.idNodeMap.delete(n), t.childNodes && t.childNodes.forEach(
      (r) => this.removeNodeFromMap(r)
    );
  }
  has(t) {
    return this.idNodeMap.has(t);
  }
  hasNode(t) {
    return this.nodeMetaMap.has(t);
  }
  add(t, n) {
    const r = n.id;
    this.idNodeMap.set(r, t), this.nodeMetaMap.set(t, n);
  }
  replace(t, n) {
    const r = this.getNode(t);
    if (r) {
      const s = this.nodeMetaMap.get(r);
      s && this.nodeMetaMap.set(n, s);
    }
    this.idNodeMap.set(t, n);
  }
  reset() {
    this.idNodeMap = /* @__PURE__ */ new Map(), this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
  }
}
function Vm() {
  return new Cc();
}
function Sr({
  maskInputOptions: e,
  tagName: t,
  type: n
}) {
  return t === "OPTION" && (t = "SELECT"), !!(e[t.toLowerCase()] || n && e[n] || n === "password" || // Default to "text" option for inputs without a "type" attribute defined
  t === "INPUT" && !n && e.text);
}
function Qt({
  isMasked: e,
  element: t,
  value: n,
  maskInputFn: r
}) {
  let s = n || "";
  return e ? (r && (s = r(s, t)), "*".repeat(s.length)) : s;
}
function Ot(e) {
  return e.toLowerCase();
}
function _s(e) {
  return e.toUpperCase();
}
const vo = "__rrweb_original__";
function Gm(e) {
  const t = e.getContext("2d");
  if (!t) return !0;
  const n = 50;
  for (let r = 0; r < e.width; r += n)
    for (let s = 0; s < e.height; s += n) {
      const i = t.getImageData, o = vo in i ? i[vo] : i;
      if (new Uint32Array(
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
        o.call(
          t,
          r,
          s,
          Math.min(n, e.width - r),
          Math.min(n, e.height - s)
        ).data.buffer
      ).some((a) => a !== 0)) return !1;
    }
  return !0;
}
function si(e) {
  const t = e.type;
  return e.hasAttribute("data-rr-is-password") ? "password" : t ? (
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
    Ot(t)
  ) : null;
}
function rr(e, t, n) {
  return t === "INPUT" && (n === "radio" || n === "checkbox") ? e.getAttribute("value") || "" : e.value;
}
function xc(e, t) {
  let n;
  try {
    n = new URL(e, t ?? window.location.href);
  } catch {
    return null;
  }
  const r = /\.([0-9a-z]+)(?:$)/i;
  return n.pathname.match(r)?.[1] ?? null;
}
const To = {};
function Mc(e) {
  const t = To[e];
  if (t)
    return t;
  const n = window.document;
  let r = window[e];
  if (n && typeof n.createElement == "function")
    try {
      const s = n.createElement("iframe");
      s.hidden = !0, n.head.appendChild(s);
      const i = s.contentWindow;
      i && i[e] && (r = // eslint-disable-next-line @typescript-eslint/unbound-method
      i[e]), n.head.removeChild(s);
    } catch {
    }
  return To[e] = r.bind(
    window
  );
}
function Ss(...e) {
  return Mc("setTimeout")(...e);
}
function Ac(...e) {
  return Mc("clearTimeout")(...e);
}
function Oc(e) {
  try {
    return e.contentDocument;
  } catch {
  }
}
let Ym = 1;
const Km = new RegExp("[^a-z0-9-_:]"), Zt = -2;
function ii() {
  return Ym++;
}
function Xm(e) {
  if (e instanceof HTMLFormElement)
    return "form";
  const t = Ot(e.tagName);
  return Km.test(t) ? "div" : t;
}
function Jm(e) {
  let t = "";
  return e.indexOf("//") > -1 ? t = e.split("/").slice(0, 3).join("/") : t = e.split("/")[0], t = t.split("?")[0], t;
}
let yt, Io;
const Qm = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm, Zm = /^(?:[a-z+]+:)?\/\//i, eg = /^www\..*/i, tg = /^(data:)([^,]*),(.*)/i;
function sr(e, t) {
  return (e || "").replace(
    Qm,
    (n, r, s, i, o, c) => {
      const a = s || o || c, u = r || i || "";
      if (!a)
        return n;
      if (Zm.test(a) || eg.test(a))
        return `url(${u}${a}${u})`;
      if (tg.test(a))
        return `url(${u}${a}${u})`;
      if (a[0] === "/")
        return `url(${u}${Jm(t) + a}${u})`;
      const l = t.split("/"), d = a.split("/");
      l.pop();
      for (const f of d)
        f !== "." && (f === ".." ? l.pop() : l.push(f));
      return `url(${u}${l.join("/")}${u})`;
    }
  );
}
const ng = /^[^ \t\n\r\u000c]+/, rg = /^[, \t\n\r\u000c]+/;
function sg(e, t) {
  if (t.trim() === "")
    return t;
  let n = 0;
  function r(i) {
    let o;
    const c = i.exec(t.substring(n));
    return c ? (o = c[0], n += o.length, o) : "";
  }
  const s = [];
  for (; r(rg), !(n >= t.length); ) {
    let i = r(ng);
    if (i.slice(-1) === ",")
      i = vt(e, i.substring(0, i.length - 1)), s.push(i);
    else {
      let o = "";
      i = vt(e, i);
      let c = !1;
      for (; ; ) {
        const a = t.charAt(n);
        if (a === "") {
          s.push((i + o).trim());
          break;
        } else if (c)
          a === ")" && (c = !1);
        else if (a === ",") {
          n += 1, s.push((i + o).trim());
          break;
        } else a === "(" && (c = !0);
        o += a, n += 1;
      }
    }
  }
  return s.join(", ");
}
const wo = /* @__PURE__ */ new WeakMap();
function vt(e, t) {
  return !t || t.trim() === "" ? t : yr(e, t);
}
function ig(e) {
  return !!(e.tagName === "svg" || e.ownerSVGElement);
}
function yr(e, t) {
  let n = wo.get(e);
  if (n || (n = e.createElement("a"), wo.set(e, n)), !t)
    t = "";
  else if (t.startsWith("blob:") || t.startsWith("data:"))
    return t;
  return n.setAttribute("href", t), n.href;
}
function Nc(e, t, n, r, s, i) {
  return r && (n === "src" || n === "href" && !(t === "use" && r[0] === "#") || n === "xlink:href" && r[0] !== "#" || n === "background" && (t === "table" || t === "td" || t === "th") ? vt(e, r) : n === "srcset" ? sg(e, r) : n === "style" ? sr(r, yr(e)) : t === "object" && n === "data" ? vt(e, r) : typeof i == "function" ? i(n, r, s) : r);
}
function Dc(e, t, n) {
  return (e === "video" || e === "audio") && t === "autoplay";
}
function Lc(e, t, n, r) {
  try {
    if (r && e.matches(r))
      return !1;
    if (typeof t == "string") {
      if (e.classList.contains(t))
        return !0;
    } else
      for (let s = e.classList.length; s--; ) {
        const i = e.classList[s];
        if (t.test(i))
          return !0;
      }
    if (n)
      return e.matches(n);
  } catch {
  }
  return !1;
}
function og(e, t) {
  for (let n = e.classList.length; n--; ) {
    const r = e.classList[n];
    if (t.test(r))
      return !0;
  }
  return !1;
}
function at(e, t, n = 1 / 0, r = 0) {
  return !e || e.nodeType !== e.ELEMENT_NODE || r > n ? -1 : t(e) ? r : at(e.parentNode, t, n, r + 1);
}
function Tt(e, t) {
  return (n) => {
    const r = n;
    if (r === null) return !1;
    try {
      if (e) {
        if (typeof e == "string") {
          if (r.matches(`.${e}`)) return !0;
        } else if (og(r, e))
          return !0;
      }
      return !!(t && r.matches(t));
    } catch {
      return !1;
    }
  };
}
function Nt(e, t, n, r, s, i) {
  try {
    const o = e.nodeType === e.ELEMENT_NODE ? e : e.parentElement;
    if (o === null) return !1;
    if (o.tagName === "INPUT") {
      const u = o.getAttribute("autocomplete");
      if ([
        "current-password",
        "new-password",
        "cc-number",
        "cc-exp",
        "cc-exp-month",
        "cc-exp-year",
        "cc-csc"
      ].includes(u))
        return !0;
    }
    let c = -1, a = -1;
    if (i) {
      if (a = at(
        o,
        Tt(r, s)
      ), a < 0)
        return !0;
      c = at(
        o,
        Tt(t, n),
        a >= 0 ? a : 1 / 0
      );
    } else {
      if (c = at(
        o,
        Tt(t, n)
      ), c < 0)
        return !1;
      a = at(
        o,
        Tt(r, s),
        c >= 0 ? c : 1 / 0
      );
    }
    return c >= 0 ? a >= 0 ? c <= a : !0 : a >= 0 ? !1 : !!i;
  } catch {
  }
  return !!i;
}
function ag(e, t, n) {
  const r = e.contentWindow;
  if (!r)
    return;
  let s = !1, i;
  try {
    i = r.document.readyState;
  } catch {
    return;
  }
  if (i !== "complete") {
    const c = Ss(() => {
      s || (t(), s = !0);
    }, n);
    e.addEventListener("load", () => {
      Ac(c), s = !0, t();
    });
    return;
  }
  const o = "about:blank";
  if (r.location.href !== o || e.src === o || e.src === "")
    return Ss(t, 0), e.addEventListener("load", t);
  e.addEventListener("load", t);
}
function cg(e, t, n) {
  let r = !1, s;
  try {
    s = e.sheet;
  } catch {
    return;
  }
  if (s) return;
  const i = Ss(() => {
    r || (t(), r = !0);
  }, n);
  e.addEventListener("load", () => {
    Ac(i), r = !0, t();
  });
}
function ug(e, t) {
  const {
    doc: n,
    mirror: r,
    blockClass: s,
    blockSelector: i,
    unblockSelector: o,
    maskAllText: c,
    maskAttributeFn: a,
    maskTextClass: u,
    unmaskTextClass: l,
    maskTextSelector: d,
    unmaskTextSelector: f,
    inlineStylesheet: p,
    maskInputOptions: h = {},
    maskTextFn: m,
    maskInputFn: S,
    dataURLOptions: E = {},
    inlineImages: w,
    recordCanvas: q,
    keepIframeSrcFn: F,
    newlyAddedElement: C = !1
  } = t, _ = lg(n, r);
  switch (e.nodeType) {
    case e.DOCUMENT_NODE:
      return e.compatMode !== "CSS1Compat" ? {
        type: oe.Document,
        childNodes: [],
        compatMode: e.compatMode
        // probably "BackCompat"
      } : {
        type: oe.Document,
        childNodes: []
      };
    case e.DOCUMENT_TYPE_NODE:
      return {
        type: oe.DocumentType,
        name: e.name,
        publicId: e.publicId,
        systemId: e.systemId,
        rootId: _
      };
    case e.ELEMENT_NODE:
      return fg(e, {
        doc: n,
        blockClass: s,
        blockSelector: i,
        unblockSelector: o,
        inlineStylesheet: p,
        maskAttributeFn: a,
        maskInputOptions: h,
        maskInputFn: S,
        dataURLOptions: E,
        inlineImages: w,
        recordCanvas: q,
        keepIframeSrcFn: F,
        newlyAddedElement: C,
        rootId: _,
        maskTextClass: u,
        unmaskTextClass: l,
        maskTextSelector: d,
        unmaskTextSelector: f
      });
    case e.TEXT_NODE:
      return dg(e, {
        doc: n,
        maskAllText: c,
        maskTextClass: u,
        unmaskTextClass: l,
        maskTextSelector: d,
        unmaskTextSelector: f,
        maskTextFn: m,
        maskInputOptions: h,
        maskInputFn: S,
        rootId: _
      });
    case e.CDATA_SECTION_NODE:
      return {
        type: oe.CDATA,
        textContent: "",
        rootId: _
      };
    case e.COMMENT_NODE:
      return {
        type: oe.Comment,
        textContent: e.textContent || "",
        rootId: _
      };
    default:
      return !1;
  }
}
function lg(e, t) {
  if (!t.hasNode(e)) return;
  const n = t.getId(e);
  return n === 1 ? void 0 : n;
}
function dg(e, t) {
  const {
    maskAllText: n,
    maskTextClass: r,
    unmaskTextClass: s,
    maskTextSelector: i,
    unmaskTextSelector: o,
    maskTextFn: c,
    maskInputOptions: a,
    maskInputFn: u,
    rootId: l
  } = t, d = e.parentNode && e.parentNode.tagName;
  let f = e.textContent;
  const p = d === "STYLE" ? !0 : void 0, h = d === "SCRIPT" ? !0 : void 0, m = d === "TEXTAREA" ? !0 : void 0;
  if (p && f) {
    try {
      e.nextSibling || e.previousSibling || e.parentNode.sheet?.cssRules && (f = nr(
        e.parentNode.sheet
      ));
    } catch (E) {
      console.warn(
        `Cannot get CSS styles from text's parentNode. Error: ${E}`,
        e
      );
    }
    f = sr(f, yr(t.doc));
  }
  h && (f = "SCRIPT_PLACEHOLDER");
  const S = Nt(
    e,
    r,
    i,
    s,
    o,
    n
  );
  if (!p && !h && !m && f && S && (f = c ? c(f, e.parentElement) : f.replace(/[\S]/g, "*")), m && f && (a.textarea || S) && (f = u ? u(f, e.parentNode) : f.replace(/[\S]/g, "*")), d === "OPTION" && f) {
    const E = Sr({
      type: null,
      tagName: d,
      maskInputOptions: a
    });
    f = Qt({
      isMasked: Nt(
        e,
        r,
        i,
        s,
        o,
        E
      ),
      element: e,
      value: f,
      maskInputFn: u
    });
  }
  return {
    type: oe.Text,
    textContent: f || "",
    isStyle: p,
    rootId: l
  };
}
function fg(e, t) {
  const {
    doc: n,
    blockClass: r,
    blockSelector: s,
    unblockSelector: i,
    inlineStylesheet: o,
    maskInputOptions: c = {},
    maskAttributeFn: a,
    maskInputFn: u,
    dataURLOptions: l = {},
    inlineImages: d,
    recordCanvas: f,
    keepIframeSrcFn: p,
    newlyAddedElement: h = !1,
    rootId: m,
    maskTextClass: S,
    unmaskTextClass: E,
    maskTextSelector: w,
    unmaskTextSelector: q
  } = t, F = Lc(
    e,
    r,
    s,
    i
  ), C = Xm(e);
  let _ = {};
  const v = e.attributes.length;
  for (let y = 0; y < v; y++) {
    const I = e.attributes[y];
    I.name && !Dc(C, I.name, I.value) && (_[I.name] = Nc(
      n,
      C,
      Ot(I.name),
      I.value,
      e,
      a
    ));
  }
  if (C === "link" && o) {
    const y = Array.from(n.styleSheets).find(($) => $.href === e.href);
    let I = null;
    y && (I = nr(y)), I && (_.rel = null, _.href = null, _.crossorigin = null, _._cssText = sr(I, y.href));
  }
  if (C === "style" && e.sheet && // TODO: Currently we only try to get dynamic stylesheet when it is an empty style element
  !(e.innerText || e.textContent || "").trim().length) {
    const y = nr(
      e.sheet
    );
    y && (_._cssText = sr(y, yr(n)));
  }
  if (C === "input" || C === "textarea" || C === "select" || C === "option") {
    const y = e, I = si(y), $ = rr(y, _s(C), I), A = y.checked;
    if (I !== "submit" && I !== "button" && $) {
      const K = Nt(
        y,
        S,
        w,
        E,
        q,
        Sr({
          type: I,
          tagName: _s(C),
          maskInputOptions: c
        })
      );
      _.value = Qt({
        isMasked: K,
        element: y,
        value: $,
        maskInputFn: u
      });
    }
    A && (_.checked = A);
  }
  if (C === "option" && (e.selected && !c.select ? _.selected = !0 : delete _.selected), C === "canvas" && f) {
    if (e.__context === "2d")
      Gm(e) || (_.rr_dataURL = e.toDataURL(
        l.type,
        l.quality
      ));
    else if (!("__context" in e)) {
      const y = e.toDataURL(
        l.type,
        l.quality
      ), I = n.createElement("canvas");
      I.width = e.width, I.height = e.height;
      const $ = I.toDataURL(
        l.type,
        l.quality
      );
      y !== $ && (_.rr_dataURL = y);
    }
  }
  if (C === "img" && d) {
    yt || (yt = n.createElement("canvas"), Io = yt.getContext("2d"));
    const y = e, I = y.currentSrc || y.getAttribute("src") || "<unknown-src>", $ = y.crossOrigin, A = () => {
      y.removeEventListener("load", A);
      try {
        yt.width = y.naturalWidth, yt.height = y.naturalHeight, Io.drawImage(y, 0, 0), _.rr_dataURL = yt.toDataURL(
          l.type,
          l.quality
        );
      } catch (K) {
        if (y.crossOrigin !== "anonymous") {
          y.crossOrigin = "anonymous", y.complete && y.naturalWidth !== 0 ? A() : y.addEventListener("load", A);
          return;
        } else
          console.warn(
            `Cannot inline img src=${I}! Error: ${K}`
          );
      }
      y.crossOrigin === "anonymous" && ($ ? _.crossOrigin = $ : y.removeAttribute("crossorigin"));
    };
    y.complete && y.naturalWidth !== 0 ? A() : y.addEventListener("load", A);
  }
  if ((C === "audio" || C === "video") && (_.rr_mediaState = e.paused ? "paused" : "played", _.rr_mediaCurrentTime = e.currentTime), h || (e.scrollLeft && (_.rr_scrollLeft = e.scrollLeft), e.scrollTop && (_.rr_scrollTop = e.scrollTop)), F) {
    const { width: y, height: I } = e.getBoundingClientRect();
    _ = {
      class: _.class,
      rr_width: `${y}px`,
      rr_height: `${I}px`
    };
  }
  C === "iframe" && !p(_.src) && (!F && !Oc(e) && (_.rr_src = _.src), delete _.src);
  let M;
  try {
    customElements.get(C) && (M = !0);
  } catch {
  }
  return {
    type: oe.Element,
    tagName: C,
    attributes: _,
    childNodes: [],
    isSVG: ig(e) || void 0,
    needBlock: F,
    rootId: m,
    isCustom: M
  };
}
function Q(e) {
  return e == null ? "" : e.toLowerCase();
}
function pg(e, t) {
  if (t.comment && e.type === oe.Comment)
    return !0;
  if (e.type === oe.Element) {
    if (t.script && // script tag
    (e.tagName === "script" || // (module)preload link
    e.tagName === "link" && (e.attributes.rel === "preload" || e.attributes.rel === "modulepreload") || // prefetch link
    e.tagName === "link" && e.attributes.rel === "prefetch" && typeof e.attributes.href == "string" && xc(e.attributes.href) === "js"))
      return !0;
    if (t.headFavicon && (e.tagName === "link" && e.attributes.rel === "shortcut icon" || e.tagName === "meta" && (Q(e.attributes.name).match(
      /^msapplication-tile(image|color)$/
    ) || Q(e.attributes.name) === "application-name" || Q(e.attributes.rel) === "icon" || Q(e.attributes.rel) === "apple-touch-icon" || Q(e.attributes.rel) === "shortcut icon")))
      return !0;
    if (e.tagName === "meta") {
      if (t.headMetaDescKeywords && Q(e.attributes.name).match(/^description|keywords$/))
        return !0;
      if (t.headMetaSocial && (Q(e.attributes.property).match(/^(og|twitter|fb):/) || // og = opengraph (facebook)
      Q(e.attributes.name).match(/^(og|twitter):/) || Q(e.attributes.name) === "pinterest"))
        return !0;
      if (t.headMetaRobots && (Q(e.attributes.name) === "robots" || Q(e.attributes.name) === "googlebot" || Q(e.attributes.name) === "bingbot"))
        return !0;
      if (t.headMetaHttpEquiv && e.attributes["http-equiv"] !== void 0)
        return !0;
      if (t.headMetaAuthorship && (Q(e.attributes.name) === "author" || Q(e.attributes.name) === "generator" || Q(e.attributes.name) === "framework" || Q(e.attributes.name) === "publisher" || Q(e.attributes.name) === "progid" || Q(e.attributes.property).match(/^article:/) || Q(e.attributes.property).match(/^product:/)))
        return !0;
      if (t.headMetaVerification && (Q(e.attributes.name) === "google-site-verification" || Q(e.attributes.name) === "yandex-verification" || Q(e.attributes.name) === "csrf-token" || Q(e.attributes.name) === "p:domain_verify" || Q(e.attributes.name) === "verify-v1" || Q(e.attributes.name) === "verification" || Q(e.attributes.name) === "shopify-checkout-api-token"))
        return !0;
    }
  }
  return !1;
}
function It(e, t) {
  const {
    doc: n,
    mirror: r,
    blockClass: s,
    blockSelector: i,
    unblockSelector: o,
    maskAllText: c,
    maskTextClass: a,
    unmaskTextClass: u,
    maskTextSelector: l,
    unmaskTextSelector: d,
    skipChild: f = !1,
    inlineStylesheet: p = !0,
    maskInputOptions: h = {},
    maskAttributeFn: m,
    maskTextFn: S,
    maskInputFn: E,
    slimDOMOptions: w,
    dataURLOptions: q = {},
    inlineImages: F = !1,
    recordCanvas: C = !1,
    onSerialize: _,
    onIframeLoad: v,
    iframeLoadTimeout: M = 5e3,
    onStylesheetLoad: y,
    stylesheetLoadTimeout: I = 5e3,
    keepIframeSrcFn: $ = () => !1,
    newlyAddedElement: A = !1
  } = t;
  let { preserveWhiteSpace: K = !0 } = t;
  const J = ug(e, {
    doc: n,
    mirror: r,
    blockClass: s,
    blockSelector: i,
    maskAllText: c,
    unblockSelector: o,
    maskTextClass: a,
    unmaskTextClass: u,
    maskTextSelector: l,
    unmaskTextSelector: d,
    inlineStylesheet: p,
    maskInputOptions: h,
    maskAttributeFn: m,
    maskTextFn: S,
    maskInputFn: E,
    dataURLOptions: q,
    inlineImages: F,
    recordCanvas: C,
    keepIframeSrcFn: $,
    newlyAddedElement: A
  });
  if (!J)
    return console.warn(e, "not serialized"), null;
  let L;
  r.hasNode(e) ? L = r.getId(e) : pg(J, w) || !K && J.type === oe.Text && !J.isStyle && !J.textContent.replace(/^\s+|\s+$/gm, "").length ? L = Zt : L = ii();
  const T = Object.assign(J, { id: L });
  if (r.add(e, T), L === Zt)
    return null;
  _ && _(e);
  let D = !f;
  if (T.type === oe.Element) {
    D = D && !T.needBlock, delete T.needBlock;
    const O = e.shadowRoot;
    O && Vt(O) && (T.isShadowHost = !0);
  }
  if ((T.type === oe.Document || T.type === oe.Element) && D) {
    w.headWhitespace && T.type === oe.Element && T.tagName === "head" && (K = !1);
    const O = {
      doc: n,
      mirror: r,
      blockClass: s,
      blockSelector: i,
      maskAllText: c,
      unblockSelector: o,
      maskTextClass: a,
      unmaskTextClass: u,
      maskTextSelector: l,
      unmaskTextSelector: d,
      skipChild: f,
      inlineStylesheet: p,
      maskInputOptions: h,
      maskAttributeFn: m,
      maskTextFn: S,
      maskInputFn: E,
      slimDOMOptions: w,
      dataURLOptions: q,
      inlineImages: F,
      recordCanvas: C,
      preserveWhiteSpace: K,
      onSerialize: _,
      onIframeLoad: v,
      iframeLoadTimeout: M,
      onStylesheetLoad: y,
      stylesheetLoadTimeout: I,
      keepIframeSrcFn: $
    };
    for (const X of Array.from(e.childNodes)) {
      const ie = It(X, O);
      ie && T.childNodes.push(ie);
    }
    if (Bm(e) && e.shadowRoot)
      for (const X of Array.from(e.shadowRoot.childNodes)) {
        const ie = It(X, O);
        ie && (Vt(e.shadowRoot) && (ie.isShadow = !0), T.childNodes.push(ie));
      }
  }
  return e.parentNode && qt(e.parentNode) && Vt(e.parentNode) && (T.isShadow = !0), T.type === oe.Element && T.tagName === "iframe" && !Lc(
    e,
    s,
    i,
    o
  ) && ag(
    e,
    () => {
      const O = Oc(e);
      if (O && v) {
        const X = It(O, {
          doc: O,
          mirror: r,
          blockClass: s,
          blockSelector: i,
          unblockSelector: o,
          maskAllText: c,
          maskTextClass: a,
          unmaskTextClass: u,
          maskTextSelector: l,
          unmaskTextSelector: d,
          skipChild: !1,
          inlineStylesheet: p,
          maskInputOptions: h,
          maskAttributeFn: m,
          maskTextFn: S,
          maskInputFn: E,
          slimDOMOptions: w,
          dataURLOptions: q,
          inlineImages: F,
          recordCanvas: C,
          preserveWhiteSpace: K,
          onSerialize: _,
          onIframeLoad: v,
          iframeLoadTimeout: M,
          onStylesheetLoad: y,
          stylesheetLoadTimeout: I,
          keepIframeSrcFn: $
        });
        X && v(
          e,
          X
        );
      }
    },
    M
  ), T.type === oe.Element && T.tagName === "link" && typeof T.attributes.rel == "string" && (T.attributes.rel === "stylesheet" || T.attributes.rel === "preload" && typeof T.attributes.href == "string" && xc(T.attributes.href) === "css") && cg(
    e,
    () => {
      if (y) {
        const O = It(e, {
          doc: n,
          mirror: r,
          blockClass: s,
          blockSelector: i,
          unblockSelector: o,
          maskAllText: c,
          maskTextClass: a,
          unmaskTextClass: u,
          maskTextSelector: l,
          unmaskTextSelector: d,
          skipChild: !1,
          inlineStylesheet: p,
          maskInputOptions: h,
          maskAttributeFn: m,
          maskTextFn: S,
          maskInputFn: E,
          slimDOMOptions: w,
          dataURLOptions: q,
          inlineImages: F,
          recordCanvas: C,
          preserveWhiteSpace: K,
          onSerialize: _,
          onIframeLoad: v,
          iframeLoadTimeout: M,
          onStylesheetLoad: y,
          stylesheetLoadTimeout: I,
          keepIframeSrcFn: $
        });
        O && y(
          e,
          O
        );
      }
    },
    I
  ), T;
}
function hg(e, t) {
  const {
    mirror: n = new Cc(),
    blockClass: r = "rr-block",
    blockSelector: s = null,
    unblockSelector: i = null,
    maskAllText: o = !1,
    maskTextClass: c = "rr-mask",
    unmaskTextClass: a = null,
    maskTextSelector: u = null,
    unmaskTextSelector: l = null,
    inlineStylesheet: d = !0,
    inlineImages: f = !1,
    recordCanvas: p = !1,
    maskAllInputs: h = !1,
    maskAttributeFn: m,
    maskTextFn: S,
    maskInputFn: E,
    slimDOM: w = !1,
    dataURLOptions: q,
    preserveWhiteSpace: F,
    onSerialize: C,
    onIframeLoad: _,
    iframeLoadTimeout: v,
    onStylesheetLoad: M,
    stylesheetLoadTimeout: y,
    keepIframeSrcFn: I = () => !1
  } = t || {};
  return It(e, {
    doc: e,
    mirror: n,
    blockClass: r,
    blockSelector: s,
    unblockSelector: i,
    maskAllText: o,
    maskTextClass: c,
    unmaskTextClass: a,
    maskTextSelector: u,
    unmaskTextSelector: l,
    skipChild: !1,
    inlineStylesheet: d,
    maskInputOptions: h === !0 ? {
      color: !0,
      date: !0,
      "datetime-local": !0,
      email: !0,
      month: !0,
      number: !0,
      range: !0,
      search: !0,
      tel: !0,
      text: !0,
      time: !0,
      url: !0,
      week: !0,
      textarea: !0,
      select: !0
    } : h === !1 ? {} : h,
    maskAttributeFn: m,
    maskTextFn: S,
    maskInputFn: E,
    slimDOMOptions: w === !0 || w === "all" ? (
      // if true: set of sensible options that should not throw away any information
      {
        script: !0,
        comment: !0,
        headFavicon: !0,
        headWhitespace: !0,
        headMetaDescKeywords: w === "all",
        // destructive
        headMetaSocial: !0,
        headMetaRobots: !0,
        headMetaHttpEquiv: !0,
        headMetaAuthorship: !0,
        headMetaVerification: !0
      }
    ) : w === !1 ? {} : w,
    dataURLOptions: q,
    inlineImages: f,
    recordCanvas: p,
    preserveWhiteSpace: F,
    onSerialize: C,
    onIframeLoad: _,
    iframeLoadTimeout: v,
    onStylesheetLoad: M,
    stylesheetLoadTimeout: y,
    keepIframeSrcFn: I,
    newlyAddedElement: !1
  });
}
function de(e, t, n = document) {
  const r = { capture: !0, passive: !0 };
  return n.addEventListener(e, t, r), () => n.removeEventListener(e, t, r);
}
const Et = `Please stop import mirror directly. Instead of that,\r
now you can use replayer.getMirror() to access the mirror instance of a replayer,\r
or you can use record.mirror to access the mirror instance during recording.`;
let ko = {
  map: {},
  getId() {
    return console.error(Et), -1;
  },
  getNode() {
    return console.error(Et), null;
  },
  removeNodeFromMap() {
    console.error(Et);
  },
  has() {
    return console.error(Et), !1;
  },
  reset() {
    console.error(Et);
  }
};
typeof window < "u" && window.Proxy && window.Reflect && (ko = new Proxy(ko, {
  get(e, t, n) {
    return t === "map" && console.error(Et), Reflect.get(e, t, n);
  }
}));
function en(e, t, n = {}) {
  let r = null, s = 0;
  return function(...i) {
    const o = Date.now();
    !s && n.leading === !1 && (s = o);
    const c = t - (o - s), a = this;
    c <= 0 || c > t ? (r && (bg(r), r = null), s = o, e.apply(a, i)) : !r && n.trailing !== !1 && (r = Er(() => {
      s = n.leading === !1 ? 0 : Date.now(), r = null, e.apply(a, i);
    }, c));
  };
}
function Pc(e, t, n, r, s = window) {
  const i = s.Object.getOwnPropertyDescriptor(e, t);
  return s.Object.defineProperty(
    e,
    t,
    r ? n : {
      set(o) {
        Er(() => {
          n.set.call(this, o);
        }, 0), i && i.set && i.set.call(this, o);
      }
    }
  ), () => Pc(e, t, i || {}, !0);
}
function oi(e, t, n) {
  try {
    if (!(t in e))
      return () => {
      };
    const r = e[t], s = n(r);
    return typeof s == "function" && (s.prototype = s.prototype || {}, Object.defineProperties(s, {
      __rrweb_original__: {
        enumerable: !1,
        value: r
      }
    })), e[t] = s, () => {
      e[t] = r;
    };
  } catch {
    return () => {
    };
  }
}
let ir = Date.now;
/* @__PURE__ */ /[1-9][0-9]{12}/.test(Date.now().toString()) || (ir = () => (/* @__PURE__ */ new Date()).getTime());
function Fc(e) {
  const t = e.document;
  return {
    left: t.scrollingElement ? t.scrollingElement.scrollLeft : e.pageXOffset !== void 0 ? e.pageXOffset : t?.documentElement.scrollLeft || t?.body?.parentElement?.scrollLeft || t?.body?.scrollLeft || 0,
    top: t.scrollingElement ? t.scrollingElement.scrollTop : e.pageYOffset !== void 0 ? e.pageYOffset : t?.documentElement.scrollTop || t?.body?.parentElement?.scrollTop || t?.body?.scrollTop || 0
  };
}
function $c() {
  return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function Bc() {
  return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function Uc(e) {
  if (!e)
    return null;
  try {
    return e.nodeType === e.ELEMENT_NODE ? e : e.parentElement;
  } catch {
    return null;
  }
}
function ge(e, t, n, r, s) {
  if (!e)
    return !1;
  const i = Uc(e);
  if (!i)
    return !1;
  const o = Tt(t, n);
  if (!s) {
    const u = r && i.matches(r);
    return o(i) && !u;
  }
  const c = at(i, o);
  let a = -1;
  return c < 0 ? !1 : (r && (a = at(
    i,
    Tt(null, r)
  )), c > -1 && a < 0 ? !0 : c < a);
}
function mg(e, t) {
  return t.getId(e) !== -1;
}
function jr(e, t) {
  return t.getId(e) === Zt;
}
function Hc(e, t) {
  if (qt(e))
    return !1;
  const n = t.getId(e);
  return t.has(n) ? e.parentNode && e.parentNode.nodeType === e.DOCUMENT_NODE ? !1 : e.parentNode ? Hc(e.parentNode, t) : !0 : !0;
}
function ys(e) {
  return !!e.changedTouches;
}
function gg(e = window) {
  "NodeList" in e && !e.NodeList.prototype.forEach && (e.NodeList.prototype.forEach = Array.prototype.forEach), "DOMTokenList" in e && !e.DOMTokenList.prototype.forEach && (e.DOMTokenList.prototype.forEach = Array.prototype.forEach), Node.prototype.contains || (Node.prototype.contains = (...t) => {
    let n = t[0];
    if (!(0 in t))
      throw new TypeError("1 argument is required");
    do
      if (this === n)
        return !0;
    while (n = n && n.parentNode);
    return !1;
  });
}
function Wc(e, t) {
  return !!(e.nodeName === "IFRAME" && t.getMeta(e));
}
function zc(e, t) {
  return !!(e.nodeName === "LINK" && e.nodeType === e.ELEMENT_NODE && e.getAttribute && e.getAttribute("rel") === "stylesheet" && t.getMeta(e));
}
function Es(e) {
  return !!e?.shadowRoot;
}
class _g {
  constructor() {
    this.id = 1, this.styleIDMap = /* @__PURE__ */ new WeakMap(), this.idStyleMap = /* @__PURE__ */ new Map();
  }
  getId(t) {
    return this.styleIDMap.get(t) ?? -1;
  }
  has(t) {
    return this.styleIDMap.has(t);
  }
  /**
   * @returns If the stylesheet is in the mirror, returns the id of the stylesheet. If not, return the new assigned id.
   */
  add(t, n) {
    if (this.has(t)) return this.getId(t);
    let r;
    return n === void 0 ? r = this.id++ : r = n, this.styleIDMap.set(t, r), this.idStyleMap.set(r, t), r;
  }
  getStyle(t) {
    return this.idStyleMap.get(t) || null;
  }
  reset() {
    this.styleIDMap = /* @__PURE__ */ new WeakMap(), this.idStyleMap = /* @__PURE__ */ new Map(), this.id = 1;
  }
  generateId() {
    return this.id++;
  }
}
function jc(e) {
  let t = null;
  return e.getRootNode?.()?.nodeType === Node.DOCUMENT_FRAGMENT_NODE && e.getRootNode().host && (t = e.getRootNode().host), t;
}
function Sg(e) {
  let t = e, n;
  for (; n = jc(t); )
    t = n;
  return t;
}
function yg(e) {
  const t = e.ownerDocument;
  if (!t) return !1;
  const n = Sg(e);
  return t.contains(n);
}
function qc(e) {
  const t = e.ownerDocument;
  return t ? t.contains(e) || yg(e) : !1;
}
const Ro = {};
function ai(e) {
  const t = Ro[e];
  if (t)
    return t;
  const n = window.document;
  let r = window[e];
  if (n && typeof n.createElement == "function")
    try {
      const s = n.createElement("iframe");
      s.hidden = !0, n.head.appendChild(s);
      const i = s.contentWindow;
      i && i[e] && (r = // eslint-disable-next-line @typescript-eslint/unbound-method
      i[e]), n.head.removeChild(s);
    } catch {
    }
  return Ro[e] = r.bind(
    window
  );
}
function Eg(...e) {
  return ai("requestAnimationFrame")(...e);
}
function Er(...e) {
  return ai("setTimeout")(...e);
}
function bg(...e) {
  return ai("clearTimeout")(...e);
}
var P = /* @__PURE__ */ ((e) => (e[e.DomContentLoaded = 0] = "DomContentLoaded", e[e.Load = 1] = "Load", e[e.FullSnapshot = 2] = "FullSnapshot", e[e.IncrementalSnapshot = 3] = "IncrementalSnapshot", e[e.Meta = 4] = "Meta", e[e.Custom = 5] = "Custom", e[e.Plugin = 6] = "Plugin", e))(P || {}), x = /* @__PURE__ */ ((e) => (e[e.Mutation = 0] = "Mutation", e[e.MouseMove = 1] = "MouseMove", e[e.MouseInteraction = 2] = "MouseInteraction", e[e.Scroll = 3] = "Scroll", e[e.ViewportResize = 4] = "ViewportResize", e[e.Input = 5] = "Input", e[e.TouchMove = 6] = "TouchMove", e[e.MediaInteraction = 7] = "MediaInteraction", e[e.StyleSheetRule = 8] = "StyleSheetRule", e[e.CanvasMutation = 9] = "CanvasMutation", e[e.Font = 10] = "Font", e[e.Log = 11] = "Log", e[e.Drag = 12] = "Drag", e[e.StyleDeclaration = 13] = "StyleDeclaration", e[e.Selection = 14] = "Selection", e[e.AdoptedStyleSheet = 15] = "AdoptedStyleSheet", e[e.CustomElement = 16] = "CustomElement", e))(x || {}), le = /* @__PURE__ */ ((e) => (e[e.MouseUp = 0] = "MouseUp", e[e.MouseDown = 1] = "MouseDown", e[e.Click = 2] = "Click", e[e.ContextMenu = 3] = "ContextMenu", e[e.DblClick = 4] = "DblClick", e[e.Focus = 5] = "Focus", e[e.Blur = 6] = "Blur", e[e.TouchStart = 7] = "TouchStart", e[e.TouchMove_Departed = 8] = "TouchMove_Departed", e[e.TouchEnd = 9] = "TouchEnd", e[e.TouchCancel = 10] = "TouchCancel", e))(le || {}), Oe = /* @__PURE__ */ ((e) => (e[e.Mouse = 0] = "Mouse", e[e.Pen = 1] = "Pen", e[e.Touch = 2] = "Touch", e))(Oe || {}), bt = /* @__PURE__ */ ((e) => (e[e.Play = 0] = "Play", e[e.Pause = 1] = "Pause", e[e.Seeked = 2] = "Seeked", e[e.VolumeChange = 3] = "VolumeChange", e[e.RateChange = 4] = "RateChange", e))(bt || {});
function ci(e) {
  try {
    return e.contentDocument;
  } catch {
  }
}
function vg(e) {
  try {
    return e.contentWindow;
  } catch {
  }
}
function Co(e) {
  return "__ln" in e;
}
class Tg {
  constructor() {
    this.length = 0, this.head = null, this.tail = null;
  }
  get(t) {
    if (t >= this.length)
      throw new Error("Position outside of list range");
    let n = this.head;
    for (let r = 0; r < t; r++)
      n = n?.next || null;
    return n;
  }
  addNode(t) {
    const n = {
      value: t,
      previous: null,
      next: null
    };
    if (t.__ln = n, t.previousSibling && Co(t.previousSibling)) {
      const r = t.previousSibling.__ln.next;
      n.next = r, n.previous = t.previousSibling.__ln, t.previousSibling.__ln.next = n, r && (r.previous = n);
    } else if (t.nextSibling && Co(t.nextSibling) && t.nextSibling.__ln.previous) {
      const r = t.nextSibling.__ln.previous;
      n.previous = r, n.next = t.nextSibling.__ln, t.nextSibling.__ln.previous = n, r && (r.next = n);
    } else
      this.head && (this.head.previous = n), n.next = this.head, this.head = n;
    n.next === null && (this.tail = n), this.length++;
  }
  removeNode(t) {
    const n = t.__ln;
    this.head && (n.previous ? (n.previous.next = n.next, n.next ? n.next.previous = n.previous : this.tail = n.previous) : (this.head = n.next, this.head ? this.head.previous = null : this.tail = null), t.__ln && delete t.__ln, this.length--);
  }
}
const xo = (e, t) => `${e}@${t}`;
class Ig {
  constructor() {
    this.frozen = !1, this.locked = !1, this.texts = [], this.attributes = [], this.attributeMap = /* @__PURE__ */ new WeakMap(), this.removes = [], this.mapRemoves = [], this.movedMap = {}, this.addedSet = /* @__PURE__ */ new Set(), this.movedSet = /* @__PURE__ */ new Set(), this.droppedSet = /* @__PURE__ */ new Set(), this.processMutations = (t) => {
      t.forEach(this.processMutation), this.emit();
    }, this.emit = () => {
      if (this.frozen || this.locked)
        return;
      const t = [], n = /* @__PURE__ */ new Set(), r = new Tg(), s = (a) => {
        let u = a, l = Zt;
        for (; l === Zt; )
          u = u && u.nextSibling, l = u && this.mirror.getId(u);
        return l;
      }, i = (a) => {
        if (!a.parentNode || !qc(a))
          return;
        const u = qt(a.parentNode) ? this.mirror.getId(jc(a)) : this.mirror.getId(a.parentNode), l = s(a);
        if (u === -1 || l === -1)
          return r.addNode(a);
        const d = It(a, {
          doc: this.doc,
          mirror: this.mirror,
          blockClass: this.blockClass,
          blockSelector: this.blockSelector,
          maskAllText: this.maskAllText,
          unblockSelector: this.unblockSelector,
          maskTextClass: this.maskTextClass,
          unmaskTextClass: this.unmaskTextClass,
          maskTextSelector: this.maskTextSelector,
          unmaskTextSelector: this.unmaskTextSelector,
          skipChild: !0,
          newlyAddedElement: !0,
          inlineStylesheet: this.inlineStylesheet,
          maskInputOptions: this.maskInputOptions,
          maskAttributeFn: this.maskAttributeFn,
          maskTextFn: this.maskTextFn,
          maskInputFn: this.maskInputFn,
          slimDOMOptions: this.slimDOMOptions,
          dataURLOptions: this.dataURLOptions,
          recordCanvas: this.recordCanvas,
          inlineImages: this.inlineImages,
          onSerialize: (f) => {
            Wc(f, this.mirror) && !ge(
              f,
              this.blockClass,
              this.blockSelector,
              this.unblockSelector,
              !1
            ) && this.iframeManager.addIframe(f), zc(f, this.mirror) && this.stylesheetManager.trackLinkElement(
              f
            ), Es(a) && this.shadowDomManager.addShadowRoot(a.shadowRoot, this.doc);
          },
          onIframeLoad: (f, p) => {
            ge(
              f,
              this.blockClass,
              this.blockSelector,
              this.unblockSelector,
              !1
            ) || (this.iframeManager.attachIframe(f, p), f.contentWindow && this.canvasManager.addWindow(f.contentWindow), this.shadowDomManager.observeAttachShadow(f));
          },
          onStylesheetLoad: (f, p) => {
            this.stylesheetManager.attachLinkElement(f, p);
          }
        });
        d && (t.push({
          parentId: u,
          nextId: l,
          node: d
        }), n.add(d.id));
      };
      for (; this.mapRemoves.length; )
        this.mirror.removeNodeFromMap(this.mapRemoves.shift());
      for (const a of this.movedSet)
        Mo(this.removes, a, this.mirror) && !this.movedSet.has(a.parentNode) || i(a);
      for (const a of this.addedSet)
        !Ao(this.droppedSet, a) && !Mo(this.removes, a, this.mirror) || Ao(this.movedSet, a) ? i(a) : this.droppedSet.add(a);
      let o = null;
      for (; r.length; ) {
        let a = null;
        if (o) {
          const u = this.mirror.getId(o.value.parentNode), l = s(o.value);
          u !== -1 && l !== -1 && (a = o);
        }
        if (!a) {
          let u = r.tail;
          for (; u; ) {
            const l = u;
            if (u = u.previous, l) {
              const d = this.mirror.getId(l.value.parentNode);
              if (s(l.value) === -1) continue;
              if (d !== -1) {
                a = l;
                break;
              } else {
                const p = l.value;
                if (p.parentNode && p.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                  const h = p.parentNode.host;
                  if (this.mirror.getId(h) !== -1) {
                    a = l;
                    break;
                  }
                }
              }
            }
          }
        }
        if (!a) {
          for (; r.head; )
            r.removeNode(r.head.value);
          break;
        }
        o = a.previous, r.removeNode(a.value), i(a.value);
      }
      const c = {
        texts: this.texts.map((a) => ({
          id: this.mirror.getId(a.node),
          value: a.value
        })).filter((a) => !n.has(a.id)).filter((a) => this.mirror.has(a.id)),
        attributes: this.attributes.map((a) => {
          const { attributes: u } = a;
          if (typeof u.style == "string") {
            const l = JSON.stringify(a.styleDiff), d = JSON.stringify(a._unchangedStyles);
            l.length < u.style.length && (l + d).split("var(").length === u.style.split("var(").length && (u.style = a.styleDiff);
          }
          return {
            id: this.mirror.getId(a.node),
            attributes: u
          };
        }).filter((a) => !n.has(a.id)).filter((a) => this.mirror.has(a.id)),
        removes: this.removes,
        adds: t
      };
      !c.texts.length && !c.attributes.length && !c.removes.length && !c.adds.length || (this.texts = [], this.attributes = [], this.attributeMap = /* @__PURE__ */ new WeakMap(), this.removes = [], this.addedSet = /* @__PURE__ */ new Set(), this.movedSet = /* @__PURE__ */ new Set(), this.droppedSet = /* @__PURE__ */ new Set(), this.movedMap = {}, this.mutationCb(c));
    }, this.processMutation = (t) => {
      if (!jr(t.target, this.mirror))
        switch (t.type) {
          case "characterData": {
            const n = t.target.textContent;
            !ge(
              t.target,
              this.blockClass,
              this.blockSelector,
              this.unblockSelector,
              !1
            ) && n !== t.oldValue && this.texts.push({
              value: Nt(
                t.target,
                this.maskTextClass,
                this.maskTextSelector,
                this.unmaskTextClass,
                this.unmaskTextSelector,
                this.maskAllText
              ) && n ? this.maskTextFn ? this.maskTextFn(n, Uc(t.target)) : n.replace(/[\S]/g, "*") : n,
              node: t.target
            });
            break;
          }
          case "attributes": {
            const n = t.target;
            let r = t.attributeName, s = t.target.getAttribute(r);
            if (r === "value") {
              const o = si(n), c = n.tagName;
              s = rr(n, c, o);
              const a = Sr({
                maskInputOptions: this.maskInputOptions,
                tagName: c,
                type: o
              }), u = Nt(
                t.target,
                this.maskTextClass,
                this.maskTextSelector,
                this.unmaskTextClass,
                this.unmaskTextSelector,
                a
              );
              s = Qt({
                isMasked: u,
                element: n,
                value: s,
                maskInputFn: this.maskInputFn
              });
            }
            if (ge(
              t.target,
              this.blockClass,
              this.blockSelector,
              this.unblockSelector,
              !1
            ) || s === t.oldValue)
              return;
            let i = this.attributeMap.get(t.target);
            if (n.tagName === "IFRAME" && r === "src" && !this.keepIframeSrcFn(s))
              if (!ci(
                n
              ))
                r = "rr_src";
              else
                return;
            if (i || (i = {
              node: t.target,
              attributes: {},
              styleDiff: {},
              _unchangedStyles: {}
            }, this.attributes.push(i), this.attributeMap.set(t.target, i)), r === "type" && n.tagName === "INPUT" && (t.oldValue || "").toLowerCase() === "password" && n.setAttribute("data-rr-is-password", "true"), !Dc(n.tagName, r) && (i.attributes[r] = Nc(
              this.doc,
              Ot(n.tagName),
              Ot(r),
              s,
              n,
              this.maskAttributeFn
            ), r === "style")) {
              if (!this.unattachedDoc)
                try {
                  this.unattachedDoc = document.implementation.createHTMLDocument();
                } catch {
                  this.unattachedDoc = this.doc;
                }
              const o = this.unattachedDoc.createElement("span");
              t.oldValue && o.setAttribute("style", t.oldValue);
              for (const c of Array.from(n.style)) {
                const a = n.style.getPropertyValue(c), u = n.style.getPropertyPriority(c);
                a !== o.style.getPropertyValue(c) || u !== o.style.getPropertyPriority(c) ? u === "" ? i.styleDiff[c] = a : i.styleDiff[c] = [a, u] : i._unchangedStyles[c] = [a, u];
              }
              for (const c of Array.from(o.style))
                n.style.getPropertyValue(c) === "" && (i.styleDiff[c] = !1);
            }
            break;
          }
          case "childList": {
            if (ge(
              t.target,
              this.blockClass,
              this.blockSelector,
              this.unblockSelector,
              !0
            ))
              return;
            t.addedNodes.forEach((n) => this.genAdds(n, t.target)), t.removedNodes.forEach((n) => {
              const r = this.mirror.getId(n), s = qt(t.target) ? this.mirror.getId(t.target.host) : this.mirror.getId(t.target);
              ge(
                t.target,
                this.blockClass,
                this.blockSelector,
                this.unblockSelector,
                !1
              ) || jr(n, this.mirror) || !mg(n, this.mirror) || (this.addedSet.has(n) ? (bs(this.addedSet, n), this.droppedSet.add(n)) : this.addedSet.has(t.target) && r === -1 || Hc(t.target, this.mirror) || (this.movedSet.has(n) && this.movedMap[xo(r, s)] ? bs(this.movedSet, n) : this.removes.push({
                parentId: s,
                id: r,
                isShadow: qt(t.target) && Vt(t.target) ? !0 : void 0
              })), this.mapRemoves.push(n));
            });
            break;
          }
        }
    }, this.genAdds = (t, n) => {
      if (!this.processedNodeManager.inOtherBuffer(t, this) && !(this.addedSet.has(t) || this.movedSet.has(t))) {
        if (this.mirror.hasNode(t)) {
          if (jr(t, this.mirror))
            return;
          this.movedSet.add(t);
          let r = null;
          n && this.mirror.hasNode(n) && (r = this.mirror.getId(n)), r && r !== -1 && (this.movedMap[xo(this.mirror.getId(t), r)] = !0);
        } else
          this.addedSet.add(t), this.droppedSet.delete(t);
        ge(
          t,
          this.blockClass,
          this.blockSelector,
          this.unblockSelector,
          !1
        ) || (t.childNodes.forEach((r) => this.genAdds(r)), Es(t) && t.shadowRoot.childNodes.forEach((r) => {
          this.processedNodeManager.add(r, this), this.genAdds(r, t);
        }));
      }
    };
  }
  init(t) {
    [
      "mutationCb",
      "blockClass",
      "blockSelector",
      "unblockSelector",
      "maskAllText",
      "maskTextClass",
      "unmaskTextClass",
      "maskTextSelector",
      "unmaskTextSelector",
      "inlineStylesheet",
      "maskInputOptions",
      "maskAttributeFn",
      "maskTextFn",
      "maskInputFn",
      "keepIframeSrcFn",
      "recordCanvas",
      "inlineImages",
      "slimDOMOptions",
      "dataURLOptions",
      "doc",
      "mirror",
      "iframeManager",
      "stylesheetManager",
      "shadowDomManager",
      "canvasManager",
      "processedNodeManager"
    ].forEach((n) => {
      this[n] = t[n];
    });
  }
  freeze() {
    this.frozen = !0, this.canvasManager.freeze();
  }
  unfreeze() {
    this.frozen = !1, this.canvasManager.unfreeze(), this.emit();
  }
  isFrozen() {
    return this.frozen;
  }
  lock() {
    this.locked = !0, this.canvasManager.lock();
  }
  unlock() {
    this.locked = !1, this.canvasManager.unlock(), this.emit();
  }
  reset() {
    this.shadowDomManager.reset(), this.canvasManager.reset();
  }
}
function bs(e, t) {
  e.delete(t), t.childNodes.forEach((n) => bs(e, n));
}
function Mo(e, t, n) {
  return e.length === 0 ? !1 : wg(e, t, n);
}
function wg(e, t, n) {
  let r = t.parentNode;
  for (; r; ) {
    const s = n.getId(r);
    if (e.some((i) => i.id === s))
      return !0;
    r = r.parentNode;
  }
  return !1;
}
function Ao(e, t) {
  return e.size === 0 ? !1 : Vc(e, t);
}
function Vc(e, t) {
  const { parentNode: n } = t;
  return n ? e.has(n) ? !0 : Vc(e, n) : !1;
}
let Gt;
function kg(e) {
  Gt = e;
}
function Rg() {
  Gt = void 0;
}
const W = (e) => Gt ? (...n) => {
  try {
    return e(...n);
  } catch (r) {
    if (Gt && Gt(r) === !0)
      return () => {
      };
    throw r;
  }
} : e, wt = [];
function _n(e) {
  try {
    if ("composedPath" in e) {
      const t = e.composedPath();
      if (t.length)
        return t[0];
    } else if ("path" in e && e.path.length)
      return e.path[0];
  } catch {
  }
  return e && e.target;
}
function Gc(e, t) {
  const n = new Ig();
  wt.push(n), n.init(e);
  let r = window.MutationObserver || /**
  * Some websites may disable MutationObserver by removing it from the window object.
  * If someone is using rrweb to build a browser extention or things like it, they
  * could not change the website's code but can have an opportunity to inject some
  * code before the website executing its JS logic.
  * Then they can do this to store the native MutationObserver:
  * window.__rrMutationObserver = MutationObserver
  */
  window.__rrMutationObserver;
  const s = window?.Zone?.__symbol__?.("MutationObserver");
  s && window[s] && (r = window[s]);
  const i = new r(
    W((o) => {
      e.onMutation && e.onMutation(o) === !1 || n.processMutations.bind(n)(o);
    })
  );
  return i.observe(t, {
    attributes: !0,
    attributeOldValue: !0,
    characterData: !0,
    characterDataOldValue: !0,
    childList: !0,
    subtree: !0
  }), i;
}
function Cg({
  mousemoveCb: e,
  sampling: t,
  doc: n,
  mirror: r
}) {
  if (t.mousemove === !1)
    return () => {
    };
  const s = typeof t.mousemove == "number" ? t.mousemove : 50, i = typeof t.mousemoveCallback == "number" ? t.mousemoveCallback : 500;
  let o = [], c;
  const a = en(
    W(
      (d) => {
        const f = Date.now() - c;
        e(
          o.map((p) => (p.timeOffset -= f, p)),
          d
        ), o = [], c = null;
      }
    ),
    i
  ), u = W(
    en(
      W((d) => {
        const f = _n(d), { clientX: p, clientY: h } = ys(d) ? d.changedTouches[0] : d;
        c || (c = ir()), o.push({
          x: p,
          y: h,
          id: r.getId(f),
          timeOffset: ir() - c
        }), a(
          typeof DragEvent < "u" && d instanceof DragEvent ? x.Drag : d instanceof MouseEvent ? x.MouseMove : x.TouchMove
        );
      }),
      s,
      {
        trailing: !1
      }
    )
  ), l = [
    de("mousemove", u, n),
    de("touchmove", u, n),
    de("drag", u, n)
  ];
  return W(() => {
    l.forEach((d) => d());
  });
}
function xg({
  mouseInteractionCb: e,
  doc: t,
  mirror: n,
  blockClass: r,
  blockSelector: s,
  unblockSelector: i,
  sampling: o
}) {
  if (o.mouseInteraction === !1)
    return () => {
    };
  const c = o.mouseInteraction === !0 || o.mouseInteraction === void 0 ? {} : o.mouseInteraction, a = [];
  let u = null;
  const l = (d) => (f) => {
    const p = _n(f);
    if (ge(p, r, s, i, !0))
      return;
    let h = null, m = d;
    if ("pointerType" in f) {
      switch (f.pointerType) {
        case "mouse":
          h = Oe.Mouse;
          break;
        case "touch":
          h = Oe.Touch;
          break;
        case "pen":
          h = Oe.Pen;
          break;
      }
      h === Oe.Touch ? le[d] === le.MouseDown ? m = "TouchStart" : le[d] === le.MouseUp && (m = "TouchEnd") : Oe.Pen;
    } else ys(f) && (h = Oe.Touch);
    h !== null ? (u = h, (m.startsWith("Touch") && h === Oe.Touch || m.startsWith("Mouse") && h === Oe.Mouse) && (h = null)) : le[d] === le.Click && (h = u, u = null);
    const S = ys(f) ? f.changedTouches[0] : f;
    if (!S)
      return;
    const E = n.getId(p), { clientX: w, clientY: q } = S;
    W(e)({
      type: le[m],
      id: E,
      x: w,
      y: q,
      ...h !== null && { pointerType: h }
    });
  };
  return Object.keys(le).filter(
    (d) => Number.isNaN(Number(d)) && !d.endsWith("_Departed") && c[d] !== !1
  ).forEach((d) => {
    let f = Ot(d);
    const p = l(d);
    if (window.PointerEvent)
      switch (le[d]) {
        case le.MouseDown:
        case le.MouseUp:
          f = f.replace(
            "mouse",
            "pointer"
          );
          break;
        case le.TouchStart:
        case le.TouchEnd:
          return;
      }
    a.push(de(f, p, t));
  }), W(() => {
    a.forEach((d) => d());
  });
}
function Yc({
  scrollCb: e,
  doc: t,
  mirror: n,
  blockClass: r,
  blockSelector: s,
  unblockSelector: i,
  sampling: o
}) {
  const c = W(
    en(
      W((a) => {
        const u = _n(a);
        if (!u || ge(
          u,
          r,
          s,
          i,
          !0
        ))
          return;
        const l = n.getId(u);
        if (u === t && t.defaultView) {
          const d = Fc(t.defaultView);
          e({
            id: l,
            x: d.left,
            y: d.top
          });
        } else
          e({
            id: l,
            x: u.scrollLeft,
            y: u.scrollTop
          });
      }),
      o.scroll || 100
    )
  );
  return de("scroll", c, t);
}
function Mg({ viewportResizeCb: e }, { win: t }) {
  let n = -1, r = -1;
  const s = W(
    en(
      W(() => {
        const i = $c(), o = Bc();
        (n !== i || r !== o) && (e({
          width: Number(o),
          height: Number(i)
        }), n = i, r = o);
      }),
      200
    )
  );
  return de("resize", s, t);
}
const Ag = ["INPUT", "TEXTAREA", "SELECT"], Oo = /* @__PURE__ */ new WeakMap();
function Og({
  inputCb: e,
  doc: t,
  mirror: n,
  blockClass: r,
  blockSelector: s,
  unblockSelector: i,
  ignoreClass: o,
  ignoreSelector: c,
  maskInputOptions: a,
  maskInputFn: u,
  sampling: l,
  userTriggeredOnInput: d,
  maskTextClass: f,
  unmaskTextClass: p,
  maskTextSelector: h,
  unmaskTextSelector: m
}) {
  function S(v) {
    let M = _n(v);
    const y = v.isTrusted, I = M && _s(M.tagName);
    if (I === "OPTION" && (M = M.parentElement), !M || !I || Ag.indexOf(I) < 0 || ge(
      M,
      r,
      s,
      i,
      !0
    ))
      return;
    const $ = M;
    if ($.classList.contains(o) || c && $.matches(c))
      return;
    const A = si(M);
    let K = rr($, I, A), J = !1;
    const L = Sr({
      maskInputOptions: a,
      tagName: I,
      type: A
    }), T = Nt(
      M,
      f,
      h,
      p,
      m,
      L
    );
    (A === "radio" || A === "checkbox") && (J = M.checked), K = Qt({
      isMasked: T,
      element: M,
      value: K,
      maskInputFn: u
    }), E(
      M,
      d ? { text: K, isChecked: J, userTriggered: y } : { text: K, isChecked: J }
    );
    const D = M.name;
    A === "radio" && D && J && t.querySelectorAll(`input[type="radio"][name="${D}"]`).forEach((O) => {
      if (O !== M) {
        const X = Qt({
          // share mask behavior of `target`
          isMasked: T,
          element: O,
          value: rr(O, I, A),
          maskInputFn: u
        });
        E(
          O,
          d ? { text: X, isChecked: !J, userTriggered: !1 } : { text: X, isChecked: !J }
        );
      }
    });
  }
  function E(v, M) {
    const y = Oo.get(v);
    if (!y || y.text !== M.text || y.isChecked !== M.isChecked) {
      Oo.set(v, M);
      const I = n.getId(v);
      W(e)({
        ...M,
        id: I
      });
    }
  }
  const q = (l.input === "last" ? ["change"] : ["input", "change"]).map(
    (v) => de(v, W(S), t)
  ), F = t.defaultView;
  if (!F)
    return () => {
      q.forEach((v) => v());
    };
  const C = F.Object.getOwnPropertyDescriptor(
    F.HTMLInputElement.prototype,
    "value"
  ), _ = [
    [F.HTMLInputElement.prototype, "value"],
    [F.HTMLInputElement.prototype, "checked"],
    [F.HTMLSelectElement.prototype, "value"],
    [F.HTMLTextAreaElement.prototype, "value"],
    // Some UI library use selectedIndex to set select value
    [F.HTMLSelectElement.prototype, "selectedIndex"],
    [F.HTMLOptionElement.prototype, "selected"]
  ];
  return C && C.set && q.push(
    ..._.map(
      (v) => Pc(
        v[0],
        v[1],
        {
          set() {
            W(S)({
              target: this,
              isTrusted: !1
              // userTriggered to false as this could well be programmatic
            });
          }
        },
        !1,
        F
      )
    )
  ), W(() => {
    q.forEach((v) => v());
  });
}
function or(e) {
  const t = [];
  function n(r, s) {
    if (An("CSSGroupingRule") && r.parentRule instanceof CSSGroupingRule || An("CSSMediaRule") && r.parentRule instanceof CSSMediaRule || An("CSSSupportsRule") && r.parentRule instanceof CSSSupportsRule || An("CSSConditionRule") && r.parentRule instanceof CSSConditionRule) {
      const o = Array.from(
        r.parentRule.cssRules
      ).indexOf(r);
      s.unshift(o);
    } else if (r.parentStyleSheet) {
      const o = Array.from(r.parentStyleSheet.cssRules).indexOf(r);
      s.unshift(o);
    }
    return s;
  }
  return n(e, t);
}
function je(e, t, n) {
  let r, s;
  return e ? (e.ownerNode ? r = t.getId(e.ownerNode) : s = n.getId(e), {
    styleId: s,
    id: r
  }) : {};
}
function Ng({ styleSheetRuleCb: e, mirror: t, stylesheetManager: n }, { win: r }) {
  if (!r.CSSStyleSheet || !r.CSSStyleSheet.prototype)
    return () => {
    };
  const s = r.CSSStyleSheet.prototype.insertRule;
  r.CSSStyleSheet.prototype.insertRule = new Proxy(s, {
    apply: W(
      (l, d, f) => {
        const [p, h] = f, { id: m, styleId: S } = je(
          d,
          t,
          n.styleMirror
        );
        return (m && m !== -1 || S && S !== -1) && e({
          id: m,
          styleId: S,
          adds: [{ rule: p, index: h }]
        }), l.apply(d, f);
      }
    )
  });
  const i = r.CSSStyleSheet.prototype.deleteRule;
  r.CSSStyleSheet.prototype.deleteRule = new Proxy(i, {
    apply: W(
      (l, d, f) => {
        const [p] = f, { id: h, styleId: m } = je(
          d,
          t,
          n.styleMirror
        );
        return (h && h !== -1 || m && m !== -1) && e({
          id: h,
          styleId: m,
          removes: [{ index: p }]
        }), l.apply(d, f);
      }
    )
  });
  let o;
  r.CSSStyleSheet.prototype.replace && (o = r.CSSStyleSheet.prototype.replace, r.CSSStyleSheet.prototype.replace = new Proxy(o, {
    apply: W(
      (l, d, f) => {
        const [p] = f, { id: h, styleId: m } = je(
          d,
          t,
          n.styleMirror
        );
        return (h && h !== -1 || m && m !== -1) && e({
          id: h,
          styleId: m,
          replace: p
        }), l.apply(d, f);
      }
    )
  }));
  let c;
  r.CSSStyleSheet.prototype.replaceSync && (c = r.CSSStyleSheet.prototype.replaceSync, r.CSSStyleSheet.prototype.replaceSync = new Proxy(c, {
    apply: W(
      (l, d, f) => {
        const [p] = f, { id: h, styleId: m } = je(
          d,
          t,
          n.styleMirror
        );
        return (h && h !== -1 || m && m !== -1) && e({
          id: h,
          styleId: m,
          replaceSync: p
        }), l.apply(d, f);
      }
    )
  }));
  const a = {};
  On("CSSGroupingRule") ? a.CSSGroupingRule = r.CSSGroupingRule : (On("CSSMediaRule") && (a.CSSMediaRule = r.CSSMediaRule), On("CSSConditionRule") && (a.CSSConditionRule = r.CSSConditionRule), On("CSSSupportsRule") && (a.CSSSupportsRule = r.CSSSupportsRule));
  const u = {};
  return Object.entries(a).forEach(([l, d]) => {
    u[l] = {
      // eslint-disable-next-line @typescript-eslint/unbound-method
      insertRule: d.prototype.insertRule,
      // eslint-disable-next-line @typescript-eslint/unbound-method
      deleteRule: d.prototype.deleteRule
    }, d.prototype.insertRule = new Proxy(
      u[l].insertRule,
      {
        apply: W(
          (f, p, h) => {
            const [m, S] = h, { id: E, styleId: w } = je(
              p.parentStyleSheet,
              t,
              n.styleMirror
            );
            return (E && E !== -1 || w && w !== -1) && e({
              id: E,
              styleId: w,
              adds: [
                {
                  rule: m,
                  index: [
                    ...or(p),
                    S || 0
                    // defaults to 0
                  ]
                }
              ]
            }), f.apply(p, h);
          }
        )
      }
    ), d.prototype.deleteRule = new Proxy(
      u[l].deleteRule,
      {
        apply: W(
          (f, p, h) => {
            const [m] = h, { id: S, styleId: E } = je(
              p.parentStyleSheet,
              t,
              n.styleMirror
            );
            return (S && S !== -1 || E && E !== -1) && e({
              id: S,
              styleId: E,
              removes: [
                { index: [...or(p), m] }
              ]
            }), f.apply(p, h);
          }
        )
      }
    );
  }), W(() => {
    r.CSSStyleSheet.prototype.insertRule = s, r.CSSStyleSheet.prototype.deleteRule = i, o && (r.CSSStyleSheet.prototype.replace = o), c && (r.CSSStyleSheet.prototype.replaceSync = c), Object.entries(a).forEach(([l, d]) => {
      d.prototype.insertRule = u[l].insertRule, d.prototype.deleteRule = u[l].deleteRule;
    });
  });
}
function Kc({
  mirror: e,
  stylesheetManager: t
}, n) {
  let r = null;
  n.nodeName === "#document" ? r = e.getId(n) : r = e.getId(n.host);
  const s = n.nodeName === "#document" ? n.defaultView?.Document : n.ownerDocument?.defaultView?.ShadowRoot, i = s?.prototype ? Object.getOwnPropertyDescriptor(
    s?.prototype,
    "adoptedStyleSheets"
  ) : void 0;
  return r === null || r === -1 || !s || !i ? () => {
  } : (Object.defineProperty(n, "adoptedStyleSheets", {
    configurable: i.configurable,
    enumerable: i.enumerable,
    get() {
      return i.get?.call(this);
    },
    set(o) {
      const c = i.set?.call(this, o);
      if (r !== null && r !== -1)
        try {
          t.adoptStyleSheets(o, r);
        } catch {
        }
      return c;
    }
  }), W(() => {
    Object.defineProperty(n, "adoptedStyleSheets", {
      configurable: i.configurable,
      enumerable: i.enumerable,
      // eslint-disable-next-line @typescript-eslint/unbound-method
      get: i.get,
      // eslint-disable-next-line @typescript-eslint/unbound-method
      set: i.set
    });
  }));
}
function Dg({
  styleDeclarationCb: e,
  mirror: t,
  ignoreCSSAttributes: n,
  stylesheetManager: r
}, { win: s }) {
  const i = s.CSSStyleDeclaration.prototype.setProperty;
  s.CSSStyleDeclaration.prototype.setProperty = new Proxy(i, {
    apply: W(
      (c, a, u) => {
        const [l, d, f] = u;
        if (n.has(l))
          return i.apply(a, [l, d, f]);
        const { id: p, styleId: h } = je(
          a.parentRule?.parentStyleSheet,
          t,
          r.styleMirror
        );
        return (p && p !== -1 || h && h !== -1) && e({
          id: p,
          styleId: h,
          set: {
            property: l,
            value: d,
            priority: f
          },
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          index: or(a.parentRule)
        }), c.apply(a, u);
      }
    )
  });
  const o = s.CSSStyleDeclaration.prototype.removeProperty;
  return s.CSSStyleDeclaration.prototype.removeProperty = new Proxy(o, {
    apply: W(
      (c, a, u) => {
        const [l] = u;
        if (n.has(l))
          return o.apply(a, [l]);
        const { id: d, styleId: f } = je(
          a.parentRule?.parentStyleSheet,
          t,
          r.styleMirror
        );
        return (d && d !== -1 || f && f !== -1) && e({
          id: d,
          styleId: f,
          remove: {
            property: l
          },
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          index: or(a.parentRule)
        }), c.apply(a, u);
      }
    )
  }), W(() => {
    s.CSSStyleDeclaration.prototype.setProperty = i, s.CSSStyleDeclaration.prototype.removeProperty = o;
  });
}
function Lg({
  mediaInteractionCb: e,
  blockClass: t,
  blockSelector: n,
  unblockSelector: r,
  mirror: s,
  sampling: i,
  doc: o
}) {
  const c = W(
    (u) => en(
      W((l) => {
        const d = _n(l);
        if (!d || ge(
          d,
          t,
          n,
          r,
          !0
        ))
          return;
        const { currentTime: f, volume: p, muted: h, playbackRate: m } = d;
        e({
          type: u,
          id: s.getId(d),
          currentTime: f,
          volume: p,
          muted: h,
          playbackRate: m
        });
      }),
      i.media || 500
    )
  ), a = [
    de("play", c(bt.Play), o),
    de("pause", c(bt.Pause), o),
    de("seeked", c(bt.Seeked), o),
    de("volumechange", c(bt.VolumeChange), o),
    de("ratechange", c(bt.RateChange), o)
  ];
  return W(() => {
    a.forEach((u) => u());
  });
}
function Pg({ fontCb: e, doc: t }) {
  const n = t.defaultView;
  if (!n)
    return () => {
    };
  const r = [], s = /* @__PURE__ */ new WeakMap(), i = n.FontFace;
  n.FontFace = function(a, u, l) {
    const d = new i(a, u, l);
    return s.set(d, {
      family: a,
      buffer: typeof u != "string",
      descriptors: l,
      fontSource: typeof u == "string" ? u : JSON.stringify(Array.from(new Uint8Array(u)))
    }), d;
  };
  const o = oi(
    t.fonts,
    "add",
    function(c) {
      return function(a) {
        return Er(
          W(() => {
            const u = s.get(a);
            u && (e(u), s.delete(a));
          }),
          0
        ), c.apply(this, [a]);
      };
    }
  );
  return r.push(() => {
    n.FontFace = i;
  }), r.push(o), W(() => {
    r.forEach((c) => c());
  });
}
function Fg(e) {
  const {
    doc: t,
    mirror: n,
    blockClass: r,
    blockSelector: s,
    unblockSelector: i,
    selectionCb: o
  } = e;
  let c = !0;
  const a = W(() => {
    const u = t.getSelection();
    if (!u || c && u?.isCollapsed) return;
    c = u.isCollapsed || !1;
    const l = [], d = u.rangeCount || 0;
    for (let f = 0; f < d; f++) {
      const p = u.getRangeAt(f), { startContainer: h, startOffset: m, endContainer: S, endOffset: E } = p;
      ge(
        h,
        r,
        s,
        i,
        !0
      ) || ge(
        S,
        r,
        s,
        i,
        !0
      ) || l.push({
        start: n.getId(h),
        startOffset: m,
        end: n.getId(S),
        endOffset: E
      });
    }
    o({ ranges: l });
  });
  return a(), de("selectionchange", a);
}
function $g({
  doc: e,
  customElementCb: t
}) {
  const n = e.defaultView;
  return !n || !n.customElements ? () => {
  } : oi(
    n.customElements,
    "define",
    function(s) {
      return function(i, o, c) {
        try {
          t({
            define: {
              name: i
            }
          });
        } catch {
        }
        return s.apply(this, [i, o, c]);
      };
    }
  );
}
function Bg(e, t = {}) {
  const n = e.doc.defaultView;
  if (!n)
    return () => {
    };
  let r;
  e.recordDOM && (r = Gc(e, e.doc));
  const s = Cg(e), i = xg(e), o = Yc(e), c = Mg(e, {
    win: n
  }), a = Og(e), u = Lg(e);
  let l = () => {
  }, d = () => {
  }, f = () => {
  }, p = () => {
  };
  e.recordDOM && (l = Ng(e, { win: n }), d = Kc(e, e.doc), f = Dg(e, {
    win: n
  }), e.collectFonts && (p = Pg(e)));
  const h = Fg(e), m = $g(e), S = [];
  for (const E of e.plugins)
    S.push(
      E.observer(E.callback, n, E.options)
    );
  return W(() => {
    wt.forEach((E) => E.reset()), r?.disconnect(), s(), i(), o(), c(), a(), u(), l(), d(), f(), p(), h(), m(), S.forEach((E) => E());
  });
}
function An(e) {
  return typeof window[e] < "u";
}
function On(e) {
  return !!(typeof window[e] < "u" && // Note: Generally, this check _shouldn't_ be necessary
  // However, in some scenarios (e.g. jsdom) this can sometimes fail, so we check for it here
  window[e].prototype && "insertRule" in window[e].prototype && "deleteRule" in window[e].prototype);
}
class vs {
  constructor(t) {
    this.generateIdFn = t, this.iframeIdToRemoteIdMap = /* @__PURE__ */ new WeakMap(), this.iframeRemoteIdToIdMap = /* @__PURE__ */ new WeakMap();
  }
  getId(t, n, r, s) {
    const i = r || this.getIdToRemoteIdMap(t), o = s || this.getRemoteIdToIdMap(t);
    let c = i.get(n);
    return c || (c = this.generateIdFn(), i.set(n, c), o.set(c, n)), c;
  }
  getIds(t, n) {
    const r = this.getIdToRemoteIdMap(t), s = this.getRemoteIdToIdMap(t);
    return n.map(
      (i) => this.getId(t, i, r, s)
    );
  }
  getRemoteId(t, n, r) {
    const s = r || this.getRemoteIdToIdMap(t);
    if (typeof n != "number") return n;
    const i = s.get(n);
    return i || -1;
  }
  getRemoteIds(t, n) {
    const r = this.getRemoteIdToIdMap(t);
    return n.map((s) => this.getRemoteId(t, s, r));
  }
  reset(t) {
    if (!t) {
      this.iframeIdToRemoteIdMap = /* @__PURE__ */ new WeakMap(), this.iframeRemoteIdToIdMap = /* @__PURE__ */ new WeakMap();
      return;
    }
    this.iframeIdToRemoteIdMap.delete(t), this.iframeRemoteIdToIdMap.delete(t);
  }
  getIdToRemoteIdMap(t) {
    let n = this.iframeIdToRemoteIdMap.get(t);
    return n || (n = /* @__PURE__ */ new Map(), this.iframeIdToRemoteIdMap.set(t, n)), n;
  }
  getRemoteIdToIdMap(t) {
    let n = this.iframeRemoteIdToIdMap.get(t);
    return n || (n = /* @__PURE__ */ new Map(), this.iframeRemoteIdToIdMap.set(t, n)), n;
  }
}
class Ug {
  constructor() {
    this.crossOriginIframeMirror = new vs(ii), this.crossOriginIframeRootIdMap = /* @__PURE__ */ new WeakMap();
  }
  addIframe() {
  }
  addLoadListener() {
  }
  attachIframe() {
  }
}
class Hg {
  constructor(t) {
    this.iframes = /* @__PURE__ */ new WeakMap(), this.crossOriginIframeMap = /* @__PURE__ */ new WeakMap(), this.crossOriginIframeMirror = new vs(ii), this.crossOriginIframeRootIdMap = /* @__PURE__ */ new WeakMap(), this.mutationCb = t.mutationCb, this.wrappedEmit = t.wrappedEmit, this.stylesheetManager = t.stylesheetManager, this.recordCrossOriginIframes = t.recordCrossOriginIframes, this.crossOriginIframeStyleMirror = new vs(
      this.stylesheetManager.styleMirror.generateId.bind(
        this.stylesheetManager.styleMirror
      )
    ), this.mirror = t.mirror, this.recordCrossOriginIframes && window.addEventListener("message", this.handleMessage.bind(this));
  }
  addIframe(t) {
    this.iframes.set(t, !0), t.contentWindow && this.crossOriginIframeMap.set(t.contentWindow, t);
  }
  addLoadListener(t) {
    this.loadListener = t;
  }
  attachIframe(t, n) {
    this.mutationCb({
      adds: [
        {
          parentId: this.mirror.getId(t),
          nextId: null,
          node: n
        }
      ],
      removes: [],
      texts: [],
      attributes: [],
      isAttachIframe: !0
    }), this.recordCrossOriginIframes && t.contentWindow?.addEventListener(
      "message",
      this.handleMessage.bind(this)
    ), this.loadListener?.(t);
    const r = ci(t);
    r && r.adoptedStyleSheets && r.adoptedStyleSheets.length > 0 && this.stylesheetManager.adoptStyleSheets(
      r.adoptedStyleSheets,
      this.mirror.getId(r)
    );
  }
  handleMessage(t) {
    const n = t;
    if (n.data.type !== "rrweb" || // To filter out the rrweb messages which are forwarded by some sites.
    n.origin !== n.data.origin || !t.source) return;
    const s = this.crossOriginIframeMap.get(t.source);
    if (!s) return;
    const i = this.transformCrossOriginEvent(
      s,
      n.data.event
    );
    i && this.wrappedEmit(
      i,
      n.data.isCheckout
    );
  }
  transformCrossOriginEvent(t, n) {
    switch (n.type) {
      case P.FullSnapshot: {
        this.crossOriginIframeMirror.reset(t), this.crossOriginIframeStyleMirror.reset(t), this.replaceIdOnNode(n.data.node, t);
        const r = n.data.node.id;
        return this.crossOriginIframeRootIdMap.set(t, r), this.patchRootIdOnNode(n.data.node, r), {
          timestamp: n.timestamp,
          type: P.IncrementalSnapshot,
          data: {
            source: x.Mutation,
            adds: [
              {
                parentId: this.mirror.getId(t),
                nextId: null,
                node: n.data.node
              }
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: !0
          }
        };
      }
      case P.Meta:
      case P.Load:
      case P.DomContentLoaded:
        return !1;
      case P.Plugin:
        return n;
      case P.Custom:
        return this.replaceIds(
          n.data.payload,
          t,
          ["id", "parentId", "previousId", "nextId"]
        ), n;
      case P.IncrementalSnapshot:
        switch (n.data.source) {
          case x.Mutation:
            return n.data.adds.forEach((r) => {
              this.replaceIds(r, t, [
                "parentId",
                "nextId",
                "previousId"
              ]), this.replaceIdOnNode(r.node, t);
              const s = this.crossOriginIframeRootIdMap.get(t);
              s && this.patchRootIdOnNode(r.node, s);
            }), n.data.removes.forEach((r) => {
              this.replaceIds(r, t, ["parentId", "id"]);
            }), n.data.attributes.forEach((r) => {
              this.replaceIds(r, t, ["id"]);
            }), n.data.texts.forEach((r) => {
              this.replaceIds(r, t, ["id"]);
            }), n;
          case x.Drag:
          case x.TouchMove:
          case x.MouseMove:
            return n.data.positions.forEach((r) => {
              this.replaceIds(r, t, ["id"]);
            }), n;
          case x.ViewportResize:
            return !1;
          case x.MediaInteraction:
          case x.MouseInteraction:
          case x.Scroll:
          case x.CanvasMutation:
          case x.Input:
            return this.replaceIds(n.data, t, ["id"]), n;
          case x.StyleSheetRule:
          case x.StyleDeclaration:
            return this.replaceIds(n.data, t, ["id"]), this.replaceStyleIds(n.data, t, ["styleId"]), n;
          case x.Font:
            return n;
          case x.Selection:
            return n.data.ranges.forEach((r) => {
              this.replaceIds(r, t, ["start", "end"]);
            }), n;
          case x.AdoptedStyleSheet:
            return this.replaceIds(n.data, t, ["id"]), this.replaceStyleIds(n.data, t, ["styleIds"]), n.data.styles?.forEach((r) => {
              this.replaceStyleIds(r, t, ["styleId"]);
            }), n;
        }
    }
    return !1;
  }
  replace(t, n, r, s) {
    for (const i of s)
      !Array.isArray(n[i]) && typeof n[i] != "number" || (Array.isArray(n[i]) ? n[i] = t.getIds(
        r,
        n[i]
      ) : n[i] = t.getId(r, n[i]));
    return n;
  }
  replaceIds(t, n, r) {
    return this.replace(this.crossOriginIframeMirror, t, n, r);
  }
  replaceStyleIds(t, n, r) {
    return this.replace(this.crossOriginIframeStyleMirror, t, n, r);
  }
  replaceIdOnNode(t, n) {
    this.replaceIds(t, n, ["id", "rootId"]), "childNodes" in t && t.childNodes.forEach((r) => {
      this.replaceIdOnNode(r, n);
    });
  }
  patchRootIdOnNode(t, n) {
    t.type !== oe.Document && !t.rootId && (t.rootId = n), "childNodes" in t && t.childNodes.forEach((r) => {
      this.patchRootIdOnNode(r, n);
    });
  }
}
class Wg {
  init() {
  }
  addShadowRoot() {
  }
  observeAttachShadow() {
  }
  reset() {
  }
}
class zg {
  constructor(t) {
    this.shadowDoms = /* @__PURE__ */ new WeakSet(), this.restoreHandlers = [], this.mutationCb = t.mutationCb, this.scrollCb = t.scrollCb, this.bypassOptions = t.bypassOptions, this.mirror = t.mirror, this.init();
  }
  init() {
    this.reset(), this.patchAttachShadow(Element, document);
  }
  addShadowRoot(t, n) {
    if (!Vt(t) || this.shadowDoms.has(t)) return;
    this.shadowDoms.add(t), this.bypassOptions.canvasManager.addShadowRoot(t);
    const r = Gc(
      {
        ...this.bypassOptions,
        doc: n,
        mutationCb: this.mutationCb,
        mirror: this.mirror,
        shadowDomManager: this
      },
      t
    );
    this.restoreHandlers.push(() => r.disconnect()), this.restoreHandlers.push(
      Yc({
        ...this.bypassOptions,
        scrollCb: this.scrollCb,
        // https://gist.github.com/praveenpuglia/0832da687ed5a5d7a0907046c9ef1813
        // scroll is not allowed to pass the boundary, so we need to listen the shadow document
        doc: t,
        mirror: this.mirror
      })
    ), Er(() => {
      t.adoptedStyleSheets && t.adoptedStyleSheets.length > 0 && this.bypassOptions.stylesheetManager.adoptStyleSheets(
        t.adoptedStyleSheets,
        this.mirror.getId(t.host)
      ), this.restoreHandlers.push(
        Kc(
          {
            mirror: this.mirror,
            stylesheetManager: this.bypassOptions.stylesheetManager
          },
          t
        )
      );
    }, 0);
  }
  /**
   * Monkey patch 'attachShadow' of an IFrameElement to observe newly added shadow doms.
   */
  observeAttachShadow(t) {
    const n = ci(t), r = vg(t);
    !n || !r || this.patchAttachShadow(
      r.Element,
      n
    );
  }
  /**
   * Patch 'attachShadow' to observe newly added shadow doms.
   */
  patchAttachShadow(t, n) {
    const r = this;
    this.restoreHandlers.push(
      oi(
        t.prototype,
        "attachShadow",
        function(s) {
          return function(i) {
            const o = s.call(this, i);
            return this.shadowRoot && qc(this) && r.addShadowRoot(this.shadowRoot, n), o;
          };
        }
      )
    );
  }
  reset() {
    this.restoreHandlers.forEach((t) => {
      try {
        t();
      } catch {
      }
    }), this.restoreHandlers = [], this.shadowDoms = /* @__PURE__ */ new WeakSet(), this.bypassOptions.canvasManager.resetShadowRoots();
  }
}
var No = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", jg = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var Nn = 0; Nn < No.length; Nn++)
  jg[No.charCodeAt(Nn)] = Nn;
class Do {
  reset() {
  }
  freeze() {
  }
  unfreeze() {
  }
  lock() {
  }
  unlock() {
  }
  snapshot() {
  }
  addWindow() {
  }
  addShadowRoot() {
  }
  resetShadowRoots() {
  }
}
class qg {
  constructor(t) {
    this.trackedLinkElements = /* @__PURE__ */ new WeakSet(), this.styleMirror = new _g(), this.mutationCb = t.mutationCb, this.adoptedStyleSheetCb = t.adoptedStyleSheetCb;
  }
  attachLinkElement(t, n) {
    "_cssText" in n.attributes && this.mutationCb({
      adds: [],
      removes: [],
      texts: [],
      attributes: [
        {
          id: n.id,
          attributes: n.attributes
        }
      ]
    }), this.trackLinkElement(t);
  }
  trackLinkElement(t) {
    this.trackedLinkElements.has(t) || (this.trackedLinkElements.add(t), this.trackStylesheetInLinkElement(t));
  }
  adoptStyleSheets(t, n) {
    if (t.length === 0) return;
    const r = {
      id: n,
      styleIds: []
    }, s = [];
    for (const i of t) {
      let o;
      this.styleMirror.has(i) ? o = this.styleMirror.getId(i) : (o = this.styleMirror.add(i), s.push({
        styleId: o,
        rules: Array.from(i.rules || CSSRule, (c, a) => ({
          rule: Rc(c),
          index: a
        }))
      })), r.styleIds.push(o);
    }
    s.length > 0 && (r.styles = s), this.adoptedStyleSheetCb(r);
  }
  reset() {
    this.styleMirror.reset(), this.trackedLinkElements = /* @__PURE__ */ new WeakSet();
  }
  // TODO: take snapshot on stylesheet reload by applying event listener
  trackStylesheetInLinkElement(t) {
  }
}
class Vg {
  constructor() {
    this.nodeMap = /* @__PURE__ */ new WeakMap(), this.active = !1;
  }
  inOtherBuffer(t, n) {
    const r = this.nodeMap.get(t);
    return r && Array.from(r).some((s) => s !== n);
  }
  add(t, n) {
    this.active || (this.active = !0, Eg(() => {
      this.nodeMap = /* @__PURE__ */ new WeakMap(), this.active = !1;
    })), this.nodeMap.set(t, (this.nodeMap.get(t) || /* @__PURE__ */ new Set()).add(n));
  }
  destroy() {
  }
}
let te, ar;
try {
  if (Array.from([1], (e) => e * 2)[0] !== 2) {
    const e = document.createElement("iframe");
    document.body.appendChild(e), Array.from = e.contentWindow?.Array.from || Array.from, document.body.removeChild(e);
  }
} catch (e) {
  console.debug("Unable to override Array.from", e);
}
const Ie = Vm();
function Le(e = {}) {
  const {
    emit: t,
    checkoutEveryNms: n,
    checkoutEveryNth: r,
    blockClass: s = "rr-block",
    blockSelector: i = null,
    unblockSelector: o = null,
    ignoreClass: c = "rr-ignore",
    ignoreSelector: a = null,
    maskAllText: u = !1,
    maskTextClass: l = "rr-mask",
    unmaskTextClass: d = null,
    maskTextSelector: f = null,
    unmaskTextSelector: p = null,
    inlineStylesheet: h = !0,
    maskAllInputs: m,
    maskInputOptions: S,
    slimDOMOptions: E,
    maskAttributeFn: w,
    maskInputFn: q,
    maskTextFn: F,
    maxCanvasSize: C = null,
    packFn: _,
    sampling: v = {},
    dataURLOptions: M = {},
    mousemoveWait: y,
    recordDOM: I = !0,
    recordCanvas: $ = !1,
    recordCrossOriginIframes: A = !1,
    recordAfter: K = e.recordAfter === "DOMContentLoaded" ? e.recordAfter : "load",
    userTriggeredOnInput: J = !1,
    collectFonts: L = !1,
    inlineImages: T = !1,
    plugins: D,
    keepIframeSrcFn: O = () => !1,
    ignoreCSSAttributes: X = /* @__PURE__ */ new Set([]),
    errorHandler: ie,
    onMutation: ve,
    getCanvasManager: nt
  } = e;
  kg(ie);
  const Re = A ? window.parent === window : !0;
  let ze = !1;
  if (!Re)
    try {
      window.parent.document && (ze = !1);
    } catch {
      ze = !0;
    }
  if (Re && !t)
    throw new Error("emit function is required");
  if (!Re && !ze)
    return () => {
    };
  y !== void 0 && v.mousemove === void 0 && (v.mousemove = y), Ie.reset();
  const Ht = m === !0 ? {
    color: !0,
    date: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0,
    textarea: !0,
    select: !0,
    radio: !0,
    checkbox: !0
  } : S !== void 0 ? S : {}, Tr = E === !0 || E === "all" ? {
    script: !0,
    comment: !0,
    headFavicon: !0,
    headWhitespace: !0,
    headMetaSocial: !0,
    headMetaRobots: !0,
    headMetaHttpEquiv: !0,
    headMetaVerification: !0,
    // the following are off for slimDOMOptions === true,
    // as they destroy some (hidden) info:
    headMetaAuthorship: E === "all",
    headMetaDescKeywords: E === "all"
  } : E || {};
  gg();
  let Ir, wr = 0;
  const Si = (G) => {
    for (const Te of D || [])
      Te.eventProcessor && (G = Te.eventProcessor(G));
    return _ && // Disable packing events which will be emitted to parent frames.
    !ze && (G = _(G)), G;
  };
  te = (G, Te) => {
    const H = G;
    if (H.timestamp = ir(), wt[0]?.isFrozen() && H.type !== P.FullSnapshot && !(H.type === P.IncrementalSnapshot && H.data.source === x.Mutation) && wt.forEach((ue) => ue.unfreeze()), Re)
      t?.(Si(H), Te);
    else if (ze) {
      const ue = {
        type: "rrweb",
        event: Si(H),
        origin: window.location.origin,
        isCheckout: Te
      };
      window.parent.postMessage(ue, "*");
    }
    if (H.type === P.FullSnapshot)
      Ir = H, wr = 0;
    else if (H.type === P.IncrementalSnapshot) {
      if (H.data.source === x.Mutation && H.data.isAttachIframe)
        return;
      wr++;
      const ue = r && wr >= r, Y = n && Ir && H.timestamp - Ir.timestamp > n;
      (ue || Y) && Cr(!0);
    }
  };
  const yn = (G) => {
    te({
      type: P.IncrementalSnapshot,
      data: {
        source: x.Mutation,
        ...G
      }
    });
  }, yi = (G) => te({
    type: P.IncrementalSnapshot,
    data: {
      source: x.Scroll,
      ...G
    }
  }), Tu = (G) => te({
    type: P.IncrementalSnapshot,
    data: {
      source: x.CanvasMutation,
      ...G
    }
  }), Iu = (G) => te({
    type: P.IncrementalSnapshot,
    data: {
      source: x.AdoptedStyleSheet,
      ...G
    }
  }), rt = new qg({
    mutationCb: yn,
    adoptedStyleSheetCb: Iu
  }), st = typeof __RRWEB_EXCLUDE_IFRAME__ == "boolean" && __RRWEB_EXCLUDE_IFRAME__ ? new Ug() : new Hg({
    mirror: Ie,
    mutationCb: yn,
    stylesheetManager: rt,
    recordCrossOriginIframes: A,
    wrappedEmit: te
  });
  for (const G of D || [])
    G.getMirror && G.getMirror({
      nodeMirror: Ie,
      crossOriginIframeMirror: st.crossOriginIframeMirror,
      crossOriginIframeStyleMirror: st.crossOriginIframeStyleMirror
    });
  const kr = new Vg(), Rr = Yg(
    nt,
    {
      mirror: Ie,
      win: window,
      mutationCb: (G) => te({
        type: P.IncrementalSnapshot,
        data: {
          source: x.CanvasMutation,
          ...G
        }
      }),
      recordCanvas: $,
      blockClass: s,
      blockSelector: i,
      unblockSelector: o,
      maxCanvasSize: C,
      sampling: v.canvas,
      dataURLOptions: M,
      errorHandler: ie
    }
  ), En = typeof __RRWEB_EXCLUDE_SHADOW_DOM__ == "boolean" && __RRWEB_EXCLUDE_SHADOW_DOM__ ? new Wg() : new zg({
    mutationCb: yn,
    scrollCb: yi,
    bypassOptions: {
      onMutation: ve,
      blockClass: s,
      blockSelector: i,
      unblockSelector: o,
      maskAllText: u,
      maskTextClass: l,
      unmaskTextClass: d,
      maskTextSelector: f,
      unmaskTextSelector: p,
      inlineStylesheet: h,
      maskInputOptions: Ht,
      dataURLOptions: M,
      maskAttributeFn: w,
      maskTextFn: F,
      maskInputFn: q,
      recordCanvas: $,
      inlineImages: T,
      sampling: v,
      slimDOMOptions: Tr,
      iframeManager: st,
      stylesheetManager: rt,
      canvasManager: Rr,
      keepIframeSrcFn: O,
      processedNodeManager: kr
    },
    mirror: Ie
  }), Cr = (G = !1) => {
    if (!I)
      return;
    te(
      {
        type: P.Meta,
        data: {
          href: window.location.href,
          width: Bc(),
          height: $c()
        }
      },
      G
    ), rt.reset(), En.init(), wt.forEach((H) => H.lock());
    const Te = hg(document, {
      mirror: Ie,
      blockClass: s,
      blockSelector: i,
      unblockSelector: o,
      maskAllText: u,
      maskTextClass: l,
      unmaskTextClass: d,
      maskTextSelector: f,
      unmaskTextSelector: p,
      inlineStylesheet: h,
      maskAllInputs: Ht,
      maskAttributeFn: w,
      maskInputFn: q,
      maskTextFn: F,
      slimDOM: Tr,
      dataURLOptions: M,
      recordCanvas: $,
      inlineImages: T,
      onSerialize: (H) => {
        Wc(H, Ie) && st.addIframe(H), zc(H, Ie) && rt.trackLinkElement(H), Es(H) && En.addShadowRoot(H.shadowRoot, document);
      },
      onIframeLoad: (H, ue) => {
        st.attachIframe(H, ue), H.contentWindow && Rr.addWindow(H.contentWindow), En.observeAttachShadow(H);
      },
      onStylesheetLoad: (H, ue) => {
        rt.attachLinkElement(H, ue);
      },
      keepIframeSrcFn: O
    });
    if (!Te)
      return console.warn("Failed to snapshot the document");
    te({
      type: P.FullSnapshot,
      data: {
        node: Te,
        initialOffset: Fc(window)
      }
    }), wt.forEach((H) => H.unlock()), document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0 && rt.adoptStyleSheets(
      document.adoptedStyleSheets,
      Ie.getId(document)
    );
  };
  ar = Cr;
  try {
    const G = [], Te = (ue) => W(Bg)(
      {
        onMutation: ve,
        mutationCb: yn,
        mousemoveCb: (Y, xr) => te({
          type: P.IncrementalSnapshot,
          data: {
            source: xr,
            positions: Y
          }
        }),
        mouseInteractionCb: (Y) => te({
          type: P.IncrementalSnapshot,
          data: {
            source: x.MouseInteraction,
            ...Y
          }
        }),
        scrollCb: yi,
        viewportResizeCb: (Y) => te({
          type: P.IncrementalSnapshot,
          data: {
            source: x.ViewportResize,
            ...Y
          }
        }),
        inputCb: (Y) => te({
          type: P.IncrementalSnapshot,
          data: {
            source: x.Input,
            ...Y
          }
        }),
        mediaInteractionCb: (Y) => te({
          type: P.IncrementalSnapshot,
          data: {
            source: x.MediaInteraction,
            ...Y
          }
        }),
        styleSheetRuleCb: (Y) => te({
          type: P.IncrementalSnapshot,
          data: {
            source: x.StyleSheetRule,
            ...Y
          }
        }),
        styleDeclarationCb: (Y) => te({
          type: P.IncrementalSnapshot,
          data: {
            source: x.StyleDeclaration,
            ...Y
          }
        }),
        canvasMutationCb: Tu,
        fontCb: (Y) => te({
          type: P.IncrementalSnapshot,
          data: {
            source: x.Font,
            ...Y
          }
        }),
        selectionCb: (Y) => {
          te({
            type: P.IncrementalSnapshot,
            data: {
              source: x.Selection,
              ...Y
            }
          });
        },
        customElementCb: (Y) => {
          te({
            type: P.IncrementalSnapshot,
            data: {
              source: x.CustomElement,
              ...Y
            }
          });
        },
        blockClass: s,
        ignoreClass: c,
        ignoreSelector: a,
        maskAllText: u,
        maskTextClass: l,
        unmaskTextClass: d,
        maskTextSelector: f,
        unmaskTextSelector: p,
        maskInputOptions: Ht,
        inlineStylesheet: h,
        sampling: v,
        recordDOM: I,
        recordCanvas: $,
        inlineImages: T,
        userTriggeredOnInput: J,
        collectFonts: L,
        doc: ue,
        maskAttributeFn: w,
        maskInputFn: q,
        maskTextFn: F,
        keepIframeSrcFn: O,
        blockSelector: i,
        unblockSelector: o,
        slimDOMOptions: Tr,
        dataURLOptions: M,
        mirror: Ie,
        iframeManager: st,
        stylesheetManager: rt,
        shadowDomManager: En,
        processedNodeManager: kr,
        canvasManager: Rr,
        ignoreCSSAttributes: X,
        plugins: D?.filter((Y) => Y.observer)?.map((Y) => ({
          observer: Y.observer,
          options: Y.options,
          callback: (xr) => te({
            type: P.Plugin,
            data: {
              plugin: Y.name,
              payload: xr
            }
          })
        })) || []
      },
      {}
    );
    st.addLoadListener((ue) => {
      try {
        G.push(Te(ue.contentDocument));
      } catch (Y) {
        console.warn(Y);
      }
    });
    const H = () => {
      Cr(), G.push(Te(document));
    };
    return document.readyState === "interactive" || document.readyState === "complete" ? H() : (G.push(
      de("DOMContentLoaded", () => {
        te({
          type: P.DomContentLoaded,
          data: {}
        }), K === "DOMContentLoaded" && H();
      })
    ), G.push(
      de(
        "load",
        () => {
          te({
            type: P.Load,
            data: {}
          }), K === "load" && H();
        },
        window
      )
    )), () => {
      G.forEach((ue) => ue()), kr.destroy(), ar = void 0, Rg();
    };
  } catch (G) {
    console.warn(G);
  }
}
function Gg(e) {
  if (!ar)
    throw new Error("please take full snapshot after start recording");
  ar(e);
}
Le.mirror = Ie;
Le.takeFullSnapshot = Gg;
function Yg(e, t) {
  try {
    return e ? e(t) : new Do();
  } catch {
    return console.warn("Unable to initialize CanvasManager"), new Do();
  }
}
var Lo;
(function(e) {
  e[e.NotStarted = 0] = "NotStarted", e[e.Running = 1] = "Running", e[e.Stopped = 2] = "Stopped";
})(Lo || (Lo = {}));
const Kg = 3, Xg = 5;
function ui(e) {
  return e > 9999999999 ? e : e * 1e3;
}
function qr(e) {
  return e > 9999999999 ? e / 1e3 : e;
}
function Sn(e, t) {
  t.category !== "sentry.transaction" && (["ui.click", "ui.input"].includes(t.category) ? e.triggerUserActivity() : e.checkAndHandleExpiredSession(), e.addUpdate(() => (e.throttledAddEvent({
    type: P.Custom,
    // TODO: We were converting from ms to seconds for breadcrumbs, spans,
    // but maybe we should just keep them as milliseconds
    timestamp: (t.timestamp || 0) * 1e3,
    data: {
      tag: "breadcrumb",
      // normalize to max. 10 depth and 1_000 properties per object
      payload: we(t, 10, 1e3)
    }
  }), t.category === "console")));
}
const Jg = "button,a";
function Xc(e) {
  return e.closest(Jg) || e;
}
function Jc(e) {
  const t = Qc(e);
  return !t || !(t instanceof Element) ? t : Xc(t);
}
function Qc(e) {
  return Qg(e) ? e.target : e;
}
function Qg(e) {
  return typeof e == "object" && !!e && "target" in e;
}
let qe;
function Zg(e) {
  return qe || (qe = [], e_()), qe.push(e), () => {
    const t = qe ? qe.indexOf(e) : -1;
    t > -1 && qe.splice(t, 1);
  };
}
function e_() {
  pe(Z, "open", function(e) {
    return function(...t) {
      if (qe)
        try {
          qe.forEach((n) => n());
        } catch {
        }
      return e.apply(Z, t);
    };
  });
}
const t_ = /* @__PURE__ */ new Set([
  x.Mutation,
  x.StyleSheetRule,
  x.StyleDeclaration,
  x.AdoptedStyleSheet,
  x.CanvasMutation,
  x.Selection,
  x.MediaInteraction
]);
function n_(e, t, n) {
  e.handleClick(t, n);
}
class r_ {
  // protected for testing
  constructor(t, n, r = Sn) {
    this._lastMutation = 0, this._lastScroll = 0, this._clicks = [], this._timeout = n.timeout / 1e3, this._threshold = n.threshold / 1e3, this._scrollTimeout = n.scrollTimeout / 1e3, this._replay = t, this._ignoreSelector = n.ignoreSelector, this._addBreadcrumbEvent = r;
  }
  /** Register click detection handlers on mutation or scroll. */
  addListeners() {
    const t = Zg(() => {
      this._lastMutation = Po();
    });
    this._teardown = () => {
      t(), this._clicks = [], this._lastMutation = 0, this._lastScroll = 0;
    };
  }
  /** Clean up listeners. */
  removeListeners() {
    this._teardown && this._teardown(), this._checkClickTimeout && clearTimeout(this._checkClickTimeout);
  }
  /** @inheritDoc */
  handleClick(t, n) {
    if (i_(n, this._ignoreSelector) || !o_(t))
      return;
    const r = {
      timestamp: qr(t.timestamp),
      clickBreadcrumb: t,
      // Set this to 0 so we know it originates from the click breadcrumb
      clickCount: 0,
      node: n
    };
    this._clicks.some((s) => s.node === r.node && Math.abs(s.timestamp - r.timestamp) < 1) || (this._clicks.push(r), this._clicks.length === 1 && this._scheduleCheckClicks());
  }
  /** @inheritDoc */
  registerMutation(t = Date.now()) {
    this._lastMutation = qr(t);
  }
  /** @inheritDoc */
  registerScroll(t = Date.now()) {
    this._lastScroll = qr(t);
  }
  /** @inheritDoc */
  registerClick(t) {
    const n = Xc(t);
    this._handleMultiClick(n);
  }
  /** Count multiple clicks on elements. */
  _handleMultiClick(t) {
    this._getClicks(t).forEach((n) => {
      n.clickCount++;
    });
  }
  /** Get all pending clicks for a given node. */
  _getClicks(t) {
    return this._clicks.filter((n) => n.node === t);
  }
  /** Check the clicks that happened. */
  _checkClicks() {
    const t = [], n = Po();
    this._clicks.forEach((r) => {
      !r.mutationAfter && this._lastMutation && (r.mutationAfter = r.timestamp <= this._lastMutation ? this._lastMutation - r.timestamp : void 0), !r.scrollAfter && this._lastScroll && (r.scrollAfter = r.timestamp <= this._lastScroll ? this._lastScroll - r.timestamp : void 0), r.timestamp + this._timeout <= n && t.push(r);
    });
    for (const r of t) {
      const s = this._clicks.indexOf(r);
      s > -1 && (this._generateBreadcrumbs(r), this._clicks.splice(s, 1));
    }
    this._clicks.length && this._scheduleCheckClicks();
  }
  /** Generate matching breadcrumb(s) for the click. */
  _generateBreadcrumbs(t) {
    const n = this._replay, r = t.scrollAfter && t.scrollAfter <= this._scrollTimeout, s = t.mutationAfter && t.mutationAfter <= this._threshold, i = !r && !s, { clickCount: o, clickBreadcrumb: c } = t;
    if (i) {
      const a = Math.min(t.mutationAfter || this._timeout, this._timeout) * 1e3, u = a < this._timeout * 1e3 ? "mutation" : "timeout", l = {
        type: "default",
        message: c.message,
        timestamp: c.timestamp,
        category: "ui.slowClickDetected",
        data: {
          ...c.data,
          url: Z.location.href,
          route: n.getCurrentRoute(),
          timeAfterClickMs: a,
          endReason: u,
          // If clickCount === 0, it means multiClick was not correctly captured here
          // - we still want to send 1 in this case
          clickCount: o || 1
        }
      };
      this._addBreadcrumbEvent(n, l);
      return;
    }
    if (o > 1) {
      const a = {
        type: "default",
        message: c.message,
        timestamp: c.timestamp,
        category: "ui.multiClick",
        data: {
          ...c.data,
          url: Z.location.href,
          route: n.getCurrentRoute(),
          clickCount: o,
          metric: !0
        }
      };
      this._addBreadcrumbEvent(n, a);
    }
  }
  /** Schedule to check current clicks. */
  _scheduleCheckClicks() {
    this._checkClickTimeout && clearTimeout(this._checkClickTimeout), this._checkClickTimeout = gn(() => this._checkClicks(), 1e3);
  }
}
const s_ = ["A", "BUTTON", "INPUT"];
function i_(e, t) {
  return !!(!s_.includes(e.tagName) || e.tagName === "INPUT" && !["submit", "button"].includes(e.getAttribute("type") || "") || e.tagName === "A" && (e.hasAttribute("download") || e.hasAttribute("target") && e.getAttribute("target") !== "_self") || t && e.matches(t));
}
function o_(e) {
  return !!(e.data && typeof e.data.nodeId == "number" && e.timestamp);
}
function Po() {
  return Date.now() / 1e3;
}
function a_(e, t) {
  try {
    if (!c_(t))
      return;
    const { source: n } = t.data;
    if (t_.has(n) && e.registerMutation(t.timestamp), n === x.Scroll && e.registerScroll(t.timestamp), u_(t)) {
      const { type: r, id: s } = t.data, i = Le.mirror.getNode(s);
      i instanceof HTMLElement && r === le.Click && e.registerClick(i);
    }
  } catch {
  }
}
function c_(e) {
  return e.type === Kg;
}
function u_(e) {
  return e.data.source === x.MouseInteraction;
}
function xe(e) {
  return {
    timestamp: Date.now() / 1e3,
    type: "default",
    ...e
  };
}
var li = /* @__PURE__ */ ((e) => (e[e.Document = 0] = "Document", e[e.DocumentType = 1] = "DocumentType", e[e.Element = 2] = "Element", e[e.Text = 3] = "Text", e[e.CDATA = 4] = "CDATA", e[e.Comment = 5] = "Comment", e))(li || {});
const l_ = /* @__PURE__ */ new Set([
  "id",
  "class",
  "aria-label",
  "role",
  "name",
  "alt",
  "title",
  "data-test-id",
  "data-testid",
  "disabled",
  "aria-disabled",
  "data-sentry-component"
]);
function d_(e) {
  const t = {};
  !e["data-sentry-component"] && e["data-sentry-element"] && (e["data-sentry-component"] = e["data-sentry-element"]);
  for (const n in e)
    if (l_.has(n)) {
      let r = n;
      (n === "data-testid" || n === "data-test-id") && (r = "testId"), t[r] = e[n];
    }
  return t;
}
const f_ = (e) => (t) => {
  if (!e.isEnabled())
    return;
  const n = p_(t);
  if (!n)
    return;
  const r = t.name === "click", s = r ? t.event : void 0;
  r && e.clickDetector && s?.target && !s.altKey && !s.metaKey && !s.ctrlKey && !s.shiftKey && n_(
    e.clickDetector,
    n,
    Jc(t.event)
  ), Sn(e, n);
};
function Zc(e, t) {
  const n = Le.mirror.getId(e), r = n && Le.mirror.getNode(n), s = r && Le.mirror.getMeta(r), i = s && m_(s) ? s : null;
  return {
    message: t,
    data: i ? {
      nodeId: n,
      node: {
        id: n,
        tagName: i.tagName,
        textContent: Array.from(i.childNodes).map((o) => o.type === li.Text && o.textContent).filter(Boolean).map((o) => o.trim()).join(""),
        attributes: d_(i.attributes)
      }
    } : {}
  };
}
function p_(e) {
  const { target: t, message: n } = h_(e);
  return xe({
    category: `ui.${e.name}`,
    ...Zc(t, n)
  });
}
function h_(e) {
  const t = e.name === "click";
  let n, r = null;
  try {
    r = t ? Jc(e.event) : Qc(e.event), n = Ee(r, { maxStringLength: 200 }) || "<unknown>";
  } catch {
    n = "<unknown>";
  }
  return { target: r, message: n };
}
function m_(e) {
  return e.type === li.Element;
}
function g_(e, t) {
  if (!e.isEnabled())
    return;
  e.updateUserActivity();
  const n = __(t);
  n && Sn(e, n);
}
function __(e) {
  const { metaKey: t, shiftKey: n, ctrlKey: r, altKey: s, key: i, target: o } = e;
  if (!o || S_(o) || !i)
    return null;
  const c = t || r || s, a = i.length === 1;
  if (!c && a)
    return null;
  const u = Ee(o, { maxStringLength: 200 }) || "<unknown>", l = Zc(o, u);
  return xe({
    category: "ui.keyDown",
    message: u,
    data: {
      ...l.data,
      metaKey: t,
      shiftKey: n,
      ctrlKey: r,
      altKey: s,
      key: i
    }
  });
}
function S_(e) {
  return e.tagName === "INPUT" || e.tagName === "TEXTAREA" || e.isContentEditable;
}
const y_ = {
  // @ts-expect-error TODO: entry type does not fit the create* functions entry type
  resource: I_,
  paint: v_,
  // @ts-expect-error TODO: entry type does not fit the create* functions entry type
  navigation: T_
};
function Vr(e, t) {
  return ({ metric: n }) => void t.replayPerformanceEntries.push(e(n));
}
function E_(e) {
  return e.map(b_).filter(Boolean);
}
function b_(e) {
  const t = y_[e.entryType];
  return t ? t(e) : null;
}
function Dt(e) {
  return ((me() || Z.performance.timeOrigin) + e) / 1e3;
}
function v_(e) {
  const { duration: t, entryType: n, name: r, startTime: s } = e, i = Dt(s);
  return {
    type: n,
    name: r,
    start: i,
    end: i + t,
    data: void 0
  };
}
function T_(e) {
  const {
    entryType: t,
    name: n,
    decodedBodySize: r,
    duration: s,
    domComplete: i,
    encodedBodySize: o,
    domContentLoadedEventStart: c,
    domContentLoadedEventEnd: a,
    domInteractive: u,
    loadEventStart: l,
    loadEventEnd: d,
    redirectCount: f,
    startTime: p,
    transferSize: h,
    type: m
  } = e;
  return s === 0 ? null : {
    type: `${t}.${m}`,
    start: Dt(p),
    end: Dt(i),
    name: n,
    data: {
      size: h,
      decodedBodySize: r,
      encodedBodySize: o,
      duration: s,
      domInteractive: u,
      domContentLoadedEventStart: c,
      domContentLoadedEventEnd: a,
      loadEventStart: l,
      loadEventEnd: d,
      domComplete: i,
      redirectCount: f
    }
  };
}
function I_(e) {
  const {
    entryType: t,
    initiatorType: n,
    name: r,
    responseEnd: s,
    startTime: i,
    decodedBodySize: o,
    encodedBodySize: c,
    responseStatus: a,
    transferSize: u
  } = e;
  return ["fetch", "xmlhttprequest"].includes(n) ? null : {
    type: `${t}.${n}`,
    start: Dt(i),
    end: Dt(s),
    name: r,
    data: {
      size: u,
      statusCode: a,
      decodedBodySize: o,
      encodedBodySize: c
    }
  };
}
function w_(e) {
  const t = e.entries[e.entries.length - 1], n = t?.element ? [t.element] : void 0;
  return di(e, "largest-contentful-paint", n);
}
function k_(e) {
  return e.sources !== void 0;
}
function R_(e) {
  const t = [], n = [];
  for (const r of e.entries)
    if (k_(r)) {
      const s = [];
      for (const i of r.sources)
        if (i.node) {
          n.push(i.node);
          const o = Le.mirror.getId(i.node);
          o && s.push(o);
        }
      t.push({ value: r.value, nodeIds: s.length ? s : void 0 });
    }
  return di(e, "cumulative-layout-shift", n, t);
}
function C_(e) {
  const t = e.entries[e.entries.length - 1], n = t?.target ? [t.target] : void 0;
  return di(e, "interaction-to-next-paint", n);
}
function di(e, t, n, r) {
  const s = e.value, i = e.rating, o = Dt(s);
  return {
    type: "web-vital",
    name: t,
    start: o,
    end: o,
    data: {
      value: s,
      size: s,
      rating: i,
      nodeIds: n ? n.map((c) => Le.mirror.getId(c)) : void 0,
      attributions: r
    }
  };
}
function x_(e) {
  function t(s) {
    e.performanceEntries.includes(s) || e.performanceEntries.push(s);
  }
  function n({ entries: s }) {
    s.forEach(t);
  }
  const r = [];
  return ["navigation", "paint", "resource"].forEach((s) => {
    r.push(ht(s, n));
  }), r.push(
    Zs(Vr(w_, e)),
    Qs(Vr(R_, e)),
    fc(Vr(C_, e))
  ), () => {
    r.forEach((s) => s());
  };
}
const k = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, M_ = 'var t=Uint8Array,n=Uint16Array,r=Int32Array,e=new t([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0,0,0,0]),i=new t([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13,0,0]),s=new t([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),a=function(t,e){for(var i=new n(31),s=0;s<31;++s)i[s]=e+=1<<t[s-1];var a=new r(i[30]);for(s=1;s<30;++s)for(var o=i[s];o<i[s+1];++o)a[o]=o-i[s]<<5|s;return{b:i,r:a}},o=a(e,2),h=o.b,f=o.r;h[28]=258,f[258]=28;for(var l=a(i,0).r,u=new n(32768),c=0;c<32768;++c){var v=(43690&c)>>1|(21845&c)<<1;v=(61680&(v=(52428&v)>>2|(13107&v)<<2))>>4|(3855&v)<<4,u[c]=((65280&v)>>8|(255&v)<<8)>>1}var d=function(t,r,e){for(var i=t.length,s=0,a=new n(r);s<i;++s)t[s]&&++a[t[s]-1];var o,h=new n(r);for(s=1;s<r;++s)h[s]=h[s-1]+a[s-1]<<1;if(e){o=new n(1<<r);var f=15-r;for(s=0;s<i;++s)if(t[s])for(var l=s<<4|t[s],c=r-t[s],v=h[t[s]-1]++<<c,d=v|(1<<c)-1;v<=d;++v)o[u[v]>>f]=l}else for(o=new n(i),s=0;s<i;++s)t[s]&&(o[s]=u[h[t[s]-1]++]>>15-t[s]);return o},p=new t(288);for(c=0;c<144;++c)p[c]=8;for(c=144;c<256;++c)p[c]=9;for(c=256;c<280;++c)p[c]=7;for(c=280;c<288;++c)p[c]=8;var g=new t(32);for(c=0;c<32;++c)g[c]=5;var w=d(p,9,0),y=d(g,5,0),m=function(t){return(t+7)/8|0},b=function(n,r,e){return(null==e||e>n.length)&&(e=n.length),new t(n.subarray(r,e))},M=["unexpected EOF","invalid block type","invalid length/literal","invalid distance","stream finished","no stream handler",,"no callback","invalid UTF-8 data","extra field too long","date not in range 1980-2099","filename too long","stream finishing","invalid zip data"],E=function(t,n,r){var e=new Error(n||M[t]);if(e.code=t,Error.captureStackTrace&&Error.captureStackTrace(e,E),!r)throw e;return e},z=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8},_=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8,t[e+2]|=r>>16},x=function(r,e){for(var i=[],s=0;s<r.length;++s)r[s]&&i.push({s:s,f:r[s]});var a=i.length,o=i.slice();if(!a)return{t:F,l:0};if(1==a){var h=new t(i[0].s+1);return h[i[0].s]=1,{t:h,l:1}}i.sort(function(t,n){return t.f-n.f}),i.push({s:-1,f:25001});var f=i[0],l=i[1],u=0,c=1,v=2;for(i[0]={s:-1,f:f.f+l.f,l:f,r:l};c!=a-1;)f=i[i[u].f<i[v].f?u++:v++],l=i[u!=c&&i[u].f<i[v].f?u++:v++],i[c++]={s:-1,f:f.f+l.f,l:f,r:l};var d=o[0].s;for(s=1;s<a;++s)o[s].s>d&&(d=o[s].s);var p=new n(d+1),g=A(i[c-1],p,0);if(g>e){s=0;var w=0,y=g-e,m=1<<y;for(o.sort(function(t,n){return p[n.s]-p[t.s]||t.f-n.f});s<a;++s){var b=o[s].s;if(!(p[b]>e))break;w+=m-(1<<g-p[b]),p[b]=e}for(w>>=y;w>0;){var M=o[s].s;p[M]<e?w-=1<<e-p[M]++-1:++s}for(;s>=0&&w;--s){var E=o[s].s;p[E]==e&&(--p[E],++w)}g=e}return{t:new t(p),l:g}},A=function(t,n,r){return-1==t.s?Math.max(A(t.l,n,r+1),A(t.r,n,r+1)):n[t.s]=r},D=function(t){for(var r=t.length;r&&!t[--r];);for(var e=new n(++r),i=0,s=t[0],a=1,o=function(t){e[i++]=t},h=1;h<=r;++h)if(t[h]==s&&h!=r)++a;else{if(!s&&a>2){for(;a>138;a-=138)o(32754);a>2&&(o(a>10?a-11<<5|28690:a-3<<5|12305),a=0)}else if(a>3){for(o(s),--a;a>6;a-=6)o(8304);a>2&&(o(a-3<<5|8208),a=0)}for(;a--;)o(s);a=1,s=t[h]}return{c:e.subarray(0,i),n:r}},T=function(t,n){for(var r=0,e=0;e<n.length;++e)r+=t[e]*n[e];return r},k=function(t,n,r){var e=r.length,i=m(n+2);t[i]=255&e,t[i+1]=e>>8,t[i+2]=255^t[i],t[i+3]=255^t[i+1];for(var s=0;s<e;++s)t[i+s+4]=r[s];return 8*(i+4+e)},U=function(t,r,a,o,h,f,l,u,c,v,m){z(r,m++,a),++h[256];for(var b=x(h,15),M=b.t,E=b.l,A=x(f,15),U=A.t,C=A.l,F=D(M),I=F.c,S=F.n,L=D(U),O=L.c,j=L.n,q=new n(19),B=0;B<I.length;++B)++q[31&I[B]];for(B=0;B<O.length;++B)++q[31&O[B]];for(var G=x(q,7),H=G.t,J=G.l,K=19;K>4&&!H[s[K-1]];--K);var N,P,Q,R,V=v+5<<3,W=T(h,p)+T(f,g)+l,X=T(h,M)+T(f,U)+l+14+3*K+T(q,H)+2*q[16]+3*q[17]+7*q[18];if(c>=0&&V<=W&&V<=X)return k(r,m,t.subarray(c,c+v));if(z(r,m,1+(X<W)),m+=2,X<W){N=d(M,E,0),P=M,Q=d(U,C,0),R=U;var Y=d(H,J,0);z(r,m,S-257),z(r,m+5,j-1),z(r,m+10,K-4),m+=14;for(B=0;B<K;++B)z(r,m+3*B,H[s[B]]);m+=3*K;for(var Z=[I,O],$=0;$<2;++$){var tt=Z[$];for(B=0;B<tt.length;++B){var nt=31&tt[B];z(r,m,Y[nt]),m+=H[nt],nt>15&&(z(r,m,tt[B]>>5&127),m+=tt[B]>>12)}}}else N=w,P=p,Q=y,R=g;for(B=0;B<u;++B){var rt=o[B];if(rt>255){_(r,m,N[(nt=rt>>18&31)+257]),m+=P[nt+257],nt>7&&(z(r,m,rt>>23&31),m+=e[nt]);var et=31&rt;_(r,m,Q[et]),m+=R[et],et>3&&(_(r,m,rt>>5&8191),m+=i[et])}else _(r,m,N[rt]),m+=P[rt]}return _(r,m,N[256]),m+P[256]},C=new r([65540,131080,131088,131104,262176,1048704,1048832,2114560,2117632]),F=new t(0),I=function(){for(var t=new Int32Array(256),n=0;n<256;++n){for(var r=n,e=9;--e;)r=(1&r&&-306674912)^r>>>1;t[n]=r}return t}(),S=function(){var t=1,n=0;return{p:function(r){for(var e=t,i=n,s=0|r.length,a=0;a!=s;){for(var o=Math.min(a+2655,s);a<o;++a)i+=e+=r[a];e=(65535&e)+15*(e>>16),i=(65535&i)+15*(i>>16)}t=e,n=i},d:function(){return(255&(t%=65521))<<24|(65280&t)<<8|(255&(n%=65521))<<8|n>>8}}},L=function(s,a,o,h,u){if(!u&&(u={l:1},a.dictionary)){var c=a.dictionary.subarray(-32768),v=new t(c.length+s.length);v.set(c),v.set(s,c.length),s=v,u.w=c.length}return function(s,a,o,h,u,c){var v=c.z||s.length,d=new t(h+v+5*(1+Math.ceil(v/7e3))+u),p=d.subarray(h,d.length-u),g=c.l,w=7&(c.r||0);if(a){w&&(p[0]=c.r>>3);for(var y=C[a-1],M=y>>13,E=8191&y,z=(1<<o)-1,_=c.p||new n(32768),x=c.h||new n(z+1),A=Math.ceil(o/3),D=2*A,T=function(t){return(s[t]^s[t+1]<<A^s[t+2]<<D)&z},F=new r(25e3),I=new n(288),S=new n(32),L=0,O=0,j=c.i||0,q=0,B=c.w||0,G=0;j+2<v;++j){var H=T(j),J=32767&j,K=x[H];if(_[J]=K,x[H]=J,B<=j){var N=v-j;if((L>7e3||q>24576)&&(N>423||!g)){w=U(s,p,0,F,I,S,O,q,G,j-G,w),q=L=O=0,G=j;for(var P=0;P<286;++P)I[P]=0;for(P=0;P<30;++P)S[P]=0}var Q=2,R=0,V=E,W=J-K&32767;if(N>2&&H==T(j-W))for(var X=Math.min(M,N)-1,Y=Math.min(32767,j),Z=Math.min(258,N);W<=Y&&--V&&J!=K;){if(s[j+Q]==s[j+Q-W]){for(var $=0;$<Z&&s[j+$]==s[j+$-W];++$);if($>Q){if(Q=$,R=W,$>X)break;var tt=Math.min(W,$-2),nt=0;for(P=0;P<tt;++P){var rt=j-W+P&32767,et=rt-_[rt]&32767;et>nt&&(nt=et,K=rt)}}}W+=(J=K)-(K=_[J])&32767}if(R){F[q++]=268435456|f[Q]<<18|l[R];var it=31&f[Q],st=31&l[R];O+=e[it]+i[st],++I[257+it],++S[st],B=j+Q,++L}else F[q++]=s[j],++I[s[j]]}}for(j=Math.max(j,B);j<v;++j)F[q++]=s[j],++I[s[j]];w=U(s,p,g,F,I,S,O,q,G,j-G,w),g||(c.r=7&w|p[w/8|0]<<3,w-=7,c.h=x,c.p=_,c.i=j,c.w=B)}else{for(j=c.w||0;j<v+g;j+=65535){var at=j+65535;at>=v&&(p[w/8|0]=g,at=v),w=k(p,w+1,s.subarray(j,at))}c.i=v}return b(d,0,h+m(w)+u)}(s,null==a.level?6:a.level,null==a.mem?u.l?Math.ceil(1.5*Math.max(8,Math.min(13,Math.log(s.length)))):20:12+a.mem,o,h,u)},O=function(t,n,r){for(;r;++n)t[n]=r,r>>>=8},j=function(){function n(n,r){if("function"==typeof n&&(r=n,n={}),this.ondata=r,this.o=n||{},this.s={l:0,i:32768,w:32768,z:32768},this.b=new t(98304),this.o.dictionary){var e=this.o.dictionary.subarray(-32768);this.b.set(e,32768-e.length),this.s.i=32768-e.length}}return n.prototype.p=function(t,n){this.ondata(L(t,this.o,0,0,this.s),n)},n.prototype.push=function(n,r){this.ondata||E(5),this.s.l&&E(4);var e=n.length+this.s.z;if(e>this.b.length){if(e>2*this.b.length-32768){var i=new t(-32768&e);i.set(this.b.subarray(0,this.s.z)),this.b=i}var s=this.b.length-this.s.z;this.b.set(n.subarray(0,s),this.s.z),this.s.z=this.b.length,this.p(this.b,!1),this.b.set(this.b.subarray(-32768)),this.b.set(n.subarray(s),32768),this.s.z=n.length-s+32768,this.s.i=32766,this.s.w=32768}else this.b.set(n,this.s.z),this.s.z+=n.length;this.s.l=1&r,(this.s.z>this.s.w+8191||r)&&(this.p(this.b,r||!1),this.s.w=this.s.i,this.s.i-=2)},n.prototype.flush=function(){this.ondata||E(5),this.s.l&&E(4),this.p(this.b,!1),this.s.w=this.s.i,this.s.i-=2},n}();function q(t,n){n||(n={});var r=function(){var t=-1;return{p:function(n){for(var r=t,e=0;e<n.length;++e)r=I[255&r^n[e]]^r>>>8;t=r},d:function(){return~t}}}(),e=t.length;r.p(t);var i,s=L(t,n,10+((i=n).filename?i.filename.length+1:0),8),a=s.length;return function(t,n){var r=n.filename;if(t[0]=31,t[1]=139,t[2]=8,t[8]=n.level<2?4:9==n.level?2:0,t[9]=3,0!=n.mtime&&O(t,4,Math.floor(new Date(n.mtime||Date.now())/1e3)),r){t[3]=8;for(var e=0;e<=r.length;++e)t[e+10]=r.charCodeAt(e)}}(s,n),O(s,a-8,r.d()),O(s,a-4,e),s}var B=function(){function t(t,n){this.c=S(),this.v=1,j.call(this,t,n)}return t.prototype.push=function(t,n){this.c.p(t),j.prototype.push.call(this,t,n)},t.prototype.p=function(t,n){var r=L(t,this.o,this.v&&(this.o.dictionary?6:2),n&&4,this.s);this.v&&(function(t,n){var r=n.level,e=0==r?0:r<6?1:9==r?3:2;if(t[0]=120,t[1]=e<<6|(n.dictionary&&32),t[1]|=31-(t[0]<<8|t[1])%31,n.dictionary){var i=S();i.p(n.dictionary),O(t,2,i.d())}}(r,this.o),this.v=0),n&&O(r,r.length-4,this.c.d()),this.ondata(r,n)},t.prototype.flush=function(){j.prototype.flush.call(this)},t}(),G="undefined"!=typeof TextEncoder&&new TextEncoder,H="undefined"!=typeof TextDecoder&&new TextDecoder;try{H.decode(F,{stream:!0})}catch(t){}var J=function(){function t(t){this.ondata=t}return t.prototype.push=function(t,n){this.ondata||E(5),this.d&&E(4),this.ondata(K(t),this.d=n||!1)},t}();function K(n,r){if(G)return G.encode(n);for(var e=n.length,i=new t(n.length+(n.length>>1)),s=0,a=function(t){i[s++]=t},o=0;o<e;++o){if(s+5>i.length){var h=new t(s+8+(e-o<<1));h.set(i),i=h}var f=n.charCodeAt(o);f<128||r?a(f):f<2048?(a(192|f>>6),a(128|63&f)):f>55295&&f<57344?(a(240|(f=65536+(1047552&f)|1023&n.charCodeAt(++o))>>18),a(128|f>>12&63),a(128|f>>6&63),a(128|63&f)):(a(224|f>>12),a(128|f>>6&63),a(128|63&f))}return b(i,0,s)}const N=new class{constructor(){this._init()}clear(){this._init()}addEvent(t){if(!t)throw new Error("Adding invalid event");const n=this._hasEvents?",":"";this.stream.push(n+t),this._hasEvents=!0}finish(){this.stream.push("]",!0);const t=function(t){let n=0;for(const r of t)n+=r.length;const r=new Uint8Array(n);for(let n=0,e=0,i=t.length;n<i;n++){const i=t[n];r.set(i,e),e+=i.length}return r}(this._deflatedData);return this._init(),t}_init(){this._hasEvents=!1,this._deflatedData=[],this.deflate=new B,this.deflate.ondata=(t,n)=>{this._deflatedData.push(t)},this.stream=new J((t,n)=>{this.deflate.push(t,n)}),this.stream.push("[")}},P={clear:()=>{N.clear()},addEvent:t=>N.addEvent(t),finish:()=>N.finish(),compress:t=>function(t){return q(K(t))}(t)};addEventListener("message",function(t){const n=t.data.method,r=t.data.id,e=t.data.arg;if(n in P&&"function"==typeof P[n])try{const t=P[n](e);postMessage({id:r,method:n,success:!0,response:t})}catch(t){postMessage({id:r,method:n,success:!1,response:t.message}),console.error(t)}}),postMessage({id:void 0,method:"init",success:!0,response:void 0});';
function A_() {
  const e = new Blob([M_]);
  return URL.createObjectURL(e);
}
const Fo = ["log", "warn", "error"], zn = "[Replay] ";
function Gr(e, t = "info") {
  Qe(
    {
      category: "console",
      data: {
        logger: "replay"
      },
      level: t,
      message: `${zn}${e}`
    },
    { level: t }
  );
}
function O_() {
  let e = !1, t = !1;
  const n = {
    exception: () => {
    },
    infoTick: () => {
    },
    setConfig: (r) => {
      e = !!r.captureExceptions, t = !!r.traceInternals;
    }
  };
  return k ? (Fo.forEach((r) => {
    n[r] = (...s) => {
      g[r](zn, ...s), t && Gr(s.join(""), Xa(r));
    };
  }), n.exception = (r, ...s) => {
    s.length && n.error && n.error(...s), g.error(zn, r), e ? dn(r) : t && Gr(r, "error");
  }, n.infoTick = (...r) => {
    g.log(zn, ...r), t && setTimeout(() => Gr(r[0]), 0);
  }) : Fo.forEach((r) => {
    n[r] = () => {
    };
  }), n;
}
const R = O_();
class fi extends Error {
  constructor() {
    super(`Event buffer exceeded maximum size of ${ri}.`);
  }
}
class eu {
  /** All the events that are buffered to be sent. */
  /** @inheritdoc */
  /** @inheritdoc */
  constructor() {
    this.events = [], this._totalSize = 0, this.hasCheckout = !1, this.waitForCheckout = !1;
  }
  /** @inheritdoc */
  get hasEvents() {
    return this.events.length > 0;
  }
  /** @inheritdoc */
  get type() {
    return "sync";
  }
  /** @inheritdoc */
  destroy() {
    this.events = [];
  }
  /** @inheritdoc */
  async addEvent(t) {
    const n = JSON.stringify(t).length;
    if (this._totalSize += n, this._totalSize > ri)
      throw new fi();
    this.events.push(t);
  }
  /** @inheritdoc */
  finish() {
    return new Promise((t) => {
      const n = this.events;
      this.clear(), t(JSON.stringify(n));
    });
  }
  /** @inheritdoc */
  clear() {
    this.events = [], this._totalSize = 0, this.hasCheckout = !1;
  }
  /** @inheritdoc */
  getEarliestTimestamp() {
    const t = this.events.map((n) => n.timestamp).sort()[0];
    return t ? ui(t) : null;
  }
}
class N_ {
  constructor(t) {
    this._worker = t, this._id = 0;
  }
  /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occurred.
   */
  ensureReady() {
    return this._ensureReadyPromise ? this._ensureReadyPromise : (this._ensureReadyPromise = new Promise((t, n) => {
      this._worker.addEventListener(
        "message",
        ({ data: r }) => {
          r.success ? t() : n();
        },
        { once: !0 }
      ), this._worker.addEventListener(
        "error",
        (r) => {
          n(r);
        },
        { once: !0 }
      );
    }), this._ensureReadyPromise);
  }
  /**
   * Destroy the worker.
   */
  destroy() {
    k && R.log("Destroying compression worker"), this._worker.terminate();
  }
  /**
   * Post message to worker and wait for response before resolving promise.
   */
  postMessage(t, n) {
    const r = this._getAndIncrementId();
    return new Promise((s, i) => {
      const o = ({ data: c }) => {
        const a = c;
        if (a.method === t && a.id === r) {
          if (this._worker.removeEventListener("message", o), !a.success) {
            k && R.error("Error in compression worker: ", a.response), i(new Error("Error in compression worker"));
            return;
          }
          s(a.response);
        }
      };
      this._worker.addEventListener("message", o), this._worker.postMessage({ id: r, method: t, arg: n });
    });
  }
  /** Get the current ID and increment it for the next call. */
  _getAndIncrementId() {
    return this._id++;
  }
}
class D_ {
  /** @inheritdoc */
  /** @inheritdoc */
  constructor(t) {
    this._worker = new N_(t), this._earliestTimestamp = null, this._totalSize = 0, this.hasCheckout = !1, this.waitForCheckout = !1;
  }
  /** @inheritdoc */
  get hasEvents() {
    return !!this._earliestTimestamp;
  }
  /** @inheritdoc */
  get type() {
    return "worker";
  }
  /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occurred.
   */
  ensureReady() {
    return this._worker.ensureReady();
  }
  /**
   * Destroy the event buffer.
   */
  destroy() {
    this._worker.destroy();
  }
  /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully received and processed by worker.
   */
  addEvent(t) {
    const n = ui(t.timestamp);
    (!this._earliestTimestamp || n < this._earliestTimestamp) && (this._earliestTimestamp = n);
    const r = JSON.stringify(t);
    return this._totalSize += r.length, this._totalSize > ri ? Promise.reject(new fi()) : this._sendEventToWorker(r);
  }
  /**
   * Finish the event buffer and return the compressed data.
   */
  finish() {
    return this._finishRequest();
  }
  /** @inheritdoc */
  clear() {
    this._earliestTimestamp = null, this._totalSize = 0, this.hasCheckout = !1, this._worker.postMessage("clear").then(null, (t) => {
      k && R.exception(t, 'Sending "clear" message to worker failed', t);
    });
  }
  /** @inheritdoc */
  getEarliestTimestamp() {
    return this._earliestTimestamp;
  }
  /**
   * Send the event to the worker.
   */
  _sendEventToWorker(t) {
    return this._worker.postMessage("addEvent", t);
  }
  /**
   * Finish the request and return the compressed data from the worker.
   */
  async _finishRequest() {
    const t = await this._worker.postMessage("finish");
    return this._earliestTimestamp = null, this._totalSize = 0, t;
  }
}
class L_ {
  constructor(t) {
    this._fallback = new eu(), this._compression = new D_(t), this._used = this._fallback, this._ensureWorkerIsLoadedPromise = this._ensureWorkerIsLoaded();
  }
  /** @inheritdoc */
  get waitForCheckout() {
    return this._used.waitForCheckout;
  }
  /** @inheritdoc */
  get type() {
    return this._used.type;
  }
  /** @inheritDoc */
  get hasEvents() {
    return this._used.hasEvents;
  }
  /** @inheritdoc */
  get hasCheckout() {
    return this._used.hasCheckout;
  }
  /** @inheritdoc */
  set hasCheckout(t) {
    this._used.hasCheckout = t;
  }
  /** @inheritdoc */
  // eslint-disable-next-line @typescript-eslint/adjacent-overload-signatures
  set waitForCheckout(t) {
    this._used.waitForCheckout = t;
  }
  /** @inheritDoc */
  destroy() {
    this._fallback.destroy(), this._compression.destroy();
  }
  /** @inheritdoc */
  clear() {
    return this._used.clear();
  }
  /** @inheritdoc */
  getEarliestTimestamp() {
    return this._used.getEarliestTimestamp();
  }
  /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully added.
   */
  addEvent(t) {
    return this._used.addEvent(t);
  }
  /** @inheritDoc */
  async finish() {
    return await this.ensureWorkerIsLoaded(), this._used.finish();
  }
  /** Ensure the worker has loaded. */
  ensureWorkerIsLoaded() {
    return this._ensureWorkerIsLoadedPromise;
  }
  /** Actually check if the worker has been loaded. */
  async _ensureWorkerIsLoaded() {
    try {
      await this._compression.ensureReady();
    } catch (t) {
      k && R.exception(t, "Failed to load the compression worker, falling back to simple buffer");
      return;
    }
    await this._switchToCompressionWorker();
  }
  /** Switch the used buffer to the compression worker. */
  async _switchToCompressionWorker() {
    const { events: t, hasCheckout: n, waitForCheckout: r } = this._fallback, s = [];
    for (const i of t)
      s.push(this._compression.addEvent(i));
    this._compression.hasCheckout = n, this._compression.waitForCheckout = r, this._used = this._compression;
    try {
      await Promise.all(s), this._fallback.clear();
    } catch (i) {
      k && R.exception(i, "Failed to add events when switching buffers.");
    }
  }
}
function P_({
  useCompression: e,
  workerUrl: t
}) {
  if (e && // eslint-disable-next-line no-restricted-globals
  window.Worker) {
    const n = F_(t);
    if (n)
      return n;
  }
  return k && R.log("Using simple buffer"), new eu();
}
function F_(e) {
  try {
    const t = e || $_();
    if (!t)
      return;
    k && R.log(`Using compression worker${e ? ` from ${e}` : ""}`);
    const n = new Worker(t);
    return new L_(n);
  } catch (t) {
    k && R.exception(t, "Failed to create compression worker");
  }
}
function $_() {
  return typeof __SENTRY_EXCLUDE_REPLAY_WORKER__ > "u" || !__SENTRY_EXCLUDE_REPLAY_WORKER__ ? A_() : "";
}
function pi() {
  try {
    return "sessionStorage" in Z && !!Z.sessionStorage;
  } catch {
    return !1;
  }
}
function B_(e) {
  U_(), e.session = void 0;
}
function U_() {
  if (pi())
    try {
      Z.sessionStorage.removeItem(ti);
    } catch {
    }
}
function tu(e) {
  return e === void 0 ? !1 : Math.random() < e;
}
function hi(e) {
  if (pi())
    try {
      Z.sessionStorage.setItem(ti, JSON.stringify(e));
    } catch {
    }
}
function nu(e) {
  const t = Date.now(), n = e.id || _e(), r = e.started || t, s = e.lastActivity || t, i = e.segmentId || 0, o = e.sampled, c = e.previousSessionId;
  return {
    id: n,
    started: r,
    lastActivity: s,
    segmentId: i,
    sampled: o,
    previousSessionId: c
  };
}
function H_(e, t) {
  return tu(e) ? "session" : t ? "buffer" : !1;
}
function $o({ sessionSampleRate: e, allowBuffering: t, stickySession: n = !1 }, { previousSessionId: r } = {}) {
  const s = H_(e, t), i = nu({
    sampled: s,
    previousSessionId: r
  });
  return n && hi(i), i;
}
function W_() {
  if (!pi())
    return null;
  try {
    const e = Z.sessionStorage.getItem(ti);
    if (!e)
      return null;
    const t = JSON.parse(e);
    return k && R.infoTick("Loading existing session"), nu(t);
  } catch {
    return null;
  }
}
function Ts(e, t, n = +/* @__PURE__ */ new Date()) {
  return e === null || t === void 0 || t < 0 ? !0 : t === 0 ? !1 : e + t <= n;
}
function ru(e, {
  maxReplayDuration: t,
  sessionIdleExpire: n,
  targetTime: r = Date.now()
}) {
  return (
    // First, check that maximum session length has not been exceeded
    Ts(e.started, t, r) || // check that the idle timeout has not been exceeded (i.e. user has
    // performed an action within the last `sessionIdleExpire` ms)
    Ts(e.lastActivity, n, r)
  );
}
function su(e, { sessionIdleExpire: t, maxReplayDuration: n }) {
  return !(!ru(e, { sessionIdleExpire: t, maxReplayDuration: n }) || e.sampled === "buffer" && e.segmentId === 0);
}
function Yr({
  sessionIdleExpire: e,
  maxReplayDuration: t,
  previousSessionId: n
}, r) {
  const s = r.stickySession && W_();
  return s ? su(s, { sessionIdleExpire: e, maxReplayDuration: t }) ? (k && R.infoTick("Session in sessionStorage is expired, creating new one..."), $o(r, { previousSessionId: s.id })) : s : (k && R.infoTick("Creating new session"), $o(r, { previousSessionId: n }));
}
function z_(e) {
  return e.type === P.Custom;
}
function mi(e, t, n) {
  return ou(e, t) ? (iu(e, t, n), !0) : !1;
}
function j_(e, t, n) {
  return ou(e, t) ? iu(e, t, n) : Promise.resolve(null);
}
async function iu(e, t, n) {
  const { eventBuffer: r } = e;
  if (!r || r.waitForCheckout && !n)
    return null;
  const s = e.recordingMode === "buffer";
  try {
    n && s && r.clear(), n && (r.hasCheckout = !0, r.waitForCheckout = !1);
    const i = e.getOptions(), o = q_(t, i.beforeAddRecordingEvent);
    return o ? await r.addEvent(o) : void 0;
  } catch (i) {
    const o = i && i instanceof fi, c = o ? "addEventSizeExceeded" : "addEvent";
    if (o && s)
      return r.clear(), r.waitForCheckout = !0, null;
    e.handleException(i), await e.stop({ reason: c });
    const a = U();
    a && a.recordDroppedEvent("internal_sdk_error", "replay");
  }
}
function ou(e, t) {
  if (!e.eventBuffer || e.isPaused() || !e.isEnabled())
    return !1;
  const n = ui(t.timestamp);
  return n + e.timeouts.sessionIdlePause < Date.now() ? !1 : n > e.getContext().initialTimestamp + e.getOptions().maxReplayDuration ? (k && R.infoTick(`Skipping event with timestamp ${n} because it is after maxReplayDuration`), !1) : !0;
}
function q_(e, t) {
  try {
    if (typeof t == "function" && z_(e))
      return t(e);
  } catch (n) {
    return k && R.exception(n, "An error occurred in the `beforeAddRecordingEvent` callback, skipping the event..."), null;
  }
  return e;
}
function gi(e) {
  return !e.type;
}
function Is(e) {
  return e.type === "transaction";
}
function V_(e) {
  return e.type === "replay_event";
}
function Bo(e) {
  return e.type === "feedback";
}
function G_(e) {
  return (t, n) => {
    if (!e.isEnabled() || !gi(t) && !Is(t))
      return;
    const r = n?.statusCode;
    if (!(!r || r < 200 || r >= 300)) {
      if (Is(t)) {
        Y_(e, t);
        return;
      }
      K_(e, t);
    }
  };
}
function Y_(e, t) {
  const n = e.getContext();
  t.contexts?.trace?.trace_id && n.traceIds.size < 100 && n.traceIds.add(t.contexts.trace.trace_id);
}
function K_(e, t) {
  const n = e.getContext();
  if (t.event_id && n.errorIds.size < 100 && n.errorIds.add(t.event_id), e.recordingMode !== "buffer" || !t.tags || !t.tags.replayId)
    return;
  const { beforeErrorSampling: r } = e.getOptions();
  typeof r == "function" && !r(t) || gn(async () => {
    try {
      await e.sendBufferedReplayOrFlush();
    } catch (s) {
      e.handleException(s);
    }
  });
}
function X_(e) {
  return (t) => {
    !e.isEnabled() || !gi(t) || J_(e, t);
  };
}
function J_(e, t) {
  const n = t.exception?.values?.[0]?.value;
  if (typeof n == "string" && // Only matches errors in production builds of react-dom
  // Example https://reactjs.org/docs/error-decoder.html?invariant=423
  // With newer React versions, the messages changed to a different website https://react.dev/errors/418
  (n.match(
    /(reactjs\.org\/docs\/error-decoder\.html\?invariant=|react\.dev\/errors\/)(418|419|422|423|425)/
  ) || // Development builds of react-dom
  // Error 1: Hydration failed because the initial UI does not match what was rendered on the server.
  // Error 2: Text content does not match server-rendered HTML. Warning: Text content did not match.
  n.match(/(does not match server-rendered HTML|Hydration failed because)/i))) {
    const r = xe({
      category: "replay.hydrate-error",
      data: {
        url: Pt()
      }
    });
    Sn(e, r);
  }
}
function Q_(e) {
  const t = U();
  t && t.on("beforeAddBreadcrumb", (n) => Z_(e, n));
}
function Z_(e, t) {
  if (!e.isEnabled() || !au(t))
    return;
  const n = eS(t);
  n && Sn(e, n);
}
function eS(e) {
  return !au(e) || [
    // fetch & xhr are handled separately,in handleNetworkBreadcrumbs
    "fetch",
    "xhr",
    // These two are breadcrumbs for emitted sentry events, we don't care about them
    "sentry.event",
    "sentry.transaction"
  ].includes(e.category) || // We capture UI breadcrumbs separately
  e.category.startsWith("ui.") ? null : e.category === "console" ? tS(e) : xe(e);
}
function tS(e) {
  const t = e.data?.arguments;
  if (!Array.isArray(t) || t.length === 0)
    return xe(e);
  let n = !1;
  const r = t.map((s) => {
    if (!s)
      return s;
    if (typeof s == "string")
      return s.length > Mn ? (n = !0, `${s.slice(0, Mn)}…`) : s;
    if (typeof s == "object")
      try {
        const i = we(s, 7);
        return JSON.stringify(i).length > Mn ? (n = !0, `${JSON.stringify(i, null, 2).slice(0, Mn)}…`) : i;
      } catch {
      }
    return s;
  });
  return xe({
    ...e,
    data: {
      ...e.data,
      arguments: r,
      ...n ? { _meta: { warnings: ["CONSOLE_ARG_TRUNCATED"] } } : {}
    }
  });
}
function au(e) {
  return !!e.category;
}
function nS(e, t) {
  return e.type || !e.exception?.values?.length ? !1 : !!t.originalException?.__rrweb__;
}
function cu() {
  const e = V().getPropagationContext().dsc;
  e && delete e.replay_id;
  const t = ce();
  if (t) {
    const n = Ue(t);
    delete n.replay_id;
  }
}
function rS(e, t) {
  e.triggerUserActivity(), e.addUpdate(() => t.timestamp ? (e.throttledAddEvent({
    type: P.Custom,
    timestamp: t.timestamp * 1e3,
    data: {
      tag: "breadcrumb",
      payload: {
        timestamp: t.timestamp,
        type: "default",
        category: "sentry.feedback",
        data: {
          feedbackId: t.event_id
        }
      }
    }
  }), !1) : !0);
}
function sS(e, t) {
  return e.recordingMode !== "buffer" || t.message === ni || !t.exception || t.type ? !1 : tu(e.getOptions().errorSampleRate);
}
function iS(e) {
  return Object.assign(
    (t, n) => !e.isEnabled() || e.isPaused() ? t : V_(t) ? (delete t.breadcrumbs, t) : !gi(t) && !Is(t) && !Bo(t) ? t : e.checkAndHandleExpiredSession() ? Bo(t) ? (e.flush(), t.contexts.feedback.replay_id = e.getSessionId(), rS(e, t), t) : nS(t, n) && !e.getOptions()._experiments.captureExceptions ? (k && R.log("Ignoring error from rrweb internals", t), null) : ((sS(e, t) || e.recordingMode === "session") && (t.tags = { ...t.tags, replayId: e.getSessionId() }), t) : (cu(), t),
    { id: "Replay" }
  );
}
function br(e, t) {
  return t.map(({ type: n, start: r, end: s, name: i, data: o }) => {
    const c = e.throttledAddEvent({
      type: P.Custom,
      timestamp: r,
      data: {
        tag: "performanceSpan",
        payload: {
          op: n,
          description: i,
          startTimestamp: r,
          endTimestamp: s,
          data: o
        }
      }
    });
    return typeof c == "string" ? Promise.resolve(null) : c;
  });
}
function oS(e) {
  const { from: t, to: n } = e, r = Date.now() / 1e3;
  return {
    type: "navigation.push",
    start: r,
    end: r,
    name: n,
    data: {
      previous: t
    }
  };
}
function aS(e) {
  return (t) => {
    if (!e.isEnabled())
      return;
    const n = oS(t);
    n !== null && (e.getContext().urls.push(n.name), e.triggerUserActivity(), e.addUpdate(() => (br(e, [n]), !1)));
  };
}
function cS(e, t) {
  return k && e.getOptions()._experiments.traceInternals ? !1 : of(t, U());
}
function uu(e, t) {
  e.isEnabled() && t !== null && (cS(e, t.name) || e.addUpdate(() => (br(e, [t]), !0)));
}
function vr(e) {
  if (!e)
    return;
  const t = new TextEncoder();
  try {
    if (typeof e == "string")
      return t.encode(e).length;
    if (e instanceof URLSearchParams)
      return t.encode(e.toString()).length;
    if (e instanceof FormData) {
      const n = bc(e);
      return t.encode(n).length;
    }
    if (e instanceof Blob)
      return e.size;
    if (e instanceof ArrayBuffer)
      return e.byteLength;
  } catch {
  }
}
function lu(e) {
  if (!e)
    return;
  const t = parseInt(e, 10);
  return isNaN(t) ? void 0 : t;
}
function cr(e, t) {
  if (!e)
    return {
      headers: {},
      size: void 0,
      _meta: {
        warnings: [t]
      }
    };
  const n = { ...e._meta }, r = n.warnings || [];
  return n.warnings = [...r, t], e._meta = n, e;
}
function du(e, t) {
  if (!t)
    return null;
  const { startTimestamp: n, endTimestamp: r, url: s, method: i, statusCode: o, request: c, response: a } = t;
  return {
    type: e,
    start: n / 1e3,
    end: r / 1e3,
    name: s,
    data: {
      method: i,
      statusCode: o,
      request: c,
      response: a
    }
  };
}
function tn(e) {
  return {
    headers: {},
    size: e,
    _meta: {
      warnings: ["URL_SKIPPED"]
    }
  };
}
function Ve(e, t, n) {
  if (!t && Object.keys(e).length === 0)
    return;
  if (!t)
    return {
      headers: e
    };
  if (!n)
    return {
      headers: e,
      size: t
    };
  const r = {
    headers: e,
    size: t
  }, { body: s, warnings: i } = uS(n);
  return r.body = s, i?.length && (r._meta = {
    warnings: i
  }), r;
}
function ws(e, t) {
  return Object.entries(e).reduce((n, [r, s]) => {
    const i = r.toLowerCase();
    return t.includes(i) && e[r] && (n[i] = s), n;
  }, {});
}
function uS(e) {
  if (!e || typeof e != "string")
    return {
      body: e
    };
  const t = e.length > yo, n = lS(e);
  if (t) {
    const r = e.slice(0, yo);
    return n ? {
      body: r,
      warnings: ["MAYBE_JSON_TRUNCATED"]
    } : {
      body: `${r}…`,
      warnings: ["TEXT_TRUNCATED"]
    };
  }
  if (n)
    try {
      return {
        body: JSON.parse(e)
      };
    } catch {
    }
  return {
    body: e
  };
}
function lS(e) {
  const t = e[0], n = e[e.length - 1];
  return t === "[" && n === "]" || t === "{" && n === "}";
}
function ur(e, t) {
  const n = dS(e);
  return De(n, t);
}
function dS(e, t = Z.document.baseURI) {
  if (e.startsWith("http://") || e.startsWith("https://") || e.startsWith(Z.location.origin))
    return e;
  const n = new URL(e, t);
  if (n.origin !== new URL(t).origin)
    return e;
  const r = n.href;
  return !e.endsWith("/") && r.endsWith("/") ? r.slice(0, -1) : r;
}
async function fS(e, t, n) {
  try {
    const r = await hS(e, t, n), s = du("resource.fetch", r);
    uu(n.replay, s);
  } catch (r) {
    k && R.exception(r, "Failed to capture fetch breadcrumb");
  }
}
function pS(e, t) {
  const { input: n, response: r } = t, s = n ? Tc(n) : void 0, i = vr(s), o = r ? lu(r.headers.get("content-length")) : void 0;
  i !== void 0 && (e.data.request_body_size = i), o !== void 0 && (e.data.response_body_size = o);
}
async function hS(e, t, n) {
  const r = Date.now(), { startTimestamp: s = r, endTimestamp: i = r } = t, {
    url: o,
    method: c,
    status_code: a = 0,
    request_body_size: u,
    response_body_size: l
  } = e.data, d = ur(o, n.networkDetailAllowUrls) && !ur(o, n.networkDetailDenyUrls), f = d ? mS(n, t.input, u) : tn(u), p = await gS(d, n, t.response, l);
  return {
    startTimestamp: s,
    endTimestamp: i,
    url: o,
    method: c,
    statusCode: a,
    request: f,
    response: p
  };
}
function mS({ networkCaptureBodies: e, networkRequestHeaders: t }, n, r) {
  const s = n ? yS(n, t) : {};
  if (!e)
    return Ve(s, r, void 0);
  const i = Tc(n), [o, c] = vc(i, R), a = Ve(s, r, o);
  return c ? cr(a, c) : a;
}
async function gS(e, {
  networkCaptureBodies: t,
  networkResponseHeaders: n
}, r, s) {
  if (!e && s !== void 0)
    return tn(s);
  const i = r ? fu(r.headers, n) : {};
  if (!r || !t && s !== void 0)
    return Ve(i, s, void 0);
  const [o, c] = await SS(r), a = _S(o, {
    networkCaptureBodies: t,
    responseBodySize: s,
    captureDetails: e,
    headers: i
  });
  return c ? cr(a, c) : a;
}
function _S(e, {
  networkCaptureBodies: t,
  responseBodySize: n,
  captureDetails: r,
  headers: s
}) {
  try {
    const i = e?.length && n === void 0 ? vr(e) : n;
    return r ? t ? Ve(s, i, e) : Ve(s, i, void 0) : tn(i);
  } catch (i) {
    return k && R.exception(i, "Failed to serialize response body"), Ve(s, n, void 0);
  }
}
async function SS(e) {
  const t = ES(e);
  if (!t)
    return [void 0, "BODY_PARSE_ERROR"];
  try {
    return [await bS(t)];
  } catch (n) {
    return n instanceof Error && n.message.indexOf("Timeout") > -1 ? (k && R.warn("Parsing text body from response timed out"), [void 0, "BODY_PARSE_TIMEOUT"]) : (k && R.exception(n, "Failed to get text body from response"), [void 0, "BODY_PARSE_ERROR"]);
  }
}
function fu(e, t) {
  const n = {};
  return t.forEach((r) => {
    e.get(r) && (n[r] = e.get(r));
  }), n;
}
function yS(e, t) {
  return e.length === 1 && typeof e[0] != "string" ? Uo(e[0], t) : e.length === 2 ? Uo(e[1], t) : {};
}
function Uo(e, t) {
  if (!e)
    return {};
  const n = e.headers;
  return n ? n instanceof Headers ? fu(n, t) : Array.isArray(n) ? {} : ws(n, t) : {};
}
function ES(e) {
  try {
    return e.clone();
  } catch (t) {
    k && R.exception(t, "Failed to clone response body");
  }
}
function bS(e) {
  return new Promise((t, n) => {
    const r = gn(() => n(new Error("Timeout while trying to read response body")), 500);
    vS(e).then(
      (s) => t(s),
      (s) => n(s)
    ).finally(() => clearTimeout(r));
  });
}
async function vS(e) {
  return await e.text();
}
async function TS(e, t, n) {
  try {
    const r = wS(e, t, n), s = du("resource.xhr", r);
    uu(n.replay, s);
  } catch (r) {
    k && R.exception(r, "Failed to capture xhr breadcrumb");
  }
}
function IS(e, t) {
  const { xhr: n, input: r } = t;
  if (!n)
    return;
  const s = vr(r), i = n.getResponseHeader("content-length") ? lu(n.getResponseHeader("content-length")) : xS(n.response, n.responseType);
  s !== void 0 && (e.data.request_body_size = s), i !== void 0 && (e.data.response_body_size = i);
}
function wS(e, t, n) {
  const r = Date.now(), { startTimestamp: s = r, endTimestamp: i = r, input: o, xhr: c } = t, {
    url: a,
    method: u,
    status_code: l = 0,
    request_body_size: d,
    response_body_size: f
  } = e.data;
  if (!a)
    return null;
  if (!c || !ur(a, n.networkDetailAllowUrls) || ur(a, n.networkDetailDenyUrls)) {
    const _ = tn(d), v = tn(f);
    return {
      startTimestamp: s,
      endTimestamp: i,
      url: a,
      method: u,
      statusCode: l,
      request: _,
      response: v
    };
  }
  const p = c[ot], h = p ? ws(p.request_headers, n.networkRequestHeaders) : {}, m = ws(kS(c), n.networkResponseHeaders), [S, E] = n.networkCaptureBodies ? vc(o, R) : [void 0], [w, q] = n.networkCaptureBodies ? RS(c) : [void 0], F = Ve(h, d, S), C = Ve(m, f, w);
  return {
    startTimestamp: s,
    endTimestamp: i,
    url: a,
    method: u,
    statusCode: l,
    request: E ? cr(F, E) : F,
    response: q ? cr(C, q) : C
  };
}
function kS(e) {
  const t = e.getAllResponseHeaders();
  return t ? t.split(`\r
`).reduce((n, r) => {
    const [s, i] = r.split(": ");
    return i && (n[s.toLowerCase()] = i), n;
  }, {}) : {};
}
function RS(e) {
  const t = [];
  try {
    return [e.responseText];
  } catch (n) {
    t.push(n);
  }
  try {
    return CS(e.response, e.responseType);
  } catch (n) {
    t.push(n);
  }
  return k && R.warn("Failed to get xhr response body", ...t), [void 0];
}
function CS(e, t) {
  try {
    if (typeof e == "string")
      return [e];
    if (e instanceof Document)
      return [e.body.outerHTML];
    if (t === "json" && e && typeof e == "object")
      return [JSON.stringify(e)];
    if (!e)
      return [void 0];
  } catch (n) {
    return k && R.exception(n, "Failed to serialize body", e), [void 0, "BODY_PARSE_ERROR"];
  }
  return k && R.log("Skipping network body because of body type", e), [void 0, "UNPARSEABLE_BODY_TYPE"];
}
function xS(e, t) {
  try {
    const n = t === "json" && e && typeof e == "object" ? JSON.stringify(e) : e;
    return vr(n);
  } catch {
    return;
  }
}
function MS(e) {
  const t = U();
  try {
    const {
      networkDetailAllowUrls: n,
      networkDetailDenyUrls: r,
      networkCaptureBodies: s,
      networkRequestHeaders: i,
      networkResponseHeaders: o
    } = e.getOptions(), c = {
      replay: e,
      networkDetailAllowUrls: n,
      networkDetailDenyUrls: r,
      networkCaptureBodies: s,
      networkRequestHeaders: i,
      networkResponseHeaders: o
    };
    t && t.on("beforeAddBreadcrumb", (a, u) => AS(c, a, u));
  } catch {
  }
}
function AS(e, t, n) {
  if (t.data)
    try {
      OS(t) && DS(n) && (IS(t, n), TS(t, n, e)), NS(t) && LS(n) && (pS(t, n), fS(t, n, e));
    } catch (r) {
      k && R.exception(r, "Error when enriching network breadcrumb");
    }
}
function OS(e) {
  return e.category === "xhr";
}
function NS(e) {
  return e.category === "fetch";
}
function DS(e) {
  return e?.xhr;
}
function LS(e) {
  return e?.response;
}
function PS(e) {
  const t = U();
  Sc(f_(e)), _r(aS(e)), Q_(e), MS(e);
  const n = iS(e);
  Md(n), t && (t.on("beforeSendEvent", X_(e)), t.on("afterSendEvent", G_(e)), t.on("createDsc", (r) => {
    const s = e.getSessionId();
    s && e.isEnabled() && e.recordingMode === "session" && e.checkAndHandleExpiredSession() && (r.replay_id = s);
  }), t.on("spanStart", (r) => {
    e.lastActiveSpan = r;
  }), t.on("spanEnd", (r) => {
    e.lastActiveSpan = r;
  }), t.on("beforeSendFeedback", async (r, s) => {
    const i = e.getSessionId();
    s?.includeReplay && e.isEnabled() && i && r.contexts?.feedback && (r.contexts.feedback.source === "api" && await e.sendBufferedReplayOrFlush(), r.contexts.feedback.replay_id = i);
  }), t.on("openFeedbackWidget", async () => {
    await e.sendBufferedReplayOrFlush();
  }));
}
async function FS(e) {
  try {
    return Promise.all(
      br(e, [
        // @ts-expect-error memory doesn't exist on type Performance as the API is non-standard (we check that it exists above)
        $S(Z.performance.memory)
      ])
    );
  } catch {
    return [];
  }
}
function $S(e) {
  const { jsHeapSizeLimit: t, totalJSHeapSize: n, usedJSHeapSize: r } = e, s = Date.now() / 1e3;
  return {
    type: "memory",
    name: "memory",
    start: s,
    end: s,
    data: {
      memory: {
        jsHeapSizeLimit: t,
        totalJSHeapSize: n,
        usedJSHeapSize: r
      }
    }
  };
}
function BS(e, t, n) {
  return df(e, t, {
    ...n,
    // @ts-expect-error - Not quite sure why these types do not match, but this is fine
    setTimeoutImpl: gn
  });
}
const Dn = z.navigator;
function US() {
  return /iPhone|iPad|iPod/i.test(Dn?.userAgent ?? "") || /Macintosh/i.test(Dn?.userAgent ?? "") && Dn?.maxTouchPoints && Dn?.maxTouchPoints > 1 ? {
    sampling: {
      mousemove: !1
    }
  } : {};
}
function HS(e) {
  let t = !1;
  return (n, r) => {
    if (!e.checkAndHandleExpiredSession()) {
      k && R.warn("Received replay event after session expired.");
      return;
    }
    const s = r || !t;
    t = !0, e.clickDetector && a_(e.clickDetector, n), e.addUpdate(() => {
      if (e.recordingMode === "buffer" && s && e.setInitialState(), !mi(e, n, s))
        return !0;
      if (!s)
        return !1;
      const i = e.session;
      if (zS(e, s), e.recordingMode === "buffer" && i && e.eventBuffer) {
        const o = e.eventBuffer.getEarliestTimestamp();
        o && (k && R.log(`Updating session start time to earliest event in buffer to ${new Date(o)}`), i.started = o, e.getOptions().stickySession && hi(i));
      }
      return i?.previousSessionId || e.recordingMode === "session" && e.flush(), !0;
    });
  };
}
function WS(e) {
  const t = e.getOptions();
  return {
    type: P.Custom,
    timestamp: Date.now(),
    data: {
      tag: "options",
      payload: {
        shouldRecordCanvas: e.isRecordingCanvas(),
        sessionSampleRate: t.sessionSampleRate,
        errorSampleRate: t.errorSampleRate,
        useCompressionOption: t.useCompression,
        blockAllMedia: t.blockAllMedia,
        maskAllText: t.maskAllText,
        maskAllInputs: t.maskAllInputs,
        useCompression: e.eventBuffer ? e.eventBuffer.type === "worker" : !1,
        networkDetailHasUrls: t.networkDetailAllowUrls.length > 0,
        networkCaptureBodies: t.networkCaptureBodies,
        networkRequestHasHeaders: t.networkRequestHeaders.length > 0,
        networkResponseHasHeaders: t.networkResponseHeaders.length > 0
      }
    }
  };
}
function zS(e, t) {
  !t || !e.session || e.session.segmentId !== 0 || mi(e, WS(e), !1);
}
function jS(e) {
  if (!e)
    return null;
  try {
    return e.nodeType === e.ELEMENT_NODE ? e : e.parentElement;
  } catch {
    return null;
  }
}
function qS(e, t, n, r) {
  return St(
    xa(e, Bs(e), r, n),
    [
      [{ type: "replay_event" }, e],
      [
        {
          type: "replay_recording",
          // If string then we need to encode to UTF8, otherwise will have
          // wrong size. TextEncoder has similar browser support to
          // MutationObserver, although it does not accept IE11.
          length: typeof t == "string" ? new TextEncoder().encode(t).length : t.length
        },
        t
      ]
    ]
  );
}
function VS({
  recordingData: e,
  headers: t
}) {
  let n;
  const r = `${JSON.stringify(t)}
`;
  if (typeof e == "string")
    n = `${r}${e}`;
  else {
    const i = new TextEncoder().encode(r);
    n = new Uint8Array(i.length + e.length), n.set(i), n.set(e, i.length);
  }
  return n;
}
async function GS({
  client: e,
  scope: t,
  replayId: n,
  event: r
}) {
  const s = typeof e._integrations == "object" && e._integrations !== null && !Array.isArray(e._integrations) ? Object.keys(e._integrations) : void 0, i = { event_id: n, integrations: s };
  e.emit("preprocessEvent", r, i);
  const o = await La(
    e.getOptions(),
    r,
    i,
    t,
    e,
    Ae()
  );
  if (!o)
    return null;
  e.emit("postprocessEvent", o, i), o.platform = o.platform || "javascript";
  const c = e.getSdkMetadata(), { name: a, version: u, settings: l } = c?.sdk || {};
  return o.sdk = {
    ...o.sdk,
    name: a || "sentry.javascript.unknown",
    version: u || "0.0.0",
    settings: l
  }, o;
}
async function YS({
  recordingData: e,
  replayId: t,
  segmentId: n,
  eventContext: r,
  timestamp: s,
  session: i
}) {
  const o = VS({
    recordingData: e,
    headers: {
      segment_id: n
    }
  }), { urls: c, errorIds: a, traceIds: u, initialTimestamp: l } = r, d = U(), f = V(), p = d?.getTransport(), h = d?.getDsn();
  if (!d || !p || !h || !i.sampled)
    return He({});
  const m = {
    type: wm,
    replay_start_timestamp: l / 1e3,
    timestamp: s / 1e3,
    error_ids: a,
    trace_ids: u,
    urls: c,
    replay_id: t,
    segment_id: n,
    replay_type: i.sampled
  }, S = await GS({ scope: f, client: d, replayId: t, event: m });
  if (!S)
    return d.recordDroppedEvent("event_processor", "replay"), k && R.log("An event processor returned `null`, will not send event."), He({});
  delete S.sdkProcessingMetadata;
  const E = qS(S, o, h, d.getOptions().tunnel);
  let w;
  try {
    w = await p.send(E);
  } catch (F) {
    const C = new Error(ni);
    try {
      C.cause = F;
    } catch {
    }
    throw C;
  }
  if (typeof w.statusCode == "number" && (w.statusCode < 200 || w.statusCode >= 300))
    throw new pu(w.statusCode);
  const q = Ga({}, w);
  if (Va(q, "replay"))
    throw new _i(q);
  return w;
}
class pu extends Error {
  constructor(t) {
    super(`Transport returned status code ${t}`);
  }
}
class _i extends Error {
  constructor(t) {
    super("Rate limit hit"), this.rateLimits = t;
  }
}
async function hu(e, t = {
  count: 0,
  interval: Am
}) {
  const { recordingData: n, onError: r } = e;
  if (n.length)
    try {
      return await YS(e), !0;
    } catch (s) {
      if (s instanceof pu || s instanceof _i)
        throw s;
      if (Cd("Replays", {
        _retryCount: t.count
      }), r && r(s), t.count >= Om) {
        const i = new Error(`${ni} - max retries exceeded`);
        try {
          i.cause = s;
        } catch {
        }
        throw i;
      }
      return t.interval *= ++t.count, new Promise((i, o) => {
        gn(async () => {
          try {
            await hu(e, t), i(!0);
          } catch (c) {
            o(c);
          }
        }, t.interval);
      });
    }
}
const mu = "__THROTTLED", KS = "__SKIPPED";
function XS(e, t, n) {
  const r = /* @__PURE__ */ new Map(), s = (c) => {
    const a = c - n;
    r.forEach((u, l) => {
      l < a && r.delete(l);
    });
  }, i = () => [...r.values()].reduce((c, a) => c + a, 0);
  let o = !1;
  return (...c) => {
    const a = Math.floor(Date.now() / 1e3);
    if (s(a), i() >= t) {
      const l = o;
      return o = !0, l ? KS : mu;
    }
    o = !1;
    const u = r.get(a) || 0;
    return r.set(a, u + 1), e(...c);
  };
}
class JS {
  /**
   * Recording can happen in one of two modes:
   *   - session: Record the whole session, sending it continuously
   *   - buffer: Always keep the last 60s of recording, requires:
   *     - having replaysOnErrorSampleRate > 0 to capture replay when an error occurs
   *     - or calling `flush()` to send the replay
   */
  /**
   * The current or last active span.
   * This is only available when performance is enabled.
   */
  /**
   * These are here so we can overwrite them in tests etc.
   * @hidden
   */
  /** The replay has to be manually started, because no sample rate (neither session or error) was provided. */
  /**
   * Options to pass to `rrweb.record()`
   */
  /**
   * Timestamp of the last user activity. This lives across sessions.
   */
  /**
   * Is the integration currently active?
   */
  /**
   * Paused is a state where:
   * - DOM Recording is not listening at all
   * - Nothing will be added to event buffer (e.g. core SDK events)
   */
  /**
   * Have we attached listeners to the core SDK?
   * Note we have to track this as there is no way to remove instrumentation handlers.
   */
  /**
   * Function to stop recording
   */
  /**
   * Internal use for canvas recording options
   */
  /**
   * Handle when visibility of the page content changes. Opening a new tab will
   * cause the state to change to hidden because of content of current page will
   * be hidden. Likewise, moving a different window to cover the contents of the
   * page will also trigger a change to a hidden state.
   */
  /**
   * Handle when page is blurred
   */
  /**
   * Handle when page is focused
   */
  /** Ensure page remains active when a key is pressed. */
  constructor({
    options: t,
    recordingOptions: n
  }) {
    this.eventBuffer = null, this.performanceEntries = [], this.replayPerformanceEntries = [], this.recordingMode = "session", this.timeouts = {
      sessionIdlePause: km,
      sessionIdleExpire: Rm
    }, this._lastActivity = Date.now(), this._isEnabled = !1, this._isPaused = !1, this._requiresManualStart = !1, this._hasInitializedCoreListeners = !1, this._context = {
      errorIds: /* @__PURE__ */ new Set(),
      traceIds: /* @__PURE__ */ new Set(),
      urls: [],
      initialTimestamp: Date.now(),
      initialUrl: ""
    }, this._recordingOptions = n, this._options = t, this._debouncedFlush = BS(() => this._flush(), this._options.flushMinDelay, {
      maxWait: this._options.flushMaxDelay
    }), this._throttledAddEvent = XS(
      (o, c) => j_(this, o, c),
      // Max 300 events...
      300,
      // ... per 5s
      5
    );
    const { slowClickTimeout: r, slowClickIgnoreSelectors: s } = this.getOptions(), i = r ? {
      threshold: Math.min(Nm, r),
      timeout: r,
      scrollTimeout: Dm,
      ignoreSelector: s ? s.join(",") : ""
    } : void 0;
    if (i && (this.clickDetector = new r_(this, i)), k) {
      const o = t._experiments;
      R.setConfig({
        captureExceptions: !!o.captureExceptions,
        traceInternals: !!o.traceInternals
      });
    }
    this._handleVisibilityChange = () => {
      Z.document.visibilityState === "visible" ? this._doChangeToForegroundTasks() : this._doChangeToBackgroundTasks();
    }, this._handleWindowBlur = () => {
      const o = xe({
        category: "ui.blur"
      });
      this._doChangeToBackgroundTasks(o);
    }, this._handleWindowFocus = () => {
      const o = xe({
        category: "ui.focus"
      });
      this._doChangeToForegroundTasks(o);
    }, this._handleKeyboardEvent = (o) => {
      g_(this, o);
    };
  }
  /** Get the event context. */
  getContext() {
    return this._context;
  }
  /** If recording is currently enabled. */
  isEnabled() {
    return this._isEnabled;
  }
  /** If recording is currently paused. */
  isPaused() {
    return this._isPaused;
  }
  /**
   * Determine if canvas recording is enabled
   */
  isRecordingCanvas() {
    return !!this._canvas;
  }
  /** Get the replay integration options. */
  getOptions() {
    return this._options;
  }
  /** A wrapper to conditionally capture exceptions. */
  handleException(t) {
    k && R.exception(t), this._options.onError && this._options.onError(t);
  }
  /**
   * Initializes the plugin based on sampling configuration. Should not be
   * called outside of constructor.
   */
  initializeSampling(t) {
    const { errorSampleRate: n, sessionSampleRate: r } = this._options, s = n <= 0 && r <= 0;
    if (this._requiresManualStart = s, !s) {
      if (this._initializeSessionForSampling(t), !this.session) {
        k && R.exception(new Error("Unable to initialize and create session"));
        return;
      }
      this.session.sampled !== !1 && (this.recordingMode = this.session.sampled === "buffer" && this.session.segmentId === 0 ? "buffer" : "session", k && R.infoTick(`Starting replay in ${this.recordingMode} mode`), this._initializeRecording());
    }
  }
  /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will log a message if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * _performanceObserver, Recording, Sentry SDK, etc)
   */
  start() {
    if (this._isEnabled && this.recordingMode === "session") {
      k && R.log("Recording is already in progress");
      return;
    }
    if (this._isEnabled && this.recordingMode === "buffer") {
      k && R.log("Buffering is in progress, call `flush()` to save the replay");
      return;
    }
    k && R.infoTick("Starting replay in session mode"), this._updateUserActivity();
    const t = Yr(
      {
        maxReplayDuration: this._options.maxReplayDuration,
        sessionIdleExpire: this.timeouts.sessionIdleExpire
      },
      {
        stickySession: this._options.stickySession,
        // This is intentional: create a new session-based replay when calling `start()`
        sessionSampleRate: 1,
        allowBuffering: !1
      }
    );
    this.session = t, this.recordingMode = "session", this._initializeRecording();
  }
  /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, an error occurs.
   */
  startBuffering() {
    if (this._isEnabled) {
      k && R.log("Buffering is in progress, call `flush()` to save the replay");
      return;
    }
    k && R.infoTick("Starting replay in buffer mode");
    const t = Yr(
      {
        sessionIdleExpire: this.timeouts.sessionIdleExpire,
        maxReplayDuration: this._options.maxReplayDuration
      },
      {
        stickySession: this._options.stickySession,
        sessionSampleRate: 0,
        allowBuffering: !0
      }
    );
    this.session = t, this.recordingMode = "buffer", this._initializeRecording();
  }
  /**
   * Start recording.
   *
   * Note that this will cause a new DOM checkout
   */
  startRecording() {
    try {
      const t = this._canvas;
      this._stopRecording = Le({
        ...this._recordingOptions,
        // When running in error sampling mode, we need to overwrite `checkoutEveryNms`
        // Without this, it would record forever, until an error happens, which we don't want
        // instead, we'll always keep the last 60 seconds of replay before an error happened
        ...this.recordingMode === "buffer" ? { checkoutEveryNms: Mm } : (
          // Otherwise, use experimental option w/ min checkout time of 6 minutes
          // This is to improve playback seeking as there could potentially be
          // less mutations to process in the worse cases.
          //
          // checkout by "N" events is probably ideal, but means we have less
          // control about the number of checkouts we make (which generally
          // increases replay size)
          this._options._experiments.continuousCheckout && {
            // Minimum checkout time is 6 minutes
            checkoutEveryNms: Math.max(36e4, this._options._experiments.continuousCheckout)
          }
        ),
        emit: HS(this),
        ...US(),
        onMutation: this._onMutationHandler.bind(this),
        ...t ? {
          recordCanvas: t.recordCanvas,
          getCanvasManager: t.getCanvasManager,
          sampling: t.sampling,
          dataURLOptions: t.dataURLOptions
        } : {}
      });
    } catch (t) {
      this.handleException(t);
    }
  }
  /**
   * Stops the recording, if it was running.
   *
   * Returns true if it was previously stopped, or is now stopped,
   * otherwise false.
   */
  stopRecording() {
    try {
      return this._stopRecording && (this._stopRecording(), this._stopRecording = void 0), !0;
    } catch (t) {
      return this.handleException(t), !1;
    }
  }
  /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */
  async stop({ forceFlush: t = !1, reason: n } = {}) {
    if (this._isEnabled) {
      this._isEnabled = !1, this.recordingMode = "buffer";
      try {
        k && R.log(`Stopping Replay${n ? ` triggered by ${n}` : ""}`), cu(), this._removeListeners(), this.stopRecording(), this._debouncedFlush.cancel(), t && await this._flush({ force: !0 }), this.eventBuffer?.destroy(), this.eventBuffer = null, B_(this);
      } catch (r) {
        this.handleException(r);
      }
    }
  }
  /**
   * Pause some replay functionality. See comments for `_isPaused`.
   * This differs from stop as this only stops DOM recording, it is
   * not as thorough of a shutdown as `stop()`.
   */
  pause() {
    this._isPaused || (this._isPaused = !0, this.stopRecording(), k && R.log("Pausing replay"));
  }
  /**
   * Resumes recording, see notes for `pause().
   *
   * Note that calling `startRecording()` here will cause a
   * new DOM checkout.`
   */
  resume() {
    !this._isPaused || !this._checkSession() || (this._isPaused = !1, this.startRecording(), k && R.log("Resuming replay"));
  }
  /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */
  async sendBufferedReplayOrFlush({ continueRecording: t = !0 } = {}) {
    if (this.recordingMode === "session")
      return this.flushImmediate();
    const n = Date.now();
    k && R.log("Converting buffer to session"), await this.flushImmediate();
    const r = this.stopRecording();
    !t || !r || this.recordingMode !== "session" && (this.recordingMode = "session", this.session && (this._updateUserActivity(n), this._updateSessionActivity(n), this._maybeSaveSession()), this.startRecording());
  }
  /**
   * We want to batch uploads of replay events. Save events only if
   * `<flushMinDelay>` milliseconds have elapsed since the last event
   * *OR* if `<flushMaxDelay>` milliseconds have elapsed.
   *
   * Accepts a callback to perform side-effects and returns true to stop batch
   * processing and hand back control to caller.
   */
  addUpdate(t) {
    const n = t();
    this.recordingMode === "buffer" || !this._isEnabled || n !== !0 && this._debouncedFlush();
  }
  /**
   * Updates the user activity timestamp and resumes recording. This should be
   * called in an event handler for a user action that we consider as the user
   * being "active" (e.g. a mouse click).
   */
  triggerUserActivity() {
    if (this._updateUserActivity(), !this._stopRecording) {
      if (!this._checkSession())
        return;
      this.resume();
      return;
    }
    this.checkAndHandleExpiredSession(), this._updateSessionActivity();
  }
  /**
   * Updates the user activity timestamp *without* resuming
   * recording. Some user events (e.g. keydown) can be create
   * low-value replays that only contain the keypress as a
   * breadcrumb. Instead this would require other events to
   * create a new replay after a session has expired.
   */
  updateUserActivity() {
    this._updateUserActivity(), this._updateSessionActivity();
  }
  /**
   * Only flush if `this.recordingMode === 'session'`
   */
  conditionalFlush() {
    return this.recordingMode === "buffer" ? Promise.resolve() : this.flushImmediate();
  }
  /**
   * Flush using debounce flush
   */
  flush() {
    return this._debouncedFlush();
  }
  /**
   * Always flush via `_debouncedFlush` so that we do not have flushes triggered
   * from calling both `flush` and `_debouncedFlush`. Otherwise, there could be
   * cases of multiple flushes happening closely together.
   */
  flushImmediate() {
    return this._debouncedFlush(), this._debouncedFlush.flush();
  }
  /**
   * Cancels queued up flushes.
   */
  cancelFlush() {
    this._debouncedFlush.cancel();
  }
  /** Get the current session (=replay) ID */
  getSessionId() {
    return this.session?.id;
  }
  /**
   * Checks if recording should be stopped due to user inactivity. Otherwise
   * check if session is expired and create a new session if so. Triggers a new
   * full snapshot on new session.
   *
   * Returns true if session is not expired, false otherwise.
   * @hidden
   */
  checkAndHandleExpiredSession() {
    if (this._lastActivity && Ts(this._lastActivity, this.timeouts.sessionIdlePause) && this.session && this.session.sampled === "session") {
      this.pause();
      return;
    }
    return !!this._checkSession();
  }
  /**
   * Capture some initial state that can change throughout the lifespan of the
   * replay. This is required because otherwise they would be captured at the
   * first flush.
   */
  setInitialState() {
    const t = `${Z.location.pathname}${Z.location.hash}${Z.location.search}`, n = `${Z.location.origin}${t}`;
    this.performanceEntries = [], this.replayPerformanceEntries = [], this._clearContext(), this._context.initialUrl = n, this._context.initialTimestamp = Date.now(), this._context.urls.push(n);
  }
  /**
   * Add a breadcrumb event, that may be throttled.
   * If it was throttled, we add a custom breadcrumb to indicate that.
   */
  throttledAddEvent(t, n) {
    const r = this._throttledAddEvent(t, n);
    if (r === mu) {
      const s = xe({
        category: "replay.throttled"
      });
      this.addUpdate(() => !mi(this, {
        type: Xg,
        timestamp: s.timestamp || 0,
        data: {
          tag: "breadcrumb",
          payload: s,
          metric: !0
        }
      }));
    }
    return r;
  }
  /**
   * This will get the parametrized route name of the current page.
   * This is only available if performance is enabled, and if an instrumented router is used.
   */
  getCurrentRoute() {
    const t = this.lastActiveSpan || ce(), n = t && ae(t), s = (n && B(n).data || {})[he];
    if (!(!n || !s || !["route", "custom"].includes(s)))
      return B(n).description;
  }
  /**
   * Initialize and start all listeners to varying events (DOM,
   * Performance Observer, Recording, Sentry SDK, etc)
   */
  _initializeRecording() {
    this.setInitialState(), this._updateSessionActivity(), this.eventBuffer = P_({
      useCompression: this._options.useCompression,
      workerUrl: this._options.workerUrl
    }), this._removeListeners(), this._addListeners(), this._isEnabled = !0, this._isPaused = !1, this.startRecording();
  }
  /**
   * Loads (or refreshes) the current session.
   */
  _initializeSessionForSampling(t) {
    const n = this._options.errorSampleRate > 0, r = Yr(
      {
        sessionIdleExpire: this.timeouts.sessionIdleExpire,
        maxReplayDuration: this._options.maxReplayDuration,
        previousSessionId: t
      },
      {
        stickySession: this._options.stickySession,
        sessionSampleRate: this._options.sessionSampleRate,
        allowBuffering: n
      }
    );
    this.session = r;
  }
  /**
   * Checks and potentially refreshes the current session.
   * Returns false if session is not recorded.
   */
  _checkSession() {
    if (!this.session)
      return !1;
    const t = this.session;
    return su(t, {
      sessionIdleExpire: this.timeouts.sessionIdleExpire,
      maxReplayDuration: this._options.maxReplayDuration
    }) ? (this._refreshSession(t), !1) : !0;
  }
  /**
   * Refresh a session with a new one.
   * This stops the current session (without forcing a flush, as that would never work since we are expired),
   * and then does a new sampling based on the refreshed session.
   */
  async _refreshSession(t) {
    this._isEnabled && (await this.stop({ reason: "refresh session" }), this.initializeSampling(t.id));
  }
  /**
   * Adds listeners to record events for the replay
   */
  _addListeners() {
    try {
      Z.document.addEventListener("visibilitychange", this._handleVisibilityChange), Z.addEventListener("blur", this._handleWindowBlur), Z.addEventListener("focus", this._handleWindowFocus), Z.addEventListener("keydown", this._handleKeyboardEvent), this.clickDetector && this.clickDetector.addListeners(), this._hasInitializedCoreListeners || (PS(this), this._hasInitializedCoreListeners = !0);
    } catch (t) {
      this.handleException(t);
    }
    this._performanceCleanupCallback = x_(this);
  }
  /**
   * Cleans up listeners that were created in `_addListeners`
   */
  _removeListeners() {
    try {
      Z.document.removeEventListener("visibilitychange", this._handleVisibilityChange), Z.removeEventListener("blur", this._handleWindowBlur), Z.removeEventListener("focus", this._handleWindowFocus), Z.removeEventListener("keydown", this._handleKeyboardEvent), this.clickDetector && this.clickDetector.removeListeners(), this._performanceCleanupCallback && this._performanceCleanupCallback();
    } catch (t) {
      this.handleException(t);
    }
  }
  /**
   * Tasks to run when we consider a page to be hidden (via blurring and/or visibility)
   */
  _doChangeToBackgroundTasks(t) {
    !this.session || ru(this.session, {
      maxReplayDuration: this._options.maxReplayDuration,
      sessionIdleExpire: this.timeouts.sessionIdleExpire
    }) || (t && this._createCustomBreadcrumb(t), this.conditionalFlush());
  }
  /**
   * Tasks to run when we consider a page to be visible (via focus and/or visibility)
   */
  _doChangeToForegroundTasks(t) {
    if (!this.session)
      return;
    if (!this.checkAndHandleExpiredSession()) {
      k && R.log("Document has become active, but session has expired");
      return;
    }
    t && this._createCustomBreadcrumb(t);
  }
  /**
   * Update user activity (across session lifespans)
   */
  _updateUserActivity(t = Date.now()) {
    this._lastActivity = t;
  }
  /**
   * Updates the session's last activity timestamp
   */
  _updateSessionActivity(t = Date.now()) {
    this.session && (this.session.lastActivity = t, this._maybeSaveSession());
  }
  /**
   * Helper to create (and buffer) a replay breadcrumb from a core SDK breadcrumb
   */
  _createCustomBreadcrumb(t) {
    this.addUpdate(() => {
      this.throttledAddEvent({
        type: P.Custom,
        timestamp: t.timestamp || 0,
        data: {
          tag: "breadcrumb",
          payload: t
        }
      });
    });
  }
  /**
   * Observed performance events are added to `this.performanceEntries`. These
   * are included in the replay event before it is finished and sent to Sentry.
   */
  _addPerformanceEntries() {
    let t = E_(this.performanceEntries).concat(this.replayPerformanceEntries);
    if (this.performanceEntries = [], this.replayPerformanceEntries = [], this._requiresManualStart) {
      const n = this._context.initialTimestamp / 1e3;
      t = t.filter((r) => r.start >= n);
    }
    return Promise.all(br(this, t));
  }
  /**
   * Clear _context
   */
  _clearContext() {
    this._context.errorIds.clear(), this._context.traceIds.clear(), this._context.urls = [];
  }
  /** Update the initial timestamp based on the buffer content. */
  _updateInitialTimestampFromEventBuffer() {
    const { session: t, eventBuffer: n } = this;
    if (!t || !n || this._requiresManualStart || t.segmentId)
      return;
    const r = n.getEarliestTimestamp();
    r && r < this._context.initialTimestamp && (this._context.initialTimestamp = r);
  }
  /**
   * Return and clear _context
   */
  _popEventContext() {
    const t = {
      initialTimestamp: this._context.initialTimestamp,
      initialUrl: this._context.initialUrl,
      errorIds: Array.from(this._context.errorIds),
      traceIds: Array.from(this._context.traceIds),
      urls: this._context.urls
    };
    return this._clearContext(), t;
  }
  /**
   * Flushes replay event buffer to Sentry.
   *
   * Performance events are only added right before flushing - this is
   * due to the buffered performance observer events.
   *
   * Should never be called directly, only by `flush`
   */
  async _runFlush() {
    const t = this.getSessionId();
    if (!this.session || !this.eventBuffer || !t) {
      k && R.error("No session or eventBuffer found to flush.");
      return;
    }
    if (await this._addPerformanceEntries(), !!this.eventBuffer?.hasEvents && (await FS(this), !!this.eventBuffer && t === this.getSessionId()))
      try {
        this._updateInitialTimestampFromEventBuffer();
        const n = Date.now();
        if (n - this._context.initialTimestamp > this._options.maxReplayDuration + 3e4)
          throw new Error("Session is too long, not sending replay");
        const r = this._popEventContext(), s = this.session.segmentId++;
        this._maybeSaveSession();
        const i = await this.eventBuffer.finish();
        await hu({
          replayId: t,
          recordingData: i,
          segmentId: s,
          eventContext: r,
          session: this.session,
          timestamp: n,
          onError: (o) => this.handleException(o)
        });
      } catch (n) {
        this.handleException(n), this.stop({ reason: "sendReplay" });
        const r = U();
        if (r) {
          const s = n instanceof _i ? "ratelimit_backoff" : "send_error";
          r.recordDroppedEvent(s, "replay");
        }
      }
  }
  /**
   * Flush recording data to Sentry. Creates a lock so that only a single flush
   * can be active at a time. Do not call this directly.
   */
  async _flush({
    force: t = !1
  } = {}) {
    if (!this._isEnabled && !t)
      return;
    if (!this.checkAndHandleExpiredSession()) {
      k && R.error("Attempting to finish replay event after session expired.");
      return;
    }
    if (!this.session)
      return;
    const n = this.session.started, s = Date.now() - n;
    this._debouncedFlush.cancel();
    const i = s < this._options.minReplayDuration, o = s > this._options.maxReplayDuration + 5e3;
    if (i || o) {
      k && R.log(
        `Session duration (${Math.floor(s / 1e3)}s) is too ${i ? "short" : "long"}, not sending replay.`
      ), i && this._debouncedFlush();
      return;
    }
    const c = this.eventBuffer;
    c && this.session.segmentId === 0 && !c.hasCheckout && k && R.log("Flushing initial segment without checkout.");
    const a = !!this._flushLock;
    this._flushLock || (this._flushLock = this._runFlush());
    try {
      await this._flushLock;
    } catch (u) {
      this.handleException(u);
    } finally {
      this._flushLock = void 0, a && this._debouncedFlush();
    }
  }
  /** Save the session, if it is sticky */
  _maybeSaveSession() {
    this.session && this._options.stickySession && hi(this.session);
  }
  /** Handler for rrweb.record.onMutation */
  _onMutationHandler(t) {
    const { ignoreMutations: n } = this._options._experiments;
    if (n?.length && t.some((c) => {
      const a = jS(c.target), u = n.join(",");
      return a?.matches(u);
    }))
      return !1;
    const r = t.length, s = this._options.mutationLimit, i = this._options.mutationBreadcrumbLimit, o = s && r > s;
    if (r > i || o) {
      const c = xe({
        category: "replay.mutations",
        data: {
          count: r,
          limit: o
        }
      });
      this._createCustomBreadcrumb(c);
    }
    return o ? (this.stop({ reason: "mutationLimit", forceFlush: this.recordingMode === "session" }), !1) : !0;
  }
}
function Wt(e, t) {
  return [
    ...e,
    // sentry defaults
    ...t
  ].join(",");
}
function QS({ mask: e, unmask: t, block: n, unblock: r, ignore: s }) {
  const i = ["base", "iframe[srcdoc]:not([src])"], o = Wt(e, [".sentry-mask", "[data-sentry-mask]"]), c = Wt(t, []);
  return {
    // We are making the decision to make text and input selectors the same
    maskTextSelector: o,
    unmaskTextSelector: c,
    blockSelector: Wt(n, [".sentry-block", "[data-sentry-block]", ...i]),
    unblockSelector: Wt(r, []),
    ignoreSelector: Wt(s, [".sentry-ignore", "[data-sentry-ignore]", 'input[type="file"]'])
  };
}
function ZS({
  el: e,
  key: t,
  maskAttributes: n,
  maskAllText: r,
  privacyOptions: s,
  value: i
}) {
  return !r || s.unmaskTextSelector && e.matches(s.unmaskTextSelector) ? i : n.includes(t) || // Need to mask `value` attribute for `<input>` if it's a button-like
  // type
  t === "value" && e.tagName === "INPUT" && ["submit", "button"].includes(e.getAttribute("type") || "") ? i.replace(/[\S]/g, "*") : i;
}
const Ho = 'img,image,svg,video,object,picture,embed,map,audio,link[rel="icon"],link[rel="apple-touch-icon"]', ey = ["content-length", "content-type", "accept"];
let Wo = !1;
const ty = (e) => new ny(e);
class ny {
  /**
   * @inheritDoc
   */
  /**
   * Options to pass to `rrweb.record()`
   */
  /**
   * Initial options passed to the replay integration, merged with default values.
   * Note: `sessionSampleRate` and `errorSampleRate` are not required here, as they
   * can only be finally set when setupOnce() is called.
   *
   * @private
   */
  constructor({
    flushMinDelay: t = Cm,
    flushMaxDelay: n = xm,
    minReplayDuration: r = Lm,
    maxReplayDuration: s = Eo,
    stickySession: i = !0,
    useCompression: o = !0,
    workerUrl: c,
    _experiments: a = {},
    maskAllText: u = !0,
    maskAllInputs: l = !0,
    blockAllMedia: d = !0,
    mutationBreadcrumbLimit: f = 750,
    mutationLimit: p = 1e4,
    slowClickTimeout: h = 7e3,
    slowClickIgnoreSelectors: m = [],
    networkDetailAllowUrls: S = [],
    networkDetailDenyUrls: E = [],
    networkCaptureBodies: w = !0,
    networkRequestHeaders: q = [],
    networkResponseHeaders: F = [],
    mask: C = [],
    maskAttributes: _ = ["title", "placeholder", "aria-label"],
    unmask: v = [],
    block: M = [],
    unblock: y = [],
    ignore: I = [],
    maskFn: $,
    beforeAddRecordingEvent: A,
    beforeErrorSampling: K,
    onError: J
  } = {}) {
    this.name = "Replay";
    const L = QS({
      mask: C,
      unmask: v,
      block: M,
      unblock: y,
      ignore: I
    });
    if (this._recordingOptions = {
      maskAllInputs: l,
      maskAllText: u,
      maskInputOptions: { password: !0 },
      maskTextFn: $,
      maskInputFn: $,
      maskAttributeFn: (T, D, O) => ZS({
        maskAttributes: _,
        maskAllText: u,
        privacyOptions: L,
        key: T,
        value: D,
        el: O
      }),
      ...L,
      // Our defaults
      slimDOMOptions: "all",
      inlineStylesheet: !0,
      // Disable inline images as it will increase segment/replay size
      inlineImages: !1,
      // collect fonts, but be aware that `sentry.io` needs to be an allowed
      // origin for playback
      collectFonts: !0,
      errorHandler: (T) => {
        try {
          T.__rrweb__ = !0;
        } catch {
        }
      },
      // experimental support for recording iframes from different origins
      recordCrossOriginIframes: !!a.recordCrossOriginIframes
    }, this._initialOptions = {
      flushMinDelay: t,
      flushMaxDelay: n,
      minReplayDuration: Math.min(r, Pm),
      maxReplayDuration: Math.min(s, Eo),
      stickySession: i,
      useCompression: o,
      workerUrl: c,
      blockAllMedia: d,
      maskAllInputs: l,
      maskAllText: u,
      mutationBreadcrumbLimit: f,
      mutationLimit: p,
      slowClickTimeout: h,
      slowClickIgnoreSelectors: m,
      networkDetailAllowUrls: S,
      networkDetailDenyUrls: E,
      networkCaptureBodies: w,
      networkRequestHeaders: zo(q),
      networkResponseHeaders: zo(F),
      beforeAddRecordingEvent: A,
      beforeErrorSampling: K,
      onError: J,
      _experiments: a
    }, this._initialOptions.blockAllMedia && (this._recordingOptions.blockSelector = this._recordingOptions.blockSelector ? `${this._recordingOptions.blockSelector},${Ho}` : Ho), this._isInitialized && uo())
      throw new Error("Multiple Sentry Session Replay instances are not supported");
    this._isInitialized = !0;
  }
  /** If replay has already been initialized */
  get _isInitialized() {
    return Wo;
  }
  /** Update _isInitialized */
  set _isInitialized(t) {
    Wo = t;
  }
  /**
   * Setup and initialize replay container
   */
  afterAllSetup(t) {
    !uo() || this._replay || (this._setup(t), this._initialize(t));
  }
  /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will log a message if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * PerformanceObserver, Recording, Sentry SDK, etc)
   */
  start() {
    this._replay && this._replay.start();
  }
  /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, until an error occurs.
   */
  startBuffering() {
    this._replay && this._replay.startBuffering();
  }
  /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */
  stop() {
    return this._replay ? this._replay.stop({ forceFlush: this._replay.recordingMode === "session" }) : Promise.resolve();
  }
  /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * If replay is not enabled, a new session replay is started.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */
  flush(t) {
    return this._replay ? this._replay.isEnabled() ? this._replay.sendBufferedReplayOrFlush(t) : (this._replay.start(), Promise.resolve()) : Promise.resolve();
  }
  /**
   * Get the current session ID.
   */
  getReplayId() {
    if (this._replay?.isEnabled())
      return this._replay.getSessionId();
  }
  /**
   * Get the current recording mode. This can be either `session` or `buffer`.
   *
   * `session`: Recording the whole session, sending it continuously
   * `buffer`: Always keeping the last 60s of recording, requires:
   *   - having replaysOnErrorSampleRate > 0 to capture replay when an error occurs
   *   - or calling `flush()` to send the replay
   */
  getRecordingMode() {
    if (this._replay?.isEnabled())
      return this._replay.recordingMode;
  }
  /**
   * Initializes replay.
   */
  _initialize(t) {
    this._replay && (this._maybeLoadFromReplayCanvasIntegration(t), this._replay.initializeSampling());
  }
  /** Setup the integration. */
  _setup(t) {
    const n = ry(this._initialOptions, t);
    this._replay = new JS({
      options: n,
      recordingOptions: this._recordingOptions
    });
  }
  /** Get canvas options from ReplayCanvas integration, if it is also added. */
  _maybeLoadFromReplayCanvasIntegration(t) {
    try {
      const n = t.getIntegrationByName("ReplayCanvas");
      if (!n)
        return;
      this._replay._canvas = n.getOptions();
    } catch {
    }
  }
}
function ry(e, t) {
  const n = t.getOptions(), r = {
    sessionSampleRate: 0,
    errorSampleRate: 0,
    ...e
  }, s = pt(n.replaysSessionSampleRate), i = pt(n.replaysOnErrorSampleRate);
  return s == null && i == null && We(() => {
    console.warn(
      "Replay is disabled because neither `replaysSessionSampleRate` nor `replaysOnErrorSampleRate` are set."
    );
  }), s != null && (r.sessionSampleRate = s), i != null && (r.errorSampleRate = i), r;
}
function zo(e) {
  return [...ey, ...e.map((t) => t.toLowerCase())];
}
function Ce(e = 0) {
  return ((me() || performance.timeOrigin) + e) / 1e3;
}
function sy(e) {
  const t = [];
  if (e.nextHopProtocol != null) {
    const { name: n, version: r } = mc(e.nextHopProtocol);
    t.push(["network.protocol.version", r], ["network.protocol.name", n]);
  }
  return me() ? [
    ...t,
    ["http.request.redirect_start", Ce(e.redirectStart)],
    ["http.request.fetch_start", Ce(e.fetchStart)],
    ["http.request.domain_lookup_start", Ce(e.domainLookupStart)],
    ["http.request.domain_lookup_end", Ce(e.domainLookupEnd)],
    ["http.request.connect_start", Ce(e.connectStart)],
    ["http.request.secure_connection_start", Ce(e.secureConnectionStart)],
    ["http.request.connection_end", Ce(e.connectEnd)],
    ["http.request.request_start", Ce(e.requestStart)],
    ["http.request.response_start", Ce(e.responseStart)],
    ["http.request.response_end", Ce(e.responseEnd)]
  ] : t;
}
const jo = /* @__PURE__ */ new WeakMap(), Kr = /* @__PURE__ */ new Map(), gu = {
  traceFetch: !0,
  traceXHR: !0,
  enableHTTPTimings: !0,
  trackFetchStreamPerformance: !1
};
function iy(e, t) {
  const {
    traceFetch: n,
    traceXHR: r,
    trackFetchStreamPerformance: s,
    shouldCreateSpanForRequest: i,
    enableHTTPTimings: o,
    tracePropagationTargets: c,
    onRequestSpanStart: a
  } = {
    ...gu,
    ...t
  }, u = typeof i == "function" ? i : (f) => !0, l = (f) => ay(f, c), d = {};
  n && (e.addEventProcessor((f) => (f.type === "transaction" && f.spans && f.spans.forEach((p) => {
    if (p.op === "http.client") {
      const h = Kr.get(p.span_id);
      h && (p.timestamp = h / 1e3, Kr.delete(p.span_id));
    }
  }), f)), s && qf((f) => {
    if (f.response) {
      const p = jo.get(f.response);
      p && f.endTimestamp && Kr.set(p, f.endTimestamp);
    }
  }), ec((f) => {
    const p = Pf(f, u, l, d);
    if (f.response && f.fetchData.__span && jo.set(f.response, f.fetchData.__span), p) {
      const h = _u(f.fetchData.url), m = h ? dt(h).host : void 0;
      p.setAttributes({
        "http.url": h,
        "server.address": m
      }), o && qo(p), a?.(p, { headers: f.headers });
    }
  })), r && Ec((f) => {
    const p = cy(f, u, l, d);
    if (p) {
      o && qo(p);
      let h;
      try {
        h = new Headers(f.xhr.__sentry_xhr_v3__?.request_headers);
      } catch {
      }
      a?.(p, { headers: h });
    }
  });
}
function oy(e) {
  return e.entryType === "resource" && "initiatorType" in e && typeof e.nextHopProtocol == "string" && (e.initiatorType === "fetch" || e.initiatorType === "xmlhttprequest");
}
function qo(e) {
  const { url: t } = B(e).data;
  if (!t || typeof t != "string")
    return;
  const n = ht("resource", ({ entries: r }) => {
    r.forEach((s) => {
      oy(s) && s.name.endsWith(t) && (sy(s).forEach((o) => e.setAttribute(...o)), setTimeout(n));
    });
  });
}
function ay(e, t) {
  const n = Pt();
  if (n) {
    let r, s;
    try {
      r = new URL(e, n), s = new URL(n).origin;
    } catch {
      return !1;
    }
    const i = r.origin === s;
    return t ? De(r.toString(), t) || i && De(r.pathname, t) : i;
  } else {
    const r = !!e.match(/^\/(?!\/)/);
    return t ? De(e, t) : r;
  }
}
function cy(e, t, n, r) {
  const s = e.xhr, i = s?.[ot];
  if (!s || s.__sentry_own_request__ || !i)
    return;
  const { url: o, method: c } = i, a = Be() && t(o);
  if (e.endTimestamp && a) {
    const m = s.__sentry_xhr_span_id__;
    if (!m) return;
    const S = r[m];
    S && i.status_code !== void 0 && (ha(S, i.status_code), S.end(), delete r[m]);
    return;
  }
  const u = _u(o), l = dt(u || o), d = sf(o), f = !!ce(), p = a && f ? Xe({
    name: `${c} ${d}`,
    attributes: {
      url: o,
      type: "xhr",
      "http.method": c,
      "http.url": u,
      "server.address": l?.host,
      [ee]: "auto.http.browser",
      [$e]: "http.client",
      ...l?.search && { "http.query": l?.search },
      ...l?.hash && { "http.fragment": l?.hash }
    }
  }) : new Ke();
  s.__sentry_xhr_span_id__ = p.spanContext().spanId, r[s.__sentry_xhr_span_id__] = p, n(o) && uy(
    s,
    // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
    // we do not want to use the span as base for the trace headers,
    // which means that the headers will be generated from the scope and the sampling decision is deferred
    Be() && f ? p : void 0
  );
  const h = U();
  return h && h.emit("beforeOutgoingRequestSpan", p, e), p;
}
function uy(e, t) {
  const { "sentry-trace": n, baggage: r } = Ka({ span: t });
  n && ly(e, n, r);
}
function ly(e, t, n) {
  const r = e.__sentry_xhr_v3__?.request_headers;
  if (!r?.["sentry-trace"])
    try {
      if (e.setRequestHeader("sentry-trace", t), n) {
        const s = r?.baggage;
        (!s || !dy(s)) && e.setRequestHeader("baggage", n);
      }
    } catch {
    }
}
function dy(e) {
  return e.split(",").some((t) => t.trim().startsWith("sentry-"));
}
function _u(e) {
  try {
    return new URL(e, j.location.origin).href;
  } catch {
    return;
  }
}
function fy() {
  j.document ? j.document.addEventListener("visibilitychange", () => {
    const e = ce();
    if (!e)
      return;
    const t = ae(e);
    if (j.document.hidden && t) {
      const n = "cancelled", { op: r, status: s } = B(t);
      be && g.log(`[Tracing] Transaction: ${n} -> since tab moved to the background, op: ${r}`), s || t.setStatus({ code: se, message: n }), t.setAttribute("sentry.cancellation_reason", "document.hidden"), t.end();
    }
  }) : be && g.warn("[Tracing] Could not set up background tab detection due to lack of global document");
}
const py = 3600, Su = "sentry_previous_trace", hy = "sentry.previous_trace";
function my(e, {
  linkPreviousTrace: t,
  consistentTraceSampling: n
}) {
  const r = t === "session-storage";
  let s = r ? Sy() : void 0;
  e.on("spanStart", (o) => {
    if (ae(o) !== o)
      return;
    const c = V().getPropagationContext();
    s = gy(s, o, c), r && _y(s);
  });
  let i = !0;
  n && e.on("beforeSampling", (o) => {
    if (!s)
      return;
    const c = V(), a = c.getPropagationContext();
    if (i && a.parentSpanId) {
      i = !1;
      return;
    }
    c.setPropagationContext({
      ...a,
      dsc: {
        ...a.dsc,
        sample_rate: String(s.sampleRate),
        sampled: String(ks(s.spanContext))
      },
      sampleRand: s.sampleRand
    }), o.parentSampled = ks(s.spanContext), o.parentSampleRate = s.sampleRate, o.spanAttributes = {
      ...o.spanAttributes,
      [fa]: s.sampleRate
    };
  });
}
function gy(e, t, n) {
  const r = B(t);
  function s() {
    try {
      return Number(n.dsc?.sample_rate) ?? Number(r.data?.[Ds]);
    } catch {
      return 0;
    }
  }
  const i = {
    spanContext: t.spanContext(),
    startTimestamp: r.start_timestamp,
    sampleRate: s(),
    sampleRand: n.sampleRand
  };
  if (!e)
    return i;
  const o = e.spanContext;
  return o.traceId === r.trace_id ? e : (Date.now() / 1e3 - e.startTimestamp <= py && (be && g.log(
    `Adding previous_trace ${o} link to span ${{
      op: r.op,
      ...t.spanContext()
    }}`
  ), t.addLink({
    context: o,
    attributes: {
      [il]: "previous_trace"
    }
  }), t.setAttribute(
    hy,
    `${o.traceId}-${o.spanId}-${ks(o) ? 1 : 0}`
  )), i);
}
function _y(e) {
  try {
    j.sessionStorage.setItem(Su, JSON.stringify(e));
  } catch (t) {
    be && g.warn("Could not store previous trace in sessionStorage", t);
  }
}
function Sy() {
  try {
    const e = j.sessionStorage?.getItem(Su);
    return JSON.parse(e);
  } catch {
    return;
  }
}
function ks(e) {
  return e.traceFlags === 1;
}
const yy = "BrowserTracing", Ey = {
  ...Bn,
  instrumentNavigation: !0,
  instrumentPageLoad: !0,
  markBackgroundSpan: !0,
  enableLongTask: !0,
  enableLongAnimationFrame: !0,
  enableInp: !0,
  enableElementTiming: !0,
  ignoreResourceSpans: [],
  ignorePerformanceApiSpans: [],
  detectRedirects: !0,
  linkPreviousTrace: "in-memory",
  consistentTraceSampling: !1,
  _experiments: {},
  ...gu
}, Vo = (e = {}) => {
  const t = {
    name: void 0,
    source: void 0
  }, n = j.document, {
    enableInp: r,
    enableElementTiming: s,
    enableLongTask: i,
    enableLongAnimationFrame: o,
    _experiments: { enableInteractions: c, enableStandaloneClsSpans: a, enableStandaloneLcpSpans: u },
    beforeStartSpan: l,
    idleTimeout: d,
    finalTimeout: f,
    childSpanTimeout: p,
    markBackgroundSpan: h,
    traceFetch: m,
    traceXHR: S,
    trackFetchStreamPerformance: E,
    shouldCreateSpanForRequest: w,
    enableHTTPTimings: q,
    ignoreResourceSpans: F,
    ignorePerformanceApiSpans: C,
    instrumentPageLoad: _,
    instrumentNavigation: v,
    detectRedirects: M,
    linkPreviousTrace: y,
    consistentTraceSampling: I,
    onRequestSpanStart: $
  } = {
    ...Ey,
    ...e
  };
  let A, K;
  function J(L, T, D = !0) {
    const O = T.op === "pageload", X = l ? l(T) : T, ie = X.attributes || {};
    if (T.name !== X.name && (ie[he] = "custom", X.attributes = ie), !D) {
      const Re = gt();
      Xe({
        ...X,
        startTime: Re
      }).end(Re);
      return;
    }
    t.name = X.name, t.source = ie[he];
    const ve = Da(X, {
      idleTimeout: d,
      finalTimeout: f,
      childSpanTimeout: p,
      // should wait for finish signal if it's a pageload transaction
      disableAutoFinish: O,
      beforeSpanEnd: (Re) => {
        A?.(), eh(Re, {
          recordClsOnPageloadSpan: !a,
          recordLcpOnPageloadSpan: !u,
          ignoreResourceSpans: F,
          ignorePerformanceApiSpans: C
        }), Yo(L, void 0);
        const ze = V(), Ht = ze.getPropagationContext();
        ze.setPropagationContext({
          ...Ht,
          traceId: ve.spanContext().traceId,
          sampled: _t(ve),
          dsc: Ue(Re)
        });
      }
    });
    Yo(L, ve);
    function nt() {
      n && ["interactive", "complete"].includes(n.readyState) && L.emit("idleSpanEnableAutoFinish", ve);
    }
    O && n && (n.addEventListener("readystatechange", () => {
      nt();
    }), nt());
  }
  return {
    name: yy,
    setup(L) {
      if (Al(), A = Gp({
        recordClsStandaloneSpans: a || !1,
        recordLcpStandaloneSpans: u || !1,
        client: L
      }), r && vh(), s && lh(), o && z.PerformanceObserver && PerformanceObserver.supportedEntryTypes && PerformanceObserver.supportedEntryTypes.includes("long-animation-frame") ? Kp() : i && Yp(), c && Xp(), M && n) {
        const D = () => {
          K = re();
        };
        addEventListener("click", D, { capture: !0 }), addEventListener("keydown", D, { capture: !0, passive: !0 });
      }
      function T() {
        const D = nn(L);
        D && !B(D).timestamp && (be && g.log(`[Tracing] Finishing current active span with op: ${B(D).op}`), D.setAttribute(Gn, "cancelled"), D.end());
      }
      L.on("startNavigationSpan", (D, O) => {
        if (U() !== L)
          return;
        if (O?.isRedirect) {
          be && g.warn("[Tracing] Detected redirect, navigation span will not be the root span, but a child span."), J(
            L,
            {
              op: "navigation.redirect",
              ...D
            },
            !1
          );
          return;
        }
        K = void 0, T(), Ae().setPropagationContext({ traceId: Ye(), sampleRand: Math.random() });
        const X = V();
        X.setPropagationContext({ traceId: Ye(), sampleRand: Math.random() }), X.setSDKProcessingMetadata({
          normalizedRequest: void 0
        }), J(L, {
          op: "navigation",
          ...D
        });
      }), L.on("startPageLoadSpan", (D, O = {}) => {
        if (U() !== L)
          return;
        T();
        const X = O.sentryTrace || Go("sentry-trace"), ie = O.baggage || Go("baggage"), ve = Tl(X, ie), nt = V();
        nt.setPropagationContext(ve), nt.setSDKProcessingMetadata({
          normalizedRequest: js()
        }), J(L, {
          op: "pageload",
          ...D
        });
      });
    },
    afterAllSetup(L) {
      let T = Pt();
      if (y !== "off" && my(L, { linkPreviousTrace: y, consistentTraceSampling: I }), j.location) {
        if (_) {
          const D = me();
          by(L, {
            name: j.location.pathname,
            // pageload should always start at timeOrigin (and needs to be in s, not ms)
            startTime: D ? D / 1e3 : void 0,
            attributes: {
              [he]: "url",
              [ee]: "auto.pageload.browser"
            }
          });
        }
        v && _r(({ to: D, from: O }) => {
          if (O === void 0 && T?.indexOf(D) !== -1) {
            T = void 0;
            return;
          }
          T = void 0;
          const X = zs(D), ie = nn(L), ve = ie && M && Ty(ie, K);
          yu(
            L,
            {
              name: X?.pathname || j.location.pathname,
              attributes: {
                [he]: "url",
                [ee]: "auto.navigation.browser"
              }
            },
            { url: D, isRedirect: ve }
          );
        });
      }
      h && fy(), c && vy(L, d, f, p, t), r && wh(), iy(L, {
        traceFetch: m,
        traceXHR: S,
        trackFetchStreamPerformance: E,
        tracePropagationTargets: L.getOptions().tracePropagationTargets,
        shouldCreateSpanForRequest: w,
        enableHTTPTimings: q,
        onRequestSpanStart: $
      });
    }
  };
};
function by(e, t, n) {
  e.emit("startPageLoadSpan", t, n), V().setTransactionName(t.name);
  const r = nn(e);
  return r && e.emit("afterStartPageLoadSpan", r), r;
}
function yu(e, t, n) {
  const { url: r, isRedirect: s } = n || {};
  e.emit("beforeStartNavigationSpan", t, { isRedirect: s }), e.emit("startNavigationSpan", t, { isRedirect: s });
  const i = V();
  return i.setTransactionName(t.name), r && !s && i.setSDKProcessingMetadata({
    normalizedRequest: {
      ...js(),
      url: r
    }
  }), nn(e);
}
function Go(e) {
  return j.document?.querySelector(`meta[name=${e}]`)?.getAttribute("content") || void 0;
}
function vy(e, t, n, r, s) {
  const i = j.document;
  let o;
  const c = () => {
    const a = "ui.action.click", u = nn(e);
    if (u) {
      const l = B(u).op;
      if (["navigation", "pageload"].includes(l)) {
        be && g.warn(`[Tracing] Did not create ${a} span because a pageload or navigation span is in progress.`);
        return;
      }
    }
    if (o && (o.setAttribute(Gn, "interactionInterrupted"), o.end(), o = void 0), !s.name) {
      be && g.warn(`[Tracing] Did not create ${a} transaction because _latestRouteName is missing.`);
      return;
    }
    o = Da(
      {
        name: s.name,
        op: a,
        attributes: {
          [he]: s.source || "url"
        }
      },
      {
        idleTimeout: t,
        finalTimeout: n,
        childSpanTimeout: r
      }
    );
  };
  i && addEventListener("click", c, { capture: !0 });
}
const Eu = "_sentry_idleSpan";
function nn(e) {
  return e[Eu];
}
function Yo(e, t) {
  Se(e, Eu, t);
}
const Ko = 1.5;
function Ty(e, t) {
  const n = B(e), r = gt(), s = n.start_timestamp;
  return !(r - s > Ko || t && r - t <= Ko);
}
const bu = ["activate", "mount"], vu = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, Iy = /(?:^|[-_])(\w)/g, wy = (e) => e.replace(Iy, (t) => t.toUpperCase()).replace(/[-_]/g, ""), ky = "<Root>", Xr = "<Anonymous>", Ry = (e, t) => e.repeat(t), Yt = (e, t) => {
  if (!e)
    return Xr;
  if (e.$root === e)
    return ky;
  if (!e.$options)
    return Xr;
  const n = e.$options;
  let r = n.name || n._componentTag || n.__name;
  const s = n.__file;
  if (!r && s) {
    const i = s.match(/([^/\\]+)\.vue$/);
    i && (r = i[1]);
  }
  return (r ? `<${wy(r)}>` : Xr) + (s && t !== !1 ? ` at ${s}` : "");
}, Cy = (e) => {
  if (e && (e._isVue || e.__isVue) && e.$parent) {
    const t = [];
    let n = 0;
    for (; e; ) {
      if (t.length > 0) {
        const s = t[t.length - 1];
        if (s.constructor === e.constructor) {
          n++, e = e.$parent;
          continue;
        } else n > 0 && (t[t.length - 1] = [s, n], n = 0);
      }
      t.push(e), e = e.$parent;
    }
    return `

found in

${t.map(
      (s, i) => `${(i === 0 ? "---> " : Ry(" ", 5 + i * 2)) + (Array.isArray(s) ? `${Yt(s[0])}... (${s[1]} recursive calls)` : Yt(s))}`
    ).join(`
`)}`;
  }
  return `

(found in ${Yt(e)})`;
}, xy = (e, t) => {
  const { errorHandler: n } = e.config;
  e.config.errorHandler = (r, s, i) => {
    const o = Yt(s, !1), c = s ? Cy(s) : "", a = {
      componentName: o,
      lifecycleHook: i,
      trace: c
    };
    if (t.attachProps && s && (s.$options?.propsData ? a.propsData = s.$options.propsData : s.$props && (a.propsData = s.$props)), setTimeout(() => {
      dn(r, {
        captureContext: { contexts: { vue: a } },
        mechanism: { handled: !!n, type: "vue" }
      });
    }), typeof n == "function" && e.config.errorHandler)
      n.call(e, r, s, i);
    else
      throw r;
  };
}, Xo = "ui.vue", My = {
  activate: ["activated", "deactivated"],
  create: ["beforeCreate", "created"],
  // Vue 3
  unmount: ["beforeUnmount", "unmounted"],
  // Vue 2
  destroy: ["beforeDestroy", "destroyed"],
  mount: ["beforeMount", "mounted"],
  update: ["beforeUpdate", "updated"]
};
function Jr(e, t, n) {
  e.$_sentryRootComponentSpanTimer && clearTimeout(e.$_sentryRootComponentSpanTimer), e.$_sentryRootComponentSpanTimer = setTimeout(() => {
    e.$root?.$_sentryRootComponentSpan && (e.$root.$_sentryRootComponentSpan.end(t), e.$root.$_sentryRootComponentSpan = void 0);
  }, n);
}
function Ay(e, t) {
  function n(s) {
    return s.replace(/^<([^\s]*)>(?: at [^\s]*)?$/, "$1");
  }
  return e.some((s) => n(t) === n(s));
}
const Oy = (e = {}) => {
  const t = (e.hooks || []).concat(bu).filter((s, i, o) => o.indexOf(s) === i), n = {}, r = e.timeout || 2e3;
  for (const s of t) {
    const i = My[s];
    if (!i) {
      vu && g.warn(`Unknown hook: ${s}`);
      continue;
    }
    for (const o of i)
      n[o] = function() {
        const c = this.$root === this;
        c && (this.$_sentryRootComponentSpan = this.$_sentryRootComponentSpan || Xe({
          name: "Application Render",
          op: `${Xo}.render`,
          attributes: {
            [ee]: "auto.ui.vue"
          },
          onlyIfParent: !0
        }), Jr(this, re(), r));
        const a = Yt(this, !1);
        if (!(c || // We always want to track the root component
        (Array.isArray(e.trackComponents) ? Ay(e.trackComponents, a) : e.trackComponents))) {
          Jr(this, re(), r);
          return;
        }
        this.$_sentryComponentSpans = this.$_sentryComponentSpans || {};
        const l = o === i[0], d = this.$root?.$_sentryRootComponentSpan || ce();
        if (l) {
          if (d) {
            const f = this.$_sentryComponentSpans[s];
            f && f.end(), this.$_sentryComponentSpans[s] = Xe({
              name: `Vue ${a}`,
              op: `${Xo}.${s}`,
              attributes: {
                [ee]: "auto.ui.vue"
              },
              // UI spans should only be created if there is an active root span (transaction)
              onlyIfParent: !0
            });
          }
        } else {
          const f = this.$_sentryComponentSpans[s];
          if (!f) return;
          f.end(), Jr(this, re(), r);
        }
      };
  }
  return n;
}, Ny = z, Dy = {
  Vue: Ny.Vue,
  attachProps: !0,
  attachErrorHandler: !0,
  tracingOptions: {
    hooks: bu,
    timeout: 2e3,
    trackComponents: !1
  }
}, Ly = "Vue", Py = (e = {}) => ({
  name: Ly,
  setup(t) {
    const n = { ...Dy, ...t.getOptions(), ...e };
    if (!n.Vue && !n.app) {
      We(() => {
        console.warn(
          "[@sentry/vue]: Misconfigured SDK. Vue specific errors will not be captured. Update your `Sentry.init` call with an appropriate config option: `app` (Application Instance - Vue 3) or `Vue` (Vue Constructor - Vue 2)."
        );
      });
      return;
    }
    n.app ? (Array.isArray(n.app) ? n.app : [n.app]).forEach((s) => Jo(s, n)) : n.Vue && Jo(n.Vue, n);
  }
}), Jo = (e, t) => {
  vu && e._instance?.isMounted === !0 && We(() => {
    console.warn(
      "[@sentry/vue]: Misconfigured SDK. Vue app is already mounted. Make sure to call `app.mount()` after `Sentry.init()`."
    );
  }), t.attachErrorHandler && xy(e, t), Be(t) && e.mixin(Oy(t.tracingOptions));
};
function Fy(e = {}) {
  const t = {
    defaultIntegrations: [...kc(), Py()],
    ...e
  };
  return Ya(t, "vue"), Im(t);
}
function $y(e, t, n) {
  let r = !1;
  e.onError((s) => dn(s, { mechanism: { handled: !1 } })), e.beforeEach((s, i, o) => {
    const c = r ? void 0 : By(), a = {};
    for (const d of Object.keys(s.params))
      a[`url.path.parameter.${d}`] = s.params[d], a[`params.${d}`] = s.params[d];
    for (const d of Object.keys(s.query)) {
      const f = s.query[d];
      f && (a[`query.${d}`] = f);
    }
    let u = s.path, l = "url";
    if (s.name && t.routeLabel !== "path")
      u = s.name.toString(), l = "custom";
    else if (s.matched.length > 0) {
      const d = s.matched.length - 1;
      u = s.matched[d].path, l = "route";
    }
    V().setTransactionName(u), t.instrumentPageLoad && c && (B(c).data[he] !== "custom" && (c.updateName(u), c.setAttribute(he, l)), c.setAttributes({
      ...a,
      [ee]: "auto.pageload.vue"
    }), r = !0), t.instrumentNavigation && !c && n({
      name: u,
      op: "navigation",
      attributes: {
        ...a,
        [ee]: "auto.navigation.vue",
        [he]: l
      }
    }), o && o();
  });
}
function By() {
  const e = ce(), t = e && ae(e);
  return t && B(t).op === "pageload" ? t : void 0;
}
function Uy(e = {}) {
  if (!e.router)
    return Vo(e);
  const t = Vo({
    ...e,
    instrumentNavigation: !1
  }), { router: n, instrumentNavigation: r = !0, instrumentPageLoad: s = !0, routeLabel: i = "name" } = e;
  return {
    ...t,
    afterAllSetup(o) {
      t.afterAllSetup(o), $y(n, { routeLabel: i, instrumentNavigation: r, instrumentPageLoad: s }, (a) => {
        yu(o, a);
      });
    }
  };
}
let Rs = {
  debug: !1
};
function Hy(e) {
  Rs = {
    ...Rs,
    ...e
  };
}
function Ge() {
  return Rs.debug;
}
function jy(e) {
  Ge() && console.warn("[BugReporter] reportGlobalTags", e), V().setTags(e);
}
function qy(e) {
  Ge() && console.warn("[BugReporter] reportIdentify", e), V().setUser(e);
}
function Wy(e, t) {
  if (!e || !t || t.length === 0)
    return !1;
  try {
    const n = e.toLowerCase();
    for (const r of t)
      try {
        if (typeof r == "string") {
          if (n === r.toLowerCase())
            return !0;
        } else if (r instanceof RegExp && r.test(e))
          return !0;
      } catch (s) {
        console.warn(
          "[BugReporter] Error checking user agent pattern:",
          r,
          s
        );
        continue;
      }
    return !1;
  } catch (n) {
    return console.warn("[BugReporter] Error in shouldIgnoreUserAgent:", n), !1;
  }
}
function zy(e, t) {
  if (!t || t.length === 0)
    return !1;
  try {
    let n = e.request?.headers?.["User-Agent"] || e.contexts?.browser?.name || e.extra?.userAgent;
    !n && typeof navigator < "u" && (n = navigator.userAgent);
    const r = typeof n == "string" ? n : void 0;
    return Wy(r, t) ? (Ge() && console.warn(
      "[BugReporter] Ignoring event due to user agent filter:",
      r
    ), !0) : !1;
  } catch (n) {
    return Ge() && console.warn("[BugReporter] Error checking user agent filter:", n), !1;
  }
}
function Vy(e) {
  Hy({ debug: e.debug ?? !1 });
  const t = [];
  e.router && t.push(
    Uy({
      router: e.router
    })
  ), e.enableReplay && t.push(ty()), Ge() && console.warn("[BugReporter] init", e);
  const n = e.vueVersion === 2 ? "Vue" : "app";
  Fy({
    [n]: e.app,
    dsn: e.dsn,
    enabled: e.enabled ?? !0,
    release: e.release,
    environment: e.environment,
    integrations: t,
    tracePropagationTargets: e.tracingTargets ?? void 0,
    // The tracesSampleRate with default to capture 10%
    // of transactions for performance monitoring.
    tracesSampleRate: e.tracesSampleRate ?? 0.1,
    // Capture Replay with defaults for 1% of all sessions,
    // plus for 10% of sessions with an error
    replaysSessionSampleRate: e.replaysSessionSampleRate ?? 0.01,
    replaysOnErrorSampleRate: e.replaysOnErrorSampleRate ?? 0.1,
    denyUrls: e.denyUrls ?? [],
    ignoreErrors: e.ignoreErrors ?? [],
    beforeSend(r) {
      try {
        return zy(r, e.ignoreUserAgents) ? (Ge() && console.warn("[BugReporter] Ignored due to user agent"), null) : r;
      } catch (s) {
        return Ge() && console.warn("[BugReporter] Error in beforeSend:", s), r;
      }
    }
  });
}
function Gy(e, t) {
  Ge() && console.warn("[BugReporter] report", e, t), dn(e, {
    tags: t?.tags,
    extra: t?.extra ?? t?.context,
    contexts: {
      // @ts-expect-error This might not always conform to Sentry's standard context format.
      state: t?.state
    }
  });
}
const Yy = [
  // Random plugins and extensions
  /googleapis/i,
  /googlebot/i,
  /googlest/i,
  /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
  // Analytics
  /doubleclick\.net/i,
  /hotjar\./i,
  /netstats\.space/i,
  /pagead\/js/i,
  // Chrome extensions.
  /^chrome:\/\//i,
  /chrome-extension:/i,
  /extensions\//i,
  // Facebook.
  /connect\.facebook\.net\/en_US\/all\.js/i,
  /graph\.facebook\.com/i,
  // Safari extensions.
  /safari-web-extension:/i,
  /safari-extension:/i
], Ky = [
  // Random plugins and extensions.
  // http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
  "atomicFindClose",
  "Can't find variable: ZiteReader",
  "canvas.contentDocument",
  "ComboSearch is not defined",
  "http://loading.retry.widdit.com/",
  "http://tt.epicplay.com",
  "jigsaw is not defined",
  "miscellaneous_bindings",
  "MyApp_RemoveAllHighlights",
  "originalCreateNotification",
  "top.GLOBALS",
  // Generic error code from errors outside the security sandbox.
  "Script error.",
  // Analytics code.
  "vars.hotjar.com",
  "doubleclick.net",
  // Avast.
  "_avast_",
  // Facebook.
  "fb_xd_fragment",
  // Broadcom ASG error.
  "ICAP Error",
  // Bytemobile proxy.
  // http://stackoverflow.com/questions/4113268
  "bmi_SafeAddOnload",
  "EBCallBackMessageReceived",
  // Conduit Toolbar.
  // http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
  "conduitPage",
  // Chrome for iOS bug.
  // https://groups.google.com/a/chromium.org/forum/#!topic/chromium-discuss/7VU0_VvC7mE
  "__gCrWeb",
  // Chromium bug.
  // https://bugs.chromium.org/p/chromium/issues/detail?id=97172
  "ntp is not defined",
  // Edge on iOS.
  "instantSearchSDKJSBridgeClearHighlight",
  // Firefox bug.
  // https://bugzilla.mozilla.org/show_bug.cgi?id=783260
  // http://stackoverflow.com/a/13101119
  'Permission denied to access property "toString"',
  // Firefox internals.
  "_firefox_",
  // Firefox freeing add-on memory.
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Dead_object
  "can't access dead object",
  // Nuance Dragon Web Extension.
  "plugin.setSuspendState",
  // Safari bug.
  // https://bugs.webkit.org/show_bug.cgi?id=119472
  "promiseReactionJob",
  // SafeBrowse extension.
  "jQSB",
  // Commonly ignored errors of unknown origin.
  "androidInterface",
  "eshopcomp",
  "eval at C",
  "eval at E_c",
  "frameConnector_isForegroundChanged",
  "harkedtremblings",
  "kw__injected",
  "NPObject",
  "siteroot",
  "SymBrowser_",
  "touchDownX",
  "uiWebview_",
  "variable: inf",
  "Window.dologin",
  // https://sentry.io/answers/load-failed-javascript/
  /Load failed\.?$/,
  /^(?:[\w: ]+(:|-)\s)?Load failed(?: \([^)]+\))?$/,
  // https://sentry.io/answers/failed-to-fetch-javascript/
  /Failed to fetch\.?$/,
  /^(?:[\w: ]+(:|-)\s)?Failed to fetch(?: \([^)]+\))?$/
];
export {
  Yy as denyUrls,
  Ky as ignoreErrors,
  Gy as report,
  jy as reportGlobalTags,
  qy as reportIdentify,
  Vy as reportInit
};
